webpackJsonp([35783957827783],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = whitespace
	
	var fromCode = String.fromCharCode
	var re = /\s/
	
	/* Check if the given character code, or the character
	 * code at the first character, is a whitespace character. */
	function whitespace(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

	
	exports = module.exports = trim;
	
	function trim(str){
	  return str.replace(/^\s*|\s*$/g, '');
	}
	
	exports.left = function(str){
	  return str.replace(/^\s*/, '');
	};
	
	exports.right = function(str){
	  return str.replace(/\s*$/, '');
	};


/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = decimal
	
	/* Check if the given character code, or the character
	 * code at the first character, is decimal. */
	function decimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return code >= 48 && code <= 57 /* 0-9 */
	}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visit
	
	var visitParents = __webpack_require__(140)
	
	var CONTINUE = visitParents.CONTINUE
	var SKIP = visitParents.SKIP
	var EXIT = visitParents.EXIT
	
	visit.CONTINUE = CONTINUE
	visit.SKIP = SKIP
	visit.EXIT = EXIT
	
	function visit(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  visitParents(tree, test, overload, reverse)
	
	  function overload(node, parents) {
	    var parent = parents[parents.length - 1]
	    var index = parent ? parent.children.indexOf(node) : null
	    return visitor(node, index, parent)
	  }
	}


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var characterEntities = __webpack_require__(74)
	var legacy = __webpack_require__(73)
	var invalid = __webpack_require__(75)
	var decimal = __webpack_require__(10)
	var hexadecimal = __webpack_require__(70)
	var alphanumerical = __webpack_require__(68)
	
	module.exports = parseEntities
	
	var own = {}.hasOwnProperty
	var fromCharCode = String.fromCharCode
	var noop = Function.prototype
	
	/* Default settings. */
	var defaults = {
	  warning: null,
	  reference: null,
	  text: null,
	  warningContext: null,
	  referenceContext: null,
	  textContext: null,
	  position: {},
	  additional: null,
	  attribute: false,
	  nonTerminated: true
	}
	
	/* Reference types. */
	var NAMED = 'named'
	var HEXADECIMAL = 'hexadecimal'
	var DECIMAL = 'decimal'
	
	/* Map of bases. */
	var BASE = {}
	
	BASE[HEXADECIMAL] = 16
	BASE[DECIMAL] = 10
	
	/* Map of types to tests. Each type of character reference
	 * accepts different characters. This test is used to
	 * detect whether a reference has ended (as the semicolon
	 * is not strictly needed). */
	var TESTS = {}
	
	TESTS[NAMED] = alphanumerical
	TESTS[DECIMAL] = decimal
	TESTS[HEXADECIMAL] = hexadecimal
	
	/* Warning messages. */
	var NAMED_NOT_TERMINATED = 1
	var NUMERIC_NOT_TERMINATED = 2
	var NAMED_EMPTY = 3
	var NUMERIC_EMPTY = 4
	var NAMED_UNKNOWN = 5
	var NUMERIC_DISALLOWED = 6
	var NUMERIC_PROHIBITED = 7
	
	var MESSAGES = {}
	
	MESSAGES[NAMED_NOT_TERMINATED] =
	  'Named character references must be terminated by a semicolon'
	MESSAGES[NUMERIC_NOT_TERMINATED] =
	  'Numeric character references must be terminated by a semicolon'
	MESSAGES[NAMED_EMPTY] = 'Named character references cannot be empty'
	MESSAGES[NUMERIC_EMPTY] = 'Numeric character references cannot be empty'
	MESSAGES[NAMED_UNKNOWN] = 'Named character references must be known'
	MESSAGES[NUMERIC_DISALLOWED] =
	  'Numeric character references cannot be disallowed'
	MESSAGES[NUMERIC_PROHIBITED] =
	  'Numeric character references cannot be outside the permissible Unicode range'
	
	/* Wrap to ensure clean parameters are given to `parse`. */
	function parseEntities(value, options) {
	  var settings = {}
	  var option
	  var key
	
	  if (!options) {
	    options = {}
	  }
	
	  for (key in defaults) {
	    option = options[key]
	    settings[key] =
	      option === null || option === undefined ? defaults[key] : option
	  }
	
	  if (settings.position.indent || settings.position.start) {
	    settings.indent = settings.position.indent || []
	    settings.position = settings.position.start
	  }
	
	  return parse(value, settings)
	}
	
	/* Parse entities. */
	function parse(value, settings) {
	  var additional = settings.additional
	  var nonTerminated = settings.nonTerminated
	  var handleText = settings.text
	  var handleReference = settings.reference
	  var handleWarning = settings.warning
	  var textContext = settings.textContext
	  var referenceContext = settings.referenceContext
	  var warningContext = settings.warningContext
	  var pos = settings.position
	  var indent = settings.indent || []
	  var length = value.length
	  var index = 0
	  var lines = -1
	  var column = pos.column || 1
	  var line = pos.line || 1
	  var queue = ''
	  var result = []
	  var entityCharacters
	  var terminated
	  var characters
	  var character
	  var reference
	  var following
	  var warning
	  var reason
	  var output
	  var entity
	  var begin
	  var start
	  var type
	  var test
	  var prev
	  var next
	  var diff
	  var end
	
	  /* Cache the current point. */
	  prev = now()
	
	  /* Wrap `handleWarning`. */
	  warning = handleWarning ? parseError : noop
	
	  /* Ensure the algorithm walks over the first character
	   * and the end (inclusive). */
	  index--
	  length++
	
	  while (++index < length) {
	    /* If the previous character was a newline. */
	    if (character === '\n') {
	      column = indent[lines] || 1
	    }
	
	    character = at(index)
	
	    /* Handle anything other than an ampersand,
	     * including newlines and EOF. */
	    if (character !== '&') {
	      if (character === '\n') {
	        line++
	        lines++
	        column = 0
	      }
	
	      if (character) {
	        queue += character
	        column++
	      } else {
	        flush()
	      }
	    } else {
	      following = at(index + 1)
	
	      /* The behaviour depends on the identity of the next
	       * character. */
	      if (
	        following === '\t' /* Tab */ ||
	        following === '\n' /* Newline */ ||
	        following === '\f' /* Form feed */ ||
	        following === ' ' /* Space */ ||
	        following === '<' /* Less-than */ ||
	        following === '&' /* Ampersand */ ||
	        following === '' ||
	        (additional && following === additional)
	      ) {
	        /* Not a character reference. No characters
	         * are consumed, and nothing is returned.
	         * This is not an error, either. */
	        queue += character
	        column++
	
	        continue
	      }
	
	      start = index + 1
	      begin = start
	      end = start
	
	      /* Numerical entity. */
	      if (following !== '#') {
	        type = NAMED
	      } else {
	        end = ++begin
	
	        /* The behaviour further depends on the
	         * character after the U+0023 NUMBER SIGN. */
	        following = at(end)
	
	        if (following === 'x' || following === 'X') {
	          /* ASCII hex digits. */
	          type = HEXADECIMAL
	          end = ++begin
	        } else {
	          /* ASCII digits. */
	          type = DECIMAL
	        }
	      }
	
	      entityCharacters = ''
	      entity = ''
	      characters = ''
	      test = TESTS[type]
	      end--
	
	      while (++end < length) {
	        following = at(end)
	
	        if (!test(following)) {
	          break
	        }
	
	        characters += following
	
	        /* Check if we can match a legacy named
	         * reference.  If so, we cache that as the
	         * last viable named reference.  This
	         * ensures we do not need to walk backwards
	         * later. */
	        if (type === NAMED && own.call(legacy, characters)) {
	          entityCharacters = characters
	          entity = legacy[characters]
	        }
	      }
	
	      terminated = at(end) === ';'
	
	      if (terminated) {
	        end++
	
	        if (type === NAMED && own.call(characterEntities, characters)) {
	          entityCharacters = characters
	          entity = characterEntities[characters]
	        }
	      }
	
	      diff = 1 + end - start
	
	      if (!terminated && !nonTerminated) {
	        /* Empty. */
	      } else if (!characters) {
	        /* An empty (possible) entity is valid, unless
	         * its numeric (thus an ampersand followed by
	         * an octothorp). */
	        if (type !== NAMED) {
	          warning(NUMERIC_EMPTY, diff)
	        }
	      } else if (type === NAMED) {
	        /* An ampersand followed by anything
	         * unknown, and not terminated, is invalid. */
	        if (terminated && !entity) {
	          warning(NAMED_UNKNOWN, 1)
	        } else {
	          /* If theres something after an entity
	           * name which is not known, cap the
	           * reference. */
	          if (entityCharacters !== characters) {
	            end = begin + entityCharacters.length
	            diff = 1 + end - begin
	            terminated = false
	          }
	
	          /* If the reference is not terminated,
	           * warn. */
	          if (!terminated) {
	            reason = entityCharacters ? NAMED_NOT_TERMINATED : NAMED_EMPTY
	
	            if (!settings.attribute) {
	              warning(reason, diff)
	            } else {
	              following = at(end)
	
	              if (following === '=') {
	                warning(reason, diff)
	                entity = null
	              } else if (alphanumerical(following)) {
	                entity = null
	              } else {
	                warning(reason, diff)
	              }
	            }
	          }
	        }
	
	        reference = entity
	      } else {
	        if (!terminated) {
	          /* All non-terminated numeric entities are
	           * not rendered, and trigger a warning. */
	          warning(NUMERIC_NOT_TERMINATED, diff)
	        }
	
	        /* When terminated and number, parse as
	         * either hexadecimal or decimal. */
	        reference = parseInt(characters, BASE[type])
	
	        /* Trigger a warning when the parsed number
	         * is prohibited, and replace with
	         * replacement character. */
	        if (prohibited(reference)) {
	          warning(NUMERIC_PROHIBITED, diff)
	          reference = '\uFFFD'
	        } else if (reference in invalid) {
	          /* Trigger a warning when the parsed number
	           * is disallowed, and replace by an
	           * alternative. */
	          warning(NUMERIC_DISALLOWED, diff)
	          reference = invalid[reference]
	        } else {
	          /* Parse the number. */
	          output = ''
	
	          /* Trigger a warning when the parsed
	           * number should not be used. */
	          if (disallowed(reference)) {
	            warning(NUMERIC_DISALLOWED, diff)
	          }
	
	          /* Stringify the number. */
	          if (reference > 0xffff) {
	            reference -= 0x10000
	            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
	            reference = 0xdc00 | (reference & 0x3ff)
	          }
	
	          reference = output + fromCharCode(reference)
	        }
	      }
	
	      /* If we could not find a reference, queue the
	       * checked characters (as normal characters),
	       * and move the pointer to their end. This is
	       * possible because we can be certain neither
	       * newlines nor ampersands are included. */
	      if (!reference) {
	        characters = value.slice(start - 1, end)
	        queue += characters
	        column += characters.length
	        index = end - 1
	      } else {
	        /* Found it! First eat the queued
	         * characters as normal text, then eat
	         * an entity. */
	        flush()
	
	        prev = now()
	        index = end - 1
	        column += end - start + 1
	        result.push(reference)
	        next = now()
	        next.offset++
	
	        if (handleReference) {
	          handleReference.call(
	            referenceContext,
	            reference,
	            {start: prev, end: next},
	            value.slice(start - 1, end)
	          )
	        }
	
	        prev = next
	      }
	    }
	  }
	
	  /* Return the reduced nodes, and any possible warnings. */
	  return result.join('')
	
	  /* Get current position. */
	  function now() {
	    return {
	      line: line,
	      column: column,
	      offset: index + (pos.offset || 0)
	    }
	  }
	
	  /* “Throw” a parse-error: a warning. */
	  function parseError(code, offset) {
	    var position = now()
	
	    position.column += offset
	    position.offset += offset
	
	    handleWarning.call(warningContext, MESSAGES[code], position, code)
	  }
	
	  /* Get character at position. */
	  function at(position) {
	    return value.charAt(position)
	  }
	
	  /* Flush `queue` (normal text). Macro invoked before
	   * each entity and at the end of `value`.
	   * Does nothing when `queue` is empty. */
	  function flush() {
	    if (queue) {
	      result.push(queue)
	
	      if (handleText) {
	        handleText.call(textContext, queue, {start: prev, end: now()})
	      }
	
	      queue = ''
	    }
	  }
	}
	
	/* Check if `character` is outside the permissible unicode range. */
	function prohibited(code) {
	  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
	}
	
	/* Check if `character` is disallowed. */
	function disallowed(code) {
	  return (
	    (code >= 0x0001 && code <= 0x0008) ||
	    code === 0x000b ||
	    (code >= 0x000d && code <= 0x001f) ||
	    (code >= 0x007f && code <= 0x009f) ||
	    (code >= 0xfdd0 && code <= 0xfdef) ||
	    (code & 0xffff) === 0xffff ||
	    (code & 0xffff) === 0xfffe
	  )
	}


/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = interrupt;
	
	function interrupt(interruptors, tokenizers, ctx, params) {
	  var bools = ['pedantic', 'commonmark'];
	  var count = bools.length;
	  var length = interruptors.length;
	  var index = -1;
	  var interruptor;
	  var config;
	  var fn;
	  var offset;
	  var bool;
	  var ignore;
	
	  while (++index < length) {
	    interruptor = interruptors[index];
	    config = interruptor[1] || {};
	    fn = interruptor[0];
	    offset = -1;
	    ignore = false;
	
	    while (++offset < count) {
	      bool = bools[offset];
	
	      if (config[bool] !== undefined && config[bool] !== ctx.options[bool]) {
	        ignore = true;
	        break;
	      }
	    }
	
	    if (ignore) {
	      continue;
	    }
	
	    if (tokenizers[fn].apply(ctx, params)) {
	      return true;
	    }
	  }
	
	  return false;
	}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var collapseWhiteSpace = __webpack_require__(56);
	
	module.exports = normalize;
	
	/* Normalize an identifier.  Collapses multiple white space
	 * characters into a single space, and removes casing. */
	function normalize(value) {
	  return collapseWhiteSpace(value).toLowerCase();
	}


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	/*!
	 * repeat-string <https://github.com/jonschlinkert/repeat-string>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Results cache
	 */
	
	var res = '';
	var cache;
	
	/**
	 * Expose `repeat`
	 */
	
	module.exports = repeat;
	
	/**
	 * Repeat the given `string` the specified `number`
	 * of times.
	 *
	 * **Example:**
	 *
	 * ```js
	 * var repeat = require('repeat-string');
	 * repeat('A', 5);
	 * //=> AAAAA
	 * ```
	 *
	 * @param {String} `string` The string to repeat
	 * @param {Number} `number` The number of times to repeat the string
	 * @return {String} Repeated string
	 * @api public
	 */
	
	function repeat(str, num) {
	  if (typeof str !== 'string') {
	    throw new TypeError('expected a string');
	  }
	
	  // cover common, quick use cases
	  if (num === 1) return str;
	  if (num === 2) return str + str;
	
	  var max = str.length * num;
	  if (cache !== str || typeof cache === 'undefined') {
	    cache = str;
	    res = '';
	  } else if (res.length >= max) {
	    return res.substr(0, max);
	  }
	
	  while (max > res.length && num > 1) {
	    if (num & 1) {
	      res += str;
	    }
	
	    num >>= 1;
	    str += str;
	  }
	
	  res += str;
	  res = res.substr(0, max);
	  return res;
	}


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = trimTrailingLines
	
	var line = '\n'
	
	/* Remove final newline characters from `value`. */
	function trimTrailingLines(value) {
	  var val = String(value)
	  var index = val.length
	
	  while (val.charAt(--index) === line) {
	    /* Empty */
	  }
	
	  return val.slice(0, index + 1)
	}


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-geo/ Version 1.6.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(243)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Array) { 'use strict';
	
	// Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	var adder = function() {
	  return new Adder;
	};
	
	function Adder() {
	  this.reset();
	}
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function(y) {
	    add(temp, y, this.t);
	    add(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;
	    else this.s = temp.t;
	  },
	  valueOf: function() {
	    return this.s;
	  }
	};
	
	var temp = new Adder;
	
	function add(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = (a - av) + (b - bv);
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var quarterPi = pi / 4;
	var tau = pi * 2;
	
	var degrees = 180 / pi;
	var radians = pi / 180;
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var ceil = Math.ceil;
	var exp = Math.exp;
	
	var log = Math.log;
	var pow = Math.pow;
	var sin = Math.sin;
	var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sqrt = Math.sqrt;
	var tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin(x / 2)) * x;
	}
	
	function noop() {}
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function(object, stream) {
	    streamGeometry(object.geometry, stream);
	  },
	  FeatureCollection: function(object, stream) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) streamGeometry(features[i].geometry, stream);
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function(object, stream) {
	    stream.sphere();
	  },
	  Point: function(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	  },
	  LineString: function(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamLine(coordinates[i], stream, 0);
	  },
	  Polygon: function(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamPolygon(coordinates[i], stream);
	  },
	  GeometryCollection: function(object, stream) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) streamGeometry(geometries[i], stream);
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1, n = coordinates.length - closed, coordinate;
	  stream.lineStart();
	  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1, n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) streamLine(coordinates[i], stream, 1);
	  stream.polygonEnd();
	}
	
	var geoStream = function(object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	};
	
	var areaRingSum = adder();
	
	var areaSum = adder();
	var lambda00;
	var phi00;
	var lambda0;
	var cosPhi0;
	var sinPhi0;
	
	var areaStream = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? tau + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = noop;
	  },
	  sphere: function() {
	    areaSum.add(tau);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= radians, phi *= radians;
	  lambda0 = lambda, cosPhi0 = cos(phi = phi / 2 + quarterPi), sinPhi0 = sin(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  phi = phi / 2 + quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = cos(phi),
	      sinPhi = sin(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * cos(adLambda),
	      v = k * sdLambda * sin(adLambda);
	  areaRingSum.add(atan2(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}
	
	var area = function(object) {
	  areaSum.reset();
	  geoStream(object, areaStream);
	  return areaSum * 2;
	};
	
	function spherical(cartesian) {
	  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0], phi = spherical[1], cosPhi = cos(phi);
	  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}
	
	var lambda0$1;
	var phi0;
	var lambda1;
	var phi1;
	var lambda2;
	var lambda00$1;
	var phi00$1;
	var p0;
	var deltaSum = adder();
	var ranges;
	var range$1;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    areaStream.polygonStart();
	  },
	  polygonEnd: function() {
	    areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	    else if (deltaSum > epsilon) phi1 = 90;
	    else if (deltaSum < -epsilon) phi0 = -90;
	    range$1[0] = lambda0$1, range$1[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = cartesian([lambda * radians, phi * radians]);
	  if (p0) {
	    var normal = cartesianCross(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = cartesianCross(equatorial, normal);
	    cartesianNormalizeInPlace(inflection);
	    inflection = spherical(inflection);
	    var delta = lambda - lambda2,
	        sign$$1 = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * degrees * sign$$1,
	        phii,
	        antimeridian = abs(delta) > 180;
	    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = inflection[1] * degrees;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = -inflection[1] * degrees;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0$1) {
	        if (lambda < lambda0$1) lambda0$1 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	        }
	      }
	    }
	  } else {
	    ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  }
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00$1 = lambda, phi00$1 = phi;
	  }
	  areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00$1, phi00$1);
	  areaStream.lineEnd();
	  if (abs(deltaSum) > epsilon) lambda0$1 = -(lambda1 = 180);
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range$$1, x) {
	  return range$$1[0] <= range$$1[1] ? range$$1[0] <= x && x <= range$$1[1] : x < range$$1[0] || range$$1[1] < x;
	}
	
	var bounds = function(feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
	  ranges = [];
	  geoStream(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range$1 = null;
	
	  return lambda0$1 === Infinity || phi0 === Infinity
	      ? [[NaN, NaN], [NaN, NaN]]
	      : [[lambda0$1, phi0], [lambda1, phi1]];
	};
	
	var W0;
	var W1;
	var X0;
	var Y0;
	var Z0;
	var X1;
	var Y1;
	var Z1;
	var X2;
	var Y2;
	var Z2;
	var lambda00$2;
	var phi00$2;
	var x0;
	var y0;
	var z0; // previous point
	
	var centroidStream = {
	  sphere: noop,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  centroidPointCartesian(cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00$2, phi00$2);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00$2 = lambda, phi00$2 = phi;
	  lambda *= radians, phi *= radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = sqrt(cx * cx + cy * cy + cz * cz),
	      w = asin(m), // line weight = angle
	      v = m && -w / m; // area weight multiplier
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	var centroid = function(object) {
	  W0 = W1 =
	  X0 = Y0 = Z0 =
	  X1 = Y1 = Z1 =
	  X2 = Y2 = Z2 = 0;
	  geoStream(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < epsilon2) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < epsilon) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < epsilon2) return [NaN, NaN];
	  }
	
	  return [atan2(y, x) * degrees, asin(z / sqrt(m)) * degrees];
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var compose = function(a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function(x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	};
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= tau) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
	    : rotationLambda(deltaLambda))
	    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
	    : rotationIdentity);
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function(lambda, phi) {
	    return lambda += deltaLambda, [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = cos(deltaPhi),
	      sinDeltaPhi = sin(deltaPhi),
	      cosDeltaGamma = cos(deltaGamma),
	      sinDeltaGamma = sin(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [
	      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	      asin(k * cosDeltaGamma + y * sinDeltaGamma)
	    ];
	  }
	
	  rotation.invert = function(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [
	      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	      asin(k * cosDeltaPhi - x * sinDeltaPhi)
	    ];
	  };
	
	  return rotation;
	}
	
	var rotation = function(rotate) {
	  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  }
	
	  forward.invert = function(coordinates) {
	    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  };
	
	  return forward;
	};
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = cos(radius),
	      sinRadius = sin(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * tau;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = spherical([cosRadius, -sinRadius * cos(t), -sinRadius * sin(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = cartesian(point), point[0] -= cosRadius;
	  cartesianNormalizeInPlace(point);
	  var radius = acos(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + tau - epsilon) % tau;
	}
	
	var circle = function() {
	  var center = constant([0, 0]),
	      radius = constant(90),
	      precision = constant(6),
	      ring,
	      rotate,
	      stream = {point: point};
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= degrees, x[1] *= degrees;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * radians,
	        p = precision.apply(this, arguments) * radians;
	    ring = [];
	    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = {type: "Polygon", coordinates: [ring]};
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function(_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), circle) : radius;
	  };
	
	  circle.precision = function(_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : constant(+_), circle) : precision;
	  };
	
	  return circle;
	};
	
	var clipBuffer = function() {
	  var lines = [],
	      line;
	  return {
	    point: function(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function() {
	      lines.push(line = []);
	    },
	    lineEnd: noop,
	    rejoin: function() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	};
	
	var clipLine = function(a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	};
	
	var pointEqual = function(a, b) {
	  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
	};
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function(segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n, p0 = segment[0], p1 = segment[n], x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if (pointEqual(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	      stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link(subject);
	  link(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) if ((current = current.n) === start) return;
	    points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	};
	
	function link(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}
	
	var clipMax = 1e9;
	var clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipExtent(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0, a1 = 0;
	    if (from == null
	        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
	        || comparePoint(from, to) < 0 ^ direction > 0) {
	      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return abs(p[0] - x0) < epsilon ? direction > 0 ? 0 : 3
	        : abs(p[0] - x1) < epsilon ? direction > 0 ? 2 : 1
	        : abs(p[1] - y0) < epsilon ? direction > 0 ? 1 : 0
	        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb
	        : ca === 0 ? b[1] - a[1]
	        : ca === 1 ? a[0] - b[0]
	        : ca === 2 ? a[1] - b[1]
	        : b[0] - a[0];
	  }
	
	  return function(stream) {
	    var activeStream = stream,
	        bufferStream = clipBuffer(),
	        segments,
	        polygon,
	        ring,
	        x__, y__, v__, // first point
	        x_, y_, v_, // previous point
	        first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
	          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = d3Array.merge(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);
	        else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if (clipLine(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}
	
	var extent = function() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
	    },
	    extent: function(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	};
	
	var sum = adder();
	
	var polygonContains = function(polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      normal = [sin(lambda), -cos(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum.reset();
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + quarterPi,
	        sinPhi0 = sin(phi0),
	        cosPhi0 = cos(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + quarterPi,
	          sinPhi1 = sin(phi1),
	          cosPhi1 = cos(phi1),
	          delta = lambda1 - lambda0,
	          sign$$1 = delta >= 0 ? 1 : -1,
	          absDelta = sign$$1 * delta,
	          antimeridian = absDelta > pi,
	          k = sinPhi0 * sinPhi1;
	
	      sum.add(atan2(k * sign$$1 * sin(absDelta), cosPhi0 * cosPhi1 + k * cos(absDelta)));
	      angle += antimeridian ? delta + sign$$1 * tau : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = cartesianCross(cartesian(point0), cartesian(point1));
	        cartesianNormalizeInPlace(arc);
	        var intersection = cartesianCross(normal, arc);
	        cartesianNormalizeInPlace(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -epsilon || angle < epsilon && sum < -epsilon) ^ (winding & 1);
	};
	
	var lengthSum = adder();
	var lambda0$2;
	var sinPhi0$1;
	var cosPhi0$1;
	
	var lengthStream = {
	  sphere: noop,
	  point: noop,
	  lineStart: lengthLineStart,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = noop;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  lambda0$2 = lambda, sinPhi0$1 = sin(phi), cosPhi0$1 = cos(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var sinPhi = sin(phi),
	      cosPhi = cos(phi),
	      delta = abs(lambda - lambda0$2),
	      cosDelta = cos(delta),
	      sinDelta = sin(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
	      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
	  lengthSum.add(atan2(sqrt(x * x + y * y), z));
	  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
	}
	
	var length = function(object) {
	  lengthSum.reset();
	  geoStream(object, lengthStream);
	  return +lengthSum;
	};
	
	var coordinates = [null, null];
	var object = {type: "LineString", coordinates: coordinates};
	
	var distance = function(a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return length(object);
	};
	
	var containsObjectType = {
	  Feature: function(object, point) {
	    return containsGeometry(object.geometry, point);
	  },
	  FeatureCollection: function(object, point) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
	    return false;
	  }
	};
	
	var containsGeometryType = {
	  Sphere: function() {
	    return true;
	  },
	  Point: function(object, point) {
	    return containsPoint(object.coordinates, point);
	  },
	  MultiPoint: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
	    return false;
	  },
	  LineString: function(object, point) {
	    return containsLine(object.coordinates, point);
	  },
	  MultiLineString: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsLine(coordinates[i], point)) return true;
	    return false;
	  },
	  Polygon: function(object, point) {
	    return containsPolygon(object.coordinates, point);
	  },
	  MultiPolygon: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
	    return false;
	  },
	  GeometryCollection: function(object, point) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
	    return false;
	  }
	};
	
	function containsGeometry(geometry, point) {
	  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
	      ? containsGeometryType[geometry.type](geometry, point)
	      : false;
	}
	
	function containsPoint(coordinates, point) {
	  return distance(coordinates, point) === 0;
	}
	
	function containsLine(coordinates, point) {
	  var ab = distance(coordinates[0], coordinates[1]),
	      ao = distance(coordinates[0], point),
	      ob = distance(point, coordinates[1]);
	  return ao + ob <= ab + epsilon;
	}
	
	function containsPolygon(coordinates, point) {
	  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
	}
	
	function ringRadians(ring) {
	  return ring = ring.map(pointRadians), ring.pop(), ring;
	}
	
	function pointRadians(point) {
	  return [point[0] * radians, point[1] * radians];
	}
	
	var contains = function(object, point) {
	  return (object && containsObjectType.hasOwnProperty(object.type)
	      ? containsObjectType[object.type]
	      : containsGeometry)(object, point);
	};
	
	function graticuleX(y0, y1, dy) {
	  var y = d3Array.range(y0, y1 - epsilon, dy).concat(y1);
	  return function(x) { return y.map(function(y) { return [x, y]; }); };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = d3Array.range(x0, x1 - epsilon, dx).concat(x1);
	  return function(y) { return x.map(function(x) { return [x, y]; }); };
	}
	
	function graticule() {
	  var x1, x0, X1, X0,
	      y1, y0, Y1, Y0,
	      dx = 10, dy = dx, DX = 90, DY = 360,
	      x, y, X, Y,
	      precision = 2.5;
	
	  function graticule() {
	    return {type: "MultiLineString", coordinates: lines()};
	  }
	
	  function lines() {
	    return d3Array.range(ceil(X0 / DX) * DX, X1, DX).map(X)
	        .concat(d3Array.range(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
	        .concat(d3Array.range(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon; }).map(x))
	        .concat(d3Array.range(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon; }).map(y));
	  }
	
	  graticule.lines = function() {
	    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
	  };
	
	  graticule.outline = function() {
	    return {
	      type: "Polygon",
	      coordinates: [
	        X(X0).concat(
	        Y(Y1).slice(1),
	        X(X1).reverse().slice(1),
	        Y(Y0).reverse().slice(1))
	      ]
	    };
	  };
	
	  graticule.extent = function(_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function(_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function(_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function(_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function(_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function(_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function(_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule
	      .extentMajor([[-180, -90 + epsilon], [180, 90 - epsilon]])
	      .extentMinor([[-180, -80 - epsilon], [180, 80 + epsilon]]);
	}
	
	function graticule10() {
	  return graticule()();
	}
	
	var interpolate = function(a, b) {
	  var x0 = a[0] * radians,
	      y0 = a[1] * radians,
	      x1 = b[0] * radians,
	      y1 = b[1] * radians,
	      cy0 = cos(y0),
	      sy0 = sin(y0),
	      cy1 = cos(y1),
	      sy1 = sin(y1),
	      kx0 = cy0 * cos(x0),
	      ky0 = cy0 * sin(x0),
	      kx1 = cy1 * cos(x1),
	      ky1 = cy1 * sin(x1),
	      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
	      k = sin(d);
	
	  var interpolate = d ? function(t) {
	    var B = sin(t *= d) / k,
	        A = sin(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [
	      atan2(y, x) * degrees,
	      atan2(z, sqrt(x * x + y * y)) * degrees
	    ];
	  } : function() {
	    return [x0 * degrees, y0 * degrees];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var areaSum$1 = adder();
	var areaRingSum$1 = adder();
	var x00;
	var y00;
	var x0$1;
	var y0$1;
	
	var areaStream$1 = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaStream$1.lineStart = areaRingStart$1;
	    areaStream$1.lineEnd = areaRingEnd$1;
	  },
	  polygonEnd: function() {
	    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop;
	    areaSum$1.add(abs(areaRingSum$1));
	    areaRingSum$1.reset();
	  },
	  result: function() {
	    var area = areaSum$1 / 2;
	    areaSum$1.reset();
	    return area;
	  }
	};
	
	function areaRingStart$1() {
	  areaStream$1.point = areaPointFirst$1;
	}
	
	function areaPointFirst$1(x, y) {
	  areaStream$1.point = areaPoint$1;
	  x00 = x0$1 = x, y00 = y0$1 = y;
	}
	
	function areaPoint$1(x, y) {
	  areaRingSum$1.add(y0$1 * x - x0$1 * y);
	  x0$1 = x, y0$1 = y;
	}
	
	function areaRingEnd$1() {
	  areaPoint$1(x00, y00);
	}
	
	var x0$2 = Infinity;
	var y0$2 = x0$2;
	var x1 = -x0$2;
	var y1 = x1;
	
	var boundsStream$1 = {
	  point: boundsPoint$1,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop,
	  result: function() {
	    var bounds = [[x0$2, y0$2], [x1, y1]];
	    x1 = y1 = -(y0$2 = x0$2 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint$1(x, y) {
	  if (x < x0$2) x0$2 = x;
	  if (x > x1) x1 = x;
	  if (y < y0$2) y0$2 = y;
	  if (y > y1) y1 = y;
	}
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0$1 = 0;
	var Y0$1 = 0;
	var Z0$1 = 0;
	var X1$1 = 0;
	var Y1$1 = 0;
	var Z1$1 = 0;
	var X2$1 = 0;
	var Y2$1 = 0;
	var Z2$1 = 0;
	var x00$1;
	var y00$1;
	var x0$3;
	var y0$3;
	
	var centroidStream$1 = {
	  point: centroidPoint$1,
	  lineStart: centroidLineStart$1,
	  lineEnd: centroidLineEnd$1,
	  polygonStart: function() {
	    centroidStream$1.lineStart = centroidRingStart$1;
	    centroidStream$1.lineEnd = centroidRingEnd$1;
	  },
	  polygonEnd: function() {
	    centroidStream$1.point = centroidPoint$1;
	    centroidStream$1.lineStart = centroidLineStart$1;
	    centroidStream$1.lineEnd = centroidLineEnd$1;
	  },
	  result: function() {
	    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
	        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
	        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
	        : [NaN, NaN];
	    X0$1 = Y0$1 = Z0$1 =
	    X1$1 = Y1$1 = Z1$1 =
	    X2$1 = Y2$1 = Z2$1 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint$1(x, y) {
	  X0$1 += x;
	  Y0$1 += y;
	  ++Z0$1;
	}
	
	function centroidLineStart$1() {
	  centroidStream$1.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream$1.point = centroidPointLine;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidLineEnd$1() {
	  centroidStream$1.point = centroidPoint$1;
	}
	
	function centroidRingStart$1() {
	  centroidStream$1.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd$1() {
	  centroidPointRing(x00$1, y00$1);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream$1.point = centroidPointRing;
	  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0$3,
	      dy = y - y0$3,
	      z = sqrt(dx * dx + dy * dy);
	
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	
	  z = y0$3 * x - x0$3 * y;
	  X2$1 += z * (x0$3 + x);
	  Y2$1 += z * (y0$3 + y);
	  Z2$1 += z * 3;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._context.moveTo(x, y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._context.lineTo(x, y);
	        break;
	      }
	      default: {
	        this._context.moveTo(x + this._radius, y);
	        this._context.arc(x, y, this._radius, 0, tau);
	        break;
	      }
	    }
	  },
	  result: noop
	};
	
	var lengthSum$1 = adder();
	var lengthRing;
	var x00$2;
	var y00$2;
	var x0$4;
	var y0$4;
	
	var lengthStream$1 = {
	  point: noop,
	  lineStart: function() {
	    lengthStream$1.point = lengthPointFirst$1;
	  },
	  lineEnd: function() {
	    if (lengthRing) lengthPoint$1(x00$2, y00$2);
	    lengthStream$1.point = noop;
	  },
	  polygonStart: function() {
	    lengthRing = true;
	  },
	  polygonEnd: function() {
	    lengthRing = null;
	  },
	  result: function() {
	    var length = +lengthSum$1;
	    lengthSum$1.reset();
	    return length;
	  }
	};
	
	function lengthPointFirst$1(x, y) {
	  lengthStream$1.point = lengthPoint$1;
	  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
	}
	
	function lengthPoint$1(x, y) {
	  x0$4 -= x, y0$4 -= y;
	  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
	  x0$4 = x, y0$4 = y;
	}
	
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _circle: circle$1(4.5),
	  pointRadius: function(_) {
	    return this._circle = circle$1(_), this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._string.push("M", x, ",", y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._string.push("L", x, ",", y);
	        break;
	      }
	      default: {
	        this._string.push("M", x, ",", y, this._circle);
	        break;
	      }
	    }
	  },
	  result: function() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    }
	  }
	};
	
	function circle$1(radius) {
	  return "m0," + radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
	      + "z";
	}
	
	var index = function(projection, context) {
	  var pointRadius = 4.5,
	      projectionStream,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      geoStream(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function(object) {
	    geoStream(object, projectionStream(areaStream$1));
	    return areaStream$1.result();
	  };
	
	  path.measure = function(object) {
	    geoStream(object, projectionStream(lengthStream$1));
	    return lengthStream$1.result();
	  };
	
	  path.bounds = function(object) {
	    geoStream(object, projectionStream(boundsStream$1));
	    return boundsStream$1.result();
	  };
	
	  path.centroid = function(object) {
	    geoStream(object, projectionStream(centroidStream$1));
	    return centroidStream$1.result();
	  };
	
	  path.projection = function(_) {
	    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity) : (projection = _).stream, path) : projection;
	  };
	
	  path.context = function(_) {
	    if (!arguments.length) return context;
	    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function(_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(projection).context(context);
	};
	
	var clip = function(pointVisible, clipLine, interpolate, start) {
	  return function(rotate, sink) {
	    var line = clipLine(sink),
	        rotatedStart = rotate.invert(start[0], start[1]),
	        ringBuffer = clipBuffer(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = d3Array.merge(segments);
	        var startInside = polygonContains(polygon, rotatedStart);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      var point = rotate(lambda, phi);
	      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      var point = rotate(lambda, phi);
	      line.point(point[0], point[1]);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      var point = rotate(lambda, phi);
	      ringSink.point(point[0], point[1]);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i, n = ringSegments.length, m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
	          sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	};
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - halfPi - epsilon : halfPi - a[1])
	       - ((b = b.x)[0] < 0 ? b[1] - halfPi - epsilon : halfPi - b[1]);
	}
	
	var clipAntimeridian = clip(
	  function() { return true; },
	  clipAntimeridianLine,
	  clipAntimeridianInterpolate,
	  [-pi, -halfPi]
	);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      clean; // no intersections
	
	  return {
	    lineStart: function() {
	      stream.lineStart();
	      clean = 1;
	    },
	    point: function(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? pi : -pi,
	          delta = abs(lambda1 - lambda0);
	      if (abs(delta - pi) < epsilon) { // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi : -halfPi);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        clean = 0;
	      } else if (sign0 !== sign1 && delta >= pi) { // line crosses antimeridian
	        if (abs(lambda0 - sign0) < epsilon) lambda0 -= sign0 * epsilon; // handle degeneracies
	        if (abs(lambda1 - sign1) < epsilon) lambda1 -= sign1 * epsilon;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function() {
	      return 2 - clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = sin(lambda0 - lambda1);
	  return abs(sinLambda0Lambda1) > epsilon
	      ? atan((sin(phi0) * (cosPhi1 = cos(phi1)) * sin(lambda1)
	          - sin(phi1) * (cosPhi0 = cos(phi0)) * sin(lambda0))
	          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
	      : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * halfPi;
	    stream.point(-pi, phi);
	    stream.point(0, phi);
	    stream.point(pi, phi);
	    stream.point(pi, 0);
	    stream.point(pi, -phi);
	    stream.point(0, -phi);
	    stream.point(-pi, -phi);
	    stream.point(-pi, 0);
	    stream.point(-pi, phi);
	  } else if (abs(from[0] - to[0]) > epsilon) {
	    var lambda = from[0] < to[0] ? pi : -pi;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}
	
	var clipCircle = function(radius, delta) {
	  var cr = cos(radius),
	      smallRadius = cr > 0,
	      notHemisphere = abs(cr) > epsilon; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    circleStream(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return cos(lambda) * cos(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	        c0, // code for previous point
	        v0, // visibility of previous point
	        v00, // visibility of first point
	        clean; // no intersections
	    return {
	      lineStart: function() {
	        v00 = v0 = false;
	        clean = 1;
	      },
	      point: function(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius
	              ? v ? 0 : code(lambda, phi)
	              : v ? code(lambda + (lambda < 0 ? pi : -pi), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (pointEqual(point0, point2) || pointEqual(point1, point2)) {
	            point1[0] += epsilon;
	            point1[1] += epsilon;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !pointEqual(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function() {
	        return clean | ((v00 && v0) << 1);
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = cartesian(a),
	        pb = cartesian(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0], // normal
	        n2 = cartesianCross(pa, pb),
	        n2n2 = cartesianDot(n2, n2),
	        n1n2 = n2[0], // cartesianDot(n1, n2),
	        determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 =  cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = cartesianCross(n1, n2),
	        A = cartesianScale(n1, c1),
	        B = cartesianScale(n2, c2);
	    cartesianAddInPlace(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = cartesianDot(A, u),
	        uu = cartesianDot(u, u),
	        t2 = w * w - uu * (cartesianDot(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = sqrt(t2),
	        q = cartesianScale(u, (-w - t) / uu);
	    cartesianAddInPlace(q, A);
	    q = spherical(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = abs(delta - pi) < epsilon,
	        meridian = polar || delta < epsilon;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian
	        ? polar
	          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon ? phi0 : phi1)
	          : phi0 <= q[1] && q[1] <= phi1
	        : delta > pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = cartesianScale(u, (-w + t) / uu);
	      cartesianAddInPlace(q1, A);
	      return [q, spherical(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : pi - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi, radius - pi]);
	};
	
	var transform = function(methods) {
	  return {
	    stream: transformer(methods)
	  };
	};
	
	function transformer(methods) {
	  return function(stream) {
	    var s = new TransformStream;
	    for (var key in methods) s[key] = methods[key];
	    s.stream = stream;
	    return s;
	  };
	}
	
	function TransformStream() {}
	
	TransformStream.prototype = {
	  constructor: TransformStream,
	  point: function(x, y) { this.stream.point(x, y); },
	  sphere: function() { this.stream.sphere(); },
	  lineStart: function() { this.stream.lineStart(); },
	  lineEnd: function() { this.stream.lineEnd(); },
	  polygonStart: function() { this.stream.polygonStart(); },
	  polygonEnd: function() { this.stream.polygonEnd(); }
	};
	
	function fitExtent(projection, extent, object) {
	  var w = extent[1][0] - extent[0][0],
	      h = extent[1][1] - extent[0][1],
	      clip = projection.clipExtent && projection.clipExtent();
	
	  projection
	      .scale(150)
	      .translate([0, 0]);
	
	  if (clip != null) projection.clipExtent(null);
	
	  geoStream(object, projection.stream(boundsStream$1));
	
	  var b = boundsStream$1.result(),
	      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	
	  if (clip != null) projection.clipExtent(clip);
	
	  return projection
	      .scale(k * 150)
	      .translate([x, y]);
	}
	
	function fitSize(projection, size, object) {
	  return fitExtent(projection, [[0, 0], size], object);
	}
	
	var maxDepth = 16;
	var cosMinDistance = cos(30 * radians); // cos(minimum angular distance)
	
	var resample = function(project, delta2) {
	  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
	};
	
	function resampleNone(project) {
	  return transformer({
	    point: function(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample$1(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = sqrt(a * a + b * b + c * c),
	          phi2 = asin(c /= m),
	          lambda2 = abs(abs(c) - 1) < epsilon || abs(lambda0 - lambda1) < epsilon ? (lambda0 + lambda1) / 2 : atan2(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function(stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	        lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
	      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = cartesian([lambda, phi]), p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}
	
	var transformRadians = transformer({
	  point: function(x, y) {
	    this.stream.point(x * radians, y * radians);
	  }
	});
	
	function projection(project) {
	  return projectionMutator(function() { return project; })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150, // scale
	      x = 480, y = 250, // translate
	      dx, dy, lambda = 0, phi = 0, // center
	      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
	      theta = null, preclip = clipAntimeridian, // clip angle
	      x0 = null, y0, x1, y1, postclip = identity, // clip extent
	      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    point = projectRotate(point[0] * radians, point[1] * radians);
	    return [point[0] * k + dx, dy - point[1] * k];
	  }
	
	  function invert(point) {
	    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
	    return point && [point[0] * degrees, point[1] * degrees];
	  }
	
	  function projectTransform(x, y) {
	    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
	  }
	
	  projection.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
	  };
	
	  projection.clipAngle = function(_) {
	    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
	  };
	
	  projection.clipExtent = function(_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function(_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function(_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function(_) {
	    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
	  };
	
	  projection.rotate = function(_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
	  };
	
	  projection.precision = function(_) {
	    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
	  };
	
	  projection.fitExtent = function(extent, object) {
	    return fitExtent(projection, extent, object);
	  };
	
	  projection.fitSize = function(size, object) {
	    return fitSize(projection, size, object);
	  };
	
	  function recenter() {
	    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
	    var center = project(lambda, phi);
	    dx = x - center[0] * k;
	    dy = y + center[1] * k;
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function() {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = pi / 3,
	      m = projectionMutator(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function(_) {
	    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees, phi1 * degrees];
	  };
	
	  return p;
	}
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = sin(y0), n = (sy0 + sin(y1)) / 2;
	
	  // Are the parallels symmetrical around the Equator?
	  if (abs(n) < epsilon) return cylindricalEqualAreaRaw(y0);
	
	  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;
	
	  function project(x, y) {
	    var r = sqrt(c - 2 * n * sin(y)) / n;
	    return [r * sin(x *= n), r0 - r * cos(x)];
	  }
	
	  project.invert = function(x, y) {
	    var r0y = r0 - y;
	    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}
	
	var conicEqualArea = function() {
	  return conicProjection(conicEqualAreaRaw)
	      .scale(155.424)
	      .center([0, 33.6442]);
	};
	
	var albers = function() {
	  return conicEqualArea()
	      .parallels([29.5, 45.5])
	      .scale(1070)
	      .translate([480, 250])
	      .rotate([96, 0])
	      .center([-0.6, 38.7]);
	};
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
	    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
	    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
	    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
	    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
	    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
	var albersUsa = function() {
	  var cache,
	      cacheStream,
	      lower48 = albers(), lower48Point,
	      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
	      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
	      point, pointStream = {point: function(x, y) { point = [x, y]; }};
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0], y = coordinates[1];
	    return point = null,
	        (lower48Point.point(x, y), point)
	        || (alaskaPoint.point(x, y), point)
	        || (hawaiiPoint.point(x, y), point);
	  }
	
	  albersUsa.invert = function(coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
	        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
	        : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function(_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function(_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function(_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(), x = +_[0], y = +_[1];
	
	    lower48Point = lower48
	        .translate(_)
	        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
	        .stream(pointStream);
	
	    alaskaPoint = alaska
	        .translate([x - 0.307 * k, y + 0.201 * k])
	        .clipExtent([[x - 0.425 * k + epsilon, y + 0.120 * k + epsilon], [x - 0.214 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    hawaiiPoint = hawaii
	        .translate([x - 0.205 * k, y + 0.212 * k])
	        .clipExtent([[x - 0.214 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.115 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = function(extent, object) {
	    return fitExtent(albersUsa, extent, object);
	  };
	
	  albersUsa.fitSize = function(size, object) {
	    return fitSize(albersUsa, size, object);
	  };
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	};
	
	function azimuthalRaw(scale) {
	  return function(x, y) {
	    var cx = cos(x),
	        cy = cos(y),
	        k = scale(cx * cy);
	    return [
	      k * cy * sin(x),
	      k * sin(y)
	    ];
	  }
	}
	
	function azimuthalInvert(angle) {
	  return function(x, y) {
	    var z = sqrt(x * x + y * y),
	        c = angle(z),
	        sc = sin(c),
	        cc = cos(c);
	    return [
	      atan2(x * sc, z * cc),
	      asin(z && y * sc / z)
	    ];
	  }
	}
	
	var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
	  return sqrt(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
	  return 2 * asin(z / 2);
	});
	
	var azimuthalEqualArea = function() {
	  return projection(azimuthalEqualAreaRaw)
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	};
	
	var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
	  return (c = acos(c)) && c / sin(c);
	});
	
	azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
	  return z;
	});
	
	var azimuthalEquidistant = function() {
	  return projection(azimuthalEquidistantRaw)
	      .scale(79.4188)
	      .clipAngle(180 - 1e-3);
	};
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, log(tan((halfPi + phi) / 2))];
	}
	
	mercatorRaw.invert = function(x, y) {
	  return [x, 2 * atan(exp(y)) - halfPi];
	};
	
	var mercator = function() {
	  return mercatorProjection(mercatorRaw)
	      .scale(961 / tau);
	};
	
	function mercatorProjection(project) {
	  var m = projection(project),
	      center = m.center,
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      x0 = null, y0, x1, y1; // clip extent
	
	  m.scale = function(_) {
	    return arguments.length ? (scale(_), reclip()) : scale();
	  };
	
	  m.translate = function(_) {
	    return arguments.length ? (translate(_), reclip()) : translate();
	  };
	
	  m.center = function(_) {
	    return arguments.length ? (center(_), reclip()) : center();
	  };
	
	  m.clipExtent = function(_) {
	    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  function reclip() {
	    var k = pi * scale(),
	        t = m(rotation(m.rotate()).invert([0, 0]));
	    return clipExtent(x0 == null
	        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
	        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
	        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
	  }
	
	  return reclip();
	}
	
	function tany(y) {
	  return tan((halfPi + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : log(cy0 / cos(y1)) / log(tany(y1) / tany(y0)),
	      f = cy0 * pow(tany(y0), n) / n;
	
	  if (!n) return mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) { if (y < -halfPi + epsilon) y = -halfPi + epsilon; }
	    else { if (y > halfPi - epsilon) y = halfPi - epsilon; }
	    var r = f / pow(tany(y), n);
	    return [r * sin(n * x), f - r * cos(n * x)];
	  }
	
	  project.invert = function(x, y) {
	    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
	    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi];
	  };
	
	  return project;
	}
	
	var conicConformal = function() {
	  return conicProjection(conicConformalRaw)
	      .scale(109.5)
	      .parallels([30, 30]);
	};
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;
	
	var equirectangular = function() {
	  return projection(equirectangularRaw)
	      .scale(152.63);
	};
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : (cy0 - cos(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if (abs(n) < epsilon) return equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y, nx = n * x;
	    return [gy * sin(nx), g - gy * cos(nx)];
	  }
	
	  project.invert = function(x, y) {
	    var gy = g - y;
	    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
	  };
	
	  return project;
	}
	
	var conicEquidistant = function() {
	  return conicProjection(conicEquidistantRaw)
	      .scale(131.154)
	      .center([0, 13.9389]);
	};
	
	function gnomonicRaw(x, y) {
	  var cy = cos(y), k = cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	gnomonicRaw.invert = azimuthalInvert(atan);
	
	var gnomonic = function() {
	  return projection(gnomonicRaw)
	      .scale(144.049)
	      .clipAngle(60);
	};
	
	function scaleTranslate(kx, ky, tx, ty) {
	  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity : transformer({
	    point: function(x, y) {
	      this.stream.point(x * kx + tx, y * ky + ty);
	    }
	  });
	}
	
	var identity$1 = function() {
	  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = identity, // scale, translate and reflect
	      x0 = null, y0, x1, y1, clip = identity, // clip extent
	      cache,
	      cacheStream,
	      projection;
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return projection = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
	    },
	    clipExtent: function(_) {
	      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	    },
	    scale: function(_) {
	      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
	    },
	    translate: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
	    },
	    reflectX: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
	    },
	    reflectY: function(_) {
	      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
	    },
	    fitExtent: function(extent, object) {
	      return fitExtent(projection, extent, object);
	    },
	    fitSize: function(size, object) {
	      return fitSize(projection, size, object);
	    }
	  };
	};
	
	function orthographicRaw(x, y) {
	  return [cos(y) * sin(x), sin(y)];
	}
	
	orthographicRaw.invert = azimuthalInvert(asin);
	
	var orthographic = function() {
	  return projection(orthographicRaw)
	      .scale(249.5)
	      .clipAngle(90 + epsilon);
	};
	
	function stereographicRaw(x, y) {
	  var cy = cos(y), k = 1 + cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	stereographicRaw.invert = azimuthalInvert(function(z) {
	  return 2 * atan(z);
	});
	
	var stereographic = function() {
	  return projection(stereographicRaw)
	      .scale(250)
	      .clipAngle(142);
	};
	
	function transverseMercatorRaw(lambda, phi) {
	  return [log(tan((halfPi + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function(x, y) {
	  return [-y, 2 * atan(exp(x)) - halfPi];
	};
	
	var transverseMercator = function() {
	  var m = mercatorProjection(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function(_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function(_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90])
	      .scale(159.155);
	};
	
	exports.geoArea = area;
	exports.geoBounds = bounds;
	exports.geoCentroid = centroid;
	exports.geoCircle = circle;
	exports.geoClipExtent = extent;
	exports.geoContains = contains;
	exports.geoDistance = distance;
	exports.geoGraticule = graticule;
	exports.geoGraticule10 = graticule10;
	exports.geoInterpolate = interpolate;
	exports.geoLength = length;
	exports.geoPath = index;
	exports.geoAlbers = albers;
	exports.geoAlbersUsa = albersUsa;
	exports.geoAzimuthalEqualArea = azimuthalEqualArea;
	exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
	exports.geoAzimuthalEquidistant = azimuthalEquidistant;
	exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
	exports.geoConicConformal = conicConformal;
	exports.geoConicConformalRaw = conicConformalRaw;
	exports.geoConicEqualArea = conicEqualArea;
	exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
	exports.geoConicEquidistant = conicEquidistant;
	exports.geoConicEquidistantRaw = conicEquidistantRaw;
	exports.geoEquirectangular = equirectangular;
	exports.geoEquirectangularRaw = equirectangularRaw;
	exports.geoGnomonic = gnomonic;
	exports.geoGnomonicRaw = gnomonicRaw;
	exports.geoIdentity = identity$1;
	exports.geoProjection = projection;
	exports.geoProjectionMutator = projectionMutator;
	exports.geoMercator = mercator;
	exports.geoMercatorRaw = mercatorRaw;
	exports.geoOrthographic = orthographic;
	exports.geoOrthographicRaw = orthographicRaw;
	exports.geoStereographic = stereographic;
	exports.geoStereographicRaw = stereographicRaw;
	exports.geoTransverseMercator = transverseMercator;
	exports.geoTransverseMercatorRaw = transverseMercatorRaw;
	exports.geoRotation = rotation;
	exports.geoStream = geoStream;
	exports.geoTransform = transform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSpriteSymbol = factory());
	}(this, (function () { 'use strict';
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var deepmerge = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = deepmerge(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	return BrowserSpriteSymbol;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSprite = factory());
	}(this, (function () { 'use strict';
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var deepmerge = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	//      
	// An event handler can take an optional event argument
	// and should not return a value
	                                          
	// An array of all currently registered event handlers for a type
	                                            
	// A map of event types and their corresponding event handlers.
	                        
	                                   
	  
	
	/** Mitt: Tiny (~200b) functional event emitter / pubsub.
	 *  @name mitt
	 *  @returns {Mitt}
	 */
	function mitt(all                 ) {
		all = all || Object.create(null);
	
		return {
			/**
			 * Register an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to listen for, or `"*"` for all events
			 * @param  {Function} handler Function to call in response to given event
			 * @memberOf mitt
			 */
			on: function on(type        , handler              ) {
				(all[type] || (all[type] = [])).push(handler);
			},
	
			/**
			 * Remove an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
			 * @param  {Function} handler Handler function to remove
			 * @memberOf mitt
			 */
			off: function off(type        , handler              ) {
				if (all[type]) {
					all[type].splice(all[type].indexOf(handler) >>> 0, 1);
				}
			},
	
			/**
			 * Invoke all handlers for the given type.
			 * If present, `"*"` handlers are invoked after type-matched handlers.
			 *
			 * @param {String} type  The event type to invoke
			 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
			 * @memberof mitt
			 */
			emit: function emit(type        , evt     ) {
				(all[type] || []).map(function (handler) { handler(evt); });
				(all['*'] || []).map(function (handler) { handler(type, evt); });
			}
		};
	}
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = deepmerge(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var svg$1 = namespaces_1.svg;
	var xlink$1 = namespaces_1.xlink;
	
	var defaultConfig = {
	  attrs: ( obj = {
	    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
	  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
	};
	var obj;
	
	var Sprite = function Sprite(config) {
	  this.config = deepmerge(defaultConfig, config || {});
	  this.symbols = [];
	};
	
	/**
	 * Add new symbol. If symbol with the same id exists it will be replaced.
	 * @param {SpriteSymbol} symbol
	 * @return {boolean} `true` - symbol was added, `false` - replaced
	 */
	Sprite.prototype.add = function add (symbol) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var existing = this.find(symbol.id);
	
	  if (existing) {
	    symbols[symbols.indexOf(existing)] = symbol;
	    return false;
	  }
	
	  symbols.push(symbol);
	  return true;
	};
	
	/**
	 * Remove symbol & destroy it
	 * @param {string} id
	 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
	 */
	Sprite.prototype.remove = function remove (id) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var symbol = this.find(id);
	
	  if (symbol) {
	    symbols.splice(symbols.indexOf(symbol), 1);
	    symbol.destroy();
	    return true;
	  }
	
	  return false;
	};
	
	/**
	 * @param {string} id
	 * @return {SpriteSymbol|null}
	 */
	Sprite.prototype.find = function find (id) {
	  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
	};
	
	/**
	 * @param {string} id
	 * @return {boolean}
	 */
	Sprite.prototype.has = function has (id) {
	  return this.find(id) !== null;
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.stringify = function stringify () {
	  var ref = this.config;
	    var attrs = ref.attrs;
	  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
	  return wrapInSvgString(stringifiedSymbols, attrs);
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	Sprite.prototype.destroy = function destroy () {
	  this.symbols.forEach(function (s) { return s.destroy(); });
	};
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	var defaultConfig$1 = {
	  /**
	   * Should following options be automatically configured:
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @type {boolean}
	   */
	  autoConfigure: true,
	
	  /**
	   * Default mounting selector
	   * @type {string}
	   */
	  mountTo: 'body',
	
	  /**
	   * Fix disappearing SVG elements when <base href> exists.
	   * Executes when sprite mounted.
	   * @see http://stackoverflow.com/a/18265336/796152
	   * @see https://github.com/everdimension/angular-svg-base-fix
	   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
	   * @type {boolean}
	   */
	  syncUrlsWithBaseTag: false,
	
	  /**
	   * Should sprite listen custom location change event
	   * @type {boolean}
	   */
	  listenLocationChangeEvent: true,
	
	  /**
	   * Custom window event name which should be emitted to update sprite urls
	   * @type {string}
	   */
	  locationChangeEvent: 'locationChange',
	
	  /**
	   * Emit location change event in Angular automatically
	   * @type {boolean}
	   */
	  locationChangeAngularEmitter: false,
	
	  /**
	   * Selector to find symbols usages when updating sprite urls
	   * @type {string}
	   */
	  usagesToUpdate: 'use[*|href]',
	
	  /**
	   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
	   * Executes when sprite is rendered, but not mounted.
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
	   * @type {boolean}
	   */
	  moveGradientsOutsideSymbol: false
	};
	
	/**
	 * @param {*} arrayLike
	 * @return {Array}
	 */
	var arrayFrom = function (arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	};
	
	var ua = navigator.userAgent;
	
	var browser = {
	  isChrome: /chrome/i.test(ua),
	  isFirefox: /firefox/i.test(ua),
	
	  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
	  isIE: /msie/i.test(ua) || /trident/i.test(ua),
	  isEdge: /edge/i.test(ua)
	};
	
	/**
	 * @param {string} name
	 * @param {*} data
	 */
	var dispatchEvent = function (name, data) {
	  var event = document.createEvent('CustomEvent');
	  event.initCustomEvent(name, false, false, data);
	  window.dispatchEvent(event);
	};
	
	/**
	 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
	 * This trick will trigger IE to read and use any existing SVG <style> tags.
	 * @see https://github.com/iconic/SVGInjector/issues/23
	 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
	 *
	 * @param {Element} node DOM Element to search <style> tags in
	 * @return {Array<HTMLStyleElement>}
	 */
	var evalStylesIEWorkaround = function (node) {
	  var updatedNodes = [];
	
	  arrayFrom(node.querySelectorAll('style'))
	    .forEach(function (style) {
	      style.textContent += '';
	      updatedNodes.push(style);
	    });
	
	  return updatedNodes;
	};
	
	/**
	 * @param {string} [url] If not provided - current URL will be used
	 * @return {string}
	 */
	var getUrlWithoutFragment = function (url) {
	  return (url || window.location.href).split('#')[0];
	};
	
	/* global angular */
	/**
	 * @param {string} eventName
	 */
	var locationChangeAngularEmitter = function (eventName) {
	  angular.module('ng').run(['$rootScope', function ($rootScope) {
	    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
	      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
	    });
	  }]);
	};
	
	var defaultSelector = 'linearGradient, radialGradient, pattern';
	
	/**
	 * @param {Element} svg
	 * @param {string} [selector]
	 * @return {Element}
	 */
	var moveGradientsOutsideSymbol = function (svg, selector) {
	  if ( selector === void 0 ) selector = defaultSelector;
	
	  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
	    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
	      symbol.parentNode.insertBefore(node, symbol);
	    });
	  });
	  return svg;
	};
	
	/**
	 * @param {NodeList} nodes
	 * @param {Function} [matcher]
	 * @return {Attr[]}
	 */
	function selectAttributes(nodes, matcher) {
	  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
	    if (!node.attributes) {
	      return acc;
	    }
	
	    var arrayfied = arrayFrom(node.attributes);
	    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
	    return acc.concat(matched);
	  }, []);
	
	  return attrs;
	}
	
	/**
	 * @param {NodeList|Node} nodes
	 * @param {boolean} [clone=true]
	 * @return {string}
	 */
	
	var xLinkNS = namespaces_1.xlink.uri;
	var xLinkAttrName = 'xlink:href';
	
	// eslint-disable-next-line no-useless-escape
	var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;
	
	function encoder(url) {
	  return url.replace(specialUrlCharsPattern, function (match) {
	    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
	  });
	}
	
	/**
	 * @param {NodeList} nodes
	 * @param {string} startsWith
	 * @param {string} replaceWith
	 * @return {NodeList}
	 */
	function updateReferences(nodes, startsWith, replaceWith) {
	  arrayFrom(nodes).forEach(function (node) {
	    var href = node.getAttribute(xLinkAttrName);
	    if (href && href.indexOf(startsWith) === 0) {
	      var newUrl = href.replace(startsWith, replaceWith);
	      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
	    }
	  });
	
	  return nodes;
	}
	
	/**
	 * List of SVG attributes to update url() target in them
	 */
	var attList = [
	  'clipPath',
	  'colorProfile',
	  'src',
	  'cursor',
	  'fill',
	  'filter',
	  'marker',
	  'markerStart',
	  'markerMid',
	  'markerEnd',
	  'mask',
	  'stroke',
	  'style'
	];
	
	var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');
	
	/**
	 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
	 * @param {Element} svg
	 * @param {NodeList} references
	 * @param {string|RegExp} startsWith
	 * @param {string} replaceWith
	 * @return {void}
	 *
	 * @example
	 * const sprite = document.querySelector('svg.sprite');
	 * const usages = document.querySelectorAll('use');
	 * updateUrls(sprite, usages, '#', 'prefix#');
	 */
	var updateUrls = function (svg, references, startsWith, replaceWith) {
	  var startsWithEncoded = encoder(startsWith);
	  var replaceWithEncoded = encoder(replaceWith);
	
	  var nodes = svg.querySelectorAll(attSelector);
	  var attrs = selectAttributes(nodes, function (ref) {
	    var localName = ref.localName;
	    var value = ref.value;
	
	    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
	  });
	
	  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
	  updateReferences(references, startsWithEncoded, replaceWithEncoded);
	};
	
	/**
	 * Internal emitter events
	 * @enum
	 * @private
	 */
	var Events = {
	  MOUNT: 'mount',
	  SYMBOL_MOUNT: 'symbol_mount'
	};
	
	var BrowserSprite = (function (Sprite$$1) {
	  function BrowserSprite(cfg) {
	    var this$1 = this;
	    if ( cfg === void 0 ) cfg = {};
	
	    Sprite$$1.call(this, deepmerge(defaultConfig$1, cfg));
	
	    var emitter = mitt();
	    this._emitter = emitter;
	    this.node = null;
	
	    var ref = this;
	    var config = ref.config;
	
	    if (config.autoConfigure) {
	      this._autoConfigure(cfg);
	    }
	
	    if (config.syncUrlsWithBaseTag) {
	      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
	      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
	    }
	
	    var handleLocationChange = this._handleLocationChange.bind(this);
	    this._handleLocationChange = handleLocationChange;
	
	    // Provide way to update sprite urls externally via dispatching custom window event
	    if (config.listenLocationChangeEvent) {
	      window.addEventListener(config.locationChangeEvent, handleLocationChange);
	    }
	
	    // Emit location change event in Angular automatically
	    if (config.locationChangeAngularEmitter) {
	      locationChangeAngularEmitter(config.locationChangeEvent);
	    }
	
	    // After sprite mounted
	    emitter.on(Events.MOUNT, function (spriteNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(spriteNode);
	      }
	    });
	
	    // After symbol mounted into sprite
	    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(symbolNode.parentNode);
	      }
	
	      if (browser.isIE || browser.isEdge) {
	        evalStylesIEWorkaround(symbolNode);
	      }
	    });
	  }
	
	  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
	  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
	  BrowserSprite.prototype.constructor = BrowserSprite;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  /**
	   * @return {boolean}
	   */
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * Automatically configure following options
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @param {Object} cfg
	   * @private
	   */
	  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
	    var ref = this;
	    var config = ref.config;
	
	    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
	      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
	    }
	
	    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
	      config.locationChangeAngularEmitter = 'angular' in window;
	    }
	
	    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
	      config.moveGradientsOutsideSymbol = browser.isFirefox;
	    }
	  };
	
	  /**
	   * @param {Event} event
	   * @param {Object} event.detail
	   * @param {string} event.detail.oldUrl
	   * @param {string} event.detail.newUrl
	   * @private
	   */
	  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
	    var ref = event.detail;
	    var oldUrl = ref.oldUrl;
	    var newUrl = ref.newUrl;
	    this.updateUrls(oldUrl, newUrl);
	  };
	
	  /**
	   * Add new symbol. If symbol with the same id exists it will be replaced.
	   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
	   * @fires Events#SYMBOL_MOUNT
	   * @param {BrowserSpriteSymbol} symbol
	   * @return {boolean} `true` - symbol was added, `false` - replaced
	   */
	  BrowserSprite.prototype.add = function add (symbol) {
	    var sprite = this;
	    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);
	
	    if (this.isMounted && isNewSymbol) {
	      symbol.mount(sprite.node);
	      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    }
	
	    return isNewSymbol;
	  };
	
	  /**
	   * Attach to existing DOM node
	   * @param {string|Element} target
	   * @return {Element|null} attached DOM Element. null if node to attach not found.
	   */
	  BrowserSprite.prototype.attach = function attach (target) {
	    var this$1 = this;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    /** @type Element */
	    var node = typeof target === 'string' ? document.querySelector(target) : target;
	    sprite.node = node;
	
	    // Already added symbols needs to be mounted
	    this.symbols.forEach(function (symbol) {
	      symbol.mount(sprite.node);
	      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    });
	
	    // Create symbols from existing DOM nodes, add and mount them
	    arrayFrom(node.querySelectorAll('symbol'))
	      .forEach(function (symbolNode) {
	        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
	        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
	        sprite.add(symbol);
	      });
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  BrowserSprite.prototype.destroy = function destroy () {
	    var ref = this;
	    var config = ref.config;
	    var symbols = ref.symbols;
	    var _emitter = ref._emitter;
	
	    symbols.forEach(function (s) { return s.destroy(); });
	
	    _emitter.off('*');
	    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);
	
	    if (this.isMounted) {
	      this.unmount();
	    }
	  };
	
	  /**
	   * @fires Events#MOUNT
	   * @param {string|Element} [target]
	   * @param {boolean} [prepend=false]
	   * @return {Element|null} rendered sprite node. null if mount node not found.
	   */
	  BrowserSprite.prototype.mount = function mount (target, prepend) {
	    if ( target === void 0 ) target = this.config.mountTo;
	    if ( prepend === void 0 ) prepend = false;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = sprite.render();
	    this.node = node;
	
	    if (prepend && mountNode.childNodes[0]) {
	      mountNode.insertBefore(node, mountNode.childNodes[0]);
	    } else {
	      mountNode.appendChild(node);
	    }
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSprite.prototype.render = function render () {
	    return parse(this.stringify());
	  };
	
	  /**
	   * Detach sprite from the DOM
	   */
	  BrowserSprite.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  /**
	   * Update URLs in sprite and usage elements
	   * @param {string} oldUrl
	   * @param {string} newUrl
	   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
	   */
	  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
	    if (!this.isMounted) {
	      return false;
	    }
	
	    var usages = document.querySelectorAll(this.config.usagesToUpdate);
	
	    updateUrls(
	      this.node,
	      usages,
	      ((getUrlWithoutFragment(oldUrl)) + "#"),
	      ((getUrlWithoutFragment(newUrl)) + "#")
	    );
	
	    return true;
	  };
	
	  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );
	
	  return BrowserSprite;
	}(Sprite));
	
	var ready$1 = createCommonjsModule(function (module) {
	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  { module.exports = definition(); }
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);
	
	
	  if (!loaded)
	  { doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener);
	    loaded = 1;
	    while (listener = fns.shift()) { listener(); }
	  }); }
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn);
	  }
	
	});
	});
	
	var spriteNodeId = '__SVG_SPRITE_NODE__';
	var spriteGlobalVarName = '__SVG_SPRITE__';
	var isSpriteExists = !!window[spriteGlobalVarName];
	
	// eslint-disable-next-line import/no-mutable-exports
	var sprite;
	
	if (isSpriteExists) {
	  sprite = window[spriteGlobalVarName];
	} else {
	  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
	  window[spriteGlobalVarName] = sprite;
	}
	
	var loadSprite = function () {
	  /**
	   * Check for page already contains sprite node
	   * If found - attach to and reuse it's content
	   * If not - render and mount the new sprite
	   */
	  var existing = document.getElementById(spriteNodeId);
	
	  if (existing) {
	    sprite.attach(existing);
	  } else {
	    sprite.mount(document.body, true);
	  }
	};
	
	if (document.body) {
	  loadSprite();
	} else {
	  ready$1(loadSprite);
	}
	
	var sprite$1 = sprite;
	
	return sprite$1;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: ", "rem;\n  height: ", "rem;\n  fill: ", ";\n"], ["\n  width: ", "rem;\n  height: ", "rem;\n  fill: ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var IconSVG = _styledComponents2.default.svg(_templateObject, function (props) {
	  return props.size;
	}, function (props) {
	  return props.size;
	}, function (props) {
	  return props.color || _baseStyles2.default.color.lightGray;
	});
	
	var Icon = function Icon(_ref) {
	  var iconRef = _ref.iconRef,
	      size = _ref.size,
	      color = _ref.color,
	      props = _objectWithoutProperties(_ref, ["iconRef", "size", "color"]);
	
	  return _react2.default.createElement(
	    IconSVG,
	    _extends({ size: size, color: color }, props),
	    _react2.default.createElement("use", { xlinkHref: "#" + iconRef.id })
	  );
	};
	
	exports.default = Icon;
	module.exports = exports["default"];

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = alphabetical
	
	/* Check if the given character code, or the character
	 * code at the first character, is alphabetical. */
	function alphabetical(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 && code <= 122) /* a-z */ ||
	    (code >= 65 && code <= 90) /* A-Z */
	  )
	}


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  position: true,
	  gfm: true,
	  commonmark: false,
	  footnotes: false,
	  pedantic: false,
	  blocks: __webpack_require__(76)
	};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var link = value.indexOf('[', fromIndex);
	  var image = value.indexOf('![', fromIndex);
	
	  if (image === -1) {
	    return link;
	  }
	
	  /* Link can never be `-1` if an image is found, so we don’t need
	   * to check for that :) */
	  return link < image ? link : image;
	}


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('<', fromIndex);
	}


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = indentation;
	
	/* Map of characters, and their column length,
	 * which can be used as indentation. */
	var characters = {' ': 1, '\t': 4};
	
	/* Gets indentation information for a line. */
	function indentation(value) {
	  var index = 0;
	  var indent = 0;
	  var character = value.charAt(index);
	  var stops = {};
	  var size;
	
	  while (character in characters) {
	    size = characters[character];
	
	    indent += size;
	
	    if (size > 1) {
	      indent = Math.floor(indent / size) * size;
	    }
	
	    stops[indent] = index;
	
	    character = value.charAt(++index);
	  }
	
	  return {indent: indent, stops: stops};
	}


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
	var unquoted = '[^"\'=<>`\\u0000-\\u0020]+';
	var singleQuoted = '\'[^\']*\'';
	var doubleQuoted = '"[^"]*"';
	var attributeValue = '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')';
	var attribute = '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)';
	var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>';
	var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
	var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
	var processing = '<[?].*?[?]>';
	var declaration = '<![A-Za-z]+\\s+[^>]*>';
	var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
	
	exports.openCloseTag = new RegExp('^(?:' + openTag + '|' + closeTag + ')');
	
	exports.tag = new RegExp('^(?:' +
	  openTag + '|' +
	  closeTag + '|' +
	  comment + '|' +
	  processing + '|' +
	  declaration + '|' +
	  cdata +
	')');


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Img = __webpack_require__(65);
	
	var _Img2 = _interopRequireDefault(_Img);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	if (typeof window !== 'undefined') {
	  __webpack_require__(67);
	}
	
	// Cache if we've intersected an image before so we don't
	// lazy-load & fade in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(_ref, shouldCache) {
	  var handle = _ref.handle;
	
	  if (imageCache[handle]) {
	    return true;
	  }
	  if (shouldCache) {
	    imageCache[handle] = true;
	  }
	  return false;
	};
	
	// check webp support
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== 'undefined' ? window.document.createElement('canvas') : {};
	  if (elem.getContext && elem.getContext('2d')) {
	    isWebpSupportedCache = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
	    return isWebpSupportedCache;
	  }
	  return false;
	};
	
	// Add IntersectionObserver to component
	var listeners = [];
	var io = void 0;
	var getIO = function getIO() {
	  if (typeof io === 'undefined' && typeof window !== 'undefined') {
	    io = new IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (listener) {
	          if (listener[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              // when we intersect we cache the intersecting image for subsequent mounts
	              io.unobserve(listener[0]);
	              listener[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: '200px' });
	  }
	
	  return io;
	};
	var listenToIntersections = function listenToIntersections(element, callback) {
	  getIO().observe(element);
	  listeners.push([element, callback]);
	};
	
	var bgColor = function bgColor(backgroundColor) {
	  return typeof backgroundColor === 'boolean' ? 'lightgray' : backgroundColor;
	};
	
	// We always keep the resize transform to have matching sizes + aspect ratio
	// If used with native height & width from GraphCMS it produces no transform
	var resizeImage = function resizeImage(_ref2) {
	  var width = _ref2.width,
	      height = _ref2.height,
	      fit = _ref2.fit;
	  return 'resize=w:' + String(width) + ',h:' + String(height) + ',fit:' + String(fit);
	};
	
	var compressAndWebp = function compressAndWebp(webp) {
	  return (webp ? 'output=format:webp/' : '') + 'compress';
	};
	
	var constructURL = function constructURL(handle, withWebp, baseURI) {
	  return function (resize) {
	    return function (transforms) {
	      return [baseURI, resize].concat(_toConsumableArray(transforms), [compressAndWebp(isWebpSupported() && withWebp), handle]).join('/');
	    };
	  };
	};
	
	// responsiveness transforms
	var responsiveSizes = function responsiveSizes(size) {
	  return [size / 4, size / 2, size, size * 1.5, size * 2, size * 3];
	};
	
	var getWidths = function getWidths(width, maxWidth) {
	  var sizes = responsiveSizes(maxWidth).filter(function (size) {
	    return size < width;
	  });
	  // Add the original width to ensure the largest image possible
	  // is available for small images.
	  var finalSizes = [].concat(_toConsumableArray(sizes), [width]);
	  return finalSizes;
	};
	
	var srcSet = function srcSet(srcBase, srcWidths, fit, transforms) {
	  return srcWidths.map(function (width) {
	    return String(srcBase(['resize=w:' + String(Math.floor(width)) + ',fit:' + String(fit)])(transforms)) + ' ' + String(Math.floor(width)) + 'w';
	  }).join(',\n');
	};
	
	var imgSizes = function imgSizes(maxWidth) {
	  return '(max-width: ' + String(maxWidth) + 'px) 100vw, ' + String(maxWidth) + 'px';
	};
	
	var GraphImage = function (_React$Component) {
	  _inherits(GraphImage, _React$Component);
	
	  function GraphImage(props) {
	    _classCallCheck(this, GraphImage);
	
	    var _this = _possibleConstructorReturn(this, (GraphImage.__proto__ || Object.getPrototypeOf(GraphImage)).call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== 'undefined' && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Never render image while server rendering
	    if (typeof window === 'undefined') {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    _this.onImageLoaded = _this.onImageLoaded.bind(_this);
	    return _this;
	  }
	
	  _createClass(GraphImage, [{
	    key: 'onImageLoaded',
	    value: function () {
	      function onImageLoaded() {
	        var _this2 = this;
	
	        if (this.state.IOSupported) {
	          this.setState(function () {
	            return {
	              imgLoaded: true
	            };
	          }, function () {
	            inImageCache(_this2.props.image, true);
	          });
	        }
	        if (this.props.onLoad) {
	          this.props.onLoad();
	        }
	      }
	
	      return onImageLoaded;
	    }()
	  }, {
	    key: 'handleRef',
	    value: function () {
	      function handleRef(ref) {
	        var _this3 = this;
	
	        if (this.state.IOSupported && ref) {
	          listenToIntersections(ref, function () {
	            _this3.setState({ isVisible: true, imgLoaded: false });
	          });
	        }
	      }
	
	      return handleRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props = this.props,
	            title = _props.title,
	            alt = _props.alt,
	            className = _props.className,
	            outerWrapperClassName = _props.outerWrapperClassName,
	            style = _props.style,
	            _props$image = _props.image,
	            width = _props$image.width,
	            height = _props$image.height,
	            handle = _props$image.handle,
	            fit = _props.fit,
	            maxWidth = _props.maxWidth,
	            withWebp = _props.withWebp,
	            transforms = _props.transforms,
	            blurryPlaceholder = _props.blurryPlaceholder,
	            backgroundColor = _props.backgroundColor,
	            fadeIn = _props.fadeIn,
	            baseURI = _props.baseURI;
	
	
	        if (width && height && handle) {
	          // unify after webp + blur resolved
	          var srcBase = constructURL(handle, withWebp, baseURI);
	          var thumbBase = constructURL(handle, false, baseURI);
	
	          // construct the final image url
	          var sizedSrc = srcBase(resizeImage({ width: width, height: height, fit: fit }));
	          var finalSrc = sizedSrc(transforms);
	
	          // construct blurry placeholder url
	          var thumbSize = { width: 20, height: 20, fit: 'crop' };
	          var thumbSrc = thumbBase(resizeImage(thumbSize))(['blur=amount:2']);
	
	          // construct srcSet if maxWidth provided
	          var srcSetImgs = srcSet(srcBase, getWidths(width, maxWidth), fit, transforms);
	          var sizes = imgSizes(maxWidth);
	
	          // The outer div is necessary to reset the z-index to 0.
	          return _react2['default'].createElement(
	            'div',
	            {
	              className: String(outerWrapperClassName) + ' graphcms-image-outer-wrapper',
	              style: {
	                zIndex: 0,
	                // Let users set component to be absolutely positioned.
	                position: style.position === 'absolute' ? 'initial' : 'relative'
	              }
	            },
	            _react2['default'].createElement(
	              'div',
	              {
	                className: String(className) + ' graphcms-image-wrapper',
	                style: Object.assign({
	                  position: 'relative',
	                  overflow: 'hidden',
	                  zIndex: 1
	                }, style),
	                ref: this.handleRef
	              },
	              _react2['default'].createElement('div', {
	                style: {
	                  width: '100%',
	                  paddingBottom: 100 / (width / height) + '%'
	                }
	              }),
	              blurryPlaceholder && _react2['default'].createElement(_Img2['default'], {
	                alt: alt,
	                title: title,
	                src: thumbSrc,
	                opacity: this.state.imgLoaded ? 0 : 1,
	                transitionDelay: '0.25s'
	              }),
	              backgroundColor && _react2['default'].createElement('div', {
	                title: title,
	                style: {
	                  backgroundColor: bgColor(backgroundColor),
	                  position: 'absolute',
	                  top: 0,
	                  bottom: 0,
	                  opacity: this.state.imgLoaded ? 0 : 1,
	                  transitionDelay: '0.25s',
	                  right: 0,
	                  left: 0
	                }
	              }),
	              this.state.isVisible && _react2['default'].createElement(_Img2['default'], {
	                alt: alt,
	                title: title,
	                srcSet: srcSetImgs,
	                src: finalSrc,
	                sizes: sizes,
	                opacity: this.state.imgLoaded || !fadeIn ? 1 : 0,
	                onLoad: this.onImageLoaded
	              })
	            )
	          );
	        }
	
	        return null;
	      }
	
	      return render;
	    }()
	  }]);
	
	  return GraphImage;
	}(_react2['default'].Component);
	
	GraphImage.defaultProps = {
	  title: '',
	  alt: '',
	  className: '',
	  outerWrapperClassName: '',
	  style: {},
	  fit: 'crop',
	  maxWidth: 800,
	  withWebp: true,
	  transforms: [],
	  blurryPlaceholder: true,
	  backgroundColor: '',
	  fadeIn: true,
	  onLoad: null,
	  baseURI: 'https://media.graphcms.com'
	};
	
	GraphImage.propTypes = {
	  title: _propTypes2['default'].string,
	  alt: _propTypes2['default'].string,
	  // Support Glamor's css prop for classname
	  className: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  outerWrapperClassName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  style: _propTypes2['default'].object,
	  image: _propTypes2['default'].shape({
	    handle: _propTypes2['default'].string,
	    height: _propTypes2['default'].number,
	    width: _propTypes2['default'].number
	  }).isRequired,
	  fit: _propTypes2['default'].oneOf(['clip', 'crop', 'scale', 'max']),
	  maxWidth: _propTypes2['default'].number,
	  withWebp: _propTypes2['default'].bool,
	  transforms: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  onLoad: _propTypes2['default'].func,
	  blurryPlaceholder: _propTypes2['default'].bool,
	  backgroundColor: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].bool]),
	  fadeIn: _propTypes2['default'].bool,
	  baseURI: _propTypes2['default'].string
	};
	
	exports['default'] = GraphImage;

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return globalLocale;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	        else {
	            if ((typeof console !==  'undefined') && console.warn) {
	                //warn user if arguments are passed but the locale could not be set
	                console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	            }
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var locale, parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                locale = loadLocale(config.parentLocale);
	                if (locale != null) {
	                    parentConfig = locale._config;
	                } else {
	                    if (!localeFamilies[config.parentLocale]) {
	                        localeFamilies[config.parentLocale] = [];
	                    }
	                    localeFamilies[config.parentLocale].push({
	                        name: name,
	                        config: config
	                    });
	                    return null;
	                }
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true;
	    var m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	        }
	    }
	    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	proto.quarter = proto.quarters = getSetQuarter;
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	proto.hour = proto.hours = getSetHour;
	proto.minute = proto.minutes = getSetMinute;
	proto.second = proto.seconds = getSetSecond;
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.21.0';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	// currently HTML5 input type only supports 24-hour formats
	hooks.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD',                             // <input type="date" />
	    TIME: 'HH:mm',                                  // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	    MONTH: 'YYYY-MM'                                // <input type="month" />
	};
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)(module)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ReactDOM = __webpack_require__(31);
	var ReactDOM__default = _interopDefault(ReactDOM);
	
	function warnOnce(msg) {
	  var hasWarned = false;
	  return function () {
	    if (!hasWarned) {
	      console.warn(msg);
	      hasWarned = true;
	    }
	  };
	}
	
	
	var statelessFunctionalComponentSupplied = warnOnce('\n>> Error, via react-flip-move <<\n\nYou provided a stateless functional component as a child to <FlipMove>. Unfortunately, SFCs aren\'t supported, because Flip Move needs access to the backing instances via refs, and SFCs don\'t have a public instance that holds that info.\n\nPlease wrap your components in a native element (eg. <div>), or a non-functional component.\n');
	
	var primitiveNodeSupplied = warnOnce('\n>> Error, via react-flip-move <<\n\nYou provided a primitive (text or number) node as a child to <FlipMove>. Flip Move needs containers with unique keys to move children around.\n\nPlease wrap your value in a native element (eg. <span>), or a component.\n');
	
	var invalidTypeForTimingProp = function invalidTypeForTimingProp(args
	// prettier-ignore
	) {
	  return console.error('\n>> Error, via react-flip-move <<\n\nThe prop you provided for \'' + args.prop + '\' is invalid. It needs to be a positive integer, or a string that can be resolved to a number. The value you provided is \'' + args.value + '\'.\n\nAs a result,  the default value for this parameter will be used, which is \'' + args.defaultValue + '\'.\n');
	};
	
	var invalidEnterLeavePreset = function invalidEnterLeavePreset(args
	// prettier-ignore
	) {
	  return console.error('\n>> Error, via react-flip-move <<\n\nThe enter/leave preset you provided is invalid. We don\'t currently have a \'' + args.value + ' preset.\'\n\nAcceptable values are ' + args.acceptableValues + '. The default value of \'' + args.defaultValue + '\' will be used.\n');
	};
	
	var parentNodePositionStatic = warnOnce('\n>> Warning, via react-flip-move <<\n\nWhen using "wrapperless" mode (by supplying \'typeName\' of \'null\'), strange things happen when the direct parent has the default "static" position.\n\nFlipMove has added \'position: relative\' to this node, to ensure Flip Move animates correctly.\n\nTo avoid seeing this warning, simply apply a non-static position to that parent node.\n');
	
	var childIsDisabled = warnOnce('\n>> Warning, via react-flip-move <<\n\nOne or more of Flip Move\'s child elements have the html attribute \'disabled\' set to true.\n\nPlease note that this will cause animations to break in Internet Explorer 11 and below. Either remove the disabled attribute or set \'animation\' to false.\n');
	
	var enterPresets = {
	  elevator: {
	    from: { transform: 'scale(0)', opacity: '0' },
	    to: { transform: '', opacity: '' }
	  },
	  fade: {
	    from: { opacity: '0' },
	    to: { opacity: '' }
	  },
	  accordionVertical: {
	    from: { transform: 'scaleY(0)', transformOrigin: 'center top' },
	    to: { transform: '', transformOrigin: 'center top' }
	  },
	  accordionHorizontal: {
	    from: { transform: 'scaleX(0)', transformOrigin: 'left center' },
	    to: { transform: '', transformOrigin: 'left center' }
	  },
	  none: null
	};
	/**
	 * React Flip Move | enterLeavePresets
	 * (c) 2016-present Joshua Comeau
	 *
	 * This contains the master list of presets available for enter/leave animations,
	 * along with the mapping between preset and styles.
	 */
	
	
	var leavePresets = {
	  elevator: {
	    from: { transform: 'scale(1)', opacity: '1' },
	    to: { transform: 'scale(0)', opacity: '0' }
	  },
	  fade: {
	    from: { opacity: '1' },
	    to: { opacity: '0' }
	  },
	  accordionVertical: {
	    from: { transform: 'scaleY(1)', transformOrigin: 'center top' },
	    to: { transform: 'scaleY(0)', transformOrigin: 'center top' }
	  },
	  accordionHorizontal: {
	    from: { transform: 'scaleX(1)', transformOrigin: 'left center' },
	    to: { transform: 'scaleX(0)', transformOrigin: 'left center' }
	  },
	  none: null
	};
	
	// For now, appearPresets will be identical to enterPresets.
	// Assigning a custom export in case we ever want to add appear-specific ones.
	var appearPresets = enterPresets;
	
	var defaultPreset = 'elevator';
	var disablePreset = 'none';
	
	var find = function find(predicate, arr) {
	  for (var i = 0; i < arr.length; i++) {
	    if (predicate(arr[i], i, arr)) {
	      return arr[i];
	    }
	  }
	
	  return undefined;
	};
	
	
	var every = function every(predicate, arr) {
	  for (var i = 0; i < arr.length; i++) {
	    if (!predicate(arr[i], i, arr)) {
	      return false;
	    }
	  }
	  return true;
	};
	
	// eslint-disable-next-line import/no-mutable-exports
	var _isArray = function isArray(arr) {
	  _isArray = Array.isArray || function (arg) {
	    return Object.prototype.toString.call(arg) === '[object Array]';
	  };
	  return _isArray(arr);
	};
	
	var isElementAnSFC = function isElementAnSFC(element) {
	  var isNativeDOMElement = typeof element.type === 'string';
	
	  if (isNativeDOMElement) {
	    return false;
	  }
	
	  return !element.type.prototype.isReactComponent;
	};
	
	function omit(obj) {
	  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var result = {};
	  Object.keys(obj).forEach(function (key) {
	    if (attrs.indexOf(key) === -1) {
	      result[key] = obj[key];
	    }
	  });
	  return result;
	}
	
	function arraysEqual(a, b) {
	  var sameObject = a === b;
	  if (sameObject) {
	    return true;
	  }
	
	  var notBothArrays = !_isArray(a) || !_isArray(b);
	  var differentLengths = a.length !== b.length;
	
	  if (notBothArrays || differentLengths) {
	    return false;
	  }
	
	  return every(function (element, index) {
	    return element === b[index];
	  }, a);
	}
	
	function memoizeString(fn) {
	  var cache = {};
	
	  return function (str) {
	    if (!cache[str]) {
	      cache[str] = fn(str);
	    }
	    return cache[str];
	  };
	}
	
	var hyphenate = memoizeString(function (str) {
	  return str.replace(/([A-Z])/g, '-$1').toLowerCase();
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	/**
	 * React Flip Move | propConverter
	 * (c) 2016-present Joshua Comeau
	 *
	 * Abstracted away a bunch of the messy business with props.
	 *   - props flow types and defaultProps
	 *   - Type conversion (We accept 'string' and 'number' values for duration,
	 *     delay, and other fields, but we actually need them to be ints.)
	 *   - Children conversion (we need the children to be an array. May not always
	 *     be, if a single child is passed in.)
	 *   - Resolving animation presets into their base CSS styles
	 */
	/* eslint-disable block-scoped-var */
	
	// eslint-disable-next-line no-duplicate-imports
	
	
	function propConverter(ComposedComponent) {
	  var _class, _temp;
	
	  return _temp = _class = function (_Component) {
	    inherits(FlipMovePropConverter, _Component);
	
	    function FlipMovePropConverter() {
	      classCallCheck(this, FlipMovePropConverter);
	      return possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    // eslint-disable-next-line class-methods-use-this
	    FlipMovePropConverter.prototype.checkChildren = function checkChildren(children) {
	      // Skip all console warnings in production.
	      // Bail early, to avoid unnecessary work.
	      if (true) {
	        return;
	      }
	
	      // same as React.Node, but without fragments, see https://github.com/facebook/flow/issues/4781
	
	
	      // FlipMove does not support stateless functional components.
	      // Check to see if any supplied components won't work.
	      // If the child doesn't have a key, it means we aren't animating it.
	      // It's allowed to be an SFC, since we ignore it.
	      React.Children.forEach(children, function (child) {
	        // null, undefined, and booleans will be filtered out by Children.toArray
	        if (child == null || typeof child === 'boolean') {
	          return;
	        }
	
	        if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) !== 'object') {
	          primitiveNodeSupplied();
	          return;
	        }
	
	        if (isElementAnSFC(child) && child.key != null) {
	          statelessFunctionalComponentSupplied();
	        }
	      });
	    };
	
	    FlipMovePropConverter.prototype.convertProps = function convertProps(props) {
	      var workingProps = {
	        // explicitly bypass the props that don't need conversion
	        children: props.children,
	        easing: props.easing,
	        onStart: props.onStart,
	        onFinish: props.onFinish,
	        onStartAll: props.onStartAll,
	        onFinishAll: props.onFinishAll,
	        typeName: props.typeName,
	        disableAllAnimations: props.disableAllAnimations,
	        getPosition: props.getPosition,
	        maintainContainerHeight: props.maintainContainerHeight,
	        verticalAlignment: props.verticalAlignment,
	
	        // Do string-to-int conversion for all timing-related props
	        duration: this.convertTimingProp('duration'),
	        delay: this.convertTimingProp('delay'),
	        staggerDurationBy: this.convertTimingProp('staggerDurationBy'),
	        staggerDelayBy: this.convertTimingProp('staggerDelayBy'),
	
	        // Our enter/leave animations can be specified as boolean (default or
	        // disabled), string (preset name), or object (actual animation values).
	        // Let's standardize this so that they're always objects
	        appearAnimation: this.convertAnimationProp(props.appearAnimation, appearPresets),
	        enterAnimation: this.convertAnimationProp(props.enterAnimation, enterPresets),
	        leaveAnimation: this.convertAnimationProp(props.leaveAnimation, leavePresets),
	
	        delegated: {}
	      };
	
	      this.checkChildren(workingProps.children);
	
	      // Gather any additional props;
	      // they will be delegated to the ReactElement created.
	      var primaryPropKeys = Object.keys(workingProps);
	      var delegatedProps = omit(this.props, primaryPropKeys);
	
	      // The FlipMove container element needs to have a non-static position.
	      // We use `relative` by default, but it can be overridden by the user.
	      // Now that we're delegating props, we need to merge this in.
	      delegatedProps.style = _extends({
	        position: 'relative'
	      }, delegatedProps.style);
	
	      workingProps.delegated = delegatedProps;
	
	      return workingProps;
	    };
	
	    FlipMovePropConverter.prototype.convertTimingProp = function convertTimingProp(prop) {
	      var rawValue = this.props[prop];
	
	      var value = typeof rawValue === 'number' ? rawValue : parseInt(rawValue, 10);
	
	      if (isNaN(value)) {
	        var defaultValue = FlipMovePropConverter.defaultProps[prop];
	
	        if (false) {
	          invalidTypeForTimingProp({
	            prop: prop,
	            value: rawValue,
	            defaultValue: defaultValue
	          });
	        }
	
	        return defaultValue;
	      }
	
	      return value;
	    };
	
	    // eslint-disable-next-line class-methods-use-this
	
	
	    FlipMovePropConverter.prototype.convertAnimationProp = function convertAnimationProp(animation, presets) {
	      switch (typeof animation === 'undefined' ? 'undefined' : _typeof(animation)) {
	        case 'boolean':
	          {
	            // If it's true, we want to use the default preset.
	            // If it's false, we want to use the 'none' preset.
	            return presets[animation ? defaultPreset : disablePreset];
	          }
	
	        case 'string':
	          {
	            var presetKeys = Object.keys(presets);
	
	            if (presetKeys.indexOf(animation) === -1) {
	              if (false) {
	                invalidEnterLeavePreset({
	                  value: animation,
	                  acceptableValues: presetKeys.join(', '),
	                  defaultValue: defaultPreset
	                });
	              }
	
	              return presets[defaultPreset];
	            }
	
	            return presets[animation];
	          }
	
	        default:
	          {
	            return animation;
	          }
	      }
	    };
	
	    FlipMovePropConverter.prototype.render = function render() {
	      return React__default.createElement(ComposedComponent, this.convertProps(this.props));
	    };
	
	    return FlipMovePropConverter;
	  }(React.Component), _class.defaultProps = {
	    easing: 'ease-in-out',
	    duration: 350,
	    delay: 0,
	    staggerDurationBy: 0,
	    staggerDelayBy: 0,
	    typeName: 'div',
	    enterAnimation: defaultPreset,
	    leaveAnimation: defaultPreset,
	    disableAllAnimations: false,
	    getPosition: function getPosition(node) {
	      return node.getBoundingClientRect();
	    },
	    maintainContainerHeight: false,
	    verticalAlignment: 'top'
	  }, _temp;
	}
	
	/**
	 * React Flip Move
	 * (c) 2016-present Joshua Comeau
	 *
	 * These methods read from and write to the DOM.
	 * They almost always have side effects, and will hopefully become the
	 * only spot in the codebase with impure functions.
	 */
	function applyStylesToDOMNode(_ref) {
	  var domNode = _ref.domNode,
	      styles = _ref.styles;
	
	  // Can't just do an object merge because domNode.styles is no regular object.
	  // Need to do it this way for the engine to fire its `set` listeners.
	  Object.keys(styles).forEach(function (key) {
	    domNode.style.setProperty(hyphenate(key), styles[key]);
	  });
	}
	
	// Modified from Modernizr
	function whichTransitionEvent() {
	  var transitions = {
	    transition: 'transitionend',
	    '-o-transition': 'oTransitionEnd',
	    '-moz-transition': 'transitionend',
	    '-webkit-transition': 'webkitTransitionEnd'
	  };
	
	  // If we're running in a browserless environment (eg. SSR), it doesn't apply.
	  // Return a placeholder string, for consistent type return.
	  if (typeof document === 'undefined') return '';
	
	  var el = document.createElement('fakeelement');
	
	  var match = find(function (t) {
	    return el.style.getPropertyValue(t) !== undefined;
	  }, Object.keys(transitions));
	
	  // If no `transition` is found, we must be running in a browser so ancient,
	  // React itself won't run. Return an empty string, for consistent type return
	  return match ? transitions[match] : '';
	}
	
	var getRelativeBoundingBox = function getRelativeBoundingBox(_ref2) {
	  var childDomNode = _ref2.childDomNode,
	      parentDomNode = _ref2.parentDomNode,
	      getPosition = _ref2.getPosition;
	
	  var parentBox = getPosition(parentDomNode);
	
	  var _getPosition = getPosition(childDomNode),
	      top = _getPosition.top,
	      left = _getPosition.left,
	      right = _getPosition.right,
	      bottom = _getPosition.bottom,
	      width = _getPosition.width,
	      height = _getPosition.height;
	
	  return {
	    top: top - parentBox.top,
	    left: left - parentBox.left,
	    right: parentBox.right - right,
	    bottom: parentBox.bottom - bottom,
	    width: width,
	    height: height
	  };
	};
	
	/** getPositionDelta
	 * This method returns the delta between two bounding boxes, to figure out
	 * how many pixels on each axis the element has moved.
	 *
	 */
	var getPositionDelta = function getPositionDelta(_ref3) {
	  var childDomNode = _ref3.childDomNode,
	      childBoundingBox = _ref3.childBoundingBox,
	      parentBoundingBox = _ref3.parentBoundingBox,
	      getPosition = _ref3.getPosition;
	
	  // TEMP: A mystery bug is sometimes causing unnecessary boundingBoxes to
	  var defaultBox = {
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    height: 0,
	    width: 0
	  };
	
	  // Our old box is its last calculated position, derived on mount or at the
	  // start of the previous animation.
	  var oldRelativeBox = childBoundingBox || defaultBox;
	  var parentBox = parentBoundingBox || defaultBox;
	
	  // Our new box is the new final resting place: Where we expect it to wind up
	  // after the animation. First we get the box in absolute terms (AKA relative
	  // to the viewport), and then we calculate its relative box (relative to the
	  // parent container)
	  var newAbsoluteBox = getPosition(childDomNode);
	  var newRelativeBox = {
	    top: newAbsoluteBox.top - parentBox.top,
	    left: newAbsoluteBox.left - parentBox.left
	  };
	
	  return [oldRelativeBox.left - newRelativeBox.left, oldRelativeBox.top - newRelativeBox.top];
	};
	
	/** removeNodeFromDOMFlow
	 * This method does something very sneaky: it removes a DOM node from the
	 * document flow, but without actually changing its on-screen position.
	 *
	 * It works by calculating where the node is, and then applying styles
	 * so that it winds up being positioned absolutely, but in exactly the
	 * same place.
	 *
	 * This is a vital part of the FLIP technique.
	 */
	var removeNodeFromDOMFlow = function removeNodeFromDOMFlow(childData, verticalAlignment) {
	  var domNode = childData.domNode,
	      boundingBox = childData.boundingBox;
	
	
	  if (!domNode || !boundingBox) {
	    return;
	  }
	
	  // For this to work, we have to offset any given `margin`.
	  var computed = window.getComputedStyle(domNode);
	
	  // We need to clean up margins, by converting and removing suffix:
	  // eg. '21px' -> 21
	  var marginAttrs = ['margin-top', 'margin-left', 'margin-right'];
	  var margins = marginAttrs.reduce(function (acc, margin) {
	    var _babelHelpers$extends;
	
	    var propertyVal = computed.getPropertyValue(margin);
	
	    return _extends({}, acc, (_babelHelpers$extends = {}, _babelHelpers$extends[margin] = Number(propertyVal.replace('px', '')), _babelHelpers$extends));
	  }, {});
	
	  // If we're bottom-aligned, we need to add the height of the child to its
	  // top offset. This is because, when the container is bottom-aligned, its
	  // height shrinks from the top, not the bottom. We're removing this node
	  // from the flow, so the top is going to drop by its height.
	  var topOffset = verticalAlignment === 'bottom' ? boundingBox.top - boundingBox.height : boundingBox.top;
	
	  var styles = {
	    position: 'absolute',
	    top: topOffset - margins['margin-top'] + 'px',
	    left: boundingBox.left - margins['margin-left'] + 'px',
	    right: boundingBox.right - margins['margin-right'] + 'px'
	  };
	
	  applyStylesToDOMNode({ domNode: domNode, styles: styles });
	};
	
	/** updateHeightPlaceholder
	 * An optional property to FlipMove is a `maintainContainerHeight` boolean.
	 * This property creates a node that fills space, so that the parent
	 * container doesn't collapse when its children are removed from the
	 * document flow.
	 */
	var updateHeightPlaceholder = function updateHeightPlaceholder(_ref4) {
	  var domNode = _ref4.domNode,
	      parentData = _ref4.parentData,
	      getPosition = _ref4.getPosition;
	
	  var parentDomNode = parentData.domNode;
	  var parentBoundingBox = parentData.boundingBox;
	
	  if (!parentDomNode || !parentBoundingBox) {
	    return;
	  }
	
	  // We need to find the height of the container *without* the placeholder.
	  // Since it's possible that the placeholder might already be present,
	  // we first set its height to 0.
	  // This allows the container to collapse down to the size of just its
	  // content (plus container padding or borders if any).
	  applyStylesToDOMNode({ domNode: domNode, styles: { height: '0' } });
	
	  // Find the distance by which the container would be collapsed by elements
	  // leaving. We compare the freshly-available parent height with the original,
	  // cached container height.
	  var originalParentHeight = parentBoundingBox.height;
	  var collapsedParentHeight = getPosition(parentDomNode).height;
	  var reductionInHeight = originalParentHeight - collapsedParentHeight;
	
	  // If the container has become shorter, update the padding element's
	  // height to take up the difference. Otherwise set its height to zero,
	  // so that it has no effect.
	  var styles = {
	    height: reductionInHeight > 0 ? reductionInHeight + 'px' : '0'
	  };
	
	  applyStylesToDOMNode({ domNode: domNode, styles: styles });
	};
	
	var getNativeNode = function getNativeNode(element) {
	  // When running in a windowless environment, abort!
	  if (typeof HTMLElement === 'undefined') {
	    return null;
	  }
	
	  // `element` may already be a native node.
	  if (element instanceof HTMLElement) {
	    return element;
	  }
	
	  // While ReactDOM's `findDOMNode` is discouraged, it's the only
	  // publicly-exposed way to find the underlying DOM node for
	  // composite components.
	  var foundNode = ReactDOM.findDOMNode(element);
	
	  if (foundNode && foundNode.nodeType === Node.TEXT_NODE) {
	    // Text nodes are not supported
	    return null;
	  }
	  // eslint-disable-next-line flowtype/no-weak-types
	  return foundNode;
	};
	
	var createTransitionString = function createTransitionString(index, props) {
	  var delay = props.delay,
	      duration = props.duration;
	  var staggerDurationBy = props.staggerDurationBy,
	      staggerDelayBy = props.staggerDelayBy,
	      easing = props.easing;
	
	
	  delay += index * staggerDelayBy;
	  duration += index * staggerDurationBy;
	
	  var cssProperties = ['transform', 'opacity'];
	
	  return cssProperties.map(function (prop) {
	    return prop + ' ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
	  }).join(', ');
	};
	
	/**
	 * React Flip Move
	 * (c) 2016-present Joshua Comeau
	 *
	 * For information on how this code is laid out, check out CODE_TOUR.md
	 */
	
	/* eslint-disable react/prop-types */
	
	// eslint-disable-next-line no-duplicate-imports
	
	
	var transitionEnd = whichTransitionEvent();
	var noBrowserSupport = !transitionEnd;
	
	function getKey(childData) {
	  return childData.key || '';
	}
	
	function getElementChildren(children) {
	  // Fix incomplete typing of Children.toArray
	  // eslint-disable-next-line flowtype/no-weak-types
	  return React.Children.toArray(children);
	}
	
	var FlipMove$1 = function (_Component) {
	  inherits(FlipMove, _Component);
	
	  function FlipMove() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, FlipMove);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      children: getElementChildren(
	      // `this.props` ought to always be defined at this point, but a report
	      // was made about it not being defined in IE10.
	      // TODO: Test in IE10, to see if there's an underlying cause that can
	      // be addressed.
	      _this.props ? _this.props.children : []).map(function (element) {
	        return _extends({}, element, {
	          element: element,
	          appearing: true
	        });
	      })
	    }, _this.childrenData = {}, _this.parentData = {
	      domNode: null,
	      boundingBox: null
	    }, _this.heightPlaceholderData = {
	      domNode: null
	    }, _this.remainingAnimations = 0, _this.childrenToAnimate = [], _this.findDOMContainer = function () {
	      // eslint-disable-next-line react/no-find-dom-node
	      var domNode = ReactDOM__default.findDOMNode(_this);
	      var parentNode = domNode && domNode.parentNode;
	
	      // This ought to be impossible, but handling it for Flow's sake.
	      if (!parentNode || !(parentNode instanceof HTMLElement)) {
	        return;
	      }
	
	      // If the parent node has static positioning, leave animations might look
	      // really funky. Let's automatically apply `position: relative` in this
	      // case, to prevent any quirkiness.
	      if (window.getComputedStyle(parentNode).position === 'static') {
	        parentNode.style.position = 'relative';
	        parentNodePositionStatic();
	      }
	
	      _this.parentData.domNode = parentNode;
	    }, _this.runAnimation = function () {
	      var dynamicChildren = _this.state.children.filter(_this.doesChildNeedToBeAnimated);
	
	      // Splitting DOM reads and writes to be peformed in batches
	      var childrenInitialStyles = dynamicChildren.map(function (child) {
	        return _this.computeInitialStyles(child);
	      });
	      dynamicChildren.forEach(function (child, index) {
	        _this.remainingAnimations += 1;
	        _this.childrenToAnimate.push(getKey(child));
	        _this.animateChild(child, index, childrenInitialStyles[index]);
	      });
	
	      if (typeof _this.props.onStartAll === 'function') {
	        _this.callChildrenHook(_this.props.onStartAll);
	      }
	    }, _this.doesChildNeedToBeAnimated = function (child) {
	      // If the child doesn't have a key, it's an immovable child (one that we
	      // do not want to do FLIP stuff to.)
	      if (!getKey(child)) {
	        return false;
	      }
	
	      var childData = _this.getChildData(getKey(child));
	      var childDomNode = childData.domNode;
	      var childBoundingBox = childData.boundingBox;
	      var parentBoundingBox = _this.parentData.boundingBox;
	
	      if (!childDomNode) {
	        return false;
	      }
	
	      var _this$props = _this.props,
	          appearAnimation = _this$props.appearAnimation,
	          enterAnimation = _this$props.enterAnimation,
	          leaveAnimation = _this$props.leaveAnimation,
	          getPosition = _this$props.getPosition;
	
	
	      var isAppearingWithAnimation = child.appearing && appearAnimation;
	      var isEnteringWithAnimation = child.entering && enterAnimation;
	      var isLeavingWithAnimation = child.leaving && leaveAnimation;
	
	      if (isAppearingWithAnimation || isEnteringWithAnimation || isLeavingWithAnimation) {
	        return true;
	      }
	
	      // If it isn't entering/leaving, we want to animate it if it's
	      // on-screen position has changed.
	
	      var _getPositionDelta = getPositionDelta({
	        childDomNode: childDomNode,
	        childBoundingBox: childBoundingBox,
	        parentBoundingBox: parentBoundingBox,
	        getPosition: getPosition
	      }),
	          dX = _getPositionDelta[0],
	          dY = _getPositionDelta[1];
	
	      return dX !== 0 || dY !== 0;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	  // Copy props.children into state.
	  // To understand why this is important (and not an anti-pattern), consider
	  // how "leave" animations work. An item has "left" when the component
	  // receives a new set of props that do NOT contain the item.
	  // If we just render the props as-is, the item would instantly disappear.
	  // We want to keep the item rendered for a little while, until its animation
	  // can complete. Because we cannot mutate props, we make `state` the source
	  // of truth.
	
	
	  // FlipMove needs to know quite a bit about its children in order to do
	  // its job. We store these as a property on the instance. We're not using
	  // state, because we don't want changes to trigger re-renders, we just
	  // need a place to keep the data for reference, when changes happen.
	  // This field should not be accessed directly. Instead, use getChildData,
	  // putChildData, etc...
	
	
	  // Similarly, track the dom node and box of our parent element.
	
	
	  // If `maintainContainerHeight` prop is set to true, we'll create a
	  // placeholder element which occupies space so that the parent height
	  // doesn't change when items are removed from the document flow (which
	  // happens during leave animations)
	
	
	  // Keep track of remaining animations so we know when to fire the
	  // all-finished callback, and clean up after ourselves.
	  // NOTE: we can't simply use childrenToAnimate.length to track remaining
	  // animations, because we need to maintain the list of animating children,
	  // to pass to the `onFinishAll` handler.
	
	
	  FlipMove.prototype.componentDidMount = function componentDidMount() {
	    // Because React 16 no longer requires wrapping elements, Flip Move can opt
	    // to not wrap the children in an element. In that case, find the parent
	    // element using `findDOMNode`.
	    if (this.props.typeName === null) {
	      this.findDOMContainer();
	    }
	
	    // Run our `appearAnimation` if it was requested, right after the
	    // component mounts.
	    var shouldTriggerFLIP = this.props.appearAnimation && !this.isAnimationDisabled(this.props);
	
	    if (shouldTriggerFLIP) {
	      this.prepForAnimation();
	      this.runAnimation();
	    }
	  };
	
	  FlipMove.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    // When the component is handed new props, we need to figure out the
	    // "resting" position of all currently-rendered DOM nodes.
	    // We store that data in this.parent and this.children,
	    // so it can be used later to work out the animation.
	    this.updateBoundingBoxCaches();
	
	    // Convert opaque children object to array.
	    var nextChildren = getElementChildren(nextProps.children);
	
	    // Next, we need to update our state, so that it contains our new set of
	    // children. If animation is disabled or unsupported, this is easy;
	    // we just copy our props into state.
	    // Assuming that we can animate, though, we have to do some work.
	    // Essentially, we want to keep just-deleted nodes in the DOM for a bit
	    // longer, so that we can animate them away.
	    this.setState({
	      children: this.isAnimationDisabled(nextProps) ? nextChildren.map(function (element) {
	        return _extends({}, element, { element: element });
	      }) : this.calculateNextSetOfChildren(nextChildren)
	    });
	  };
	
	  FlipMove.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
	    if (this.props.typeName === null) {
	      this.findDOMContainer();
	    }
	    // If the children have been re-arranged, moved, or added/removed,
	    // trigger the main FLIP animation.
	    //
	    // IMPORTANT: We need to make sure that the children have actually changed.
	    // At the end of the transition, we clean up nodes that need to be removed.
	    // We DON'T want this cleanup to trigger another update.
	
	    var oldChildrenKeys = getElementChildren(this.props.children).map(function (d) {
	      return d.key;
	    });
	    var nextChildrenKeys = getElementChildren(previousProps.children).map(function (d) {
	      return d.key;
	    });
	
	    var shouldTriggerFLIP = !arraysEqual(oldChildrenKeys, nextChildrenKeys) && !this.isAnimationDisabled(this.props);
	
	    if (shouldTriggerFLIP) {
	      this.prepForAnimation();
	      this.runAnimation();
	    }
	  };
	
	  FlipMove.prototype.calculateNextSetOfChildren = function calculateNextSetOfChildren(nextChildren) {
	    var _this2 = this;
	
	    // We want to:
	    //   - Mark all new children as `entering`
	    //   - Pull in previous children that aren't in nextChildren, and mark them
	    //     as `leaving`
	    //   - Preserve the nextChildren list order, with leaving children in their
	    //     appropriate places.
	    //
	
	    var updatedChildren = nextChildren.map(function (nextChild) {
	      var child = _this2.findChildByKey(nextChild.key);
	
	      // If the current child did exist, but it was in the midst of leaving,
	      // we want to treat it as though it's entering
	      var isEntering = !child || child.leaving;
	
	      return _extends({}, nextChild, { element: nextChild, entering: isEntering });
	    });
	
	    // This is tricky. We want to keep the nextChildren's ordering, but with
	    // any just-removed items maintaining their original position.
	    // eg.
	    //   this.state.children  = [ 1, 2, 3, 4 ]
	    //   nextChildren         = [ 3, 1 ]
	    //
	    // In this example, we've removed the '2' & '4'
	    // We want to end up with:  [ 2, 3, 1, 4 ]
	    //
	    // To accomplish that, we'll iterate through this.state.children. whenever
	    // we find a match, we'll append our `leaving` flag to it, and insert it
	    // into the nextChildren in its ORIGINAL position. Note that, as we keep
	    // inserting old items into the new list, the "original" position will
	    // keep incrementing.
	    var numOfChildrenLeaving = 0;
	    this.state.children.forEach(function (child, index) {
	      var isLeaving = !find(function (_ref) {
	        var key = _ref.key;
	        return key === getKey(child);
	      }, nextChildren);
	
	      // If the child isn't leaving (or, if there is no leave animation),
	      // we don't need to add it into the state children.
	      if (!isLeaving || !_this2.props.leaveAnimation) return;
	
	      var nextChild = _extends({}, child, { leaving: true });
	      var nextChildIndex = index + numOfChildrenLeaving;
	
	      updatedChildren.splice(nextChildIndex, 0, nextChild);
	      numOfChildrenLeaving += 1;
	    });
	
	    return updatedChildren;
	  };
	
	  FlipMove.prototype.prepForAnimation = function prepForAnimation() {
	    var _this3 = this;
	
	    // Our animation prep consists of:
	    // - remove children that are leaving from the DOM flow, so that the new
	    //   layout can be accurately calculated,
	    // - update the placeholder container height, if needed, to ensure that
	    //   the parent's height doesn't collapse.
	
	    var _props = this.props,
	        leaveAnimation = _props.leaveAnimation,
	        maintainContainerHeight = _props.maintainContainerHeight,
	        getPosition = _props.getPosition;
	
	    // we need to make all leaving nodes "invisible" to the layout calculations
	    // that will take place in the next step (this.runAnimation).
	
	    if (leaveAnimation) {
	      var leavingChildren = this.state.children.filter(function (child) {
	        return child.leaving;
	      });
	
	      leavingChildren.forEach(function (leavingChild) {
	        var childData = _this3.getChildData(getKey(leavingChild));
	
	        // Warn if child is disabled
	        if (!_this3.isAnimationDisabled(_this3.props) && childData.domNode && childData.domNode.disabled) {
	          childIsDisabled();
	        }
	
	        // We need to take the items out of the "flow" of the document, so that
	        // its siblings can move to take its place.
	        if (childData.boundingBox) {
	          removeNodeFromDOMFlow(childData, _this3.props.verticalAlignment);
	        }
	      });
	
	      if (maintainContainerHeight && this.heightPlaceholderData.domNode) {
	        updateHeightPlaceholder({
	          domNode: this.heightPlaceholderData.domNode,
	          parentData: this.parentData,
	          getPosition: getPosition
	        });
	      }
	    }
	
	    // For all children not in the middle of entering or leaving,
	    // we need to reset the transition, so that the NEW shuffle starts from
	    // the right place.
	    this.state.children.forEach(function (child) {
	      var _getChildData = _this3.getChildData(getKey(child)),
	          domNode = _getChildData.domNode;
	
	      // Ignore children that don't render DOM nodes (eg. by returning null)
	
	
	      if (!domNode) {
	        return;
	      }
	
	      if (!child.entering && !child.leaving) {
	        applyStylesToDOMNode({
	          domNode: domNode,
	          styles: {
	            transition: ''
	          }
	        });
	      }
	    });
	  };
	
	  FlipMove.prototype.animateChild = function animateChild(child, index, childInitialStyles) {
	    var _this4 = this;
	
	    var _getChildData2 = this.getChildData(getKey(child)),
	        domNode = _getChildData2.domNode;
	
	    if (!domNode) {
	      return;
	    }
	
	    // Apply the relevant style for this DOM node
	    // This is the offset from its actual DOM position.
	    // eg. if an item has been re-rendered 20px lower, we want to apply a
	    // style of 'transform: translate(-20px)', so that it appears to be where
	    // it started.
	    // In FLIP terminology, this is the 'Invert' stage.
	    applyStylesToDOMNode({
	      domNode: domNode,
	      styles: childInitialStyles
	    });
	
	    // Start by invoking the onStart callback for this child.
	    if (this.props.onStart) this.props.onStart(child, domNode);
	
	    // Next, animate the item from it's artificially-offset position to its
	    // new, natural position.
	    requestAnimationFrame(function () {
	      requestAnimationFrame(function () {
	        // NOTE, RE: the double-requestAnimationFrame:
	        // Sadly, this is the most browser-compatible way to do this I've found.
	        // Essentially we need to set the initial styles outside of any request
	        // callbacks to avoid batching them. Then, a frame needs to pass with
	        // the styles above rendered. Then, on the second frame, we can apply
	        // our final styles to perform the animation.
	
	        // Our first order of business is to "undo" the styles applied in the
	        // previous frames, while also adding a `transition` property.
	        // This way, the item will smoothly transition from its old position
	        // to its new position.
	
	        // eslint-disable-next-line flowtype/require-variable-type
	        var styles = {
	          transition: createTransitionString(index, _this4.props),
	          transform: '',
	          opacity: ''
	        };
	
	        if (child.appearing && _this4.props.appearAnimation) {
	          styles = _extends({}, styles, _this4.props.appearAnimation.to);
	        } else if (child.entering && _this4.props.enterAnimation) {
	          styles = _extends({}, styles, _this4.props.enterAnimation.to);
	        } else if (child.leaving && _this4.props.leaveAnimation) {
	          styles = _extends({}, styles, _this4.props.leaveAnimation.to);
	        }
	
	        // In FLIP terminology, this is the 'Play' stage.
	        applyStylesToDOMNode({ domNode: domNode, styles: styles });
	      });
	    });
	
	    this.bindTransitionEndHandler(child);
	  };
	
	  FlipMove.prototype.bindTransitionEndHandler = function bindTransitionEndHandler(child) {
	    var _this5 = this;
	
	    var _getChildData3 = this.getChildData(getKey(child)),
	        domNode = _getChildData3.domNode;
	
	    if (!domNode) {
	      return;
	    }
	
	    // The onFinish callback needs to be bound to the transitionEnd event.
	    // We also need to unbind it when the transition completes, so this ugly
	    // inline function is required (we need it here so it closes over
	    // dependent variables `child` and `domNode`)
	    var transitionEndHandler = function transitionEndHandler(ev) {
	      // It's possible that this handler is fired not on our primary transition,
	      // but on a nested transition (eg. a hover effect). Ignore these cases.
	      if (ev.target !== domNode) return;
	
	      // Remove the 'transition' inline style we added. This is cleanup.
	      domNode.style.transition = '';
	
	      // Trigger any applicable onFinish/onFinishAll hooks
	      _this5.triggerFinishHooks(child, domNode);
	
	      domNode.removeEventListener(transitionEnd, transitionEndHandler);
	
	      if (child.leaving) {
	        _this5.removeChildData(getKey(child));
	      }
	    };
	
	    domNode.addEventListener(transitionEnd, transitionEndHandler);
	  };
	
	  FlipMove.prototype.triggerFinishHooks = function triggerFinishHooks(child, domNode) {
	    var _this6 = this;
	
	    if (this.props.onFinish) this.props.onFinish(child, domNode);
	
	    // Reduce the number of children we need to animate by 1,
	    // so that we can tell when all children have finished.
	    this.remainingAnimations -= 1;
	
	    if (this.remainingAnimations === 0) {
	      // Remove any items from the DOM that have left, and reset `entering`.
	      var nextChildren = this.state.children.filter(function (_ref2) {
	        var leaving = _ref2.leaving;
	        return !leaving;
	      }).map(function (item) {
	        return _extends({}, item, {
	          // fix for Flow
	          element: item.element,
	          appearing: false,
	          entering: false
	        });
	      });
	
	      this.setState({ children: nextChildren }, function () {
	        if (typeof _this6.props.onFinishAll === 'function') {
	          _this6.callChildrenHook(_this6.props.onFinishAll);
	        }
	
	        // Reset our variables for the next iteration
	        _this6.childrenToAnimate = [];
	      });
	
	      // If the placeholder was holding the container open while elements were
	      // leaving, we we can now set its height to zero.
	      if (this.heightPlaceholderData.domNode) {
	        this.heightPlaceholderData.domNode.style.height = '0';
	      }
	    }
	  };
	
	  FlipMove.prototype.callChildrenHook = function callChildrenHook(hook) {
	    var _this7 = this;
	
	    var elements = [];
	    var domNodes = [];
	
	    this.childrenToAnimate.forEach(function (childKey) {
	      // If this was an exit animation, the child may no longer exist.
	      // If so, skip it.
	      var child = _this7.findChildByKey(childKey);
	
	      if (!child) {
	        return;
	      }
	
	      elements.push(child);
	
	      if (_this7.hasChildData(childKey)) {
	        domNodes.push(_this7.getChildData(childKey).domNode);
	      }
	    });
	
	    hook(elements, domNodes);
	  };
	
	  FlipMove.prototype.updateBoundingBoxCaches = function updateBoundingBoxCaches() {
	    var _this8 = this;
	
	    // This is the ONLY place that parentData and childrenData's
	    // bounding boxes are updated. They will be calculated at other times
	    // to be compared to this value, but it's important that the cache is
	    // updated once per update.
	    var parentDomNode = this.parentData.domNode;
	
	    if (!parentDomNode) {
	      return;
	    }
	
	    this.parentData.boundingBox = this.props.getPosition(parentDomNode);
	
	    // Splitting DOM reads and writes to be peformed in batches
	    var childrenBoundingBoxes = [];
	
	    this.state.children.forEach(function (child) {
	      var childKey = getKey(child);
	
	      // It is possible that a child does not have a `key` property;
	      // Ignore these children, they don't need to be moved.
	      if (!childKey) {
	        childrenBoundingBoxes.push(null);
	        return;
	      }
	
	      // In very rare circumstances, for reasons unknown, the ref is never
	      // populated for certain children. In this case, avoid doing this update.
	      // see: https://github.com/joshwcomeau/react-flip-move/pull/91
	      if (!_this8.hasChildData(childKey)) {
	        childrenBoundingBoxes.push(null);
	        return;
	      }
	
	      var childData = _this8.getChildData(childKey);
	
	      // If the child element returns null, we need to avoid trying to
	      // account for it
	      if (!childData.domNode || !child) {
	        childrenBoundingBoxes.push(null);
	        return;
	      }
	
	      childrenBoundingBoxes.push(getRelativeBoundingBox({
	        childDomNode: childData.domNode,
	        parentDomNode: parentDomNode,
	        getPosition: _this8.props.getPosition
	      }));
	    });
	
	    this.state.children.forEach(function (child, index) {
	      var childKey = getKey(child);
	
	      var childBoundingBox = childrenBoundingBoxes[index];
	
	      if (!childKey) {
	        return;
	      }
	
	      _this8.setChildData(childKey, {
	        boundingBox: childBoundingBox
	      });
	    });
	  };
	
	  FlipMove.prototype.computeInitialStyles = function computeInitialStyles(child) {
	    if (child.appearing) {
	      return this.props.appearAnimation ? this.props.appearAnimation.from : {};
	    } else if (child.entering) {
	      if (!this.props.enterAnimation) {
	        return {};
	      }
	      // If this child was in the middle of leaving, it still has its
	      // absolute positioning styles applied. We need to undo those.
	      return _extends({
	        position: '',
	        top: '',
	        left: '',
	        right: '',
	        bottom: ''
	      }, this.props.enterAnimation.from);
	    } else if (child.leaving) {
	      return this.props.leaveAnimation ? this.props.leaveAnimation.from : {};
	    }
	
	    var childData = this.getChildData(getKey(child));
	    var childDomNode = childData.domNode;
	    var childBoundingBox = childData.boundingBox;
	    var parentBoundingBox = this.parentData.boundingBox;
	
	    if (!childDomNode) {
	      return {};
	    }
	
	    var _getPositionDelta2 = getPositionDelta({
	      childDomNode: childDomNode,
	      childBoundingBox: childBoundingBox,
	      parentBoundingBox: parentBoundingBox,
	      getPosition: this.props.getPosition
	    }),
	        dX = _getPositionDelta2[0],
	        dY = _getPositionDelta2[1];
	
	    return {
	      transform: 'translate(' + dX + 'px, ' + dY + 'px)'
	    };
	  };
	
	  // eslint-disable-next-line class-methods-use-this
	
	
	  FlipMove.prototype.isAnimationDisabled = function isAnimationDisabled(props) {
	    // If the component is explicitly passed a `disableAllAnimations` flag,
	    // we can skip this whole process. Similarly, if all of the numbers have
	    // been set to 0, there is no point in trying to animate; doing so would
	    // only cause a flicker (and the intent is probably to disable animations)
	    // We can also skip this rigamarole if there's no browser support for it.
	    return noBrowserSupport || props.disableAllAnimations || props.duration === 0 && props.delay === 0 && props.staggerDurationBy === 0 && props.staggerDelayBy === 0;
	  };
	
	  FlipMove.prototype.findChildByKey = function findChildByKey(key) {
	    return find(function (child) {
	      return getKey(child) === key;
	    }, this.state.children);
	  };
	
	  FlipMove.prototype.hasChildData = function hasChildData(key) {
	    // Object has some built-in properties on its prototype, such as toString.  hasOwnProperty makes
	    // sure that key is present on childrenData itself, not on its prototype.
	    return Object.prototype.hasOwnProperty.call(this.childrenData, key);
	  };
	
	  FlipMove.prototype.getChildData = function getChildData(key) {
	    return this.hasChildData(key) ? this.childrenData[key] : {};
	  };
	
	  FlipMove.prototype.setChildData = function setChildData(key, data) {
	    this.childrenData[key] = _extends({}, this.getChildData(key), data);
	  };
	
	  FlipMove.prototype.removeChildData = function removeChildData(key) {
	    delete this.childrenData[key];
	    this.setState(function (prevState) {
	      return _extends({}, prevState, {
	        children: prevState.children.filter(function (child) {
	          return child.element.key !== key;
	        })
	      });
	    });
	  };
	
	  FlipMove.prototype.createHeightPlaceholder = function createHeightPlaceholder() {
	    var _this9 = this;
	
	    var typeName = this.props.typeName;
	
	    // If requested, create an invisible element at the end of the list.
	    // Its height will be modified to prevent the container from collapsing
	    // prematurely.
	
	    var isContainerAList = typeName === 'ul' || typeName === 'ol';
	    var placeholderType = isContainerAList ? 'li' : 'div';
	
	    return React.createElement(placeholderType, {
	      key: 'height-placeholder',
	      ref: function ref(domNode) {
	        _this9.heightPlaceholderData.domNode = domNode;
	      },
	      style: { visibility: 'hidden', height: 0 }
	    });
	  };
	
	  FlipMove.prototype.childrenWithRefs = function childrenWithRefs() {
	    var _this10 = this;
	
	    // We need to clone the provided children, capturing a reference to the
	    // underlying DOM node. Flip Move needs to use the React escape hatches to
	    // be able to do its calculations.
	    return this.state.children.map(function (child) {
	      return React.cloneElement(child.element, {
	        ref: function ref(element) {
	          // Stateless Functional Components are not supported by FlipMove,
	          // because they don't have instances.
	          if (!element) {
	            return;
	          }
	
	          var domNode = getNativeNode(element);
	          _this10.setChildData(getKey(child), { domNode: domNode });
	        }
	      });
	    });
	  };
	
	  FlipMove.prototype.render = function render() {
	    var _this11 = this;
	
	    var _props2 = this.props,
	        typeName = _props2.typeName,
	        delegated = _props2.delegated,
	        leaveAnimation = _props2.leaveAnimation,
	        maintainContainerHeight = _props2.maintainContainerHeight;
	
	
	    var children = this.childrenWithRefs();
	    if (leaveAnimation && maintainContainerHeight) {
	      children.push(this.createHeightPlaceholder());
	    }
	
	    if (!typeName) return children;
	
	    var props = _extends({}, delegated, {
	      children: children,
	      ref: function ref(node) {
	        _this11.parentData.domNode = node;
	      }
	    });
	
	    return React.createElement(typeName, props);
	  };
	
	  return FlipMove;
	}(React.Component);
	
	var enhancedFlipMove = /* #__PURE__ */propConverter(FlipMove$1);
	
	/**
	 * React Flip Move
	 * (c) 2016-present Joshua Comeau
	 */
	
	module.exports = enhancedFlipMove;


/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = bail
	
	function bail(err) {
	  if (err) {
	    throw err
	  }
	}


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = collapse
	
	/* collapse(' \t\nbar \nbaz\t'); // ' bar baz ' */
	function collapse(value) {
	  return String(value).replace(/\s+/g, ' ')
	}


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = target[name];
					copy = options[name];
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							target[name] = extend(deep, clone, copy);
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							target[name] = copy;
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      transitionDelay = props.transitionDelay,
	      otherProps = _objectWithoutProperties(props, ['opacity', 'onLoad', 'transitionDelay']);
	
	  return _react2['default'].createElement('img', _extends({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      transition: 'opacity 0.5s',
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: '100%',
	      height: '100%',
	      objectFit: 'cover',
	      objectPosition: 'center'
	    }
	  }));
	};
	
	Img.defaultProps = {
	  transitionDelay: '',
	  onLoad: null
	};
	
	Img.propTypes = {
	  opacity: _propTypes2['default'].oneOf([0, 1]).isRequired,
	  transitionDelay: _propTypes2['default'].string,
	  onLoad: _propTypes2['default'].func
	};
	
	exports['default'] = Img;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
	 *
	 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
	 *
	 */
	
	(function(window, document) {
	'use strict';
	
	
	// Exits early if all IntersectionObserver and IntersectionObserverEntry
	// features are natively supported.
	if ('IntersectionObserver' in window &&
	    'IntersectionObserverEntry' in window &&
	    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
	
	  // Minimal polyfill for Edge 15's lack of `isIntersecting`
	  // See: https://github.com/w3c/IntersectionObserver/issues/211
	  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
	    Object.defineProperty(window.IntersectionObserverEntry.prototype,
	      'isIntersecting', {
	      get: function () {
	        return this.intersectionRatio > 0;
	      }
	    });
	  }
	  return;
	}
	
	
	/**
	 * An IntersectionObserver registry. This registry exists to hold a strong
	 * reference to IntersectionObserver instances currently observering a target
	 * element. Without this registry, instances without another reference may be
	 * garbage collected.
	 */
	var registry = [];
	
	
	/**
	 * Creates the global IntersectionObserverEntry constructor.
	 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
	 * @param {Object} entry A dictionary of instance properties.
	 * @constructor
	 */
	function IntersectionObserverEntry(entry) {
	  this.time = entry.time;
	  this.target = entry.target;
	  this.rootBounds = entry.rootBounds;
	  this.boundingClientRect = entry.boundingClientRect;
	  this.intersectionRect = entry.intersectionRect || getEmptyRect();
	  this.isIntersecting = !!entry.intersectionRect;
	
	  // Calculates the intersection ratio.
	  var targetRect = this.boundingClientRect;
	  var targetArea = targetRect.width * targetRect.height;
	  var intersectionRect = this.intersectionRect;
	  var intersectionArea = intersectionRect.width * intersectionRect.height;
	
	  // Sets intersection ratio.
	  if (targetArea) {
	    this.intersectionRatio = intersectionArea / targetArea;
	  } else {
	    // If area is zero and is intersecting, sets to 1, otherwise to 0
	    this.intersectionRatio = this.isIntersecting ? 1 : 0;
	  }
	}
	
	
	/**
	 * Creates the global IntersectionObserver constructor.
	 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
	 * @param {Function} callback The function to be invoked after intersection
	 *     changes have queued. The function is not invoked if the queue has
	 *     been emptied by calling the `takeRecords` method.
	 * @param {Object=} opt_options Optional configuration options.
	 * @constructor
	 */
	function IntersectionObserver(callback, opt_options) {
	
	  var options = opt_options || {};
	
	  if (typeof callback != 'function') {
	    throw new Error('callback must be a function');
	  }
	
	  if (options.root && options.root.nodeType != 1) {
	    throw new Error('root must be an Element');
	  }
	
	  // Binds and throttles `this._checkForIntersections`.
	  this._checkForIntersections = throttle(
	      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
	
	  // Private properties.
	  this._callback = callback;
	  this._observationTargets = [];
	  this._queuedEntries = [];
	  this._rootMarginValues = this._parseRootMargin(options.rootMargin);
	
	  // Public properties.
	  this.thresholds = this._initThresholds(options.threshold);
	  this.root = options.root || null;
	  this.rootMargin = this._rootMarginValues.map(function(margin) {
	    return margin.value + margin.unit;
	  }).join(' ');
	}
	
	
	/**
	 * The minimum interval within which the document will be checked for
	 * intersection changes.
	 */
	IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
	
	
	/**
	 * The frequency in which the polyfill polls for intersection changes.
	 * this can be updated on a per instance basis and must be set prior to
	 * calling `observe` on the first target.
	 */
	IntersectionObserver.prototype.POLL_INTERVAL = null;
	
	/**
	 * Use a mutation observer on the root element
	 * to detect intersection changes.
	 */
	IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
	
	
	/**
	 * Starts observing a target element for intersection changes based on
	 * the thresholds values.
	 * @param {Element} target The DOM element to observe.
	 */
	IntersectionObserver.prototype.observe = function(target) {
	  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
	    return item.element == target;
	  });
	
	  if (isTargetAlreadyObserved) {
	    return;
	  }
	
	  if (!(target && target.nodeType == 1)) {
	    throw new Error('target must be an Element');
	  }
	
	  this._registerInstance();
	  this._observationTargets.push({element: target, entry: null});
	  this._monitorIntersections();
	  this._checkForIntersections();
	};
	
	
	/**
	 * Stops observing a target element for intersection changes.
	 * @param {Element} target The DOM element to observe.
	 */
	IntersectionObserver.prototype.unobserve = function(target) {
	  this._observationTargets =
	      this._observationTargets.filter(function(item) {
	
	    return item.element != target;
	  });
	  if (!this._observationTargets.length) {
	    this._unmonitorIntersections();
	    this._unregisterInstance();
	  }
	};
	
	
	/**
	 * Stops observing all target elements for intersection changes.
	 */
	IntersectionObserver.prototype.disconnect = function() {
	  this._observationTargets = [];
	  this._unmonitorIntersections();
	  this._unregisterInstance();
	};
	
	
	/**
	 * Returns any queue entries that have not yet been reported to the
	 * callback and clears the queue. This can be used in conjunction with the
	 * callback to obtain the absolute most up-to-date intersection information.
	 * @return {Array} The currently queued entries.
	 */
	IntersectionObserver.prototype.takeRecords = function() {
	  var records = this._queuedEntries.slice();
	  this._queuedEntries = [];
	  return records;
	};
	
	
	/**
	 * Accepts the threshold value from the user configuration object and
	 * returns a sorted array of unique threshold values. If a value is not
	 * between 0 and 1 and error is thrown.
	 * @private
	 * @param {Array|number=} opt_threshold An optional threshold value or
	 *     a list of threshold values, defaulting to [0].
	 * @return {Array} A sorted list of unique and valid threshold values.
	 */
	IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
	  var threshold = opt_threshold || [0];
	  if (!Array.isArray(threshold)) threshold = [threshold];
	
	  return threshold.sort().filter(function(t, i, a) {
	    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
	      throw new Error('threshold must be a number between 0 and 1 inclusively');
	    }
	    return t !== a[i - 1];
	  });
	};
	
	
	/**
	 * Accepts the rootMargin value from the user configuration object
	 * and returns an array of the four margin values as an object containing
	 * the value and unit properties. If any of the values are not properly
	 * formatted or use a unit other than px or %, and error is thrown.
	 * @private
	 * @param {string=} opt_rootMargin An optional rootMargin value,
	 *     defaulting to '0px'.
	 * @return {Array<Object>} An array of margin objects with the keys
	 *     value and unit.
	 */
	IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
	  var marginString = opt_rootMargin || '0px';
	  var margins = marginString.split(/\s+/).map(function(margin) {
	    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
	    if (!parts) {
	      throw new Error('rootMargin must be specified in pixels or percent');
	    }
	    return {value: parseFloat(parts[1]), unit: parts[2]};
	  });
	
	  // Handles shorthand.
	  margins[1] = margins[1] || margins[0];
	  margins[2] = margins[2] || margins[0];
	  margins[3] = margins[3] || margins[1];
	
	  return margins;
	};
	
	
	/**
	 * Starts polling for intersection changes if the polling is not already
	 * happening, and if the page's visibilty state is visible.
	 * @private
	 */
	IntersectionObserver.prototype._monitorIntersections = function() {
	  if (!this._monitoringIntersections) {
	    this._monitoringIntersections = true;
	
	    // If a poll interval is set, use polling instead of listening to
	    // resize and scroll events or DOM mutations.
	    if (this.POLL_INTERVAL) {
	      this._monitoringInterval = setInterval(
	          this._checkForIntersections, this.POLL_INTERVAL);
	    }
	    else {
	      addEvent(window, 'resize', this._checkForIntersections, true);
	      addEvent(document, 'scroll', this._checkForIntersections, true);
	
	      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
	        this._domObserver = new MutationObserver(this._checkForIntersections);
	        this._domObserver.observe(document, {
	          attributes: true,
	          childList: true,
	          characterData: true,
	          subtree: true
	        });
	      }
	    }
	  }
	};
	
	
	/**
	 * Stops polling for intersection changes.
	 * @private
	 */
	IntersectionObserver.prototype._unmonitorIntersections = function() {
	  if (this._monitoringIntersections) {
	    this._monitoringIntersections = false;
	
	    clearInterval(this._monitoringInterval);
	    this._monitoringInterval = null;
	
	    removeEvent(window, 'resize', this._checkForIntersections, true);
	    removeEvent(document, 'scroll', this._checkForIntersections, true);
	
	    if (this._domObserver) {
	      this._domObserver.disconnect();
	      this._domObserver = null;
	    }
	  }
	};
	
	
	/**
	 * Scans each observation target for intersection changes and adds them
	 * to the internal entries queue. If new entries are found, it
	 * schedules the callback to be invoked.
	 * @private
	 */
	IntersectionObserver.prototype._checkForIntersections = function() {
	  var rootIsInDom = this._rootIsInDom();
	  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
	
	  this._observationTargets.forEach(function(item) {
	    var target = item.element;
	    var targetRect = getBoundingClientRect(target);
	    var rootContainsTarget = this._rootContainsTarget(target);
	    var oldEntry = item.entry;
	    var intersectionRect = rootIsInDom && rootContainsTarget &&
	        this._computeTargetAndRootIntersection(target, rootRect);
	
	    var newEntry = item.entry = new IntersectionObserverEntry({
	      time: now(),
	      target: target,
	      boundingClientRect: targetRect,
	      rootBounds: rootRect,
	      intersectionRect: intersectionRect
	    });
	
	    if (!oldEntry) {
	      this._queuedEntries.push(newEntry);
	    } else if (rootIsInDom && rootContainsTarget) {
	      // If the new entry intersection ratio has crossed any of the
	      // thresholds, add a new entry.
	      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
	        this._queuedEntries.push(newEntry);
	      }
	    } else {
	      // If the root is not in the DOM or target is not contained within
	      // root but the previous entry for this target had an intersection,
	      // add a new record indicating removal.
	      if (oldEntry && oldEntry.isIntersecting) {
	        this._queuedEntries.push(newEntry);
	      }
	    }
	  }, this);
	
	  if (this._queuedEntries.length) {
	    this._callback(this.takeRecords(), this);
	  }
	};
	
	
	/**
	 * Accepts a target and root rect computes the intersection between then
	 * following the algorithm in the spec.
	 * TODO(philipwalton): at this time clip-path is not considered.
	 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
	 * @param {Element} target The target DOM element
	 * @param {Object} rootRect The bounding rect of the root after being
	 *     expanded by the rootMargin value.
	 * @return {?Object} The final intersection rect object or undefined if no
	 *     intersection is found.
	 * @private
	 */
	IntersectionObserver.prototype._computeTargetAndRootIntersection =
	    function(target, rootRect) {
	
	  // If the element isn't displayed, an intersection can't happen.
	  if (window.getComputedStyle(target).display == 'none') return;
	
	  var targetRect = getBoundingClientRect(target);
	  var intersectionRect = targetRect;
	  var parent = getParentNode(target);
	  var atRoot = false;
	
	  while (!atRoot) {
	    var parentRect = null;
	    var parentComputedStyle = parent.nodeType == 1 ?
	        window.getComputedStyle(parent) : {};
	
	    // If the parent isn't displayed, an intersection can't happen.
	    if (parentComputedStyle.display == 'none') return;
	
	    if (parent == this.root || parent == document) {
	      atRoot = true;
	      parentRect = rootRect;
	    } else {
	      // If the element has a non-visible overflow, and it's not the <body>
	      // or <html> element, update the intersection rect.
	      // Note: <body> and <html> cannot be clipped to a rect that's not also
	      // the document rect, so no need to compute a new intersection.
	      if (parent != document.body &&
	          parent != document.documentElement &&
	          parentComputedStyle.overflow != 'visible') {
	        parentRect = getBoundingClientRect(parent);
	      }
	    }
	
	    // If either of the above conditionals set a new parentRect,
	    // calculate new intersection data.
	    if (parentRect) {
	      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
	
	      if (!intersectionRect) break;
	    }
	    parent = getParentNode(parent);
	  }
	  return intersectionRect;
	};
	
	
	/**
	 * Returns the root rect after being expanded by the rootMargin value.
	 * @return {Object} The expanded root rect.
	 * @private
	 */
	IntersectionObserver.prototype._getRootRect = function() {
	  var rootRect;
	  if (this.root) {
	    rootRect = getBoundingClientRect(this.root);
	  } else {
	    // Use <html>/<body> instead of window since scroll bars affect size.
	    var html = document.documentElement;
	    var body = document.body;
	    rootRect = {
	      top: 0,
	      left: 0,
	      right: html.clientWidth || body.clientWidth,
	      width: html.clientWidth || body.clientWidth,
	      bottom: html.clientHeight || body.clientHeight,
	      height: html.clientHeight || body.clientHeight
	    };
	  }
	  return this._expandRectByRootMargin(rootRect);
	};
	
	
	/**
	 * Accepts a rect and expands it by the rootMargin value.
	 * @param {Object} rect The rect object to expand.
	 * @return {Object} The expanded rect.
	 * @private
	 */
	IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
	  var margins = this._rootMarginValues.map(function(margin, i) {
	    return margin.unit == 'px' ? margin.value :
	        margin.value * (i % 2 ? rect.width : rect.height) / 100;
	  });
	  var newRect = {
	    top: rect.top - margins[0],
	    right: rect.right + margins[1],
	    bottom: rect.bottom + margins[2],
	    left: rect.left - margins[3]
	  };
	  newRect.width = newRect.right - newRect.left;
	  newRect.height = newRect.bottom - newRect.top;
	
	  return newRect;
	};
	
	
	/**
	 * Accepts an old and new entry and returns true if at least one of the
	 * threshold values has been crossed.
	 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
	 *    particular target element or null if no previous entry exists.
	 * @param {IntersectionObserverEntry} newEntry The current entry for a
	 *    particular target element.
	 * @return {boolean} Returns true if a any threshold has been crossed.
	 * @private
	 */
	IntersectionObserver.prototype._hasCrossedThreshold =
	    function(oldEntry, newEntry) {
	
	  // To make comparing easier, an entry that has a ratio of 0
	  // but does not actually intersect is given a value of -1
	  var oldRatio = oldEntry && oldEntry.isIntersecting ?
	      oldEntry.intersectionRatio || 0 : -1;
	  var newRatio = newEntry.isIntersecting ?
	      newEntry.intersectionRatio || 0 : -1;
	
	  // Ignore unchanged ratios
	  if (oldRatio === newRatio) return;
	
	  for (var i = 0; i < this.thresholds.length; i++) {
	    var threshold = this.thresholds[i];
	
	    // Return true if an entry matches a threshold or if the new ratio
	    // and the old ratio are on the opposite sides of a threshold.
	    if (threshold == oldRatio || threshold == newRatio ||
	        threshold < oldRatio !== threshold < newRatio) {
	      return true;
	    }
	  }
	};
	
	
	/**
	 * Returns whether or not the root element is an element and is in the DOM.
	 * @return {boolean} True if the root element is an element and is in the DOM.
	 * @private
	 */
	IntersectionObserver.prototype._rootIsInDom = function() {
	  return !this.root || containsDeep(document, this.root);
	};
	
	
	/**
	 * Returns whether or not the target element is a child of root.
	 * @param {Element} target The target element to check.
	 * @return {boolean} True if the target element is a child of root.
	 * @private
	 */
	IntersectionObserver.prototype._rootContainsTarget = function(target) {
	  return containsDeep(this.root || document, target);
	};
	
	
	/**
	 * Adds the instance to the global IntersectionObserver registry if it isn't
	 * already present.
	 * @private
	 */
	IntersectionObserver.prototype._registerInstance = function() {
	  if (registry.indexOf(this) < 0) {
	    registry.push(this);
	  }
	};
	
	
	/**
	 * Removes the instance from the global IntersectionObserver registry.
	 * @private
	 */
	IntersectionObserver.prototype._unregisterInstance = function() {
	  var index = registry.indexOf(this);
	  if (index != -1) registry.splice(index, 1);
	};
	
	
	/**
	 * Returns the result of the performance.now() method or null in browsers
	 * that don't support the API.
	 * @return {number} The elapsed time since the page was requested.
	 */
	function now() {
	  return window.performance && performance.now && performance.now();
	}
	
	
	/**
	 * Throttles a function and delays its executiong, so it's only called at most
	 * once within a given time period.
	 * @param {Function} fn The function to throttle.
	 * @param {number} timeout The amount of time that must pass before the
	 *     function can be called again.
	 * @return {Function} The throttled function.
	 */
	function throttle(fn, timeout) {
	  var timer = null;
	  return function () {
	    if (!timer) {
	      timer = setTimeout(function() {
	        fn();
	        timer = null;
	      }, timeout);
	    }
	  };
	}
	
	
	/**
	 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
	 * @param {Node} node The DOM node to add the event handler to.
	 * @param {string} event The event name.
	 * @param {Function} fn The event handler to add.
	 * @param {boolean} opt_useCapture Optionally adds the even to the capture
	 *     phase. Note: this only works in modern browsers.
	 */
	function addEvent(node, event, fn, opt_useCapture) {
	  if (typeof node.addEventListener == 'function') {
	    node.addEventListener(event, fn, opt_useCapture || false);
	  }
	  else if (typeof node.attachEvent == 'function') {
	    node.attachEvent('on' + event, fn);
	  }
	}
	
	
	/**
	 * Removes a previously added event handler from a DOM node.
	 * @param {Node} node The DOM node to remove the event handler from.
	 * @param {string} event The event name.
	 * @param {Function} fn The event handler to remove.
	 * @param {boolean} opt_useCapture If the event handler was added with this
	 *     flag set to true, it should be set to true here in order to remove it.
	 */
	function removeEvent(node, event, fn, opt_useCapture) {
	  if (typeof node.removeEventListener == 'function') {
	    node.removeEventListener(event, fn, opt_useCapture || false);
	  }
	  else if (typeof node.detatchEvent == 'function') {
	    node.detatchEvent('on' + event, fn);
	  }
	}
	
	
	/**
	 * Returns the intersection between two rect objects.
	 * @param {Object} rect1 The first rect.
	 * @param {Object} rect2 The second rect.
	 * @return {?Object} The intersection rect or undefined if no intersection
	 *     is found.
	 */
	function computeRectIntersection(rect1, rect2) {
	  var top = Math.max(rect1.top, rect2.top);
	  var bottom = Math.min(rect1.bottom, rect2.bottom);
	  var left = Math.max(rect1.left, rect2.left);
	  var right = Math.min(rect1.right, rect2.right);
	  var width = right - left;
	  var height = bottom - top;
	
	  return (width >= 0 && height >= 0) && {
	    top: top,
	    bottom: bottom,
	    left: left,
	    right: right,
	    width: width,
	    height: height
	  };
	}
	
	
	/**
	 * Shims the native getBoundingClientRect for compatibility with older IE.
	 * @param {Element} el The element whose bounding rect to get.
	 * @return {Object} The (possibly shimmed) rect of the element.
	 */
	function getBoundingClientRect(el) {
	  var rect;
	
	  try {
	    rect = el.getBoundingClientRect();
	  } catch (err) {
	    // Ignore Windows 7 IE11 "Unspecified error"
	    // https://github.com/w3c/IntersectionObserver/pull/205
	  }
	
	  if (!rect) return getEmptyRect();
	
	  // Older IE
	  if (!(rect.width && rect.height)) {
	    rect = {
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left,
	      width: rect.right - rect.left,
	      height: rect.bottom - rect.top
	    };
	  }
	  return rect;
	}
	
	
	/**
	 * Returns an empty rect object. An empty rect is returned when an element
	 * is not in the DOM.
	 * @return {Object} The empty rect.
	 */
	function getEmptyRect() {
	  return {
	    top: 0,
	    bottom: 0,
	    left: 0,
	    right: 0,
	    width: 0,
	    height: 0
	  };
	}
	
	/**
	 * Checks to see if a parent element contains a child elemnt (including inside
	 * shadow DOM).
	 * @param {Node} parent The parent element.
	 * @param {Node} child The child element.
	 * @return {boolean} True if the parent node contains the child node.
	 */
	function containsDeep(parent, child) {
	  var node = child;
	  while (node) {
	    if (node == parent) return true;
	
	    node = getParentNode(node);
	  }
	  return false;
	}
	
	
	/**
	 * Gets the parent node of an element or its host element if the parent node
	 * is a shadow root.
	 * @param {Node} node The node whose parent to get.
	 * @return {Node|null} The parent node or null if no parent exists.
	 */
	function getParentNode(node) {
	  var parent = node.parentNode;
	
	  if (parent && parent.nodeType == 11 && parent.host) {
	    // If the parent is a shadow root, return the host element.
	    return parent.host;
	  }
	  return parent;
	}
	
	
	// Exposes the constructors globally.
	window.IntersectionObserver = IntersectionObserver;
	window.IntersectionObserverEntry = IntersectionObserverEntry;
	
	}(window, document));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var alphabetical = __webpack_require__(29)
	var decimal = __webpack_require__(10)
	
	module.exports = alphanumerical
	
	/* Check if the given character code, or the character
	 * code at the first character, is alphanumerical. */
	function alphanumerical(character) {
	  return alphabetical(character) || decimal(character)
	}


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = hexadecimal
	
	/* Check if the given character code, or the character
	 * code at the first character, is hexadecimal. */
	function hexadecimal(character) {
	  var code = typeof character === 'string' ? character.charCodeAt(0) : character
	
	  return (
	    (code >= 97 /* a */ && code <= 102) /* z */ ||
	    (code >= 65 /* A */ && code <= 70) /* Z */ ||
	    (code >= 48 /* A */ && code <= 57) /* Z */
	  )
	}


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	'use strict';
	var toString = Object.prototype.toString;
	
	module.exports = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = wordCharacter
	
	var fromCode = String.fromCharCode
	var re = /\w/
	
	/* Check if the given character code, or the character
	 * code at the first character, is a word character. */
	function wordCharacter(character) {
	  return re.test(
	    typeof character === 'number' ? fromCode(character) : character.charAt(0)
	  )
	}


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = {"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	module.exports = {"AEli":"Æ","AElig":"Æ","AM":"&","AMP":"&","Aacut":"Á","Aacute":"Á","Abreve":"Ă","Acir":"Â","Acirc":"Â","Acy":"А","Afr":"𝔄","Agrav":"À","Agrave":"À","Alpha":"Α","Amacr":"Ā","And":"⩓","Aogon":"Ą","Aopf":"𝔸","ApplyFunction":"⁡","Arin":"Å","Aring":"Å","Ascr":"𝒜","Assign":"≔","Atild":"Ã","Atilde":"Ã","Aum":"Ä","Auml":"Ä","Backslash":"∖","Barv":"⫧","Barwed":"⌆","Bcy":"Б","Because":"∵","Bernoullis":"ℬ","Beta":"Β","Bfr":"𝔅","Bopf":"𝔹","Breve":"˘","Bscr":"ℬ","Bumpeq":"≎","CHcy":"Ч","COP":"©","COPY":"©","Cacute":"Ć","Cap":"⋒","CapitalDifferentialD":"ⅅ","Cayleys":"ℭ","Ccaron":"Č","Ccedi":"Ç","Ccedil":"Ç","Ccirc":"Ĉ","Cconint":"∰","Cdot":"Ċ","Cedilla":"¸","CenterDot":"·","Cfr":"ℭ","Chi":"Χ","CircleDot":"⊙","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","Colon":"∷","Colone":"⩴","Congruent":"≡","Conint":"∯","ContourIntegral":"∮","Copf":"ℂ","Coproduct":"∐","CounterClockwiseContourIntegral":"∳","Cross":"⨯","Cscr":"𝒞","Cup":"⋓","CupCap":"≍","DD":"ⅅ","DDotrahd":"⤑","DJcy":"Ђ","DScy":"Ѕ","DZcy":"Џ","Dagger":"‡","Darr":"↡","Dashv":"⫤","Dcaron":"Ď","Dcy":"Д","Del":"∇","Delta":"Δ","Dfr":"𝔇","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","Diamond":"⋄","DifferentialD":"ⅆ","Dopf":"𝔻","Dot":"¨","DotDot":"⃜","DotEqual":"≐","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrow":"↓","DownArrowBar":"⤓","DownArrowUpArrow":"⇵","DownBreve":"̑","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVector":"↽","DownLeftVectorBar":"⥖","DownRightTeeVector":"⥟","DownRightVector":"⇁","DownRightVectorBar":"⥗","DownTee":"⊤","DownTeeArrow":"↧","Downarrow":"⇓","Dscr":"𝒟","Dstrok":"Đ","ENG":"Ŋ","ET":"Ð","ETH":"Ð","Eacut":"É","Eacute":"É","Ecaron":"Ě","Ecir":"Ê","Ecirc":"Ê","Ecy":"Э","Edot":"Ė","Efr":"𝔈","Egrav":"È","Egrave":"È","Element":"∈","Emacr":"Ē","EmptySmallSquare":"◻","EmptyVerySmallSquare":"▫","Eogon":"Ę","Eopf":"𝔼","Epsilon":"Ε","Equal":"⩵","EqualTilde":"≂","Equilibrium":"⇌","Escr":"ℰ","Esim":"⩳","Eta":"Η","Eum":"Ë","Euml":"Ë","Exists":"∃","ExponentialE":"ⅇ","Fcy":"Ф","Ffr":"𝔉","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","Fopf":"𝔽","ForAll":"∀","Fouriertrf":"ℱ","Fscr":"ℱ","GJcy":"Ѓ","G":">","GT":">","Gamma":"Γ","Gammad":"Ϝ","Gbreve":"Ğ","Gcedil":"Ģ","Gcirc":"Ĝ","Gcy":"Г","Gdot":"Ġ","Gfr":"𝔊","Gg":"⋙","Gopf":"𝔾","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","Gt":"≫","HARDcy":"Ъ","Hacek":"ˇ","Hat":"^","Hcirc":"Ĥ","Hfr":"ℌ","HilbertSpace":"ℋ","Hopf":"ℍ","HorizontalLine":"─","Hscr":"ℋ","Hstrok":"Ħ","HumpDownHump":"≎","HumpEqual":"≏","IEcy":"Е","IJlig":"Ĳ","IOcy":"Ё","Iacut":"Í","Iacute":"Í","Icir":"Î","Icirc":"Î","Icy":"И","Idot":"İ","Ifr":"ℑ","Igrav":"Ì","Igrave":"Ì","Im":"ℑ","Imacr":"Ī","ImaginaryI":"ⅈ","Implies":"⇒","Int":"∬","Integral":"∫","Intersection":"⋂","InvisibleComma":"⁣","InvisibleTimes":"⁢","Iogon":"Į","Iopf":"𝕀","Iota":"Ι","Iscr":"ℐ","Itilde":"Ĩ","Iukcy":"І","Ium":"Ï","Iuml":"Ï","Jcirc":"Ĵ","Jcy":"Й","Jfr":"𝔍","Jopf":"𝕁","Jscr":"𝒥","Jsercy":"Ј","Jukcy":"Є","KHcy":"Х","KJcy":"Ќ","Kappa":"Κ","Kcedil":"Ķ","Kcy":"К","Kfr":"𝔎","Kopf":"𝕂","Kscr":"𝒦","LJcy":"Љ","L":"<","LT":"<","Lacute":"Ĺ","Lambda":"Λ","Lang":"⟪","Laplacetrf":"ℒ","Larr":"↞","Lcaron":"Ľ","Lcedil":"Ļ","Lcy":"Л","LeftAngleBracket":"⟨","LeftArrow":"←","LeftArrowBar":"⇤","LeftArrowRightArrow":"⇆","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVector":"⇃","LeftDownVectorBar":"⥙","LeftFloor":"⌊","LeftRightArrow":"↔","LeftRightVector":"⥎","LeftTee":"⊣","LeftTeeArrow":"↤","LeftTeeVector":"⥚","LeftTriangle":"⊲","LeftTriangleBar":"⧏","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVector":"↿","LeftUpVectorBar":"⥘","LeftVector":"↼","LeftVectorBar":"⥒","Leftarrow":"⇐","Leftrightarrow":"⇔","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","LessLess":"⪡","LessSlantEqual":"⩽","LessTilde":"≲","Lfr":"𝔏","Ll":"⋘","Lleftarrow":"⇚","Lmidot":"Ŀ","LongLeftArrow":"⟵","LongLeftRightArrow":"⟷","LongRightArrow":"⟶","Longleftarrow":"⟸","Longleftrightarrow":"⟺","Longrightarrow":"⟹","Lopf":"𝕃","LowerLeftArrow":"↙","LowerRightArrow":"↘","Lscr":"ℒ","Lsh":"↰","Lstrok":"Ł","Lt":"≪","Map":"⤅","Mcy":"М","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","MinusPlus":"∓","Mopf":"𝕄","Mscr":"ℳ","Mu":"Μ","NJcy":"Њ","Nacute":"Ń","Ncaron":"Ň","Ncedil":"Ņ","Ncy":"Н","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","Nfr":"𝔑","NoBreak":"⁠","NonBreakingSpace":" ","Nopf":"ℕ","Not":"⫬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","NotLeftTriangle":"⋪","NotLeftTriangleBar":"⧏̸","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangle":"⋫","NotRightTriangleBar":"⧐̸","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","Nscr":"𝒩","Ntild":"Ñ","Ntilde":"Ñ","Nu":"Ν","OElig":"Œ","Oacut":"Ó","Oacute":"Ó","Ocir":"Ô","Ocirc":"Ô","Ocy":"О","Odblac":"Ő","Ofr":"𝔒","Ograv":"Ò","Ograve":"Ò","Omacr":"Ō","Omega":"Ω","Omicron":"Ο","Oopf":"𝕆","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","Or":"⩔","Oscr":"𝒪","Oslas":"Ø","Oslash":"Ø","Otild":"Õ","Otilde":"Õ","Otimes":"⨷","Oum":"Ö","Ouml":"Ö","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","PartialD":"∂","Pcy":"П","Pfr":"𝔓","Phi":"Φ","Pi":"Π","PlusMinus":"±","Poincareplane":"ℌ","Popf":"ℙ","Pr":"⪻","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","Prime":"″","Product":"∏","Proportion":"∷","Proportional":"∝","Pscr":"𝒫","Psi":"Ψ","QUO":"\"","QUOT":"\"","Qfr":"𝔔","Qopf":"ℚ","Qscr":"𝒬","RBarr":"⤐","RE":"®","REG":"®","Racute":"Ŕ","Rang":"⟫","Rarr":"↠","Rarrtl":"⤖","Rcaron":"Ř","Rcedil":"Ŗ","Rcy":"Р","Re":"ℜ","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","Rfr":"ℜ","Rho":"Ρ","RightAngleBracket":"⟩","RightArrow":"→","RightArrowBar":"⇥","RightArrowLeftArrow":"⇄","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVector":"⇂","RightDownVectorBar":"⥕","RightFloor":"⌋","RightTee":"⊢","RightTeeArrow":"↦","RightTeeVector":"⥛","RightTriangle":"⊳","RightTriangleBar":"⧐","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVector":"↾","RightUpVectorBar":"⥔","RightVector":"⇀","RightVectorBar":"⥓","Rightarrow":"⇒","Ropf":"ℝ","RoundImplies":"⥰","Rrightarrow":"⇛","Rscr":"ℛ","Rsh":"↱","RuleDelayed":"⧴","SHCHcy":"Щ","SHcy":"Ш","SOFTcy":"Ь","Sacute":"Ś","Sc":"⪼","Scaron":"Š","Scedil":"Ş","Scirc":"Ŝ","Scy":"С","Sfr":"𝔖","ShortDownArrow":"↓","ShortLeftArrow":"←","ShortRightArrow":"→","ShortUpArrow":"↑","Sigma":"Σ","SmallCircle":"∘","Sopf":"𝕊","Sqrt":"√","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","Sscr":"𝒮","Star":"⋆","Sub":"⋐","Subset":"⋐","SubsetEqual":"⊆","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","SuchThat":"∋","Sum":"∑","Sup":"⋑","Superset":"⊃","SupersetEqual":"⊇","Supset":"⋑","THOR":"Þ","THORN":"Þ","TRADE":"™","TSHcy":"Ћ","TScy":"Ц","Tab":"\t","Tau":"Τ","Tcaron":"Ť","Tcedil":"Ţ","Tcy":"Т","Tfr":"𝔗","Therefore":"∴","Theta":"Θ","ThickSpace":"  ","ThinSpace":" ","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","Topf":"𝕋","TripleDot":"⃛","Tscr":"𝒯","Tstrok":"Ŧ","Uacut":"Ú","Uacute":"Ú","Uarr":"↟","Uarrocir":"⥉","Ubrcy":"Ў","Ubreve":"Ŭ","Ucir":"Û","Ucirc":"Û","Ucy":"У","Udblac":"Ű","Ufr":"𝔘","Ugrav":"Ù","Ugrave":"Ù","Umacr":"Ū","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","Uopf":"𝕌","UpArrow":"↑","UpArrowBar":"⤒","UpArrowDownArrow":"⇅","UpDownArrow":"↕","UpEquilibrium":"⥮","UpTee":"⊥","UpTeeArrow":"↥","Uparrow":"⇑","Updownarrow":"⇕","UpperLeftArrow":"↖","UpperRightArrow":"↗","Upsi":"ϒ","Upsilon":"Υ","Uring":"Ů","Uscr":"𝒰","Utilde":"Ũ","Uum":"Ü","Uuml":"Ü","VDash":"⊫","Vbar":"⫫","Vcy":"В","Vdash":"⊩","Vdashl":"⫦","Vee":"⋁","Verbar":"‖","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","Vopf":"𝕍","Vscr":"𝒱","Vvdash":"⊪","Wcirc":"Ŵ","Wedge":"⋀","Wfr":"𝔚","Wopf":"𝕎","Wscr":"𝒲","Xfr":"𝔛","Xi":"Ξ","Xopf":"𝕏","Xscr":"𝒳","YAcy":"Я","YIcy":"Ї","YUcy":"Ю","Yacut":"Ý","Yacute":"Ý","Ycirc":"Ŷ","Ycy":"Ы","Yfr":"𝔜","Yopf":"𝕐","Yscr":"𝒴","Yuml":"Ÿ","ZHcy":"Ж","Zacute":"Ź","Zcaron":"Ž","Zcy":"З","Zdot":"Ż","ZeroWidthSpace":"​","Zeta":"Ζ","Zfr":"ℨ","Zopf":"ℤ","Zscr":"𝒵","aacut":"á","aacute":"á","abreve":"ă","ac":"∾","acE":"∾̳","acd":"∿","acir":"â","acirc":"â","acut":"´","acute":"´","acy":"а","aeli":"æ","aelig":"æ","af":"⁡","afr":"𝔞","agrav":"à","agrave":"à","alefsym":"ℵ","aleph":"ℵ","alpha":"α","amacr":"ā","amalg":"⨿","am":"&","amp":"&","and":"∧","andand":"⩕","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsd":"∡","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","aogon":"ą","aopf":"𝕒","ap":"≈","apE":"⩰","apacir":"⩯","ape":"≊","apid":"≋","apos":"'","approx":"≈","approxeq":"≊","arin":"å","aring":"å","ascr":"𝒶","ast":"*","asymp":"≈","asympeq":"≍","atild":"ã","atilde":"ã","aum":"ä","auml":"ä","awconint":"∳","awint":"⨑","bNot":"⫭","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","barvee":"⊽","barwed":"⌅","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","beta":"β","beth":"ℶ","between":"≬","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bnot":"⌐","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxDL":"╗","boxDR":"╔","boxDl":"╖","boxDr":"╓","boxH":"═","boxHD":"╦","boxHU":"╩","boxHd":"╤","boxHu":"╧","boxUL":"╝","boxUR":"╚","boxUl":"╜","boxUr":"╙","boxV":"║","boxVH":"╬","boxVL":"╣","boxVR":"╠","boxVh":"╫","boxVl":"╢","boxVr":"╟","boxbox":"⧉","boxdL":"╕","boxdR":"╒","boxdl":"┐","boxdr":"┌","boxh":"─","boxhD":"╥","boxhU":"╨","boxhd":"┬","boxhu":"┴","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxuL":"╛","boxuR":"╘","boxul":"┘","boxur":"└","boxv":"│","boxvH":"╪","boxvL":"╡","boxvR":"╞","boxvh":"┼","boxvl":"┤","boxvr":"├","bprime":"‵","breve":"˘","brvba":"¦","brvbar":"¦","bscr":"𝒷","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsol":"\\","bsolb":"⧅","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","bumpeq":"≏","cacute":"ć","cap":"∩","capand":"⩄","capbrcup":"⩉","capcap":"⩋","capcup":"⩇","capdot":"⩀","caps":"∩︀","caret":"⁁","caron":"ˇ","ccaps":"⩍","ccaron":"č","ccedi":"ç","ccedil":"ç","ccirc":"ĉ","ccups":"⩌","ccupssm":"⩐","cdot":"ċ","cedi":"¸","cedil":"¸","cemptyv":"⦲","cen":"¢","cent":"¢","centerdot":"·","cfr":"𝔠","chcy":"ч","check":"✓","checkmark":"✓","chi":"χ","cir":"○","cirE":"⧃","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledR":"®","circledS":"Ⓢ","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","clubs":"♣","clubsuit":"♣","colon":":","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","conint":"∮","copf":"𝕔","coprod":"∐","cop":"©","copy":"©","copysr":"℗","crarr":"↵","cross":"✗","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cup":"∪","cupbrcap":"⩈","cupcap":"⩆","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curre":"¤","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dArr":"⇓","dHar":"⥥","dagger":"†","daleth":"ℸ","darr":"↓","dash":"‐","dashv":"⊣","dbkarow":"⤏","dblac":"˝","dcaron":"ď","dcy":"д","dd":"ⅆ","ddagger":"‡","ddarr":"⇊","ddotseq":"⩷","de":"°","deg":"°","delta":"δ","demptyv":"⦱","dfisht":"⥿","dfr":"𝔡","dharl":"⇃","dharr":"⇂","diam":"⋄","diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","digamma":"ϝ","disin":"⋲","div":"÷","divid":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","dopf":"𝕕","dot":"˙","doteq":"≐","doteqdot":"≑","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","downarrow":"↓","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","dscr":"𝒹","dscy":"ѕ","dsol":"⧶","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","dzcy":"џ","dzigrarr":"⟿","eDDot":"⩷","eDot":"≑","eacut":"é","eacute":"é","easter":"⩮","ecaron":"ě","ecir":"ê","ecirc":"ê","ecolon":"≕","ecy":"э","edot":"ė","ee":"ⅇ","efDot":"≒","efr":"𝔢","eg":"⪚","egrav":"è","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","emacr":"ē","empty":"∅","emptyset":"∅","emptyv":"∅","emsp13":" ","emsp14":" ","emsp":" ","eng":"ŋ","ensp":" ","eogon":"ę","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","equals":"=","equest":"≟","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erDot":"≓","erarr":"⥱","escr":"ℯ","esdot":"≐","esim":"≂","eta":"η","et":"ð","eth":"ð","eum":"ë","euml":"ë","euro":"€","excl":"!","exist":"∃","expectation":"ℰ","exponentiale":"ⅇ","fallingdotseq":"≒","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","ffr":"𝔣","filig":"ﬁ","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","fopf":"𝕗","forall":"∀","fork":"⋔","forkv":"⫙","fpartint":"⨍","frac1":"¼","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac3":"¾","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","gE":"≧","gEl":"⪌","gacute":"ǵ","gamma":"γ","gammad":"ϝ","gap":"⪆","gbreve":"ğ","gcirc":"ĝ","gcy":"г","gdot":"ġ","ge":"≥","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","ges":"⩾","gescc":"⪩","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","gfr":"𝔤","gg":"≫","ggg":"⋙","gimel":"ℷ","gjcy":"ѓ","gl":"≷","glE":"⪒","gla":"⪥","glj":"⪤","gnE":"≩","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gneq":"⪈","gneqq":"≩","gnsim":"⋧","gopf":"𝕘","grave":"`","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","g":">","gt":">","gtcc":"⪧","gtcir":"⩺","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","hArr":"⇔","hairsp":" ","half":"½","hamilt":"ℋ","hardcy":"ъ","harr":"↔","harrcir":"⥈","harrw":"↭","hbar":"ℏ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","horbar":"―","hscr":"𝒽","hslash":"ℏ","hstrok":"ħ","hybull":"⁃","hyphen":"‐","iacut":"í","iacute":"í","ic":"⁣","icir":"î","icirc":"î","icy":"и","iecy":"е","iexc":"¡","iexcl":"¡","iff":"⇔","ifr":"𝔦","igrav":"ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","ijlig":"ĳ","imacr":"ī","image":"ℑ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","imof":"⊷","imped":"Ƶ","in":"∈","incare":"℅","infin":"∞","infintie":"⧝","inodot":"ı","int":"∫","intcal":"⊺","integers":"ℤ","intercal":"⊺","intlarhk":"⨗","intprod":"⨼","iocy":"ё","iogon":"į","iopf":"𝕚","iota":"ι","iprod":"⨼","iques":"¿","iquest":"¿","iscr":"𝒾","isin":"∈","isinE":"⋹","isindot":"⋵","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","itilde":"ĩ","iukcy":"і","ium":"ï","iuml":"ï","jcirc":"ĵ","jcy":"й","jfr":"𝔧","jmath":"ȷ","jopf":"𝕛","jscr":"𝒿","jsercy":"ј","jukcy":"є","kappa":"κ","kappav":"ϰ","kcedil":"ķ","kcy":"к","kfr":"𝔨","kgreen":"ĸ","khcy":"х","kjcy":"ќ","kopf":"𝕜","kscr":"𝓀","lAarr":"⇚","lArr":"⇐","lAtail":"⤛","lBarr":"⤎","lE":"≦","lEg":"⪋","lHar":"⥢","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","lambda":"λ","lang":"⟨","langd":"⦑","langle":"⟨","lap":"⪅","laqu":"«","laquo":"«","larr":"←","larrb":"⇤","larrbfs":"⤟","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","lat":"⪫","latail":"⤙","late":"⪭","lates":"⪭︀","lbarr":"⤌","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","lcaron":"ľ","lcedil":"ļ","lceil":"⌈","lcub":"{","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","leftarrow":"←","leftarrowtail":"↢","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","leftthreetimes":"⋋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","les":"⩽","lescc":"⪨","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","lessgtr":"≶","lesssim":"≲","lfisht":"⥼","lfloor":"⌊","lfr":"𝔩","lg":"≶","lgE":"⪑","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","ljcy":"љ","ll":"≪","llarr":"⇇","llcorner":"⌞","llhard":"⥫","lltri":"◺","lmidot":"ŀ","lmoust":"⎰","lmoustache":"⎰","lnE":"≨","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","longleftrightarrow":"⟷","longmapsto":"⟼","longrightarrow":"⟶","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","lstrok":"ł","l":"<","lt":"<","ltcc":"⪦","ltcir":"⩹","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltrPar":"⦖","ltri":"◃","ltrie":"⊴","ltrif":"◂","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","mDDot":"∺","mac":"¯","macr":"¯","male":"♂","malt":"✠","maltese":"✠","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","mcy":"м","mdash":"—","measuredangle":"∡","mfr":"𝔪","mho":"℧","micr":"µ","micro":"µ","mid":"∣","midast":"*","midcir":"⫰","middo":"·","middot":"·","minus":"−","minusb":"⊟","minusd":"∸","minusdu":"⨪","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","mopf":"𝕞","mp":"∓","mscr":"𝓂","mstpos":"∾","mu":"μ","multimap":"⊸","mumap":"⊸","nGg":"⋙̸","nGt":"≫⃒","nGtv":"≫̸","nLeftarrow":"⇍","nLeftrightarrow":"⇎","nLl":"⋘̸","nLt":"≪⃒","nLtv":"≪̸","nRightarrow":"⇏","nVDash":"⊯","nVdash":"⊮","nabla":"∇","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natur":"♮","natural":"♮","naturals":"ℕ","nbs":" ","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","ncaron":"ň","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","ncy":"н","ndash":"–","ne":"≠","neArr":"⇗","nearhk":"⤤","nearr":"↗","nearrow":"↗","nedot":"≐̸","nequiv":"≢","nesear":"⤨","nesim":"≂̸","nexist":"∄","nexists":"∄","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","ngsim":"≵","ngt":"≯","ngtr":"≯","nhArr":"⇎","nharr":"↮","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","njcy":"њ","nlArr":"⇍","nlE":"≦̸","nlarr":"↚","nldr":"‥","nle":"≰","nleftarrow":"↚","nleftrightarrow":"↮","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nlsim":"≴","nlt":"≮","nltri":"⋪","nltrie":"⋬","nmid":"∤","nopf":"𝕟","no":"¬","not":"¬","notin":"∉","notinE":"⋹̸","notindot":"⋵̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","npar":"∦","nparallel":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","npre":"⪯̸","nprec":"⊀","npreceq":"⪯̸","nrArr":"⇏","nrarr":"↛","nrarrc":"⤳̸","nrarrw":"↝̸","nrightarrow":"↛","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","ntild":"ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","nu":"ν","num":"#","numero":"№","numsp":" ","nvDash":"⊭","nvHarr":"⤄","nvap":"≍⃒","nvdash":"⊬","nvge":"≥⃒","nvgt":">⃒","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwArr":"⇖","nwarhk":"⤣","nwarr":"↖","nwarrow":"↖","nwnear":"⤧","oS":"Ⓢ","oacut":"ó","oacute":"ó","oast":"⊛","ocir":"ô","ocirc":"ô","ocy":"о","odash":"⊝","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","oelig":"œ","ofcir":"⦿","ofr":"𝔬","ogon":"˛","ograv":"ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","omacr":"ō","omega":"ω","omicron":"ο","omid":"⦶","ominus":"⊖","oopf":"𝕠","opar":"⦷","operp":"⦹","oplus":"⊕","or":"∨","orarr":"↻","ord":"º","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oscr":"ℴ","oslas":"ø","oslash":"ø","osol":"⊘","otild":"õ","otilde":"õ","otimes":"⊗","otimesas":"⨶","oum":"ö","ouml":"ö","ovbar":"⌽","par":"¶","para":"¶","parallel":"∥","parsim":"⫳","parsl":"⫽","part":"∂","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","pfr":"𝔭","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plus":"+","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plusdo":"∔","plusdu":"⨥","pluse":"⩲","plusm":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","pointint":"⨕","popf":"𝕡","poun":"£","pound":"£","pr":"≺","prE":"⪳","prap":"⪷","prcue":"≼","pre":"⪯","prec":"≺","precapprox":"⪷","preccurlyeq":"≼","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","precsim":"≾","prime":"′","primes":"ℙ","prnE":"⪵","prnap":"⪹","prnsim":"⋨","prod":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","propto":"∝","prsim":"≾","prurel":"⊰","pscr":"𝓅","psi":"ψ","puncsp":" ","qfr":"𝔮","qint":"⨌","qopf":"𝕢","qprime":"⁗","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quo":"\"","quot":"\"","rAarr":"⇛","rArr":"⇒","rAtail":"⤜","rBarr":"⤏","rHar":"⥤","race":"∽̱","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","rangd":"⦒","range":"⦥","rangle":"⟩","raqu":"»","raquo":"»","rarr":"→","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","rarrtl":"↣","rarrw":"↝","ratail":"⤚","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","rcaron":"ř","rcedil":"ŗ","rceil":"⌉","rcub":"}","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","rect":"▭","re":"®","reg":"®","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","rhard":"⇁","rharu":"⇀","rharul":"⥬","rho":"ρ","rhov":"ϱ","rightarrow":"→","rightarrowtail":"↣","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","rightthreetimes":"⋌","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoust":"⎱","rmoustache":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","roplus":"⨮","rotimes":"⨵","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","rsaquo":"›","rscr":"𝓇","rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","ruluhar":"⥨","rx":"℞","sacute":"ś","sbquo":"‚","sc":"≻","scE":"⪴","scap":"⪸","scaron":"š","sccue":"≽","sce":"⪰","scedil":"ş","scirc":"ŝ","scnE":"⪶","scnap":"⪺","scnsim":"⋩","scpolint":"⨓","scsim":"≿","scy":"с","sdot":"⋅","sdotb":"⊡","sdote":"⩦","seArr":"⇘","searhk":"⤥","searr":"↘","searrow":"↘","sec":"§","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","sfr":"𝔰","sfrown":"⌢","sharp":"♯","shchcy":"щ","shcy":"ш","shortmid":"∣","shortparallel":"∥","sh":"­","shy":"­","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","softcy":"ь","sol":"/","solb":"⧄","solbar":"⌿","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","squ":"□","square":"□","squarf":"▪","squf":"▪","srarr":"→","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","subE":"⫅","subdot":"⪽","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","subseteq":"⊆","subseteqq":"⫅","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succ":"≻","succapprox":"⪸","succcurlyeq":"≽","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","sum":"∑","sung":"♪","sup":"⊃","sup1":"¹","sup2":"²","sup3":"³","supE":"⫆","supdot":"⪾","supdsub":"⫘","supe":"⊇","supedot":"⫄","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swArr":"⇙","swarhk":"⤦","swarr":"↙","swarrow":"↙","swnwar":"⤪","szli":"ß","szlig":"ß","target":"⌖","tau":"τ","tbrk":"⎴","tcaron":"ť","tcedil":"ţ","tcy":"т","tdot":"⃛","telrec":"⌕","tfr":"𝔱","there4":"∴","therefore":"∴","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","thinsp":" ","thkap":"≈","thksim":"∼","thor":"þ","thorn":"þ","tilde":"˜","time":"×","times":"×","timesb":"⊠","timesbar":"⨱","timesd":"⨰","tint":"∭","toea":"⤨","top":"⊤","topbot":"⌶","topcir":"⫱","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","tscr":"𝓉","tscy":"ц","tshcy":"ћ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","uArr":"⇑","uHar":"⥣","uacut":"ú","uacute":"ú","uarr":"↑","ubrcy":"ў","ubreve":"ŭ","ucir":"û","ucirc":"û","ucy":"у","udarr":"⇅","udblac":"ű","udhar":"⥮","ufisht":"⥾","ufr":"𝔲","ugrav":"ù","ugrave":"ù","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","umacr":"ū","um":"¨","uml":"¨","uogon":"ų","uopf":"𝕦","uparrow":"↑","updownarrow":"↕","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","upsi":"υ","upsih":"ϒ","upsilon":"υ","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","uring":"ů","urtri":"◹","uscr":"𝓊","utdot":"⋰","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","uum":"ü","uuml":"ü","uwangle":"⦧","vArr":"⇕","vBar":"⫨","vBarv":"⫩","vDash":"⊨","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vcy":"в","vdash":"⊢","vee":"∨","veebar":"⊻","veeeq":"≚","vellip":"⋮","verbar":"|","vert":"|","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","vopf":"𝕧","vprop":"∝","vrtri":"⊳","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","vzigzag":"⦚","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","wedgeq":"≙","weierp":"℘","wfr":"𝔴","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","xfr":"𝔵","xhArr":"⟺","xharr":"⟷","xi":"ξ","xlArr":"⟸","xlarr":"⟵","xmap":"⟼","xnis":"⋻","xodot":"⨀","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrArr":"⟹","xrarr":"⟶","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","yacut":"ý","yacute":"ý","yacy":"я","ycirc":"ŷ","ycy":"ы","ye":"¥","yen":"¥","yfr":"𝔶","yicy":"ї","yopf":"𝕪","yscr":"𝓎","yucy":"ю","yum":"ÿ","yuml":"ÿ","zacute":"ź","zcaron":"ž","zcy":"з","zdot":"ż","zeetrf":"ℨ","zeta":"ζ","zfr":"𝔷","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = {"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	module.exports = ["address","article","aside","base","basefont","blockquote","body","caption","center","col","colgroup","dd","details","dialog","dir","div","dl","dt","fieldset","figcaption","figure","footer","form","frame","frameset","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","legend","li","link","main","menu","menuitem","meta","nav","noframes","ol","optgroup","option","p","param","pre","section","source","title","summary","table","tbody","td","tfoot","th","thead","title","tr","track","ul"]

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = escapes
	
	var defaults = [
	  '\\',
	  '`',
	  '*',
	  '{',
	  '}',
	  '[',
	  ']',
	  '(',
	  ')',
	  '#',
	  '+',
	  '-',
	  '.',
	  '!',
	  '_',
	  '>'
	]
	
	var gfm = defaults.concat(['~', '|'])
	
	var commonmark = gfm.concat([
	  '\n',
	  '"',
	  '$',
	  '%',
	  '&',
	  "'",
	  ',',
	  '/',
	  ':',
	  ';',
	  '<',
	  '=',
	  '?',
	  '@',
	  '^'
	])
	
	escapes.default = defaults
	escapes.gfm = gfm
	escapes.commonmark = commonmark
	
	/* Get markdown escapes. */
	function escapes(options) {
	  var settings = options || {}
	
	  if (settings.commonmark) {
	    return commonmark
	  }
	
	  return settings.gfm ? gfm : defaults
	}


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var visitWithParents = __webpack_require__(139);
	
	function addListMetadata() {
	  return function (ast) {
	    visitWithParents(ast, 'list', function (listNode, parents) {
	      var depth = 0, i, n;
	      for (i = 0, n = parents.length; i < n; i++) {
	        if (parents[i].type === 'list') depth += 1;
	      }
	      for (i = 0, n = listNode.children.length; i < n; i++) {
	        var child = listNode.children[i];
	        child.index = i;
	        child.ordered = listNode.ordered;
	      }
	      listNode.depth = depth;
	    });
	    return ast;
	  };
	}
	
	module.exports = addListMetadata;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var xtend = __webpack_require__(5);
	
	function astToReact(node, options) {
	  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	  var renderer = options.renderers[node.type];
	
	  var pos = node.position.start;
	  var key = [node.type, pos.line, pos.column].join('-');
	
	  if (node.type === 'text') {
	    return renderer ? renderer(node.value, key) : node.value;
	  }
	
	  if (typeof renderer !== 'function' && typeof renderer !== 'string' && !isReactFragment(renderer)) {
	    throw new Error('Renderer for type `' + node.type + '` not defined or is not renderable');
	  }
	
	  var nodeProps = getNodeProps(node, key, options, renderer, parent, index);
	
	  return React.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);
	
	  function resolveChildren() {
	    return node.children && node.children.map(function (childNode, i) {
	      return astToReact(childNode, options, { node: node, props: nodeProps }, i);
	    });
	  }
	}
	
	function isReactFragment(renderer) {
	  return React.Fragment && React.Fragment === renderer;
	}
	
	// eslint-disable-next-line max-params, complexity
	function getNodeProps(node, key, opts, renderer, parent, index) {
	  var props = { key: key };
	
	  var isTagRenderer = typeof renderer === 'string';
	
	  // `sourcePos` is true if the user wants source information (line/column info from markdown source)
	  if (opts.sourcePos && node.position) {
	    props['data-sourcepos'] = flattenPosition(node.position);
	  }
	
	  if (opts.rawSourcePos && !isTagRenderer) {
	    props.sourcePosition = node.position;
	  }
	
	  // If `includeNodeIndex` is true, pass node index info to all non-tag renderers
	  if (opts.includeNodeIndex && parent.node && parent.node.children && !isTagRenderer) {
	    props.index = parent.node.children.indexOf(node);
	    props.parentChildCount = parent.node.children.length;
	  }
	
	  var ref = node.identifier !== null && node.identifier !== undefined ? opts.definitions[node.identifier] || {} : null;
	
	  switch (node.type) {
	    case 'root':
	      assignDefined(props, { className: opts.className });
	      break;
	    case 'heading':
	      props.level = node.depth;
	      break;
	    case 'list':
	      props.start = node.start;
	      props.ordered = node.ordered;
	      props.tight = !node.loose;
	      props.depth = node.depth;
	      break;
	    case 'listItem':
	      props.checked = node.checked;
	      props.tight = !node.loose;
	      props.ordered = node.ordered;
	      props.index = node.index;
	      props.children = (props.tight ? unwrapParagraphs(node) : node.children).map(function (childNode, i) {
	        return astToReact(childNode, opts, { node: node, props: props }, i);
	      });
	      break;
	    case 'definition':
	      assignDefined(props, { identifier: node.identifier, title: node.title, url: node.url });
	      break;
	    case 'code':
	      assignDefined(props, { language: node.lang && node.lang.split(/\s/, 1)[0] });
	      break;
	    case 'inlineCode':
	      props.children = node.value;
	      props.inline = true;
	      break;
	    case 'link':
	      assignDefined(props, {
	        title: node.title || undefined,
	        target: typeof opts.linkTarget === 'function' ? opts.linkTarget(node.url, node.children, node.title) : opts.linkTarget,
	        href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
	      });
	      break;
	    case 'image':
	      assignDefined(props, {
	        alt: node.alt || undefined,
	        title: node.title || undefined,
	        src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url
	      });
	      break;
	    case 'linkReference':
	      assignDefined(props, xtend(ref, {
	        href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
	      }));
	      break;
	    case 'imageReference':
	      assignDefined(props, {
	        src: opts.transformImageUri && ref.href ? opts.transformImageUri(ref.href, node.children, ref.title, node.alt) : ref.href,
	        title: ref.title || undefined,
	        alt: node.alt || undefined
	      });
	      break;
	    case 'table':
	    case 'tableHead':
	    case 'tableBody':
	      props.columnAlignment = node.align;
	      break;
	    case 'tableRow':
	      props.isHeader = parent.node.type === 'tableHead';
	      props.columnAlignment = parent.props.columnAlignment;
	      break;
	    case 'tableCell':
	      assignDefined(props, {
	        isHeader: parent.props.isHeader,
	        align: parent.props.columnAlignment[index]
	      });
	      break;
	    case 'virtualHtml':
	      props.tag = node.tag;
	      break;
	    case 'html':
	      // @todo find a better way than this
	      props.isBlock = node.position.start.line !== node.position.end.line;
	      props.escapeHtml = opts.escapeHtml;
	      props.skipHtml = opts.skipHtml;
	      break;
	    default:
	      assignDefined(props, xtend(node, {
	        type: undefined,
	        position: undefined,
	        children: undefined
	      }));
	  }
	
	  if (!isTagRenderer && node.value) {
	    props.value = node.value;
	  }
	
	  return props;
	}
	
	function assignDefined(target, attrs) {
	  for (var key in attrs) {
	    if (typeof attrs[key] !== 'undefined') {
	      target[key] = attrs[key];
	    }
	  }
	}
	
	function flattenPosition(pos) {
	  return [pos.start.line, ':', pos.start.column, '-', pos.end.line, ':', pos.end.column].map(String).join('');
	}
	
	function unwrapParagraphs(node) {
	  return node.children.reduce(function (array, child) {
	    return array.concat(child.type === 'paragraph' ? child.children || [] : [child]);
	  }, []);
	}
	
	module.exports = astToReact;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function getDefinitions(node) {
	  var defs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return (node.children || []).reduce(function (definitions, child) {
	    if (child.type === 'definition') {
	      definitions[child.identifier] = {
	        href: child.url,
	        title: child.title
	      };
	    }
	
	    return getDefinitions(child, definitions);
	  }, defs);
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(11);
	
	exports.ofType = function (types, mode) {
	  return function (node) {
	    types.forEach(function (type) {
	      return visit(node, type, disallow, true);
	    });
	    return node;
	  };
	
	  function disallow(node, index, parent) {
	    if (parent) {
	      untangle(node, index, parent, mode);
	    }
	  }
	};
	
	exports.ifNotMatch = function (allowNode, mode) {
	  return function (node) {
	    visit(node, disallow, true);
	    return node;
	  };
	
	  function disallow(node, index, parent) {
	    if (parent && !allowNode(node, index, parent)) {
	      untangle(node, index, parent, mode);
	    }
	  }
	};
	
	function untangle(node, index, parent, mode) {
	  if (mode === 'remove') {
	    parent.children.splice(index, 1);
	  } else if (mode === 'unwrap') {
	    var args = [index, 1];
	
	    if (node.children) {
	      args = args.concat(node.children);
	    }
	
	    Array.prototype.splice.apply(parent.children, args);
	  }
	}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Naive, simple plugin to match inline nodes without attributes
	 * This allows say <strong>foo</strong>, but not <strong class="very">foo</strong>
	 * For proper HTML support, you'll want a different plugin
	 **/
	var visit = __webpack_require__(11);
	
	var type = 'virtualHtml';
	var selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
	var simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;
	
	module.exports = function (tree) {
	  var open = void 0;
	  var currentParent = void 0;
	  visit(tree, 'html', function (node, index, parent) {
	    if (currentParent !== parent) {
	      open = [];
	      currentParent = parent;
	    }
	
	    var selfClosing = getSelfClosing(node);
	    if (selfClosing) {
	      parent.children.splice(index, 1, {
	        type: type,
	        tag: selfClosing,
	        position: node.position
	      });
	      return true;
	    }
	
	    var current = getSimpleTag(node, parent);
	    if (!current) {
	      return true;
	    }
	
	    var matching = findAndPull(open, current.tag);
	
	    if (matching) {
	      parent.children.splice(index, 0, virtual(current, matching, parent));
	    } else if (!current.opening) {
	      open.push(current);
	    }
	
	    return true;
	  }, true // Iterate in reverse
	  );
	
	  return tree;
	};
	
	function findAndPull(open, matchingTag) {
	  var i = open.length;
	  while (i--) {
	    if (open[i].tag === matchingTag) {
	      return open.splice(i, 1)[0];
	    }
	  }
	
	  return false;
	}
	
	function getSimpleTag(node, parent) {
	  var match = node.value.match(simpleTagRe);
	  return match ? { tag: match[2], opening: !match[1], node: node } : false;
	}
	
	function getSelfClosing(node) {
	  var match = node.value.match(selfClosingRe);
	  return match ? match[1] : false;
	}
	
	function virtual(fromNode, toNode, parent) {
	  var fromIndex = parent.children.indexOf(fromNode.node);
	  var toIndex = parent.children.indexOf(toNode.node);
	
	  var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
	  var children = extracted.slice(1, -1);
	  return {
	    type: type,
	    children: children,
	    tag: fromNode.tag,
	    position: {
	      start: fromNode.node.position.start,
	      end: toNode.node.position.end,
	      indent: []
	    }
	  };
	}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var xtend = __webpack_require__(5);
	var unified = __webpack_require__(135);
	var parse = __webpack_require__(90);
	var PropTypes = __webpack_require__(2);
	var addListMetadata = __webpack_require__(78);
	var naiveHtml = __webpack_require__(82);
	var disallowNode = __webpack_require__(81);
	var astToReact = __webpack_require__(79);
	var wrapTableRows = __webpack_require__(86);
	var getDefinitions = __webpack_require__(80);
	var uriTransformer = __webpack_require__(85);
	var defaultRenderers = __webpack_require__(84);
	
	var allTypes = Object.keys(defaultRenderers);
	
	var ReactMarkdown = function ReactMarkdown(props) {
	  var src = props.source || props.children || '';
	
	  if (props.allowedTypes && props.disallowedTypes) {
	    throw new Error('Only one of `allowedTypes` and `disallowedTypes` should be defined');
	  }
	
	  var renderers = xtend(defaultRenderers, props.renderers);
	
	  var plugins = [parse].concat(props.plugins || []);
	  var parser = plugins.reduce(applyParserPlugin, unified());
	
	  var rawAst = parser.parse(src);
	  var renderProps = xtend(props, {
	    renderers: renderers,
	    definitions: getDefinitions(rawAst)
	  });
	
	  var astPlugins = determineAstPlugins(props);
	  var ast = astPlugins.reduce(function (node, plugin) {
	    return plugin(node, renderProps);
	  }, rawAst);
	
	  return astToReact(ast, renderProps);
	};
	
	function applyParserPlugin(parser, plugin) {
	  return Array.isArray(plugin) ? parser.use.apply(parser, _toConsumableArray(plugin)) : parser.use(plugin);
	}
	
	function determineAstPlugins(props) {
	  var plugins = [wrapTableRows, addListMetadata()];
	
	  var disallowedTypes = props.disallowedTypes;
	  if (props.allowedTypes) {
	    disallowedTypes = allTypes.filter(function (type) {
	      return type !== 'root' && props.allowedTypes.indexOf(type) === -1;
	    });
	  }
	
	  var removalMethod = props.unwrapDisallowed ? 'unwrap' : 'remove';
	  if (disallowedTypes && disallowedTypes.length > 0) {
	    plugins.push(disallowNode.ofType(disallowedTypes, removalMethod));
	  }
	
	  if (props.allowNode) {
	    plugins.push(disallowNode.ifNotMatch(props.allowNode, removalMethod));
	  }
	
	  var renderHtml = !props.escapeHtml && !props.skipHtml;
	  if (renderHtml) {
	    plugins.push(naiveHtml);
	  }
	
	  return props.astPlugins ? plugins.concat(props.astPlugins) : plugins;
	}
	
	ReactMarkdown.defaultProps = {
	  renderers: {},
	  escapeHtml: true,
	  skipHtml: false,
	  sourcePos: false,
	  rawSourcePos: false,
	  transformLinkUri: uriTransformer,
	  astPlugins: [],
	  plugins: []
	};
	
	ReactMarkdown.propTypes = {
	  className: PropTypes.string,
	  source: PropTypes.string,
	  children: PropTypes.string,
	  sourcePos: PropTypes.bool,
	  rawSourcePos: PropTypes.bool,
	  escapeHtml: PropTypes.bool,
	  skipHtml: PropTypes.bool,
	  allowNode: PropTypes.func,
	  allowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
	  disallowedTypes: PropTypes.arrayOf(PropTypes.oneOf(allTypes)),
	  transformLinkUri: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
	  linkTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
	  transformImageUri: PropTypes.func,
	  astPlugins: PropTypes.arrayOf(PropTypes.func),
	  unwrapDisallowed: PropTypes.bool,
	  renderers: PropTypes.object,
	  plugins: PropTypes.array
	};
	
	ReactMarkdown.types = allTypes;
	ReactMarkdown.renderers = defaultRenderers;
	ReactMarkdown.uriTransformer = uriTransformer;
	
	module.exports = ReactMarkdown;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable react/prop-types, react/no-multi-comp */
	'use strict';
	
	var xtend = __webpack_require__(5);
	var React = __webpack_require__(1);
	var createElement = React.createElement;
	
	module.exports = {
	  root: 'div',
	  break: 'br',
	  paragraph: 'p',
	  emphasis: 'em',
	  strong: 'strong',
	  thematicBreak: 'hr',
	  blockquote: 'blockquote',
	  delete: 'del',
	  link: 'a',
	  image: 'img',
	  linkReference: 'a',
	  imageReference: 'img',
	  table: SimpleRenderer.bind(null, 'table'),
	  tableHead: SimpleRenderer.bind(null, 'thead'),
	  tableBody: SimpleRenderer.bind(null, 'tbody'),
	  tableRow: SimpleRenderer.bind(null, 'tr'),
	  tableCell: TableCell,
	
	  list: List,
	  listItem: ListItem,
	  definition: NullRenderer,
	  heading: Heading,
	  inlineCode: InlineCode,
	  code: CodeBlock,
	  html: Html,
	  virtualHtml: VirtualHtml
	};
	
	function SimpleRenderer(tag, props) {
	  return createElement(tag, getCoreProps(props), props.children);
	}
	
	function TableCell(props) {
	  var style = props.align ? { textAlign: props.align } : undefined;
	  var coreProps = getCoreProps(props);
	  return createElement(props.isHeader ? 'th' : 'td', style ? xtend({ style: style }, coreProps) : coreProps, props.children);
	}
	
	function Heading(props) {
	  return createElement('h' + props.level, getCoreProps(props), props.children);
	}
	
	function List(props) {
	  var attrs = getCoreProps(props);
	  if (props.start !== null && props.start !== 1) {
	    attrs.start = props.start.toString();
	  }
	
	  return createElement(props.ordered ? 'ol' : 'ul', attrs, props.children);
	}
	
	function ListItem(props) {
	  var checkbox = null;
	  if (props.checked !== null) {
	    var checked = props.checked;
	    checkbox = createElement('input', { type: 'checkbox', checked: checked, readOnly: true });
	  }
	
	  return createElement('li', getCoreProps(props), checkbox, props.children);
	}
	
	function CodeBlock(props) {
	  var className = props.language && 'language-' + props.language;
	  var code = createElement('code', className ? { className: className } : null, props.value);
	  return createElement('pre', getCoreProps(props), code);
	}
	
	function InlineCode(props) {
	  return createElement('code', getCoreProps(props), props.children);
	}
	
	function Html(props) {
	  if (props.skipHtml) {
	    return null;
	  }
	
	  var tag = props.isBlock ? 'div' : 'span';
	  if (props.escapeHtml) {
	    // @todo when fiber lands, we can simply render props.value
	    return createElement(tag, null, props.value);
	  }
	
	  var nodeProps = { dangerouslySetInnerHTML: { __html: props.value } };
	  return createElement(tag, nodeProps);
	}
	
	function VirtualHtml(props) {
	  return createElement(props.tag, getCoreProps(props), props.children);
	}
	
	function NullRenderer() {
	  return null;
	}
	
	function getCoreProps(props) {
	  return props['data-sourcepos'] ? { 'data-sourcepos': props['data-sourcepos'] } : {};
	}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	var protocols = ['http', 'https', 'mailto', 'tel'];
	
	module.exports = function uriTransformer(uri) {
	  var url = (uri || '').trim();
	  var first = url.charAt(0);
	
	  if (first === '#' || first === '/') {
	    return url;
	  }
	
	  var colon = url.indexOf(':');
	  if (colon === -1) {
	    return url;
	  }
	
	  var length = protocols.length;
	  var index = -1;
	
	  while (++index < length) {
	    var protocol = protocols[index];
	
	    if (colon === protocol.length && url.slice(0, protocol.length) === protocol) {
	      return url;
	    }
	  }
	
	  index = url.indexOf('?');
	  if (index !== -1 && colon > index) {
	    return url;
	  }
	
	  index = url.indexOf('#');
	  if (index !== -1 && colon > index) {
	    return url;
	  }
	
	  // eslint-disable-next-line no-script-url
	  return 'javascript:void(0)';
	};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(11);
	
	module.exports = function (node) {
	  visit(node, 'table', wrap);
	  return node;
	};
	
	function wrap(table) {
	  var children = table.children;
	  table.children = [{
	    type: 'tableHead',
	    align: table.align,
	    children: [children[0]],
	    position: children[0].position
	  }];
	  if (children.length > 1) {
	    table.children.push({
	      type: 'tableBody',
	      align: table.align,
	      children: children.slice(1),
	      position: {
	        start: children[1].position.start,
	        end: children[children.length - 1].position.end
	      }
	    });
	  }
	}

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateResizeFactor = calculateResizeFactor;
	exports.calculateMousePosition = calculateMousePosition;
	exports.isChildOfType = isChildOfType;
	exports.createNewChildren = createNewChildren;
	exports.roundPath = roundPath;
	exports.createConnectorPath = createConnectorPath;
	exports.createTextAnchor = createTextAnchor;
	exports.computeBackdrop = computeBackdrop;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calculateResizeFactor(actualDimension, baseDimension) {
	  if (actualDimension === 0) return 1;
	  return 1 / 100 * (100 / actualDimension * baseDimension);
	}
	
	function calculateMousePosition(direction, projection, props, zoom, resizeFactor) {
	  var center = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : props.center;
	  var width = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : props.width;
	  var height = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : props.height;
	
	  var reference = { x: 0, y: 1 };
	  var canRotate = !!projection.rotate;
	  var reverseRotation = !!canRotate ? projection.rotate().map(function (item) {
	    return -item;
	  }) : false;
	  var point = !!reverseRotation ? projection.rotate(reverseRotation)([-center[0], -center[1]]) : projection([center[0], center[1]]);
	  var returner = point ? (point[reference[direction]] - (reference[direction] === 0 ? width : height) / 2) * zoom * (1 / resizeFactor) : 0;
	  if (canRotate) projection.rotate([-reverseRotation[0], -reverseRotation[1], -reverseRotation[2]]);
	  return !!reverseRotation ? returner : -returner;
	}
	
	function isChildOfType(child, expectedTypes) {
	  return expectedTypes.indexOf(child.props.componentIdentifier) !== -1;
	}
	
	function createNewChildren(children, props) {
	  if (!children) return;
	  if (!children.length) {
	    return isChildOfType(children, ["Geographies"]) ? _react2.default.cloneElement(children, {
	      projection: props.projection
	    }) : isChildOfType(children, ["Group", "Markers", "Lines", "Annotations", "Annotation", "Graticule"]) ? _react2.default.cloneElement(children, {
	      projection: props.projection,
	      zoom: props.zoom,
	      width: props.width,
	      height: props.height,
	      groupName: props.groupName,
	      itemName: props.itemName
	    }) : children;
	  } else {
	    return children.map(function (child, i) {
	      if (!child) return;
	      return isChildOfType(child, ["Geographies"]) ? _react2.default.cloneElement(child, {
	        key: "zoomable-child-" + i,
	        projection: props.projection
	      }) : isChildOfType(child, ["Group", "Markers", "Lines", "Annotations", "Annotation", "Graticule"]) ? _react2.default.cloneElement(child, {
	        key: "zoomable-child-" + i,
	        projection: props.projection,
	        zoom: props.zoom,
	        width: props.width,
	        height: props.height,
	        groupName: props.groupName,
	        itemName: props.itemName
	      }) : child;
	    });
	  }
	}
	
	function roundPath(path, precision) {
	  if (!path) return;
	  var query = /[\d\.-][\d\.e-]*/g;
	  return path.replace(query, function (n) {
	    return Math.round(n * (1 / precision)) / (1 / precision);
	  });
	}
	
	function createConnectorPath(connectorType, endPoint, curve) {
	  var e0 = endPoint[0];
	  var e1 = endPoint[1];
	  return "M0,0 Q " + (curve + 1) / 2 * e0 + "," + (e1 - (curve + 1) / 2 * e1) + " " + e0 + "," + e1;
	}
	
	function createTextAnchor(dx) {
	  if (dx > 0) return "start";else if (dx < 0) return "end";else return "middle";
	}
	
	function computeBackdrop(projection, backdrop) {
	  var canRotate = projection.rotate;
	  var originalRotation = canRotate ? projection.rotate() : null;
	
	  var tl = canRotate ? projection.rotate([0, 0, 0])([backdrop.x[0], backdrop.y[0]]) : projection([backdrop.x[0], backdrop.y[0]]);
	
	  var br = canRotate ? projection.rotate([0, 0, 0])([backdrop.x[1], backdrop.y[1]]) : projection([backdrop.x[1], backdrop.y[1]]);
	
	  var x = tl ? tl[0] : 0;
	  var x0 = br ? br[0] : 0;
	
	  var y = tl ? tl[1] : 0;
	  var y0 = br ? br[1] : 0;
	
	  var width = x0 - x;
	  var height = y0 - y;
	
	  if (originalRotation) projection.rotate(originalRotation);
	
	  return { x: x, y: y, width: width, height: height };
	}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var unherit = __webpack_require__(134);
	var xtend = __webpack_require__(5);
	var Parser = __webpack_require__(100);
	
	module.exports = parse;
	parse.Parser = Parser;
	
	function parse(options) {
	  var Local = unherit(Parser);
	  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
	  this.Parser = Local;
	}


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(5);
	var entities = __webpack_require__(15);
	
	module.exports = factory;
	
	/* Factory to create an entity decoder. */
	function factory(ctx) {
	  decoder.raw = decodeRaw;
	
	  return decoder;
	
	  /* Normalize `position` to add an `indent`. */
	  function normalize(position) {
	    var offsets = ctx.offset;
	    var line = position.line;
	    var result = [];
	
	    while (++line) {
	      if (!(line in offsets)) {
	        break;
	      }
	
	      result.push((offsets[line] || 0) + 1);
	    }
	
	    return {
	      start: position,
	      indent: result
	    };
	  }
	
	  /* Handle a warning.
	   * See https://github.com/wooorm/parse-entities
	   * for the warnings. */
	  function handleWarning(reason, position, code) {
	    if (code === 3) {
	      return;
	    }
	
	    ctx.file.message(reason, position);
	  }
	
	  /* Decode `value` (at `position`) into text-nodes. */
	  function decoder(value, position, handler) {
	    entities(value, {
	      position: normalize(position),
	      warning: handleWarning,
	      text: handler,
	      reference: handler,
	      textContext: ctx,
	      referenceContext: ctx
	    });
	  }
	
	  /* Decode `value` (at `position`) into a string. */
	  function decodeRaw(value, position, options) {
	    return entities(value, xtend(options, {
	      position: normalize(position),
	      warning: handleWarning
	    }));
	  }
	}


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var index = value.indexOf('\n', fromIndex);
	
	  while (index > fromIndex) {
	    if (value.charAt(index - 1) !== ' ') {
	      break;
	    }
	
	    index--;
	  }
	
	  return index;
	}


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('`', fromIndex);
	}


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('~~', fromIndex);
	}


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('*', fromIndex);
	  var underscore = value.indexOf('_', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  return value.indexOf('\\', fromIndex);
	}


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	function locate(value, fromIndex) {
	  var asterisk = value.indexOf('**', fromIndex);
	  var underscore = value.indexOf('__', fromIndex);
	
	  if (underscore === -1) {
	    return asterisk;
	  }
	
	  if (asterisk === -1) {
	    return underscore;
	  }
	
	  return underscore < asterisk ? underscore : asterisk;
	}


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = locate;
	
	var PROTOCOLS = ['https://', 'http://', 'mailto:'];
	
	function locate(value, fromIndex) {
	  var length = PROTOCOLS.length;
	  var index = -1;
	  var min = -1;
	  var position;
	
	  if (!this.options.gfm) {
	    return -1;
	  }
	
	  while (++index < length) {
	    position = value.indexOf(PROTOCOLS[index], fromIndex);
	
	    if (position !== -1 && (position < min || min === -1)) {
	      min = position;
	    }
	  }
	
	  return min;
	}


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(5);
	var removePosition = __webpack_require__(137);
	
	module.exports = parse;
	
	var C_NEWLINE = '\n';
	var EXPRESSION_LINE_BREAKS = /\r\n|\r/g;
	
	/* Parse the bound file. */
	function parse() {
	  var self = this;
	  var value = String(self.file);
	  var start = {line: 1, column: 1, offset: 0};
	  var content = xtend(start);
	  var node;
	
	  /* Clean non-unix newlines: `\r\n` and `\r` are all
	   * changed to `\n`.  This should not affect positional
	   * information. */
	  value = value.replace(EXPRESSION_LINE_BREAKS, C_NEWLINE);
	
	  if (value.charCodeAt(0) === 0xFEFF) {
	    value = value.slice(1);
	
	    content.column++;
	    content.offset++;
	  }
	
	  node = {
	    type: 'root',
	    children: self.tokenizeBlock(value, content),
	    position: {
	      start: start,
	      end: self.eof || xtend(start)
	    }
	  };
	
	  if (!self.options.position) {
	    removePosition(node, true);
	  }
	
	  return node;
	}


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(5);
	var toggle = __webpack_require__(131);
	var vfileLocation = __webpack_require__(141);
	var unescape = __webpack_require__(128);
	var decode = __webpack_require__(91);
	var tokenizer = __webpack_require__(127);
	
	module.exports = Parser;
	
	function Parser(doc, file) {
	  this.file = file;
	  this.offset = {};
	  this.options = xtend(this.options);
	  this.setOptions({});
	
	  this.inList = false;
	  this.inBlock = false;
	  this.inLink = false;
	  this.atStart = true;
	
	  this.toOffset = vfileLocation(file).toOffset;
	  this.unescape = unescape(this, 'escape');
	  this.decode = decode(this);
	}
	
	var proto = Parser.prototype;
	
	/* Expose core. */
	proto.setOptions = __webpack_require__(101);
	proto.parse = __webpack_require__(99);
	
	/* Expose `defaults`. */
	proto.options = __webpack_require__(32);
	
	/* Enter and exit helpers. */
	proto.exitStart = toggle('atStart', true);
	proto.enterList = toggle('inList', false);
	proto.enterLink = toggle('inLink', false);
	proto.enterBlock = toggle('inBlock', false);
	
	/* Nodes that can interupt a paragraph:
	 *
	 * ```markdown
	 * A paragraph, followed by a thematic break.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the paragraph. */
	proto.interruptParagraph = [
	  ['thematicBreak'],
	  ['atxHeading'],
	  ['fencedCode'],
	  ['blockquote'],
	  ['html'],
	  ['setextHeading', {commonmark: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a list:
	 *
	 * ```markdown
	 * - One
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the list. */
	proto.interruptList = [
	  ['atxHeading', {pedantic: false}],
	  ['fencedCode', {pedantic: false}],
	  ['thematicBreak', {pedantic: false}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Nodes that can interupt a blockquote:
	 *
	 * ```markdown
	 * > A paragraph.
	 * ___
	 * ```
	 *
	 * In the above example, the thematic break “interupts”
	 * the blockquote. */
	proto.interruptBlockquote = [
	  ['indentedCode', {commonmark: true}],
	  ['fencedCode', {commonmark: true}],
	  ['atxHeading', {commonmark: true}],
	  ['setextHeading', {commonmark: true}],
	  ['thematicBreak', {commonmark: true}],
	  ['html', {commonmark: true}],
	  ['list', {commonmark: true}],
	  ['definition', {commonmark: false}],
	  ['footnote', {commonmark: false}]
	];
	
	/* Handlers. */
	proto.blockTokenizers = {
	  newline: __webpack_require__(119),
	  indentedCode: __webpack_require__(106),
	  fencedCode: __webpack_require__(105),
	  blockquote: __webpack_require__(103),
	  atxHeading: __webpack_require__(113),
	  thematicBreak: __webpack_require__(125),
	  list: __webpack_require__(118),
	  setextHeading: __webpack_require__(114),
	  html: __webpack_require__(115),
	  footnote: __webpack_require__(112),
	  definition: __webpack_require__(108),
	  table: __webpack_require__(123),
	  paragraph: __webpack_require__(120)
	};
	
	proto.inlineTokenizers = {
	  escape: __webpack_require__(111),
	  autoLink: __webpack_require__(102),
	  url: __webpack_require__(126),
	  html: __webpack_require__(116),
	  link: __webpack_require__(117),
	  reference: __webpack_require__(121),
	  strong: __webpack_require__(122),
	  emphasis: __webpack_require__(110),
	  deletion: __webpack_require__(109),
	  code: __webpack_require__(107),
	  break: __webpack_require__(104),
	  text: __webpack_require__(124)
	};
	
	/* Expose precedence. */
	proto.blockMethods = keys(proto.blockTokenizers);
	proto.inlineMethods = keys(proto.inlineTokenizers);
	
	/* Tokenizers. */
	proto.tokenizeBlock = tokenizer('block');
	proto.tokenizeInline = tokenizer('inline');
	proto.tokenizeFactory = tokenizer;
	
	/* Get all keys in `value`. */
	function keys(value) {
	  var result = [];
	  var key;
	
	  for (key in value) {
	    result.push(key);
	  }
	
	  return result;
	}


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(5);
	var escapes = __webpack_require__(77);
	var defaults = __webpack_require__(32);
	
	module.exports = setOptions;
	
	function setOptions(options) {
	  var self = this;
	  var current = self.options;
	  var key;
	  var value;
	
	  if (options == null) {
	    options = {};
	  } else if (typeof options === 'object') {
	    options = xtend(options);
	  } else {
	    throw new Error(
	      'Invalid value `' + options + '` ' +
	      'for setting `options`'
	    );
	  }
	
	  for (key in defaults) {
	    value = options[key];
	
	    if (value == null) {
	      value = current[key];
	    }
	
	    if (
	      (key !== 'blocks' && typeof value !== 'boolean') ||
	      (key === 'blocks' && typeof value !== 'object')
	    ) {
	      throw new Error('Invalid value `' + value + '` for setting `options.' + key + '`');
	    }
	
	    options[key] = value;
	  }
	
	  self.options = options;
	  self.escape = escapes(options);
	
	  return self;
	}


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(3);
	var decode = __webpack_require__(15);
	var locate = __webpack_require__(34);
	
	module.exports = autoLink;
	autoLink.locator = locate;
	autoLink.notInLink = true;
	
	var C_LT = '<';
	var C_GT = '>';
	var C_AT_SIGN = '@';
	var C_SLASH = '/';
	var MAILTO = 'mailto:';
	var MAILTO_LENGTH = MAILTO.length;
	
	/* Tokenise a link. */
	function autoLink(eat, value, silent) {
	  var self;
	  var subvalue;
	  var length;
	  var index;
	  var queue;
	  var character;
	  var hasAtCharacter;
	  var link;
	  var now;
	  var content;
	  var tokenizers;
	  var exit;
	
	  if (value.charAt(0) !== C_LT) {
	    return;
	  }
	
	  self = this;
	  subvalue = '';
	  length = value.length;
	  index = 0;
	  queue = '';
	  hasAtCharacter = false;
	  link = '';
	
	  index++;
	  subvalue = C_LT;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      whitespace(character) ||
	      character === C_GT ||
	      character === C_AT_SIGN ||
	      (character === ':' && value.charAt(index + 1) === C_SLASH)
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  link += queue;
	  queue = '';
	
	  character = value.charAt(index);
	  link += character;
	  index++;
	
	  if (character === C_AT_SIGN) {
	    hasAtCharacter = true;
	  } else {
	    if (
	      character !== ':' ||
	      value.charAt(index + 1) !== C_SLASH
	    ) {
	      return;
	    }
	
	    link += C_SLASH;
	    index++;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_GT) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!queue || character !== C_GT) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  link += queue;
	  content = link;
	  subvalue += link + character;
	  now = eat.now();
	  now.column++;
	  now.offset++;
	
	  if (hasAtCharacter) {
	    if (link.slice(0, MAILTO_LENGTH).toLowerCase() === MAILTO) {
	      content = content.substr(MAILTO_LENGTH);
	      now.column += MAILTO_LENGTH;
	      now.offset += MAILTO_LENGTH;
	    } else {
	      link = MAILTO + link;
	    }
	  }
	
	  /* Temporarily remove all tokenizers except text in autolinks. */
	  tokenizers = self.inlineTokenizers;
	  self.inlineTokenizers = {text: tokenizers.text};
	
	  exit = self.enterLink();
	
	  content = self.tokenizeInline(content, now);
	
	  self.inlineTokenizers = tokenizers;
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(link, {nonTerminated: false}),
	    children: content
	  });
	}


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(8);
	var interrupt = __webpack_require__(17);
	
	module.exports = blockquote;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_GT = '>';
	
	/* Tokenise a blockquote. */
	function blockquote(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptBlockquote;
	  var now = eat.now();
	  var currentLine = now.line;
	  var length = value.length;
	  var values = [];
	  var contents = [];
	  var indents = [];
	  var add;
	  var index = 0;
	  var character;
	  var rest;
	  var nextIndex;
	  var content;
	  var line;
	  var startIndex;
	  var prefixed;
	  var exit;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_GT) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      index++;
	    }
	
	    if (value.charAt(index) === C_GT) {
	      index++;
	      prefixed = true;
	
	      if (value.charAt(index) === C_SPACE) {
	        index++;
	      }
	    } else {
	      index = startIndex;
	    }
	
	    content = value.slice(index, nextIndex);
	
	    if (!prefixed && !trim(content)) {
	      index = startIndex;
	      break;
	    }
	
	    if (!prefixed) {
	      rest = value.slice(index);
	
	      /* Check if the following code contains a possible
	       * block. */
	      if (interrupt(interruptors, tokenizers, self, [eat, rest, true])) {
	        break;
	      }
	    }
	
	    line = startIndex === index ? content : value.slice(startIndex, nextIndex);
	
	    indents.push(index - startIndex);
	    values.push(line);
	    contents.push(content);
	
	    index = nextIndex + 1;
	  }
	
	  index = -1;
	  length = indents.length;
	  add = eat(values.join(C_NEWLINE));
	
	  while (++index < length) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
	    currentLine++;
	  }
	
	  exit = self.enterBlock();
	  contents = self.tokenizeBlock(contents.join(C_NEWLINE), now);
	  exit();
	
	  return add({
	    type: 'blockquote',
	    children: contents
	  });
	}


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(92);
	
	module.exports = hardBreak;
	hardBreak.locator = locate;
	
	var MIN_BREAK_LENGTH = 2;
	
	function hardBreak(eat, value, silent) {
	  var length = value.length;
	  var index = -1;
	  var queue = '';
	  var character;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === '\n') {
	      if (index < MIN_BREAK_LENGTH) {
	        return;
	      }
	
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      queue += character;
	
	      return eat(queue)({type: 'break'});
	    }
	
	    if (character !== ' ') {
	      return;
	    }
	
	    queue += character;
	  }
	}


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(20);
	
	module.exports = fencedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_TILDE = '~';
	var C_TICK = '`';
	
	var MIN_FENCE_COUNT = 3;
	var CODE_INDENT_COUNT = 4;
	
	function fencedCode(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = 0;
	  var subvalue = '';
	  var fenceCount;
	  var marker;
	  var character;
	  var flag;
	  var queue;
	  var content;
	  var exdentedContent;
	  var closing;
	  var exdentedClosing;
	  var indent;
	  var now;
	
	  if (!settings.gfm) {
	    return;
	  }
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  indent = index;
	
	  /* Eat the fence. */
	  character = value.charAt(index);
	
	  if (character !== C_TILDE && character !== C_TICK) {
	    return;
	  }
	
	  index++;
	  marker = character;
	  fenceCount = 1;
	  subvalue += character;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      break;
	    }
	
	    subvalue += character;
	    fenceCount++;
	    index++;
	  }
	
	  if (fenceCount < MIN_FENCE_COUNT) {
	    return;
	  }
	
	  /* Eat spacing before flag. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat flag. */
	  flag = '';
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_NEWLINE ||
	      character === C_TILDE ||
	      character === C_TICK
	    ) {
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      flag += queue + character;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character && character !== C_NEWLINE) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	
	  subvalue += flag;
	  flag = self.decode.raw(self.unescape(flag), now);
	
	  if (queue) {
	    subvalue += queue;
	  }
	
	  queue = '';
	  closing = '';
	  exdentedClosing = '';
	  content = '';
	  exdentedContent = '';
	
	  /* Eat content. */
	  while (index < length) {
	    character = value.charAt(index);
	    content += closing;
	    exdentedContent += exdentedClosing;
	    closing = '';
	    exdentedClosing = '';
	
	    if (character !== C_NEWLINE) {
	      content += character;
	      exdentedClosing += character;
	      index++;
	      continue;
	    }
	
	    /* Add the newline to `subvalue` if its the first
	     * character.  Otherwise, add it to the `closing`
	     * queue. */
	    if (content) {
	      closing += character;
	      exdentedClosing += character;
	    } else {
	      subvalue += character;
	    }
	
	    queue = '';
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue.slice(indent);
	
	    if (queue.length >= CODE_INDENT_COUNT) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    closing += queue;
	    exdentedClosing += queue;
	
	    if (queue.length < fenceCount) {
	      continue;
	    }
	
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character !== C_SPACE && character !== C_TAB) {
	        break;
	      }
	
	      closing += character;
	      exdentedClosing += character;
	      index++;
	    }
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	  }
	
	  subvalue += content + closing;
	
	  return eat(subvalue)({
	    type: 'code',
	    lang: flag || null,
	    value: trim(exdentedContent)
	  });
	}


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var repeat = __webpack_require__(19);
	var trim = __webpack_require__(20);
	
	module.exports = indentedCode;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var CODE_INDENT_COUNT = 4;
	var CODE_INDENT = repeat(C_SPACE, CODE_INDENT_COUNT);
	
	/* Tokenise indented code. */
	function indentedCode(eat, value, silent) {
	  var index = -1;
	  var length = value.length;
	  var subvalue = '';
	  var content = '';
	  var subvalueQueue = '';
	  var contentQueue = '';
	  var character;
	  var blankQueue;
	  var indent;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (indent) {
	      indent = false;
	
	      subvalue += subvalueQueue;
	      content += contentQueue;
	      subvalueQueue = '';
	      contentQueue = '';
	
	      if (character === C_NEWLINE) {
	        subvalueQueue = character;
	        contentQueue = character;
	      } else {
	        subvalue += character;
	        content += character;
	
	        while (++index < length) {
	          character = value.charAt(index);
	
	          if (!character || character === C_NEWLINE) {
	            contentQueue = character;
	            subvalueQueue = character;
	            break;
	          }
	
	          subvalue += character;
	          content += character;
	        }
	      }
	    } else if (
	      character === C_SPACE &&
	      value.charAt(index + 1) === character &&
	      value.charAt(index + 2) === character &&
	      value.charAt(index + 3) === character
	    ) {
	      subvalueQueue += CODE_INDENT;
	      index += 3;
	      indent = true;
	    } else if (character === C_TAB) {
	      subvalueQueue += character;
	      indent = true;
	    } else {
	      blankQueue = '';
	
	      while (character === C_TAB || character === C_SPACE) {
	        blankQueue += character;
	        character = value.charAt(++index);
	      }
	
	      if (character !== C_NEWLINE) {
	        break;
	      }
	
	      subvalueQueue += blankQueue + character;
	      contentQueue += character;
	    }
	  }
	
	  if (content) {
	    if (silent) {
	      return true;
	    }
	
	    return eat(subvalue)({
	      type: 'code',
	      lang: null,
	      value: trim(content)
	    });
	  }
	}


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(3);
	var locate = __webpack_require__(93);
	
	module.exports = inlineCode;
	inlineCode.locator = locate;
	
	var C_TICK = '`';
	
	/* Tokenise inline code. */
	function inlineCode(eat, value, silent) {
	  var length = value.length;
	  var index = 0;
	  var queue = '';
	  var tickQueue = '';
	  var contentQueue;
	  var subqueue;
	  var count;
	  var openingCount;
	  var subvalue;
	  var character;
	  var found;
	  var next;
	
	  while (index < length) {
	    if (value.charAt(index) !== C_TICK) {
	      break;
	    }
	
	    queue += C_TICK;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue = queue;
	  openingCount = index;
	  queue = '';
	  next = value.charAt(index);
	  count = 0;
	
	  while (index < length) {
	    character = next;
	    next = value.charAt(index + 1);
	
	    if (character === C_TICK) {
	      count++;
	      tickQueue += character;
	    } else {
	      count = 0;
	      queue += character;
	    }
	
	    if (count && next !== C_TICK) {
	      if (count === openingCount) {
	        subvalue += queue + tickQueue;
	        found = true;
	        break;
	      }
	
	      queue += tickQueue;
	      tickQueue = '';
	    }
	
	    index++;
	  }
	
	  if (!found) {
	    if (openingCount % 2 !== 0) {
	      return;
	    }
	
	    queue = '';
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  contentQueue = '';
	  subqueue = '';
	  length = queue.length;
	  index = -1;
	
	  while (++index < length) {
	    character = queue.charAt(index);
	
	    if (whitespace(character)) {
	      subqueue += character;
	      continue;
	    }
	
	    if (subqueue) {
	      if (contentQueue) {
	        contentQueue += subqueue;
	      }
	
	      subqueue = '';
	    }
	
	    contentQueue += character;
	  }
	
	  return eat(subvalue)({
	    type: 'inlineCode',
	    value: contentQueue
	  });
	}


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(3);
	var normalize = __webpack_require__(18);
	
	module.exports = definition;
	definition.notInList = true;
	definition.notInBlock = true;
	
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_COLON = ':';
	var C_LT = '<';
	var C_GT = '>';
	
	function definition(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var beforeURL;
	  var beforeTitle;
	  var queue;
	  var character;
	  var test;
	  var identifier;
	  var url;
	  var title;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  identifier = queue;
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isEnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === isEnclosedURLCharacter.delimiter) {
	      subvalue += C_LT + queue + character;
	      index++;
	    } else {
	      if (commonmark) {
	        return;
	      }
	
	      index -= queue.length + 1;
	      queue = '';
	    }
	  }
	
	  if (!queue) {
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!isUnclosedURLCharacter(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    subvalue += queue;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  url = queue;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (
	      character !== C_TAB &&
	      character !== C_SPACE &&
	      character !== C_NEWLINE
	    ) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  test = null;
	
	  if (character === C_DOUBLE_QUOTE) {
	    test = C_DOUBLE_QUOTE;
	  } else if (character === C_SINGLE_QUOTE) {
	    test = C_SINGLE_QUOTE;
	  } else if (character === C_PAREN_OPEN) {
	    test = C_PAREN_CLOSE;
	  }
	
	  if (!test) {
	    queue = '';
	    index = subvalue.length;
	  } else if (queue) {
	    subvalue += queue + character;
	    index = subvalue.length;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === test) {
	        break;
	      }
	
	      if (character === C_NEWLINE) {
	        index++;
	        character = value.charAt(index);
	
	        if (character === C_NEWLINE || character === test) {
	          return;
	        }
	
	        queue += C_NEWLINE;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character !== test) {
	      return;
	    }
	
	    beforeTitle = subvalue;
	    subvalue += queue + character;
	    index++;
	    title = queue;
	    queue = '';
	  } else {
	    return;
	  }
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  if (!character || character === C_NEWLINE) {
	    if (silent) {
	      return true;
	    }
	
	    beforeURL = eat(beforeURL).test().end;
	    url = self.decode.raw(self.unescape(url), beforeURL, {nonTerminated: false});
	
	    if (title) {
	      beforeTitle = eat(beforeTitle).test().end;
	      title = self.decode.raw(self.unescape(title), beforeTitle);
	    }
	
	    return eat(subvalue)({
	      type: 'definition',
	      identifier: normalize(identifier),
	      title: title || null,
	      url: url
	    });
	  }
	}
	
	/* Check if `character` can be inside an enclosed URI. */
	function isEnclosedURLCharacter(character) {
	  return character !== C_GT &&
	    character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE;
	}
	
	isEnclosedURLCharacter.delimiter = C_GT;
	
	/* Check if `character` can be inside an unclosed URI. */
	function isUnclosedURLCharacter(character) {
	  return character !== C_BRACKET_OPEN &&
	    character !== C_BRACKET_CLOSE &&
	    !whitespace(character);
	}


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(3);
	var locate = __webpack_require__(94);
	
	module.exports = strikethrough;
	strikethrough.locator = locate;
	
	var C_TILDE = '~';
	var DOUBLE = '~~';
	
	function strikethrough(eat, value, silent) {
	  var self = this;
	  var character = '';
	  var previous = '';
	  var preceding = '';
	  var subvalue = '';
	  var index;
	  var length;
	  var now;
	
	  if (
	    !self.options.gfm ||
	    value.charAt(0) !== C_TILDE ||
	    value.charAt(1) !== C_TILDE ||
	    whitespace(value.charAt(2))
	  ) {
	    return;
	  }
	
	  index = 1;
	  length = value.length;
	  now = eat.now();
	  now.column += 2;
	  now.offset += 2;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (
	      character === C_TILDE &&
	      previous === C_TILDE &&
	      (!preceding || !whitespace(preceding))
	    ) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      return eat(DOUBLE + subvalue + DOUBLE)({
	        type: 'delete',
	        children: self.tokenizeInline(subvalue, now)
	      });
	    }
	
	    subvalue += previous;
	    preceding = previous;
	    previous = character;
	  }
	}


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(8);
	var word = __webpack_require__(72);
	var whitespace = __webpack_require__(3);
	var locate = __webpack_require__(95);
	
	module.exports = emphasis;
	emphasis.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function emphasis(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (character !== C_ASTERISK && character !== C_UNDERSCORE) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  subvalue = character;
	  marker = character;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (character === marker && (!pedantic || !whitespace(prev))) {
	      character = value.charAt(++index);
	
	      if (character !== marker) {
	        if (!trim(queue) || prev === marker) {
	          return;
	        }
	
	        if (!pedantic && marker === C_UNDERSCORE && word(character)) {
	          queue += marker;
	          continue;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column++;
	        now.offset++;
	
	        return eat(subvalue + queue + marker)({
	          type: 'emphasis',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	
	      queue += marker;
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var locate = __webpack_require__(96);
	
	module.exports = escape;
	escape.locator = locate;
	
	function escape(eat, value, silent) {
	  var self = this;
	  var character;
	  var node;
	
	  if (value.charAt(0) === '\\') {
	    character = value.charAt(1);
	
	    if (self.escape.indexOf(character) !== -1) {
	      /* istanbul ignore if - never used (yet) */
	      if (silent) {
	        return true;
	      }
	
	      if (character === '\n') {
	        node = {type: 'break'};
	      } else {
	        node = {
	          type: 'text',
	          value: character
	        };
	      }
	
	      return eat('\\' + character)(node);
	    }
	  }
	}


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(3);
	var normalize = __webpack_require__(18);
	
	module.exports = footnoteDefinition;
	footnoteDefinition.notInList = true;
	footnoteDefinition.notInBlock = true;
	
	var C_BACKSLASH = '\\';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_CARET = '^';
	var C_COLON = ':';
	
	var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm;
	
	function footnoteDefinition(eat, value, silent) {
	  var self = this;
	  var offsets = self.offset;
	  var index;
	  var length;
	  var subvalue;
	  var now;
	  var currentLine;
	  var content;
	  var queue;
	  var subqueue;
	  var character;
	  var identifier;
	  var add;
	  var exit;
	
	  if (!self.options.footnotes) {
	    return;
	  }
	
	  index = 0;
	  length = value.length;
	  subvalue = '';
	  now = eat.now();
	  currentLine = now.line;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  if (
	    value.charAt(index) !== C_BRACKET_OPEN ||
	    value.charAt(index + 1) !== C_CARET
	  ) {
	    return;
	  }
	
	  subvalue += C_BRACKET_OPEN + C_CARET;
	  index = subvalue.length;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      break;
	    } else if (character === C_BACKSLASH) {
	      queue += character;
	      index++;
	      character = value.charAt(index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (
	    !queue ||
	    value.charAt(index) !== C_BRACKET_CLOSE ||
	    value.charAt(index + 1) !== C_COLON
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  identifier = normalize(queue);
	  subvalue += queue + C_BRACKET_CLOSE + C_COLON;
	  index = subvalue.length;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  queue = '';
	  content = '';
	  subqueue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      subqueue = character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_NEWLINE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      queue += subqueue;
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character !== C_SPACE) {
	          break;
	        }
	
	        subqueue += character;
	        index++;
	      }
	
	      if (subqueue.length === 0) {
	        break;
	      }
	
	      queue += subqueue;
	    }
	
	    if (queue) {
	      content += queue;
	      queue = '';
	    }
	
	    content += character;
	    index++;
	  }
	
	  subvalue += content;
	
	  content = content.replace(EXPRESSION_INITIAL_TAB, function (line) {
	    offsets[currentLine] = (offsets[currentLine] || 0) + line.length;
	    currentLine++;
	
	    return '';
	  });
	
	  add = eat(subvalue);
	
	  exit = self.enterBlock();
	  content = self.tokenizeBlock(content, now);
	  exit();
	
	  return add({
	    type: 'footnoteDefinition',
	    identifier: identifier,
	    children: content
	  });
	}


/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = atxHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_HASH = '#';
	
	var MAX_ATX_COUNT = 6;
	
	function atxHeading(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var length = value.length + 1;
	  var index = -1;
	  var now = eat.now();
	  var subvalue = '';
	  var content = '';
	  var character;
	  var queue;
	  var depth;
	
	  /* Eat initial spacing. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat hashes. */
	  depth = 0;
	
	  while (++index <= length) {
	    character = value.charAt(index);
	
	    if (character !== C_HASH) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	    depth++;
	  }
	
	  if (depth > MAX_ATX_COUNT) {
	    return;
	  }
	
	  if (
	    !depth ||
	    (!settings.pedantic && value.charAt(index + 1) === C_HASH)
	  ) {
	    return;
	  }
	
	  length = value.length + 1;
	
	  /* Eat intermediate white-space. */
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE && character !== C_TAB) {
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  /* Exit when not in pedantic mode without spacing. */
	  if (
	    !settings.pedantic &&
	    queue.length === 0 &&
	    character &&
	    character !== C_NEWLINE
	  ) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  /* Eat content. */
	  subvalue += queue;
	  queue = '';
	  content = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (!character || character === C_NEWLINE) {
	      break;
	    }
	
	    if (
	      character !== C_SPACE &&
	      character !== C_TAB &&
	      character !== C_HASH
	    ) {
	      content += queue + character;
	      queue = '';
	      continue;
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_HASH) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    while (character === C_SPACE || character === C_TAB) {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    index--;
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  return eat(subvalue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = setextHeading;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_EQUALS = '=';
	var C_DASH = '-';
	
	var MAX_HEADING_INDENT = 3;
	
	/* Map of characters which can be used to mark setext
	 * headers, mapping to their corresponding depth. */
	var SETEXT_MARKERS = {};
	
	SETEXT_MARKERS[C_EQUALS] = 1;
	SETEXT_MARKERS[C_DASH] = 2;
	
	function setextHeading(eat, value, silent) {
	  var self = this;
	  var now = eat.now();
	  var length = value.length;
	  var index = -1;
	  var subvalue = '';
	  var content;
	  var queue;
	  var character;
	  var marker;
	  var depth;
	
	  /* Eat initial indentation. */
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_SPACE || index >= MAX_HEADING_INDENT) {
	      index--;
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  /* Eat content. */
	  content = '';
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === C_NEWLINE) {
	      index--;
	      break;
	    }
	
	    if (character === C_SPACE || character === C_TAB) {
	      queue += character;
	    } else {
	      content += queue + character;
	      queue = '';
	    }
	  }
	
	  now.column += subvalue.length;
	  now.offset += subvalue.length;
	  subvalue += content + queue;
	
	  /* Ensure the content is followed by a newline and a
	   * valid marker. */
	  character = value.charAt(++index);
	  marker = value.charAt(++index);
	
	  if (character !== C_NEWLINE || !SETEXT_MARKERS[marker]) {
	    return;
	  }
	
	  subvalue += character;
	
	  /* Eat Setext-line. */
	  queue = marker;
	  depth = SETEXT_MARKERS[marker];
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== marker) {
	      if (character !== C_NEWLINE) {
	        return;
	      }
	
	      index--;
	      break;
	    }
	
	    queue += character;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  return eat(subvalue + queue)({
	    type: 'heading',
	    depth: depth,
	    children: self.tokenizeInline(content, now)
	  });
	}


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var openCloseTag = __webpack_require__(36).openCloseTag;
	
	module.exports = blockHTML;
	
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_LT = '<';
	
	function blockHTML(eat, value, silent) {
	  var self = this;
	  var blocks = self.options.blocks;
	  var length = value.length;
	  var index = 0;
	  var next;
	  var line;
	  var offset;
	  var character;
	  var count;
	  var sequence;
	  var subvalue;
	
	  var sequences = [
	    [/^<(script|pre|style)(?=(\s|>|$))/i, /<\/(script|pre|style)>/i, true],
	    [/^<!--/, /-->/, true],
	    [/^<\?/, /\?>/, true],
	    [/^<![A-Za-z]/, />/, true],
	    [/^<!\[CDATA\[/, /\]\]>/, true],
	    [new RegExp('^</?(' + blocks.join('|') + ')(?=(\\s|/?>|$))', 'i'), /^$/, true],
	    [new RegExp(openCloseTag.source + '\\s*$'), /^$/, false]
	  ];
	
	  /* Eat initial spacing. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    index++;
	  }
	
	  if (value.charAt(index) !== C_LT) {
	    return;
	  }
	
	  next = value.indexOf(C_NEWLINE, index + 1);
	  next = next === -1 ? length : next;
	  line = value.slice(index, next);
	  offset = -1;
	  count = sequences.length;
	
	  while (++offset < count) {
	    if (sequences[offset][0].test(line)) {
	      sequence = sequences[offset];
	      break;
	    }
	  }
	
	  if (!sequence) {
	    return;
	  }
	
	  if (silent) {
	    return sequence[2];
	  }
	
	  index = next;
	
	  if (!sequence[1].test(line)) {
	    while (index < length) {
	      next = value.indexOf(C_NEWLINE, index + 1);
	      next = next === -1 ? length : next;
	      line = value.slice(index + 1, next);
	
	      if (sequence[1].test(line)) {
	        if (line) {
	          index = next;
	        }
	
	        break;
	      }
	
	      index = next;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabetical = __webpack_require__(29);
	var locate = __webpack_require__(34);
	var tag = __webpack_require__(36).tag;
	
	module.exports = inlineHTML;
	inlineHTML.locator = locate;
	
	var EXPRESSION_HTML_LINK_OPEN = /^<a /i;
	var EXPRESSION_HTML_LINK_CLOSE = /^<\/a>/i;
	
	function inlineHTML(eat, value, silent) {
	  var self = this;
	  var length = value.length;
	  var character;
	  var subvalue;
	
	  if (value.charAt(0) !== '<' || length < 3) {
	    return;
	  }
	
	  character = value.charAt(1);
	
	  if (
	    !alphabetical(character) &&
	    character !== '?' &&
	    character !== '!' &&
	    character !== '/'
	  ) {
	    return;
	  }
	
	  subvalue = value.match(tag);
	
	  if (!subvalue) {
	    return;
	  }
	
	  /* istanbul ignore if - not used yet. */
	  if (silent) {
	    return true;
	  }
	
	  subvalue = subvalue[0];
	
	  if (!self.inLink && EXPRESSION_HTML_LINK_OPEN.test(subvalue)) {
	    self.inLink = true;
	  } else if (self.inLink && EXPRESSION_HTML_LINK_CLOSE.test(subvalue)) {
	    self.inLink = false;
	  }
	
	  return eat(subvalue)({type: 'html', value: subvalue});
	}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(3);
	var locate = __webpack_require__(33);
	
	module.exports = link;
	link.locator = locate;
	
	var own = {}.hasOwnProperty;
	
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_GT = '>';
	var C_TICK = '`';
	var C_DOUBLE_QUOTE = '"';
	var C_SINGLE_QUOTE = '\'';
	
	/* Map of characters, which can be used to mark link
	 * and image titles. */
	var LINK_MARKERS = {};
	
	LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	
	/* Map of characters, which can be used to mark link
	 * and image titles in commonmark-mode. */
	var COMMONMARK_LINK_MARKERS = {};
	
	COMMONMARK_LINK_MARKERS[C_DOUBLE_QUOTE] = C_DOUBLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_SINGLE_QUOTE] = C_SINGLE_QUOTE;
	COMMONMARK_LINK_MARKERS[C_PAREN_OPEN] = C_PAREN_CLOSE;
	
	function link(eat, value, silent) {
	  var self = this;
	  var subvalue = '';
	  var index = 0;
	  var character = value.charAt(0);
	  var pedantic = self.options.pedantic;
	  var commonmark = self.options.commonmark;
	  var gfm = self.options.gfm;
	  var closed;
	  var count;
	  var opening;
	  var beforeURL;
	  var beforeTitle;
	  var subqueue;
	  var hasMarker;
	  var markers;
	  var isImage;
	  var content;
	  var marker;
	  var length;
	  var title;
	  var depth;
	  var queue;
	  var url;
	  var now;
	  var exit;
	  var node;
	
	  /* Detect whether this is an image. */
	  if (character === '!') {
	    isImage = true;
	    subvalue = character;
	    character = value.charAt(++index);
	  }
	
	  /* Eat the opening. */
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  /* Exit when this is a link and we’re already inside
	   * a link. */
	  if (!isImage && self.inLink) {
	    return;
	  }
	
	  subvalue += character;
	  queue = '';
	  index++;
	
	  /* Eat the content. */
	  length = value.length;
	  now = eat.now();
	  depth = 0;
	
	  now.column += index;
	  now.offset += index;
	
	  while (index < length) {
	    character = value.charAt(index);
	    subqueue = character;
	
	    if (character === C_TICK) {
	      /* Inline-code in link content. */
	      count = 1;
	
	      while (value.charAt(index + 1) === C_TICK) {
	        subqueue += character;
	        index++;
	        count++;
	      }
	
	      if (!opening) {
	        opening = count;
	      } else if (count >= opening) {
	        opening = 0;
	      }
	    } else if (character === C_BACKSLASH) {
	      /* Allow brackets to be escaped. */
	      index++;
	      subqueue += value.charAt(index);
	    /* In GFM mode, brackets in code still count.
	     * In all other modes, they don’t.  This empty
	     * block prevents the next statements are
	     * entered. */
	    } else if ((!opening || gfm) && character === C_BRACKET_OPEN) {
	      depth++;
	    } else if ((!opening || gfm) && character === C_BRACKET_CLOSE) {
	      if (depth) {
	        depth--;
	      } else {
	        /* Allow white-space between content and
	         * url in GFM mode. */
	        if (!pedantic) {
	          while (index < length) {
	            character = value.charAt(index + 1);
	
	            if (!whitespace(character)) {
	              break;
	            }
	
	            subqueue += character;
	            index++;
	          }
	        }
	
	        if (value.charAt(index + 1) !== C_PAREN_OPEN) {
	          return;
	        }
	
	        subqueue += C_PAREN_OPEN;
	        closed = true;
	        index++;
	
	        break;
	      }
	    }
	
	    queue += subqueue;
	    subqueue = '';
	    index++;
	  }
	
	  /* Eat the content closing. */
	  if (!closed) {
	    return;
	  }
	
	  content = queue;
	  subvalue += queue + subqueue;
	  index++;
	
	  /* Eat white-space. */
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    subvalue += character;
	    index++;
	  }
	
	  /* Eat the URL. */
	  character = value.charAt(index);
	  markers = commonmark ? COMMONMARK_LINK_MARKERS : LINK_MARKERS;
	  queue = '';
	  beforeURL = subvalue;
	
	  if (character === C_LT) {
	    index++;
	    beforeURL += C_LT;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_GT) {
	        break;
	      }
	
	      if (commonmark && character === '\n') {
	        return;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    if (value.charAt(index) !== C_GT) {
	      return;
	    }
	
	    subvalue += C_LT + queue + C_GT;
	    url = queue;
	    index++;
	  } else {
	    character = null;
	    subqueue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (subqueue && own.call(markers, character)) {
	        break;
	      }
	
	      if (whitespace(character)) {
	        if (!pedantic) {
	          break;
	        }
	
	        subqueue += character;
	      } else {
	        if (character === C_PAREN_OPEN) {
	          depth++;
	        } else if (character === C_PAREN_CLOSE) {
	          if (depth === 0) {
	            break;
	          }
	
	          depth--;
	        }
	
	        queue += subqueue;
	        subqueue = '';
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        queue += character;
	      }
	
	      index++;
	    }
	
	    subvalue += queue;
	    url = queue;
	    index = subvalue.length;
	  }
	
	  /* Eat white-space. */
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	  subvalue += queue;
	
	  /* Eat the title. */
	  if (queue && own.call(markers, character)) {
	    index++;
	    subvalue += character;
	    queue = '';
	    marker = markers[character];
	    beforeTitle = subvalue;
	
	    /* In commonmark-mode, things are pretty easy: the
	     * marker cannot occur inside the title.
	     *
	     * Non-commonmark does, however, support nested
	     * delimiters. */
	    if (commonmark) {
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          break;
	        }
	
	        if (character === C_BACKSLASH) {
	          queue += C_BACKSLASH;
	          character = value.charAt(++index);
	        }
	
	        index++;
	        queue += character;
	      }
	
	      character = value.charAt(index);
	
	      if (character !== marker) {
	        return;
	      }
	
	      title = queue;
	      subvalue += queue + character;
	      index++;
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (!whitespace(character)) {
	          break;
	        }
	
	        subvalue += character;
	        index++;
	      }
	    } else {
	      subqueue = '';
	
	      while (index < length) {
	        character = value.charAt(index);
	
	        if (character === marker) {
	          if (hasMarker) {
	            queue += marker + subqueue;
	            subqueue = '';
	          }
	
	          hasMarker = true;
	        } else if (!hasMarker) {
	          queue += character;
	        } else if (character === C_PAREN_CLOSE) {
	          subvalue += queue + marker + subqueue;
	          title = queue;
	          break;
	        } else if (whitespace(character)) {
	          subqueue += character;
	        } else {
	          queue += marker + subqueue + character;
	          subqueue = '';
	          hasMarker = false;
	        }
	
	        index++;
	      }
	    }
	  }
	
	  if (value.charAt(index) !== C_PAREN_CLOSE) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  subvalue += C_PAREN_CLOSE;
	
	  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {nonTerminated: false});
	
	  if (title) {
	    beforeTitle = eat(beforeTitle).test().end;
	    title = self.decode.raw(self.unescape(title), beforeTitle);
	  }
	
	  node = {
	    type: isImage ? 'image' : 'link',
	    title: title || null,
	    url: url
	  };
	
	  if (isImage) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  } else {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  }
	
	  return eat(subvalue)(node);
	}


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable max-params */
	
	var trim = __webpack_require__(8);
	var repeat = __webpack_require__(19);
	var decimal = __webpack_require__(10);
	var getIndent = __webpack_require__(35);
	var removeIndent = __webpack_require__(129);
	var interrupt = __webpack_require__(17);
	
	module.exports = list;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_PLUS = '+';
	var C_DASH = '-';
	var C_DOT = '.';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_PAREN_CLOSE = ')';
	var C_X_LOWER = 'x';
	
	var TAB_SIZE = 4;
	var EXPRESSION_LOOSE_LIST_ITEM = /\n\n(?!\s*$)/;
	var EXPRESSION_TASK_ITEM = /^\[([ \t]|x|X)][ \t]/;
	var EXPRESSION_BULLET = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/;
	var EXPRESSION_PEDANTIC_BULLET = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/;
	var EXPRESSION_INITIAL_INDENT = /^( {1,4}|\t)?/gm;
	
	/* Map of characters which can be used to mark
	 * list-items. */
	var LIST_UNORDERED_MARKERS = {};
	
	LIST_UNORDERED_MARKERS[C_ASTERISK] = true;
	LIST_UNORDERED_MARKERS[C_PLUS] = true;
	LIST_UNORDERED_MARKERS[C_DASH] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_MARKERS = {};
	
	LIST_ORDERED_MARKERS[C_DOT] = true;
	
	/* Map of characters which can be used to mark
	 * list-items after a digit. */
	var LIST_ORDERED_COMMONMARK_MARKERS = {};
	
	LIST_ORDERED_COMMONMARK_MARKERS[C_DOT] = true;
	LIST_ORDERED_COMMONMARK_MARKERS[C_PAREN_CLOSE] = true;
	
	function list(eat, value, silent) {
	  var self = this;
	  var commonmark = self.options.commonmark;
	  var pedantic = self.options.pedantic;
	  var tokenizers = self.blockTokenizers;
	  var interuptors = self.interruptList;
	  var markers;
	  var index = 0;
	  var length = value.length;
	  var start = null;
	  var size = 0;
	  var queue;
	  var ordered;
	  var character;
	  var marker;
	  var nextIndex;
	  var startIndex;
	  var prefixed;
	  var currentMarker;
	  var content;
	  var line;
	  var prevEmpty;
	  var empty;
	  var items;
	  var allLines;
	  var emptyLines;
	  var item;
	  var enterTop;
	  var exitBlockquote;
	  var isLoose;
	  var node;
	  var now;
	  var end;
	  var indented;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_TAB) {
	      size += TAB_SIZE - (size % TAB_SIZE);
	    } else if (character === C_SPACE) {
	      size++;
	    } else {
	      break;
	    }
	
	    index++;
	  }
	
	  if (size >= TAB_SIZE) {
	    return;
	  }
	
	  character = value.charAt(index);
	
	  markers = commonmark ?
	    LIST_ORDERED_COMMONMARK_MARKERS :
	    LIST_ORDERED_MARKERS;
	
	  if (LIST_UNORDERED_MARKERS[character] === true) {
	    marker = character;
	    ordered = false;
	  } else {
	    ordered = true;
	    queue = '';
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (!decimal(character)) {
	        break;
	      }
	
	      queue += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (!queue || markers[character] !== true) {
	      return;
	    }
	
	    start = parseInt(queue, 10);
	    marker = character;
	  }
	
	  character = value.charAt(++index);
	
	  if (character !== C_SPACE && character !== C_TAB) {
	    return;
	  }
	
	  if (silent) {
	    return true;
	  }
	
	  index = 0;
	  items = [];
	  allLines = [];
	  emptyLines = [];
	
	  while (index < length) {
	    nextIndex = value.indexOf(C_NEWLINE, index);
	    startIndex = index;
	    prefixed = false;
	    indented = false;
	
	    if (nextIndex === -1) {
	      nextIndex = length;
	    }
	
	    end = index + TAB_SIZE;
	    size = 0;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_TAB) {
	        size += TAB_SIZE - (size % TAB_SIZE);
	      } else if (character === C_SPACE) {
	        size++;
	      } else {
	        break;
	      }
	
	      index++;
	    }
	
	    if (size >= TAB_SIZE) {
	      indented = true;
	    }
	
	    if (item && size >= item.indent) {
	      indented = true;
	    }
	
	    character = value.charAt(index);
	    currentMarker = null;
	
	    if (!indented) {
	      if (LIST_UNORDERED_MARKERS[character] === true) {
	        currentMarker = character;
	        index++;
	        size++;
	      } else {
	        queue = '';
	
	        while (index < length) {
	          character = value.charAt(index);
	
	          if (!decimal(character)) {
	            break;
	          }
	
	          queue += character;
	          index++;
	        }
	
	        character = value.charAt(index);
	        index++;
	
	        if (queue && markers[character] === true) {
	          currentMarker = character;
	          size += queue.length + 1;
	        }
	      }
	
	      if (currentMarker) {
	        character = value.charAt(index);
	
	        if (character === C_TAB) {
	          size += TAB_SIZE - (size % TAB_SIZE);
	          index++;
	        } else if (character === C_SPACE) {
	          end = index + TAB_SIZE;
	
	          while (index < end) {
	            if (value.charAt(index) !== C_SPACE) {
	              break;
	            }
	
	            index++;
	            size++;
	          }
	
	          if (index === end && value.charAt(index) === C_SPACE) {
	            index -= TAB_SIZE - 1;
	            size -= TAB_SIZE - 1;
	          }
	        } else if (character !== C_NEWLINE && character !== '') {
	          currentMarker = null;
	        }
	      }
	    }
	
	    if (currentMarker) {
	      if (!pedantic && marker !== currentMarker) {
	        break;
	      }
	
	      prefixed = true;
	    } else {
	      if (!commonmark && !indented && value.charAt(startIndex) === C_SPACE) {
	        indented = true;
	      } else if (commonmark && item) {
	        indented = size >= item.indent || size > TAB_SIZE;
	      }
	
	      prefixed = false;
	      index = startIndex;
	    }
	
	    line = value.slice(startIndex, nextIndex);
	    content = startIndex === index ? line : value.slice(index, nextIndex);
	
	    if (
	      currentMarker === C_ASTERISK ||
	      currentMarker === C_UNDERSCORE ||
	      currentMarker === C_DASH
	    ) {
	      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
	        break;
	      }
	    }
	
	    prevEmpty = empty;
	    empty = !trim(content).length;
	
	    if (indented && item) {
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (prefixed) {
	      if (emptyLines.length !== 0) {
	        item.value.push('');
	        item.trail = emptyLines.concat();
	      }
	
	      item = {
	        value: [line],
	        indent: size,
	        trail: []
	      };
	
	      items.push(item);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    } else if (empty) {
	      if (prevEmpty) {
	        break;
	      }
	
	      emptyLines.push(line);
	    } else {
	      if (prevEmpty) {
	        break;
	      }
	
	      if (interrupt(interuptors, tokenizers, self, [eat, line, true])) {
	        break;
	      }
	
	      item.value = item.value.concat(emptyLines, line);
	      allLines = allLines.concat(emptyLines, line);
	      emptyLines = [];
	    }
	
	    index = nextIndex + 1;
	  }
	
	  node = eat(allLines.join(C_NEWLINE)).reset({
	    type: 'list',
	    ordered: ordered,
	    start: start,
	    loose: null,
	    children: []
	  });
	
	  enterTop = self.enterList();
	  exitBlockquote = self.enterBlock();
	  isLoose = false;
	  index = -1;
	  length = items.length;
	
	  while (++index < length) {
	    item = items[index].value.join(C_NEWLINE);
	    now = eat.now();
	
	    item = eat(item)(listItem(self, item, now), node);
	
	    if (item.loose) {
	      isLoose = true;
	    }
	
	    item = items[index].trail.join(C_NEWLINE);
	
	    if (index !== length - 1) {
	      item += C_NEWLINE;
	    }
	
	    eat(item);
	  }
	
	  enterTop();
	  exitBlockquote();
	
	  node.loose = isLoose;
	
	  return node;
	}
	
	function listItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem;
	  var checked = null;
	  var task;
	  var indent;
	
	  value = fn.apply(null, arguments);
	
	  if (ctx.options.gfm) {
	    task = value.match(EXPRESSION_TASK_ITEM);
	
	    if (task) {
	      indent = task[0].length;
	      checked = task[1].toLowerCase() === C_X_LOWER;
	      offsets[position.line] += indent;
	      value = value.slice(indent);
	    }
	  }
	
	  return {
	    type: 'listItem',
	    loose: EXPRESSION_LOOSE_LIST_ITEM.test(value) ||
	      value.charAt(value.length - 1) === C_NEWLINE,
	    checked: checked,
	    children: ctx.tokenizeBlock(value, position)
	  };
	}
	
	/* Create a list-item using overly simple mechanics. */
	function pedanticListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_PEDANTIC_BULLET, replacer);
	
	  /* The initial line was also matched by the below, so
	   * we reset the `line`. */
	  line = position.line;
	
	  return value.replace(EXPRESSION_INITIAL_INDENT, replacer);
	
	  /* A simple replacer which removed all matches,
	   * and adds their length to `offset`. */
	  function replacer($0) {
	    offsets[line] = (offsets[line] || 0) + $0.length;
	    line++;
	
	    return '';
	  }
	}
	
	/* Create a list-item using sane mechanics. */
	function normalListItem(ctx, value, position) {
	  var offsets = ctx.offset;
	  var line = position.line;
	  var max;
	  var bullet;
	  var rest;
	  var lines;
	  var trimmedLines;
	  var index;
	  var length;
	
	  /* Remove the list-item’s bullet. */
	  value = value.replace(EXPRESSION_BULLET, replacer);
	
	  lines = value.split(C_NEWLINE);
	
	  trimmedLines = removeIndent(value, getIndent(max).indent).split(C_NEWLINE);
	
	  /* We replaced the initial bullet with something
	   * else above, which was used to trick
	   * `removeIndentation` into removing some more
	   * characters when possible.  However, that could
	   * result in the initial line to be stripped more
	   * than it should be. */
	  trimmedLines[0] = rest;
	
	  offsets[line] = (offsets[line] || 0) + bullet.length;
	  line++;
	
	  index = 0;
	  length = lines.length;
	
	  while (++index < length) {
	    offsets[line] = (offsets[line] || 0) +
	      lines[index].length - trimmedLines[index].length;
	    line++;
	  }
	
	  return trimmedLines.join(C_NEWLINE);
	
	  function replacer($0, $1, $2, $3, $4) {
	    bullet = $1 + $2 + $3;
	    rest = $4;
	
	    /* Make sure that the first nine numbered list items
	     * can indent with an extra space.  That is, when
	     * the bullet did not receive an extra final space. */
	    if (Number($2) < 10 && bullet.length % 2 === 1) {
	      $2 = C_SPACE + $2;
	    }
	
	    max = $1 + repeat(C_SPACE, $2.length) + $3;
	
	    return max + rest;
	  }
	}


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(3);
	
	module.exports = newline;
	
	/* Tokenise newline. */
	function newline(eat, value, silent) {
	  var character = value.charAt(0);
	  var length;
	  var subvalue;
	  var queue;
	  var index;
	
	  if (character !== '\n') {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  index = 1;
	  length = value.length;
	  subvalue = character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	
	    if (character === '\n') {
	      subvalue += queue;
	      queue = '';
	    }
	
	    index++;
	  }
	
	  eat(subvalue);
	}


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(8);
	var decimal = __webpack_require__(10);
	var trimTrailingLines = __webpack_require__(20);
	var interrupt = __webpack_require__(17);
	
	module.exports = paragraph;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	
	var TAB_SIZE = 4;
	
	/* Tokenise paragraph. */
	function paragraph(eat, value, silent) {
	  var self = this;
	  var settings = self.options;
	  var commonmark = settings.commonmark;
	  var gfm = settings.gfm;
	  var tokenizers = self.blockTokenizers;
	  var interruptors = self.interruptParagraph;
	  var index = value.indexOf(C_NEWLINE);
	  var length = value.length;
	  var position;
	  var subvalue;
	  var character;
	  var size;
	  var now;
	
	  while (index < length) {
	    /* Eat everything if there’s no following newline. */
	    if (index === -1) {
	      index = length;
	      break;
	    }
	
	    /* Stop if the next character is NEWLINE. */
	    if (value.charAt(index + 1) === C_NEWLINE) {
	      break;
	    }
	
	    /* In commonmark-mode, following indented lines
	     * are part of the paragraph. */
	    if (commonmark) {
	      size = 0;
	      position = index + 1;
	
	      while (position < length) {
	        character = value.charAt(position);
	
	        if (character === C_TAB) {
	          size = TAB_SIZE;
	          break;
	        } else if (character === C_SPACE) {
	          size++;
	        } else {
	          break;
	        }
	
	        position++;
	      }
	
	      if (size >= TAB_SIZE) {
	        index = value.indexOf(C_NEWLINE, index + 1);
	        continue;
	      }
	    }
	
	    subvalue = value.slice(index + 1);
	
	    /* Check if the following code contains a possible
	     * block. */
	    if (interrupt(interruptors, tokenizers, self, [eat, subvalue, true])) {
	      break;
	    }
	
	    /* Break if the following line starts a list, when
	     * already in a list, or when in commonmark, or when
	     * in gfm mode and the bullet is *not* numeric. */
	    if (
	      tokenizers.list.call(self, eat, subvalue, true) &&
	      (
	        self.inList ||
	        commonmark ||
	        (gfm && !decimal(trim.left(subvalue).charAt(0)))
	      )
	    ) {
	      break;
	    }
	
	    position = index;
	    index = value.indexOf(C_NEWLINE, index + 1);
	
	    if (index !== -1 && trim(value.slice(position, index)) === '') {
	      index = position;
	      break;
	    }
	  }
	
	  subvalue = value.slice(0, index);
	
	  if (trim(subvalue) === '') {
	    eat(subvalue);
	
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  now = eat.now();
	  subvalue = trimTrailingLines(subvalue);
	
	  return eat(subvalue)({
	    type: 'paragraph',
	    children: self.tokenizeInline(subvalue, now)
	  });
	}


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(3);
	var locate = __webpack_require__(33);
	var normalize = __webpack_require__(18);
	
	module.exports = reference;
	reference.locator = locate;
	
	var T_LINK = 'link';
	var T_IMAGE = 'image';
	var T_FOOTNOTE = 'footnote';
	var REFERENCE_TYPE_SHORTCUT = 'shortcut';
	var REFERENCE_TYPE_COLLAPSED = 'collapsed';
	var REFERENCE_TYPE_FULL = 'full';
	var C_CARET = '^';
	var C_BACKSLASH = '\\';
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	
	function reference(eat, value, silent) {
	  var self = this;
	  var character = value.charAt(0);
	  var index = 0;
	  var length = value.length;
	  var subvalue = '';
	  var intro = '';
	  var type = T_LINK;
	  var referenceType = REFERENCE_TYPE_SHORTCUT;
	  var content;
	  var identifier;
	  var now;
	  var node;
	  var exit;
	  var queue;
	  var bracketed;
	  var depth;
	
	  /* Check whether we’re eating an image. */
	  if (character === '!') {
	    type = T_IMAGE;
	    intro = character;
	    character = value.charAt(++index);
	  }
	
	  if (character !== C_BRACKET_OPEN) {
	    return;
	  }
	
	  index++;
	  intro += character;
	  queue = '';
	
	  /* Check whether we’re eating a footnote. */
	  if (self.options.footnotes && value.charAt(index) === C_CARET) {
	    /* Exit if `![^` is found, so the `!` will be seen as text after this,
	     * and we’ll enter this function again when `[^` is found. */
	    if (type === T_IMAGE) {
	      return;
	    }
	
	    intro += C_CARET;
	    index++;
	    type = T_FOOTNOTE;
	  }
	
	  /* Eat the text. */
	  depth = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_OPEN) {
	      bracketed = true;
	      depth++;
	    } else if (character === C_BRACKET_CLOSE) {
	      if (!depth) {
	        break;
	      }
	
	      depth--;
	    }
	
	    if (character === C_BACKSLASH) {
	      queue += C_BACKSLASH;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	
	  subvalue = queue;
	  content = queue;
	  character = value.charAt(index);
	
	  if (character !== C_BRACKET_CLOSE) {
	    return;
	  }
	
	  index++;
	  subvalue += character;
	  queue = '';
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (!whitespace(character)) {
	      break;
	    }
	
	    queue += character;
	    index++;
	  }
	
	  character = value.charAt(index);
	
	  /* Inline footnotes cannot have an identifier. */
	  if (type !== T_FOOTNOTE && character === C_BRACKET_OPEN) {
	    identifier = '';
	    queue += character;
	    index++;
	
	    while (index < length) {
	      character = value.charAt(index);
	
	      if (character === C_BRACKET_OPEN || character === C_BRACKET_CLOSE) {
	        break;
	      }
	
	      if (character === C_BACKSLASH) {
	        identifier += C_BACKSLASH;
	        character = value.charAt(++index);
	      }
	
	      identifier += character;
	      index++;
	    }
	
	    character = value.charAt(index);
	
	    if (character === C_BRACKET_CLOSE) {
	      referenceType = identifier ? REFERENCE_TYPE_FULL : REFERENCE_TYPE_COLLAPSED;
	      queue += identifier + character;
	      index++;
	    } else {
	      identifier = '';
	    }
	
	    subvalue += queue;
	    queue = '';
	  } else {
	    if (!content) {
	      return;
	    }
	
	    identifier = content;
	  }
	
	  /* Brackets cannot be inside the identifier. */
	  if (referenceType !== REFERENCE_TYPE_FULL && bracketed) {
	    return;
	  }
	
	  subvalue = intro + subvalue;
	
	  if (type === T_LINK && self.inLink) {
	    return null;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  if (type === T_FOOTNOTE && content.indexOf(' ') !== -1) {
	    return eat(subvalue)({
	      type: 'footnote',
	      children: this.tokenizeInline(content, eat.now())
	    });
	  }
	
	  now = eat.now();
	  now.column += intro.length;
	  now.offset += intro.length;
	  identifier = referenceType === REFERENCE_TYPE_FULL ? identifier : content;
	
	  node = {
	    type: type + 'Reference',
	    identifier: normalize(identifier)
	  };
	
	  if (type === T_LINK || type === T_IMAGE) {
	    node.referenceType = referenceType;
	  }
	
	  if (type === T_LINK) {
	    exit = self.enterLink();
	    node.children = self.tokenizeInline(content, now);
	    exit();
	  } else if (type === T_IMAGE) {
	    node.alt = self.decode.raw(self.unescape(content), now) || null;
	  }
	
	  return eat(subvalue)(node);
	}


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(8);
	var whitespace = __webpack_require__(3);
	var locate = __webpack_require__(97);
	
	module.exports = strong;
	strong.locator = locate;
	
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	
	function strong(eat, value, silent) {
	  var self = this;
	  var index = 0;
	  var character = value.charAt(index);
	  var now;
	  var pedantic;
	  var marker;
	  var queue;
	  var subvalue;
	  var length;
	  var prev;
	
	  if (
	    (character !== C_ASTERISK && character !== C_UNDERSCORE) ||
	    value.charAt(++index) !== character
	  ) {
	    return;
	  }
	
	  pedantic = self.options.pedantic;
	  marker = character;
	  subvalue = marker + marker;
	  length = value.length;
	  index++;
	  queue = '';
	  character = '';
	
	  if (pedantic && whitespace(value.charAt(index))) {
	    return;
	  }
	
	  while (index < length) {
	    prev = character;
	    character = value.charAt(index);
	
	    if (
	      character === marker &&
	      value.charAt(index + 1) === marker &&
	      (!pedantic || !whitespace(prev))
	    ) {
	      character = value.charAt(index + 2);
	
	      if (character !== marker) {
	        if (!trim(queue)) {
	          return;
	        }
	
	        /* istanbul ignore if - never used (yet) */
	        if (silent) {
	          return true;
	        }
	
	        now = eat.now();
	        now.column += 2;
	        now.offset += 2;
	
	        return eat(subvalue + queue + subvalue)({
	          type: 'strong',
	          children: self.tokenizeInline(queue, now)
	        });
	      }
	    }
	
	    if (!pedantic && character === '\\') {
	      queue += character;
	      character = value.charAt(++index);
	    }
	
	    queue += character;
	    index++;
	  }
	}


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var whitespace = __webpack_require__(3);
	
	module.exports = table;
	
	var C_BACKSLASH = '\\';
	var C_TICK = '`';
	var C_DASH = '-';
	var C_PIPE = '|';
	var C_COLON = ':';
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	var MIN_TABLE_COLUMNS = 1;
	var MIN_TABLE_ROWS = 2;
	
	var TABLE_ALIGN_LEFT = 'left';
	var TABLE_ALIGN_CENTER = 'center';
	var TABLE_ALIGN_RIGHT = 'right';
	var TABLE_ALIGN_NONE = null;
	
	function table(eat, value, silent) {
	  var self = this;
	  var index;
	  var alignments;
	  var alignment;
	  var subvalue;
	  var row;
	  var length;
	  var lines;
	  var queue;
	  var character;
	  var hasDash;
	  var align;
	  var cell;
	  var preamble;
	  var count;
	  var opening;
	  var now;
	  var position;
	  var lineCount;
	  var line;
	  var rows;
	  var table;
	  var lineIndex;
	  var pipeIndex;
	  var first;
	
	  /* Exit when not in gfm-mode. */
	  if (!self.options.gfm) {
	    return;
	  }
	
	  /* Get the rows.
	   * Detecting tables soon is hard, so there are some
	   * checks for performance here, such as the minimum
	   * number of rows, and allowed characters in the
	   * alignment row. */
	  index = 0;
	  lineCount = 0;
	  length = value.length + 1;
	  lines = [];
	
	  while (index < length) {
	    lineIndex = value.indexOf(C_NEWLINE, index);
	    pipeIndex = value.indexOf(C_PIPE, index + 1);
	
	    if (lineIndex === -1) {
	      lineIndex = value.length;
	    }
	
	    if (pipeIndex === -1 || pipeIndex > lineIndex) {
	      if (lineCount < MIN_TABLE_ROWS) {
	        return;
	      }
	
	      break;
	    }
	
	    lines.push(value.slice(index, lineIndex));
	    lineCount++;
	    index = lineIndex + 1;
	  }
	
	  /* Parse the alignment row. */
	  subvalue = lines.join(C_NEWLINE);
	  alignments = lines.splice(1, 1)[0] || [];
	  index = 0;
	  length = alignments.length;
	  lineCount--;
	  alignment = false;
	  align = [];
	
	  while (index < length) {
	    character = alignments.charAt(index);
	
	    if (character === C_PIPE) {
	      hasDash = null;
	
	      if (alignment === false) {
	        if (first === false) {
	          return;
	        }
	      } else {
	        align.push(alignment);
	        alignment = false;
	      }
	
	      first = false;
	    } else if (character === C_DASH) {
	      hasDash = true;
	      alignment = alignment || TABLE_ALIGN_NONE;
	    } else if (character === C_COLON) {
	      if (alignment === TABLE_ALIGN_LEFT) {
	        alignment = TABLE_ALIGN_CENTER;
	      } else if (hasDash && alignment === TABLE_ALIGN_NONE) {
	        alignment = TABLE_ALIGN_RIGHT;
	      } else {
	        alignment = TABLE_ALIGN_LEFT;
	      }
	    } else if (!whitespace(character)) {
	      return;
	    }
	
	    index++;
	  }
	
	  if (alignment !== false) {
	    align.push(alignment);
	  }
	
	  /* Exit when without enough columns. */
	  if (align.length < MIN_TABLE_COLUMNS) {
	    return;
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  /* Parse the rows. */
	  position = -1;
	  rows = [];
	
	  table = eat(subvalue).reset({
	    type: 'table',
	    align: align,
	    children: rows
	  });
	
	  while (++position < lineCount) {
	    line = lines[position];
	    row = {type: 'tableRow', children: []};
	
	    /* Eat a newline character when this is not the
	     * first row. */
	    if (position) {
	      eat(C_NEWLINE);
	    }
	
	    /* Eat the row. */
	    eat(line).reset(row, table);
	
	    length = line.length + 1;
	    index = 0;
	    queue = '';
	    cell = '';
	    preamble = true;
	    count = null;
	    opening = null;
	
	    while (index < length) {
	      character = line.charAt(index);
	
	      if (character === C_TAB || character === C_SPACE) {
	        if (cell) {
	          queue += character;
	        } else {
	          eat(character);
	        }
	
	        index++;
	        continue;
	      }
	
	      if (character === '' || character === C_PIPE) {
	        if (preamble) {
	          eat(character);
	        } else {
	          if (character && opening) {
	            queue += character;
	            index++;
	            continue;
	          }
	
	          if ((cell || character) && !preamble) {
	            subvalue = cell;
	
	            if (queue.length > 1) {
	              if (character) {
	                subvalue += queue.slice(0, queue.length - 1);
	                queue = queue.charAt(queue.length - 1);
	              } else {
	                subvalue += queue;
	                queue = '';
	              }
	            }
	
	            now = eat.now();
	
	            eat(subvalue)({
	              type: 'tableCell',
	              children: self.tokenizeInline(cell, now)
	            }, row);
	          }
	
	          eat(queue + character);
	
	          queue = '';
	          cell = '';
	        }
	      } else {
	        if (queue) {
	          cell += queue;
	          queue = '';
	        }
	
	        cell += character;
	
	        if (character === C_BACKSLASH && index !== length - 2) {
	          cell += line.charAt(index + 1);
	          index++;
	        }
	
	        if (character === C_TICK) {
	          count = 1;
	
	          while (line.charAt(index + 1) === character) {
	            cell += character;
	            index++;
	            count++;
	          }
	
	          if (!opening) {
	            opening = count;
	          } else if (count >= opening) {
	            opening = 0;
	          }
	        }
	      }
	
	      preamble = false;
	      index++;
	    }
	
	    /* Eat the alignment row. */
	    if (!position) {
	      eat(C_NEWLINE + alignments);
	    }
	  }
	
	  return table;
	}


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = text;
	
	function text(eat, value, silent) {
	  var self = this;
	  var methods;
	  var tokenizers;
	  var index;
	  var length;
	  var subvalue;
	  var position;
	  var tokenizer;
	  var name;
	  var min;
	  var now;
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  methods = self.inlineMethods;
	  length = methods.length;
	  tokenizers = self.inlineTokenizers;
	  index = -1;
	  min = value.length;
	
	  while (++index < length) {
	    name = methods[index];
	
	    if (name === 'text' || !tokenizers[name]) {
	      continue;
	    }
	
	    tokenizer = tokenizers[name].locator;
	
	    if (!tokenizer) {
	      eat.file.fail('Missing locator: `' + name + '`');
	    }
	
	    position = tokenizer.call(self, value, 1);
	
	    if (position !== -1 && position < min) {
	      min = position;
	    }
	  }
	
	  subvalue = value.slice(0, min);
	  now = eat.now();
	
	  self.decode(subvalue, now, function (content, position, source) {
	    eat(source || content)({
	      type: 'text',
	      value: content
	    });
	  });
	}


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = thematicBreak;
	
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	var C_SPACE = ' ';
	var C_ASTERISK = '*';
	var C_UNDERSCORE = '_';
	var C_DASH = '-';
	
	var THEMATIC_BREAK_MARKER_COUNT = 3;
	
	function thematicBreak(eat, value, silent) {
	  var index = -1;
	  var length = value.length + 1;
	  var subvalue = '';
	  var character;
	  var marker;
	  var markerCount;
	  var queue;
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character !== C_TAB && character !== C_SPACE) {
	      break;
	    }
	
	    subvalue += character;
	  }
	
	  if (
	    character !== C_ASTERISK &&
	    character !== C_DASH &&
	    character !== C_UNDERSCORE
	  ) {
	    return;
	  }
	
	  marker = character;
	  subvalue += character;
	  markerCount = 1;
	  queue = '';
	
	  while (++index < length) {
	    character = value.charAt(index);
	
	    if (character === marker) {
	      markerCount++;
	      subvalue += queue + marker;
	      queue = '';
	    } else if (character === C_SPACE) {
	      queue += character;
	    } else if (
	      markerCount >= THEMATIC_BREAK_MARKER_COUNT &&
	      (!character || character === C_NEWLINE)
	    ) {
	      subvalue += queue;
	
	      if (silent) {
	        return true;
	      }
	
	      return eat(subvalue)({type: 'thematicBreak'});
	    } else {
	      return;
	    }
	  }
	}


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var decode = __webpack_require__(15);
	var whitespace = __webpack_require__(3);
	var locate = __webpack_require__(98);
	
	module.exports = url;
	url.locator = locate;
	url.notInLink = true;
	
	var C_BRACKET_OPEN = '[';
	var C_BRACKET_CLOSE = ']';
	var C_PAREN_OPEN = '(';
	var C_PAREN_CLOSE = ')';
	var C_LT = '<';
	var C_AT_SIGN = '@';
	
	var HTTP_PROTOCOL = 'http://';
	var HTTPS_PROTOCOL = 'https://';
	var MAILTO_PROTOCOL = 'mailto:';
	
	var PROTOCOLS = [
	  HTTP_PROTOCOL,
	  HTTPS_PROTOCOL,
	  MAILTO_PROTOCOL
	];
	
	var PROTOCOLS_LENGTH = PROTOCOLS.length;
	
	function url(eat, value, silent) {
	  var self = this;
	  var subvalue;
	  var content;
	  var character;
	  var index;
	  var position;
	  var protocol;
	  var match;
	  var length;
	  var queue;
	  var parenCount;
	  var nextCharacter;
	  var exit;
	
	  if (!self.options.gfm) {
	    return;
	  }
	
	  subvalue = '';
	  index = -1;
	  length = PROTOCOLS_LENGTH;
	
	  while (++index < length) {
	    protocol = PROTOCOLS[index];
	    match = value.slice(0, protocol.length);
	
	    if (match.toLowerCase() === protocol) {
	      subvalue = match;
	      break;
	    }
	  }
	
	  if (!subvalue) {
	    return;
	  }
	
	  index = subvalue.length;
	  length = value.length;
	  queue = '';
	  parenCount = 0;
	
	  while (index < length) {
	    character = value.charAt(index);
	
	    if (whitespace(character) || character === C_LT) {
	      break;
	    }
	
	    if (
	      character === '.' ||
	      character === ',' ||
	      character === ':' ||
	      character === ';' ||
	      character === '"' ||
	      character === '\'' ||
	      character === ')' ||
	      character === ']'
	    ) {
	      nextCharacter = value.charAt(index + 1);
	
	      if (!nextCharacter || whitespace(nextCharacter)) {
	        break;
	      }
	    }
	
	    if (character === C_PAREN_OPEN || character === C_BRACKET_OPEN) {
	      parenCount++;
	    }
	
	    if (character === C_PAREN_CLOSE || character === C_BRACKET_CLOSE) {
	      parenCount--;
	
	      if (parenCount < 0) {
	        break;
	      }
	    }
	
	    queue += character;
	    index++;
	  }
	
	  if (!queue) {
	    return;
	  }
	
	  subvalue += queue;
	  content = subvalue;
	
	  if (protocol === MAILTO_PROTOCOL) {
	    position = queue.indexOf(C_AT_SIGN);
	
	    if (position === -1 || position === length - 1) {
	      return;
	    }
	
	    content = content.substr(MAILTO_PROTOCOL.length);
	  }
	
	  /* istanbul ignore if - never used (yet) */
	  if (silent) {
	    return true;
	  }
	
	  exit = self.enterLink();
	  content = self.tokenizeInline(content, eat.now());
	  exit();
	
	  return eat(subvalue)({
	    type: 'link',
	    title: null,
	    url: decode(subvalue, {nonTerminated: false}),
	    children: content
	  });
	}


/***/ }),
/* 127 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	var MERGEABLE_NODES = {
	  text: mergeText,
	  blockquote: mergeBlockquote
	};
	
	/* Check whether a node is mergeable with adjacent nodes. */
	function mergeable(node) {
	  var start;
	  var end;
	
	  if (node.type !== 'text' || !node.position) {
	    return true;
	  }
	
	  start = node.position.start;
	  end = node.position.end;
	
	  /* Only merge nodes which occupy the same size as their
	   * `value`. */
	  return start.line !== end.line ||
	      end.column - start.column === node.value.length;
	}
	
	/* Merge two text nodes: `node` into `prev`. */
	function mergeText(prev, node) {
	  prev.value += node.value;
	
	  return prev;
	}
	
	/* Merge two blockquotes: `node` into `prev`, unless in
	 * CommonMark mode. */
	function mergeBlockquote(prev, node) {
	  if (this.options.commonmark) {
	    return node;
	  }
	
	  prev.children = prev.children.concat(node.children);
	
	  return prev;
	}
	
	/* Construct a tokenizer.  This creates both
	 * `tokenizeInline` and `tokenizeBlock`. */
	function factory(type) {
	  return tokenize;
	
	  /* Tokenizer for a bound `type`. */
	  function tokenize(value, location) {
	    var self = this;
	    var offset = self.offset;
	    var tokens = [];
	    var methods = self[type + 'Methods'];
	    var tokenizers = self[type + 'Tokenizers'];
	    var line = location.line;
	    var column = location.column;
	    var index;
	    var length;
	    var method;
	    var name;
	    var matched;
	    var valueLength;
	
	    /* Trim white space only lines. */
	    if (!value) {
	      return tokens;
	    }
	
	    /* Expose on `eat`. */
	    eat.now = now;
	    eat.file = self.file;
	
	    /* Sync initial offset. */
	    updatePosition('');
	
	    /* Iterate over `value`, and iterate over all
	     * tokenizers.  When one eats something, re-iterate
	     * with the remaining value.  If no tokenizer eats,
	     * something failed (should not happen) and an
	     * exception is thrown. */
	    while (value) {
	      index = -1;
	      length = methods.length;
	      matched = false;
	
	      while (++index < length) {
	        name = methods[index];
	        method = tokenizers[name];
	
	        if (
	          method &&
	          /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) &&
	          (!method.notInList || !self.inList) &&
	          (!method.notInBlock || !self.inBlock) &&
	          (!method.notInLink || !self.inLink)
	        ) {
	          valueLength = value.length;
	
	          method.apply(self, [eat, value]);
	
	          matched = valueLength !== value.length;
	
	          if (matched) {
	            break;
	          }
	        }
	      }
	
	      /* istanbul ignore if */
	      if (!matched) {
	        self.file.fail(new Error('Infinite loop'), eat.now());
	      }
	    }
	
	    self.eof = now();
	
	    return tokens;
	
	    /* Update line, column, and offset based on
	     * `value`. */
	    function updatePosition(subvalue) {
	      var lastIndex = -1;
	      var index = subvalue.indexOf('\n');
	
	      while (index !== -1) {
	        line++;
	        lastIndex = index;
	        index = subvalue.indexOf('\n', index + 1);
	      }
	
	      if (lastIndex === -1) {
	        column += subvalue.length;
	      } else {
	        column = subvalue.length - lastIndex;
	      }
	
	      if (line in offset) {
	        if (lastIndex !== -1) {
	          column += offset[line];
	        } else if (column <= offset[line]) {
	          column = offset[line] + 1;
	        }
	      }
	    }
	
	    /* Get offset.  Called before the first character is
	     * eaten to retrieve the range's offsets. */
	    function getOffset() {
	      var indentation = [];
	      var pos = line + 1;
	
	      /* Done.  Called when the last character is
	       * eaten to retrieve the range’s offsets. */
	      return function () {
	        var last = line + 1;
	
	        while (pos < last) {
	          indentation.push((offset[pos] || 0) + 1);
	
	          pos++;
	        }
	
	        return indentation;
	      };
	    }
	
	    /* Get the current position. */
	    function now() {
	      var pos = {line: line, column: column};
	
	      pos.offset = self.toOffset(pos);
	
	      return pos;
	    }
	
	    /* Store position information for a node. */
	    function Position(start) {
	      this.start = start;
	      this.end = now();
	    }
	
	    /* Throw when a value is incorrectly eaten.
	     * This shouldn’t happen but will throw on new,
	     * incorrect rules. */
	    function validateEat(subvalue) {
	      /* istanbul ignore if */
	      if (value.substring(0, subvalue.length) !== subvalue) {
	        /* Capture stack-trace. */
	        self.file.fail(
	          new Error(
	            'Incorrectly eaten value: please report this ' +
	            'warning on http://git.io/vg5Ft'
	          ),
	          now()
	        );
	      }
	    }
	
	    /* Mark position and patch `node.position`. */
	    function position() {
	      var before = now();
	
	      return update;
	
	      /* Add the position to a node. */
	      function update(node, indent) {
	        var prev = node.position;
	        var start = prev ? prev.start : before;
	        var combined = [];
	        var n = prev && prev.end.line;
	        var l = before.line;
	
	        node.position = new Position(start);
	
	        /* If there was already a `position`, this
	         * node was merged.  Fixing `start` wasn’t
	         * hard, but the indent is different.
	         * Especially because some information, the
	         * indent between `n` and `l` wasn’t
	         * tracked.  Luckily, that space is
	         * (should be?) empty, so we can safely
	         * check for it now. */
	        if (prev && indent && prev.indent) {
	          combined = prev.indent;
	
	          if (n < l) {
	            while (++n < l) {
	              combined.push((offset[n] || 0) + 1);
	            }
	
	            combined.push(before.column);
	          }
	
	          indent = combined.concat(indent);
	        }
	
	        node.position.indent = indent || [];
	
	        return node;
	      }
	    }
	
	    /* Add `node` to `parent`s children or to `tokens`.
	     * Performs merges where possible. */
	    function add(node, parent) {
	      var children = parent ? parent.children : tokens;
	      var prev = children[children.length - 1];
	
	      if (
	        prev &&
	        node.type === prev.type &&
	        node.type in MERGEABLE_NODES &&
	        mergeable(prev) &&
	        mergeable(node)
	      ) {
	        node = MERGEABLE_NODES[node.type].call(self, prev, node);
	      }
	
	      if (node !== prev) {
	        children.push(node);
	      }
	
	      if (self.atStart && tokens.length !== 0) {
	        self.exitStart();
	      }
	
	      return node;
	    }
	
	    /* Remove `subvalue` from `value`.
	     * `subvalue` must be at the start of `value`. */
	    function eat(subvalue) {
	      var indent = getOffset();
	      var pos = position();
	      var current = now();
	
	      validateEat(subvalue);
	
	      apply.reset = reset;
	      reset.test = test;
	      apply.test = test;
	
	      value = value.substring(subvalue.length);
	
	      updatePosition(subvalue);
	
	      indent = indent();
	
	      return apply;
	
	      /* Add the given arguments, add `position` to
	       * the returned node, and return the node. */
	      function apply(node, parent) {
	        return pos(add(pos(node), parent), indent);
	      }
	
	      /* Functions just like apply, but resets the
	       * content:  the line and column are reversed,
	       * and the eaten value is re-added.
	       * This is useful for nodes with a single
	       * type of content, such as lists and tables.
	       * See `apply` above for what parameters are
	       * expected. */
	      function reset() {
	        var node = apply.apply(null, arguments);
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return node;
	      }
	
	      /* Test the position, after eating, and reverse
	       * to a not-eaten state. */
	      function test() {
	        var result = pos({});
	
	        line = current.line;
	        column = current.column;
	        value = subvalue + value;
	
	        return result.position;
	      }
	    }
	  }
	}


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = factory;
	
	/* Factory to de-escape a value, based on a list at `key`
	 * in `ctx`. */
	function factory(ctx, key) {
	  return unescape;
	
	  /* De-escape a string using the expression at `key`
	   * in `ctx`. */
	  function unescape(value) {
	    var prev = 0;
	    var index = value.indexOf('\\');
	    var escape = ctx[key];
	    var queue = [];
	    var character;
	
	    while (index !== -1) {
	      queue.push(value.slice(prev, index));
	      prev = index + 1;
	      character = value.charAt(prev);
	
	      /* If the following character is not a valid escape,
	       * add the slash. */
	      if (!character || escape.indexOf(character) === -1) {
	        queue.push('\\');
	      }
	
	      index = value.indexOf('\\', prev);
	    }
	
	    queue.push(value.slice(prev));
	
	    return queue.join('');
	  }
	}


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var trim = __webpack_require__(8);
	var repeat = __webpack_require__(19);
	var getIndent = __webpack_require__(35);
	
	module.exports = indentation;
	
	var C_SPACE = ' ';
	var C_NEWLINE = '\n';
	var C_TAB = '\t';
	
	/* Remove the minimum indent from every line in `value`.
	 * Supports both tab, spaced, and mixed indentation (as
	 * well as possible). */
	function indentation(value, maximum) {
	  var values = value.split(C_NEWLINE);
	  var position = values.length + 1;
	  var minIndent = Infinity;
	  var matrix = [];
	  var index;
	  var indentation;
	  var stops;
	  var padding;
	
	  values.unshift(repeat(C_SPACE, maximum) + '!');
	
	  while (position--) {
	    indentation = getIndent(values[position]);
	
	    matrix[position] = indentation.stops;
	
	    if (trim(values[position]).length === 0) {
	      continue;
	    }
	
	    if (indentation.indent) {
	      if (indentation.indent > 0 && indentation.indent < minIndent) {
	        minIndent = indentation.indent;
	      }
	    } else {
	      minIndent = Infinity;
	
	      break;
	    }
	  }
	
	  if (minIndent !== Infinity) {
	    position = values.length;
	
	    while (position--) {
	      stops = matrix[position];
	      index = minIndent;
	
	      while (index && !(index in stops)) {
	        index--;
	      }
	
	      if (
	        trim(values[position]).length !== 0 &&
	        minIndent &&
	        index !== minIndent
	      ) {
	        padding = C_TAB;
	      } else {
	        padding = '';
	      }
	
	      values[position] = padding + values[position].slice(
	        index in stops ? stops[index] + 1 : 0
	      );
	    }
	  }
	
	  values.shift();
	
	  return values.join(C_NEWLINE);
	}


/***/ }),
/* 130 */,
/* 131 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = factory
	
	/* Construct a state `toggler`: a function which inverses
	 * `property` in context based on its current value.
	 * The by `toggler` returned function restores that value. */
	function factory(key, state, ctx) {
	  return enter
	
	  function enter() {
	    var context = ctx || this
	    var current = context[key]
	
	    context[key] = !state
	
	    return exit
	
	    function exit() {
	      context[key] = current
	    }
	  }
	}


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var wrap = __webpack_require__(133)
	
	module.exports = trough
	
	trough.wrap = wrap
	
	var slice = [].slice
	
	/* Create new middleware. */
	function trough() {
	  var fns = []
	  var middleware = {}
	
	  middleware.run = run
	  middleware.use = use
	
	  return middleware
	
	  /* Run `fns`.  Last argument must be
	   * a completion handler. */
	  function run() {
	    var index = -1
	    var input = slice.call(arguments, 0, -1)
	    var done = arguments[arguments.length - 1]
	
	    if (typeof done !== 'function') {
	      throw new Error('Expected function as last argument, not ' + done)
	    }
	
	    next.apply(null, [null].concat(input))
	
	    /* Run the next `fn`, if any. */
	    function next(err) {
	      var fn = fns[++index]
	      var params = slice.call(arguments, 0)
	      var values = params.slice(1)
	      var length = input.length
	      var pos = -1
	
	      if (err) {
	        done(err)
	        return
	      }
	
	      /* Copy non-nully input into values. */
	      while (++pos < length) {
	        if (values[pos] === null || values[pos] === undefined) {
	          values[pos] = input[pos]
	        }
	      }
	
	      input = values
	
	      /* Next or done. */
	      if (fn) {
	        wrap(fn, next).apply(null, input)
	      } else {
	        done.apply(null, [null].concat(input))
	      }
	    }
	  }
	
	  /* Add `fn` to the list. */
	  function use(fn) {
	    if (typeof fn !== 'function') {
	      throw new Error('Expected `fn` to be a function, not ' + fn)
	    }
	
	    fns.push(fn)
	
	    return middleware
	  }
	}


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	'use strict'
	
	var slice = [].slice
	
	module.exports = wrap
	
	/* Wrap `fn`.  Can be sync or async; return a promise,
	 * receive a completion handler, return new values and
	 * errors. */
	function wrap(fn, callback) {
	  var invoked
	
	  return wrapped
	
	  function wrapped() {
	    var params = slice.call(arguments, 0)
	    var callback = fn.length > params.length
	    var result
	
	    if (callback) {
	      params.push(done)
	    }
	
	    try {
	      result = fn.apply(null, params)
	    } catch (err) {
	      /* Well, this is quite the pickle.  `fn` received
	       * a callback and invoked it (thus continuing the
	       * pipeline), but later also threw an error.
	       * We’re not about to restart the pipeline again,
	       * so the only thing left to do is to throw the
	       * thing instea. */
	      if (callback && invoked) {
	        throw err
	      }
	
	      return done(err)
	    }
	
	    if (!callback) {
	      if (result && typeof result.then === 'function') {
	        result.then(then, done)
	      } else if (result instanceof Error) {
	        done(result)
	      } else {
	        then(result)
	      }
	    }
	  }
	
	  /* Invoke `next`, only once. */
	  function done() {
	    if (!invoked) {
	      invoked = true
	
	      callback.apply(null, arguments)
	    }
	  }
	
	  /* Invoke `done` with one value.
	   * Tracks if an error is passed, too. */
	  function then(value) {
	    done(null, value)
	  }
	}


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(5)
	var inherits = __webpack_require__(66)
	
	module.exports = unherit
	
	/* Create a custom constructor which can be modified
	 * without affecting the original class. */
	function unherit(Super) {
	  var result
	  var key
	  var value
	
	  inherits(Of, Super)
	  inherits(From, Of)
	
	  /* Clone values. */
	  result = Of.prototype
	
	  for (key in result) {
	    value = result[key]
	
	    if (value && typeof value === 'object') {
	      result[key] = 'concat' in value ? value.concat() : xtend(value)
	    }
	  }
	
	  return Of
	
	  /* Constructor accepting a single argument,
	   * which itself is an `arguments` object. */
	  function From(parameters) {
	    return Super.apply(this, parameters)
	  }
	
	  /* Constructor accepting variadic arguments. */
	  function Of() {
	    if (!(this instanceof Of)) {
	      return new From(arguments)
	    }
	
	    return Super.apply(this, arguments)
	  }
	}


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict'
	
	/* Dependencies. */
	var extend = __webpack_require__(64)
	var bail = __webpack_require__(55)
	var vfile = __webpack_require__(144)
	var trough = __webpack_require__(132)
	var string = __webpack_require__(146)
	var plain = __webpack_require__(71)
	
	/* Expose a frozen processor. */
	module.exports = unified().freeze()
	
	var slice = [].slice
	var own = {}.hasOwnProperty
	
	/* Process pipeline. */
	var pipeline = trough()
	  .use(pipelineParse)
	  .use(pipelineRun)
	  .use(pipelineStringify)
	
	function pipelineParse(p, ctx) {
	  ctx.tree = p.parse(ctx.file)
	}
	
	function pipelineRun(p, ctx, next) {
	  p.run(ctx.tree, ctx.file, done)
	
	  function done(err, tree, file) {
	    if (err) {
	      next(err)
	    } else {
	      ctx.tree = tree
	      ctx.file = file
	      next()
	    }
	  }
	}
	
	function pipelineStringify(p, ctx) {
	  ctx.file.contents = p.stringify(ctx.tree, ctx.file)
	}
	
	/* Function to create the first processor. */
	function unified() {
	  var attachers = []
	  var transformers = trough()
	  var namespace = {}
	  var frozen = false
	  var freezeIndex = -1
	
	  /* Data management. */
	  processor.data = data
	
	  /* Lock. */
	  processor.freeze = freeze
	
	  /* Plug-ins. */
	  processor.attachers = attachers
	  processor.use = use
	
	  /* API. */
	  processor.parse = parse
	  processor.stringify = stringify
	  processor.run = run
	  processor.runSync = runSync
	  processor.process = process
	  processor.processSync = processSync
	
	  /* Expose. */
	  return processor
	
	  /* Create a new processor based on the processor
	   * in the current scope. */
	  function processor() {
	    var destination = unified()
	    var length = attachers.length
	    var index = -1
	
	    while (++index < length) {
	      destination.use.apply(null, attachers[index])
	    }
	
	    destination.data(extend(true, {}, namespace))
	
	    return destination
	  }
	
	  /* Freeze: used to signal a processor that has finished
	   * configuration.
	   *
	   * For example, take unified itself.  It’s frozen.
	   * Plug-ins should not be added to it.  Rather, it should
	   * be extended, by invoking it, before modifying it.
	   *
	   * In essence, always invoke this when exporting a
	   * processor. */
	  function freeze() {
	    var values
	    var plugin
	    var options
	    var transformer
	
	    if (frozen) {
	      return processor
	    }
	
	    while (++freezeIndex < attachers.length) {
	      values = attachers[freezeIndex]
	      plugin = values[0]
	      options = values[1]
	      transformer = null
	
	      if (options === false) {
	        continue
	      }
	
	      if (options === true) {
	        values[1] = undefined
	      }
	
	      transformer = plugin.apply(processor, values.slice(1))
	
	      if (typeof transformer === 'function') {
	        transformers.use(transformer)
	      }
	    }
	
	    frozen = true
	    freezeIndex = Infinity
	
	    return processor
	  }
	
	  /* Data management.
	   * Getter / setter for processor-specific informtion. */
	  function data(key, value) {
	    if (string(key)) {
	      /* Set `key`. */
	      if (arguments.length === 2) {
	        assertUnfrozen('data', frozen)
	
	        namespace[key] = value
	
	        return processor
	      }
	
	      /* Get `key`. */
	      return (own.call(namespace, key) && namespace[key]) || null
	    }
	
	    /* Set space. */
	    if (key) {
	      assertUnfrozen('data', frozen)
	      namespace = key
	      return processor
	    }
	
	    /* Get space. */
	    return namespace
	  }
	
	  /* Plug-in management.
	   *
	   * Pass it:
	   * *   an attacher and options,
	   * *   a preset,
	   * *   a list of presets, attachers, and arguments (list
	   *     of attachers and options). */
	  function use(value) {
	    var settings
	
	    assertUnfrozen('use', frozen)
	
	    if (value === null || value === undefined) {
	      /* Empty */
	    } else if (typeof value === 'function') {
	      addPlugin.apply(null, arguments)
	    } else if (typeof value === 'object') {
	      if ('length' in value) {
	        addList(value)
	      } else {
	        addPreset(value)
	      }
	    } else {
	      throw new Error('Expected usable value, not `' + value + '`')
	    }
	
	    if (settings) {
	      namespace.settings = extend(namespace.settings || {}, settings)
	    }
	
	    return processor
	
	    function addPreset(result) {
	      addList(result.plugins)
	
	      if (result.settings) {
	        settings = extend(settings || {}, result.settings)
	      }
	    }
	
	    function add(value) {
	      if (typeof value === 'function') {
	        addPlugin(value)
	      } else if (typeof value === 'object') {
	        if ('length' in value) {
	          addPlugin.apply(null, value)
	        } else {
	          addPreset(value)
	        }
	      } else {
	        throw new Error('Expected usable value, not `' + value + '`')
	      }
	    }
	
	    function addList(plugins) {
	      var length
	      var index
	
	      if (plugins === null || plugins === undefined) {
	        /* Empty */
	      } else if (typeof plugins === 'object' && 'length' in plugins) {
	        length = plugins.length
	        index = -1
	
	        while (++index < length) {
	          add(plugins[index])
	        }
	      } else {
	        throw new Error('Expected a list of plugins, not `' + plugins + '`')
	      }
	    }
	
	    function addPlugin(plugin, value) {
	      var entry = find(plugin)
	
	      if (entry) {
	        if (plain(entry[1]) && plain(value)) {
	          value = extend(entry[1], value)
	        }
	
	        entry[1] = value
	      } else {
	        attachers.push(slice.call(arguments))
	      }
	    }
	  }
	
	  function find(plugin) {
	    var length = attachers.length
	    var index = -1
	    var entry
	
	    while (++index < length) {
	      entry = attachers[index]
	
	      if (entry[0] === plugin) {
	        return entry
	      }
	    }
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the
	   * processor. */
	  function parse(doc) {
	    var file = vfile(doc)
	    var Parser
	
	    freeze()
	    Parser = processor.Parser
	    assertParser('parse', Parser)
	
	    if (newable(Parser)) {
	      return new Parser(String(file), file).parse()
	    }
	
	    return Parser(String(file), file) // eslint-disable-line new-cap
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), async. */
	  function run(node, file, cb) {
	    assertNode(node)
	    freeze()
	
	    if (!cb && typeof file === 'function') {
	      cb = file
	      file = null
	    }
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      transformers.run(node, vfile(file), done)
	
	      function done(err, tree, file) {
	        tree = tree || node
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(tree)
	        } else {
	          cb(null, tree, file)
	        }
	      }
	    }
	  }
	
	  /* Run transforms on a Unist node representation of a file
	   * (in string or VFile representation), sync. */
	  function runSync(node, file) {
	    var complete = false
	    var result
	
	    run(node, file, done)
	
	    assertDone('runSync', 'run', complete)
	
	    return result
	
	    function done(err, tree) {
	      complete = true
	      bail(err)
	      result = tree
	    }
	  }
	
	  /* Stringify a Unist node representation of a file
	   * (in string or VFile representation) into a string
	   * using the `Compiler` on the processor. */
	  function stringify(node, doc) {
	    var file = vfile(doc)
	    var Compiler
	
	    freeze()
	    Compiler = processor.Compiler
	    assertCompiler('stringify', Compiler)
	    assertNode(node)
	
	    if (newable(Compiler)) {
	      return new Compiler(node, file).compile()
	    }
	
	    return Compiler(node, file) // eslint-disable-line new-cap
	  }
	
	  /* Parse a file (in string or VFile representation)
	   * into a Unist node using the `Parser` on the processor,
	   * then run transforms on that node, and compile the
	   * resulting node using the `Compiler` on the processor,
	   * and store that result on the VFile. */
	  function process(doc, cb) {
	    freeze()
	    assertParser('process', processor.Parser)
	    assertCompiler('process', processor.Compiler)
	
	    if (!cb) {
	      return new Promise(executor)
	    }
	
	    executor(null, cb)
	
	    function executor(resolve, reject) {
	      var file = vfile(doc)
	
	      pipeline.run(processor, {file: file}, done)
	
	      function done(err) {
	        if (err) {
	          reject(err)
	        } else if (resolve) {
	          resolve(file)
	        } else {
	          cb(null, file)
	        }
	      }
	    }
	  }
	
	  /* Process the given document (in string or VFile
	   * representation), sync. */
	  function processSync(doc) {
	    var complete = false
	    var file
	
	    freeze()
	    assertParser('processSync', processor.Parser)
	    assertCompiler('processSync', processor.Compiler)
	    file = vfile(doc)
	
	    process(file, done)
	
	    assertDone('processSync', 'process', complete)
	
	    return file
	
	    function done(err) {
	      complete = true
	      bail(err)
	    }
	  }
	}
	
	/* Check if `func` is a constructor. */
	function newable(value) {
	  return typeof value === 'function' && keys(value.prototype)
	}
	
	/* Check if `value` is an object with keys. */
	function keys(value) {
	  var key
	  for (key in value) {
	    return true
	  }
	  return false
	}
	
	/* Assert a parser is available. */
	function assertParser(name, Parser) {
	  if (typeof Parser !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Parser`')
	  }
	}
	
	/* Assert a compiler is available. */
	function assertCompiler(name, Compiler) {
	  if (typeof Compiler !== 'function') {
	    throw new Error('Cannot `' + name + '` without `Compiler`')
	  }
	}
	
	/* Assert the processor is not frozen. */
	function assertUnfrozen(name, frozen) {
	  if (frozen) {
	    throw new Error(
	      [
	        'Cannot invoke `' + name + '` on a frozen processor.\nCreate a new ',
	        'processor first, by invoking it: use `processor()` instead of ',
	        '`processor`.'
	      ].join('')
	    )
	  }
	}
	
	/* Assert `node` is a Unist node. */
	function assertNode(node) {
	  if (!node || !string(node.type)) {
	    throw new Error('Expected node, got `' + node + '`')
	  }
	}
	
	/* Assert that `complete` is `true`. */
	function assertDone(name, asyncName, complete) {
	  if (!complete) {
	    throw new Error(
	      '`' + name + '` finished async. Use `' + asyncName + '` instead'
	    )
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	'use strict'
	
	/* eslint-disable max-params */
	
	/* Expose. */
	module.exports = is
	
	/* Assert if `test` passes for `node`.
	 * When a `parent` node is known the `index` of node */
	function is(test, node, index, parent, context) {
	  var hasParent = parent !== null && parent !== undefined
	  var hasIndex = index !== null && index !== undefined
	  var check = convert(test)
	
	  if (
	    hasIndex &&
	    (typeof index !== 'number' || index < 0 || index === Infinity)
	  ) {
	    throw new Error('Expected positive finite index or child node')
	  }
	
	  if (hasParent && (!is(null, parent) || !parent.children)) {
	    throw new Error('Expected parent node')
	  }
	
	  if (!node || !node.type || typeof node.type !== 'string') {
	    return false
	  }
	
	  if (hasParent !== hasIndex) {
	    throw new Error('Expected both parent and index')
	  }
	
	  return Boolean(check.call(context, node, index, parent))
	}
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	/* Utility assert each property in `test` is represented
	 * in `node`, and each values are strictly equal. */
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	/* Utility to convert a string into a function which checks
	 * a given node’s type for said string. */
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	/* Utility to return true. */
	function ok() {
	  return true
	}


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var visit = __webpack_require__(11)
	
	module.exports = removePosition
	
	/* Remove `position`s from `tree`. */
	function removePosition(node, force) {
	  visit(node, force ? hard : soft)
	  return node
	}
	
	function hard(node) {
	  delete node.position
	}
	
	function soft(node) {
	  node.position = undefined
	}


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	'use strict'
	
	var own = {}.hasOwnProperty
	
	module.exports = stringify
	
	function stringify(value) {
	  /* Nothing. */
	  if (!value || typeof value !== 'object') {
	    return null
	  }
	
	  /* Node. */
	  if (own.call(value, 'position') || own.call(value, 'type')) {
	    return position(value.position)
	  }
	
	  /* Position. */
	  if (own.call(value, 'start') || own.call(value, 'end')) {
	    return position(value)
	  }
	
	  /* Point. */
	  if (own.call(value, 'line') || own.call(value, 'column')) {
	    return point(value)
	  }
	
	  /* ? */
	  return null
	}
	
	function point(point) {
	  if (!point || typeof point !== 'object') {
	    point = {}
	  }
	
	  return index(point.line) + ':' + index(point.column)
	}
	
	function position(pos) {
	  if (!pos || typeof pos !== 'object') {
	    pos = {}
	  }
	
	  return point(pos.start) + '-' + point(pos.end)
	}
	
	function index(value) {
	  return value && typeof value === 'number' ? value : 1
	}


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = visitParents
	
	/* Visit. */
	function visitParents(tree, type, visitor) {
	  var stack = []
	
	  if (typeof type === 'function') {
	    visitor = type
	    type = null
	  }
	
	  one(tree)
	
	  /* Visit a single node. */
	  function one(node) {
	    var result
	
	    if (!type || node.type === type) {
	      result = visitor(node, stack.concat())
	    }
	
	    if (node.children && result !== false) {
	      return all(node.children, node)
	    }
	
	    return result
	  }
	
	  /* Visit children in `parent`. */
	  function all(children, parent) {
	    var length = children.length
	    var index = -1
	    var child
	
	    stack.push(parent)
	
	    while (++index < length) {
	      child = children[index]
	
	      if (child && one(child) === false) {
	        return false
	      }
	    }
	
	    stack.pop()
	
	    return true
	  }
	}


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visitParents
	
	var is = __webpack_require__(136)
	
	var CONTINUE = true
	var SKIP = 'skip'
	var EXIT = false
	
	visitParents.CONTINUE = CONTINUE
	visitParents.SKIP = SKIP
	visitParents.EXIT = EXIT
	
	function visitParents(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  one(tree, null, [])
	
	  // Visit a single node.
	  function one(node, index, parents) {
	    var result
	
	    if (!test || is(test, node, index, parents[parents.length - 1] || null)) {
	      result = visitor(node, parents)
	
	      if (result === EXIT) {
	        return result
	      }
	    }
	
	    if (node.children && result !== SKIP) {
	      return all(node.children, parents.concat(node)) === EXIT ? EXIT : result
	    }
	
	    return result
	  }
	
	  // Visit children in `parent`.
	  function all(children, parents) {
	    var min = -1
	    var step = reverse ? -1 : 1
	    var index = (reverse ? children.length : min) + step
	    var child
	    var result
	
	    while (index > min && index < children.length) {
	      child = children[index]
	      result = child && one(child, index, parents)
	
	      if (result === EXIT) {
	        return result
	      }
	
	      index = typeof result === 'number' ? result : index + step
	    }
	  }
	}


/***/ }),
/* 141 */
/***/ (function(module, exports) {

	'use strict'
	
	/* Expose. */
	module.exports = factory
	
	/* Factory. */
	function factory(file) {
	  var contents = indices(String(file))
	
	  return {
	    toPosition: offsetToPositionFactory(contents),
	    toOffset: positionToOffsetFactory(contents)
	  }
	}
	
	/* Factory to get the line and column-based `position` for
	 * `offset` in the bound indices. */
	function offsetToPositionFactory(indices) {
	  return offsetToPosition
	
	  /* Get the line and column-based `position` for
	   * `offset` in the bound indices. */
	  function offsetToPosition(offset) {
	    var index = -1
	    var length = indices.length
	
	    if (offset < 0) {
	      return {}
	    }
	
	    while (++index < length) {
	      if (indices[index] > offset) {
	        return {
	          line: index + 1,
	          column: offset - (indices[index - 1] || 0) + 1,
	          offset: offset
	        }
	      }
	    }
	
	    return {}
	  }
	}
	
	/* Factory to get the `offset` for a line and column-based
	 * `position` in the bound indices. */
	function positionToOffsetFactory(indices) {
	  return positionToOffset
	
	  /* Get the `offset` for a line and column-based
	   * `position` in the bound indices. */
	  function positionToOffset(position) {
	    var line = position && position.line
	    var column = position && position.column
	
	    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
	      return (indices[line - 2] || 0) + column - 1 || 0
	    }
	
	    return -1
	  }
	}
	
	/* Get indices of line-breaks in `value`. */
	function indices(value) {
	  var result = []
	  var index = value.indexOf('\n')
	
	  while (index !== -1) {
	    result.push(index + 1)
	    index = value.indexOf('\n', index + 1)
	  }
	
	  result.push(value.length + 1)
	
	  return result
	}


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var stringify = __webpack_require__(138)
	
	module.exports = VMessage
	
	/* Inherit from `Error#`. */
	function VMessagePrototype() {}
	VMessagePrototype.prototype = Error.prototype
	VMessage.prototype = new VMessagePrototype()
	
	/* Message properties. */
	var proto = VMessage.prototype
	
	proto.file = ''
	proto.name = ''
	proto.reason = ''
	proto.message = ''
	proto.stack = ''
	proto.fatal = null
	proto.column = null
	proto.line = null
	
	/* Construct a new VMessage.
	 *
	 * Note: We cannot invoke `Error` on the created context,
	 * as that adds readonly `line` and `column` attributes on
	 * Safari 9, thus throwing and failing the data. */
	function VMessage(reason, position, origin) {
	  var parts
	  var range
	  var location
	
	  if (typeof position === 'string') {
	    origin = position
	    position = null
	  }
	
	  parts = parseOrigin(origin)
	  range = stringify(position) || '1:1'
	
	  location = {
	    start: {line: null, column: null},
	    end: {line: null, column: null}
	  }
	
	  /* Node. */
	  if (position && position.position) {
	    position = position.position
	  }
	
	  if (position) {
	    /* Position. */
	    if (position.start) {
	      location = position
	      position = position.start
	    } else {
	      /* Point. */
	      location.start = position
	    }
	  }
	
	  if (reason.stack) {
	    this.stack = reason.stack
	    reason = reason.message
	  }
	
	  this.message = reason
	  this.name = range
	  this.reason = reason
	  this.line = position ? position.line : null
	  this.column = position ? position.column : null
	  this.location = location
	  this.source = parts[0]
	  this.ruleId = parts[1]
	}
	
	function parseOrigin(origin) {
	  var result = [null, null]
	  var index
	
	  if (typeof origin === 'string') {
	    index = origin.indexOf(':')
	
	    if (index === -1) {
	      result[1] = origin
	    } else {
	      result[0] = origin.slice(0, index)
	      result[1] = origin.slice(index + 1)
	    }
	  }
	
	  return result
	}


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var path = __webpack_require__(30);
	var replace = __webpack_require__(145);
	var buffer = __webpack_require__(69);
	
	module.exports = VFile;
	
	var own = {}.hasOwnProperty;
	var proto = VFile.prototype;
	
	proto.toString = toString;
	
	/* Order of setting (least specific to most), we need this because
	 * otherwise `{stem: 'a', path: '~/b.js'}` would throw, as a path
	 * is needed before a stem can be set. */
	var order = [
	  'history',
	  'path',
	  'basename',
	  'stem',
	  'extname',
	  'dirname'
	];
	
	/* Construct a new file. */
	function VFile(options) {
	  var prop;
	  var index;
	  var length;
	
	  if (!options) {
	    options = {};
	  } else if (typeof options === 'string' || buffer(options)) {
	    options = {contents: options};
	  } else if ('message' in options && 'messages' in options) {
	    return options;
	  }
	
	  if (!(this instanceof VFile)) {
	    return new VFile(options);
	  }
	
	  this.data = {};
	  this.messages = [];
	  this.history = [];
	  this.cwd = process.cwd();
	
	  /* Set path related properties in the correct order. */
	  index = -1;
	  length = order.length;
	
	  while (++index < length) {
	    prop = order[index];
	
	    if (own.call(options, prop)) {
	      this[prop] = options[prop];
	    }
	  }
	
	  /* Set non-path related properties. */
	  for (prop in options) {
	    if (order.indexOf(prop) === -1) {
	      this[prop] = options[prop];
	    }
	  }
	}
	
	/* Access full path (`~/index.min.js`). */
	Object.defineProperty(proto, 'path', {
	  get: function () {
	    return this.history[this.history.length - 1];
	  },
	  set: function (path) {
	    assertNonEmpty(path, 'path');
	
	    if (path !== this.path) {
	      this.history.push(path);
	    }
	  }
	});
	
	/* Access parent path (`~`). */
	Object.defineProperty(proto, 'dirname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.dirname(this.path) : undefined;
	  },
	  set: function (dirname) {
	    assertPath(this.path, 'dirname');
	    this.path = path.join(dirname || '', this.basename);
	  }
	});
	
	/* Access basename (`index.min.js`). */
	Object.defineProperty(proto, 'basename', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path) : undefined;
	  },
	  set: function (basename) {
	    assertNonEmpty(basename, 'basename');
	    assertPart(basename, 'basename');
	    this.path = path.join(this.dirname || '', basename);
	  }
	});
	
	/* Access extname (`.js`). */
	Object.defineProperty(proto, 'extname', {
	  get: function () {
	    return typeof this.path === 'string' ? path.extname(this.path) : undefined;
	  },
	  set: function (extname) {
	    var ext = extname || '';
	
	    assertPart(ext, 'extname');
	    assertPath(this.path, 'extname');
	
	    if (ext) {
	      if (ext.charAt(0) !== '.') {
	        throw new Error('`extname` must start with `.`');
	      }
	
	      if (ext.indexOf('.', 1) !== -1) {
	        throw new Error('`extname` cannot contain multiple dots');
	      }
	    }
	
	    this.path = replace(this.path, ext);
	  }
	});
	
	/* Access stem (`index.min`). */
	Object.defineProperty(proto, 'stem', {
	  get: function () {
	    return typeof this.path === 'string' ? path.basename(this.path, this.extname) : undefined;
	  },
	  set: function (stem) {
	    assertNonEmpty(stem, 'stem');
	    assertPart(stem, 'stem');
	    this.path = path.join(this.dirname || '', stem + (this.extname || ''));
	  }
	});
	
	/* Get the value of the file. */
	function toString(encoding) {
	  var value = this.contents || '';
	  return buffer(value) ? value.toString(encoding) : String(value);
	}
	
	/* Assert that `part` is not a path (i.e., does
	 * not contain `path.sep`). */
	function assertPart(part, name) {
	  if (part.indexOf(path.sep) !== -1) {
	    throw new Error('`' + name + '` cannot be a path: did not expect `' + path.sep + '`');
	  }
	}
	
	/* Assert that `part` is not empty. */
	function assertNonEmpty(part, name) {
	  if (!part) {
	    throw new Error('`' + name + '` cannot be empty');
	  }
	}
	
	/* Assert `path` exists. */
	function assertPath(path, name) {
	  if (!path) {
	    throw new Error('Setting `' + name + '` requires `path` to be set too');
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var VMessage = __webpack_require__(142);
	var VFile = __webpack_require__(143);
	
	module.exports = VFile;
	
	var proto = VFile.prototype;
	
	proto.message = message;
	proto.info = info;
	proto.fail = fail;
	
	/* Slight backwards compatibility.  Remove in the future. */
	proto.warn = message;
	
	/* Create a message with `reason` at `position`.
	 * When an error is passed in as `reason`, copies the stack. */
	function message(reason, position, origin) {
	  var filePath = this.path;
	  var message = new VMessage(reason, position, origin);
	
	  if (filePath) {
	    message.name = filePath + ':' + message.name;
	    message.file = filePath;
	  }
	
	  message.fatal = false;
	
	  this.messages.push(message);
	
	  return message;
	}
	
	/* Fail. Creates a vmessage, associates it with the file,
	 * and throws it. */
	function fail() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = true;
	
	  throw message;
	}
	
	/* Info. Creates a vmessage, associates it with the file,
	 * and marks the fatality as null. */
	function info() {
	  var message = this.message.apply(this, arguments);
	
	  message.fatal = null;
	
	  return message;
	}


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var path = __webpack_require__(30);
	
	function replaceExt(npath, ext) {
	  if (typeof npath !== 'string') {
	    return npath;
	  }
	
	  if (npath.length === 0) {
	    return npath;
	  }
	
	  var nFileName = path.basename(npath, path.extname(npath)) + ext;
	  return path.join(path.dirname(npath), nFileName);
	}
	
	module.exports = replaceExt;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	var toString = Object.prototype.toString
	
	module.exports = isString
	
	function isString(obj) {
	    return toString.call(obj) === "[object String]"
	}


/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapGroup = function (_Component) {
	  _inherits(MapGroup, _Component);
	
	  function MapGroup() {
	    _classCallCheck(this, MapGroup);
	
	    return _possibleConstructorReturn(this, (MapGroup.__proto__ || Object.getPrototypeOf(MapGroup)).apply(this, arguments));
	  }
	
	  _createClass(MapGroup, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          projection = _props.projection,
	          style = _props.style,
	          zoom = _props.zoom,
	          width = _props.width,
	          height = _props.height,
	          groupName = _props.groupName,
	          itemName = _props.itemName;
	
	      return _react2.default.createElement(
	        "g",
	        { className: "rsm-" + groupName, style: style },
	        !children ? null : children.length === undefined ? _react2.default.cloneElement(children, {
	          projection: projection,
	          zoom: zoom,
	          width: width,
	          height: height
	        }) : children.map(function (child, i) {
	          return !child ? null : _react2.default.cloneElement(child, {
	            key: child.key || itemName + "-" + i,
	            projection: projection,
	            zoom: zoom,
	            width: width,
	            height: height
	          });
	        })
	      );
	    }
	  }]);
	
	  return MapGroup;
	}(_react.Component);
	
	MapGroup.defaultProps = {
	  componentIdentifier: "Group",
	  groupName: "group",
	  itemName: "group-item"
	};
	
	exports.default = MapGroup;

/***/ }),
/* 164 */,
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  box-shadow: ", ";\n  border-radius: 3px;\n  background-color: ", ";\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  transition: 0.2s 0.05s all ease-in-out;\n  :hover {\n    box-shadow: ", ";\n  }\n  text-align: left;\n"], ["\n  height: 100%;\n  box-shadow: ", ";\n  border-radius: 3px;\n  background-color: ", ";\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  transition: 0.2s 0.05s all ease-in-out;\n  :hover {\n    box-shadow: ", ";\n  }\n  text-align: left;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-family: Lato;\n  font-size: 15px;\n  color: ", ";\n  letter-spacing: 1.41px;\n  margin: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 400;\n"], ["\n  font-family: Lato;\n  font-size: 15px;\n  color: ", ";\n  letter-spacing: 1.41px;\n  margin: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 400;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  object-fit: cover;\n  height: 14rem;\n  width: 100%;\n  border-radius: 3px 3px 0 0;\n"], ["\n  object-fit: cover;\n  height: 14rem;\n  width: 100%;\n  border-radius: 3px 3px 0 0;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-family: Lato;\n  font-size: 14px;\n  color: ", ";\n  letter-spacing: 1.2px;\n  font-weight: 300;\n  margin-bottom: 0.5rem;\n"], ["\n  font-family: Lato;\n  font-size: 14px;\n  color: ", ";\n  letter-spacing: 1.2px;\n  font-weight: 300;\n  margin-bottom: 0.5rem;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  margin: 1rem 2rem 2rem 2rem;\n"], ["\n  margin: 1rem 2rem 2rem 2rem;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n  width: 100%;\n"], ["\n  text-decoration: none;\n  width: 100%;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  margin: 0.5rem 0;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin: 0.5rem 0;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  font-family: Poppins-Light;\n  font-size: 0.75rem;\n  color: ", ";\n  letter-spacing: 1.2px;\n  flex: 1;\n  :not(:first-child) {\n    margin-left: 1rem;\n  }\n"], ["\n  font-family: Poppins-Light;\n  font-size: 0.75rem;\n  color: ", ";\n  letter-spacing: 1.2px;\n  flex: 1;\n  :not(:first-child) {\n    margin-left: 1rem;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _moment = __webpack_require__(52);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _graphcmsImage = __webpack_require__(50);
	
	var _graphcmsImage2 = _interopRequireDefault(_graphcmsImage);
	
	var _Icon = __webpack_require__(26);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Card = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var active = _ref.active;
	  return active ? _baseStyles2.default.layers.l5 : _baseStyles2.default.layers.l3;
	}, _baseStyles2.default.color.white.o100, function (_ref2) {
	  var active = _ref2.active;
	  return active ? _baseStyles2.default.layers.l5 : _baseStyles2.default.layers.l4;
	});
	var EventTitle = _styledComponents2.default.h4(_templateObject2, _baseStyles2.default.color.darkGray);
	
	var Image = (0, _styledComponents2.default)(_graphcmsImage2.default)(_templateObject3);
	
	var Description = _styledComponents2.default.span(_templateObject4, _baseStyles2.default.color.lightGray);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject5);
	
	var Link = _styledComponents2.default.a(_templateObject6);
	
	var LabelContainer = _styledComponents2.default.div(_templateObject7);
	
	var Label = _styledComponents2.default.span(_templateObject8, _baseStyles2.default.color.white2);
	
	var JobCard = function JobCard(props) {
	  var date = (0, _moment2.default)(props.date).format("MMM Do YY, h:mm a");
	  return _react2.default.createElement(
	    Card,
	    null,
	    _react2.default.createElement(
	      Link,
	      { href: props.link, target: "__blank" },
	      _react2.default.createElement(Image, { image: props.image, withWebp: true, "max-width": 600, alt: props.title }),
	      _react2.default.createElement(
	        ContentWrapper,
	        null,
	        _react2.default.createElement(
	          EventTitle,
	          null,
	          props.title
	        ),
	        _react2.default.createElement(
	          LabelContainer,
	          null,
	          _react2.default.createElement(
	            Label,
	            null,
	            date
	          ),
	          _react2.default.createElement(
	            Label,
	            null,
	            props.locationName
	          )
	        ),
	        _react2.default.createElement(
	          Description,
	          null,
	          props.description
	        )
	      )
	    )
	  );
	};
	
	exports.default = JobCard;
	module.exports = exports["default"];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 48%;\n  margin-bottom: 4%;\n  @media screen and (max-width: 48em) {\n    width: 100%;\n    margin-bottom: 2rem;\n  }\n"], ["\n  width: 48%;\n  margin-bottom: 4%;\n  @media screen and (max-width: 48em) {\n    width: 100%;\n    margin-bottom: 2rem;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFlipMove = __webpack_require__(53);
	
	var _reactFlipMove2 = _interopRequireDefault(_reactFlipMove);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _EventCard = __webpack_require__(165);
	
	var _EventCard2 = _interopRequireDefault(_EventCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var EventCardWrapper = _styledComponents2.default.div(_templateObject);
	
	var Container = (0, _styledComponents2.default)(_reactFlipMove2.default)(_templateObject2);
	
	var EventCardList = function (_Component) {
	  _inherits(EventCardList, _Component);
	
	  function EventCardList() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EventCardList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      activeEvent: ""
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  EventCardList.prototype.toggleActive = function toggleActive(eventId) {
	    this.setState(function (prevState) {
	      if (eventId === prevState.activeEvent) {
	        return { activeEvent: "" };
	      }
	      return { activeEvent: eventId };
	    });
	  };
	
	  EventCardList.prototype.isActive = function isActive(eventId) {
	    if (this.state.activeEvent === eventId) {
	      return true;
	    }
	    return false;
	  };
	
	  EventCardList.prototype.events = function events() {
	    var _this2 = this;
	
	    var eventsFromToday = this.props.events.filter(function (_ref) {
	      var node = _ref.node;
	      return new Date(node.date) > new Date();
	    });
	    return eventsFromToday.map(function (_ref2) {
	      var node = _ref2.node;
	      return _react2.default.createElement(
	        EventCardWrapper,
	        { key: node.id },
	        _react2.default.createElement(_EventCard2.default, _extends({
	          toggleActive: function toggleActive() {
	            return _this2.toggleActive(node.id);
	          }
	        }, node, {
	          active: _this2.isActive(node.id)
	        }))
	      );
	    });
	  };
	
	  EventCardList.prototype.render = function render() {
	    return _react2.default.createElement(
	      Container,
	      { duration: 300, easing: "ease-out" },
	      this.events()
	    );
	  };
	
	  return EventCardList;
	}(_react.Component);
	
	exports.default = EventCardList;
	module.exports = exports["default"];

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  box-shadow: ", ";\n  border-radius: 3px;\n  background-color: ", ";\n  padding: 1rem;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  transition: 0.2s 0.05s all ease-in-out;\n  transform: ", ";\n  :not(:last-of-type) {\n    margin-bottom: 1.5rem;\n  }\n  :hover {\n    box-shadow: ", ";\n  }\n"], ["\n  box-shadow: ", ";\n  border-radius: 3px;\n  background-color: ", ";\n  padding: 1rem;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  transition: 0.2s 0.05s all ease-in-out;\n  transform: ", ";\n  :not(:last-of-type) {\n    margin-bottom: 1.5rem;\n  }\n  :hover {\n    box-shadow: ", ";\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  font-family: Lato;\n  font-size: 15px;\n  color: ", ";\n  letter-spacing: 1.41px;\n  margin: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 400;\n"], ["\n  font-family: Lato;\n  font-size: 15px;\n  color: ", ";\n  letter-spacing: 1.41px;\n  margin: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 400;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  height: 4rem;\n  width: 4rem;\n  border-radius: 50%;\n"], ["\n  height: 4rem;\n  width: 4rem;\n  border-radius: 50%;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-family: Lato;\n  font-size: 14px;\n  color: ", ";\n  letter-spacing: 1.2px;\n  font-weight: 300;\n  margin-bottom: 0.25rem;\n"], ["\n  font-family: Lato;\n  font-size: 14px;\n  color: ", ";\n  letter-spacing: 1.2px;\n  font-weight: 300;\n  margin-bottom: 0.25rem;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  margin-right: 1rem;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  margin-right: 1rem;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n  flex-direction: column;\n  text-align: right;\n  @media screen and (max-width: 48em) {\n    text-align: left;\n    align-items: flex-start;\n    margin-top: 2rem;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n  flex-direction: column;\n  text-align: right;\n  @media screen and (max-width: 48em) {\n    text-align: left;\n    align-items: flex-start;\n    margin-top: 2rem;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  align-items: flex-start;\n  text-decoration: none;\n  @media screen and (max-width: 48em) {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  align-items: flex-start;\n  text-decoration: none;\n  @media screen and (max-width: 48em) {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _moment = __webpack_require__(52);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _startup = __webpack_require__(215);
	
	var _startup2 = _interopRequireDefault(_startup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Card = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var active = _ref.active;
	  return active ? _baseStyles2.default.layers.l5 : _baseStyles2.default.layers.l3;
	}, _baseStyles2.default.color.white.o100, function (props) {
	  return props.active ? "scale(1.03)" : "none";
	}, function (_ref2) {
	  var active = _ref2.active;
	  return active ? _baseStyles2.default.layers.l5 : _baseStyles2.default.layers.l4;
	});
	var JobTitle = _styledComponents2.default.h4(_templateObject2, _baseStyles2.default.color.darkGray);
	
	var Logo = _styledComponents2.default.img(_templateObject3);
	
	var Subheading = _styledComponents2.default.span(_templateObject4, _baseStyles2.default.color.lightGray);
	
	var LeftColumn = _styledComponents2.default.div(_templateObject5);
	
	var RightColumn = _styledComponents2.default.div(_templateObject6);
	
	var DefaultContent = _styledComponents2.default.a(_templateObject7);
	
	var JobCard = function JobCard(_ref3) {
	  var postedAt = _ref3.postedAt,
	      company = _ref3.company,
	      link = _ref3.link,
	      country = _ref3.country,
	      title = _ref3.title,
	      location = _ref3.location,
	      role = _ref3.role,
	      positionType = _ref3.positionType;
	
	  var date = (0, _moment2.default)(postedAt).fromNow();
	  return company ? _react2.default.createElement(
	    Card,
	    null,
	    _react2.default.createElement(
	      DefaultContent,
	      { href: link, target: "__blank" },
	      _react2.default.createElement(
	        LeftColumn,
	        null,
	        _react2.default.createElement(Logo, {
	          src: company.logo.url ? company.logo.url : _startup2.default,
	          alt: company.name + " Logo"
	        }),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              display: "flex",
	              flexDirection: "column",
	              alignItems: "flex-start",
	              marginLeft: "2rem"
	            }
	          },
	          _react2.default.createElement(
	            JobTitle,
	            null,
	            title
	          ),
	          _react2.default.createElement(
	            Subheading,
	            null,
	            company.name
	          )
	        )
	      ),
	      _react2.default.createElement(
	        RightColumn,
	        null,
	        _react2.default.createElement(
	          Subheading,
	          null,
	          "posted ",
	          date
	        ),
	        _react2.default.createElement(
	          Subheading,
	          null,
	          country,
	          " / ",
	          location
	        ),
	        _react2.default.createElement(
	          Subheading,
	          null,
	          role,
	          " / ",
	          positionType
	        )
	      )
	    )
	  ) : null;
	};
	
	exports.default = JobCard;
	module.exports = exports["default"];

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin: 1rem 0;\n"], ["\n  margin: 1rem 0;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFlipMove = __webpack_require__(53);
	
	var _reactFlipMove2 = _interopRequireDefault(_reactFlipMove);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _JobCard = __webpack_require__(167);
	
	var _JobCard2 = _interopRequireDefault(_JobCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var JobCardWrapper = _styledComponents2.default.div(_templateObject);
	
	var JobCardList = function (_Component) {
	  _inherits(JobCardList, _Component);
	
	  function JobCardList() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JobCardList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      activeJob: ""
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  JobCardList.prototype.toggleActive = function toggleActive(jobId) {
	    this.setState(function (prevState) {
	      if (jobId === prevState.activeJob) {
	        return { activeJob: "" };
	      }
	      return { activeJob: jobId };
	    });
	  };
	
	  JobCardList.prototype.isActive = function isActive(jobId) {
	    if (this.state.activeJob === jobId) {
	      return true;
	    }
	    return false;
	  };
	
	  JobCardList.prototype.jobs = function jobs() {
	    var _this2 = this;
	
	    return this.props.jobs.map(function (job) {
	      return _react2.default.createElement(
	        JobCardWrapper,
	        { key: job.id },
	        _react2.default.createElement(_JobCard2.default, _extends({
	          toggleActive: function toggleActive() {
	            return _this2.toggleActive(job.id);
	          }
	        }, job, {
	          active: _this2.isActive(job.id)
	        }))
	      );
	    });
	  };
	
	  JobCardList.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactFlipMove2.default,
	      { duration: 300, easing: "ease-out" },
	      this.jobs()
	    );
	  };
	
	  return JobCardList;
	}(_react.Component);
	
	exports.default = JobCardList;
	module.exports = exports["default"];

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ v1.0.9 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var frame = 0, // is an animation frame pending?
	    timeout = 0, // is a timeout pending?
	    interval = 0, // are any timers active?
	    pokeDelay = 1000, // how frequently we check for clock skew
	    taskHead,
	    taskTail,
	    clockLast = 0,
	    clockNow = 0,
	    clockSkew = 0,
	    clock = typeof performance === "object" && performance.now ? performance : Date,
	    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	function timeout$1(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	}
	
	function interval$1(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	}
	
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(160)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(24);
	var sprite = __webpack_require__(25);
	var symbol = new SpriteSymbol({
	  "id": "startup",
	  "use": "startup-usage",
	  "viewBox": "0 0 100 125",
	  "content": "<symbol viewBox=\"0 0 100 125\" id=\"startup\">\n    <path d=\"m92.1 10.3a5.1 5.1 0 0 0 -.9-1.3h-.2l-1-.7c-3.7-2.5-11.7-2.3-20.4.1a63.3 63.3 0 0 0 -27.7 15.8 58.6 58.6 0 0 0 -5.6 6.5h-.8a30.2 30.2 0 0 0 -18.3 4.8l-8.5 5.6a5 5 0 0 0 1.6 9.1l13.1 3a9 9 0 0 0 -2.5 11.1h-1l-1.2.3a20.7 20.7 0 0 0 -4.9 3.6c-6.6 6.7-7.7 17.7-5.2 21.7a4.1 4.1 0 0 0 .6.9h.1l.6.5a11 11 0 0 0 5.9 1.4 23.1 23.1 0 0 0 15.8-6.4 20.6 20.6 0 0 0 3.5-4.7 3 3 0 0 0 .4-1.2v-1.3a9 9 0 0 0 4.1 1h.8a9 9 0 0 0 6.3-3.4l3 13.1a5 5 0 0 0 4 3.8h.9a5 5 0 0 0 4.2-2.3l5.5-8.5a30.2 30.2 0 0 0 4.8-18.3v-.8a58.6 58.6 0 0 0 6.5-5.6c16.4-16.3 20.4-40.7 16.5-47.8zm-71.6 30.3a24.1 24.1 0 0 1 11.9-3.9 66.4 66.4 0 0 0 -5.2 11.2l-13.2-3zm6.9 41.4c-4.6 4.6-11.8 5.1-13.8 4.4s-.2-9.2 4.4-13.8a14.5 14.5 0 0 1 3-2.3l5-.3 4 4-.4 5.2a14.4 14.4 0 0 1 -2.2 2.8zm14.8-9.3a3 3 0 0 1 -4.6.4l-10.8-10.7a3 3 0 0 1 .4-4.6l1.1-.7 14.6 14.6zm17.2 6.7-4.3 6.6-3-13.2a66.4 66.4 0 0 0 11.2-5.1 24.1 24.1 0 0 1 -3.9 11.8zm12.1-25.6a57.6 57.6 0 0 1 -23.9 14.1l-15.5-15.5a57.7 57.7 0 0 1 14.1-23.9c15.7-15.7 37.4-17.3 40.6-15.3 2.4 4.2-.4 25.8-15.3 40.6z\" />\n    <path d=\"m67.4 20.5a8.5 8.5 0 1 0 12.1 0 8.5 8.5 0 0 0 -12.1 0zm7.8 7.8a2.6 2.6 0 0 1 -3.6 0 2.5 2.5 0 1 1 3.6 0z\" />\n    <path d=\"m48.1 35.2a11.8 11.8 0 0 0 16.7 16.7 11.8 11.8 0 1 0 -16.7-16.7zm12.5 12.5a5.8 5.8 0 1 1 1.7-4.1 5.8 5.8 0 0 1 -1.7 4.1z\" />\n</symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  text-align: center;\n  cursor: pointer;\n  padding: 0.5rem 2rem;\n  height: 2.5rem;\n  border-radius: 3px;\n  box-shadow: ", ";\n  transition: 0.2s all ease-in-out;\n  letter-spacing: 1.2px;\n  font-family: Lato;\n  font-size: 15px;\n  font-weight: 500;\n  :hover {\n    box-shadow: ", ";\n  }\n"], ["\n  text-transform: uppercase;\n  text-align: center;\n  cursor: pointer;\n  padding: 0.5rem 2rem;\n  height: 2.5rem;\n  border-radius: 3px;\n  box-shadow: ", ";\n  transition: 0.2s all ease-in-out;\n  letter-spacing: 1.2px;\n  font-family: Lato;\n  font-size: 15px;\n  font-weight: 500;\n  :hover {\n    box-shadow: ", ";\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  background-image: ", ";\n  color: rgba(255, 255, 255, 0.95);\n  border: none;\n"], ["\n  background-image: ", ";\n  color: rgba(255, 255, 255, 0.95);\n  border: none;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Button = _styledComponents2.default.button(_templateObject, _baseStyles2.default.layers.l2, _baseStyles2.default.layers.l3);
	
	var ButtonPrimary = (0, _styledComponents2.default)(Button)(_templateObject2, _baseStyles2.default.color.blueGradient);
	var ButtonComponent = function ButtonComponent(props) {
	  return props.primary ? _react2.default.createElement(
	    ButtonPrimary,
	    props,
	    props.children
	  ) : _react2.default.createElement(
	    Button,
	    props,
	    props.children
	  );
	};
	
	exports.default = ButtonComponent;
	module.exports = exports["default"];

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  scale: 160,
	  xOffset: 0,
	  yOffset: 0,
	  rotation: [0, 0, 0],
	  precision: 0.1
	};

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphcmsImage = __webpack_require__(50);
	
	var _graphcmsImage2 = _interopRequireDefault(_graphcmsImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSlide = function ImageSlide(_ref) {
	  var image = _ref.image,
	      alt = _ref.alt;
	
	  return _react2.default.createElement(_graphcmsImage2.default, {
	    style: {
	      width: "100%",
	      minHeight: "100%",
	      objectFit: "cover",
	      transition: "0.5s all ease-out",
	      zIndex: -1
	    },
	    withWebp: true,
	    image: image,
	    "max-width": 2000,
	    alt: alt
	  });
	};
	
	exports.default = ImageSlide;
	module.exports = exports["default"];

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 75vh;\n  background-size: cover;\n  display: flex;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 90%);\n  ::before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: inline-block;\n    background-image: linear-gradient(\n      to bottom,\n      rgba(255, 255, 255, 1) 10%,\n      rgba(255, 255, 255, 0) 40%,\n      rgba(0, 0, 0, 0) 40%,\n      rgba(0, 0, 0, 0.7) 100%\n    );\n    z-index: 1;\n  }\n"], ["\n  width: 100%;\n  height: 75vh;\n  background-size: cover;\n  display: flex;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 90%);\n  ::before {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: inline-block;\n    background-image: linear-gradient(\n      to bottom,\n      rgba(255, 255, 255, 1) 10%,\n      rgba(255, 255, 255, 0) 40%,\n      rgba(0, 0, 0, 0) 40%,\n      rgba(0, 0, 0, 0.7) 100%\n    );\n    z-index: 1;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n"], ["\n  position: absolute;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ImageSlide = __webpack_require__(277);
	
	var _ImageSlide2 = _interopRequireDefault(_ImageSlide);
	
	var _nukaCarousel = __webpack_require__(478);
	
	var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.section(_templateObject);
	
	var ChildWrapper = _styledComponents2.default.div(_templateObject2);
	
	var Carousel = function (_Component) {
	  _inherits(Carousel, _Component);
	
	  function Carousel() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Carousel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.mapImages = function () {
	      return _this.props.images.map(function (_ref, index) {
	        var image = _ref.image,
	            imageDescription = _ref.imageDescription,
	            id = _ref.id;
	
	        return _react2.default.createElement(_ImageSlide2.default, { key: id, image: image, alt: imageDescription });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Carousel.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        _nukaCarousel2.default,
	        { autoplay: true, wrapAround: true, withoutControls: true, heightMode: "current" },
	        this.mapImages()
	      ),
	      _react2.default.createElement(
	        ChildWrapper,
	        null,
	        children
	      )
	    );
	  };
	
	  return Carousel;
	}(_react.Component);
	
	exports.default = Carousel;
	module.exports = exports["default"];

/***/ }),
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  transition: 0.3s all ease-in;\n  font-family: Lato;\n  font-size: 1.25rem;\n  color: ", ";\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  font-weight: 600;\n  margin: 0 0 0 0.5rem;\n  padding: 0;\n"], ["\n  transition: 0.3s all ease-in;\n  font-family: Lato;\n  font-size: 1.25rem;\n  color: ", ";\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  font-weight: 600;\n  margin: 0 0 0 0.5rem;\n  padding: 0;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  height: 1.5rem;\n"], ["\n  height: 1.5rem;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  overflow-y: auto;\n  font-family: Lato;\n  font-size: 1rem;\n  color: rgba(37, 42, 43, 0.75);\n  text-align: left;\n"], ["\n  overflow-y: auto;\n  font-family: Lato;\n  font-size: 1rem;\n  color: rgba(37, 42, 43, 0.75);\n  text-align: left;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _Button = __webpack_require__(218);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactMarkdown = __webpack_require__(83);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _gatsbyLink = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Title = _styledComponents2.default.div(_templateObject);
	
	var Country = _styledComponents2.default.h2(_templateObject2, _baseStyles2.default.color.gray);
	
	var Flag = _styledComponents2.default.img(_templateObject3);
	
	var Description = (0, _styledComponents2.default)(_reactMarkdown2.default)(_templateObject4);
	
	var InfoCard = function InfoCard(_ref) {
	  var url = _ref.url,
	      name = _ref.name,
	      description = _ref.description;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      Title,
	      null,
	      _react2.default.createElement(Flag, { src: url, alt: name }),
	      _react2.default.createElement(
	        Country,
	        null,
	        name
	      )
	    ),
	    _react2.default.createElement(Description, { source: description }),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        style: { marginTop: "auto" },
	        primary: true,
	        onClick: function onClick() {
	          return (0, _gatsbyLink.navigateTo)("/nordics/" + name.toLowerCase());
	        }
	      },
	      "Learn more"
	    )
	  );
	};
	
	exports.default = InfoCard;
	module.exports = exports["default"];

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 140px;\n"], ["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 140px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  background: #fff;\n  box-shadow: ", ";\n  border-radius: 10px;\n  padding: 2rem;\n  max-width: 30rem;\n  height: 23rem;\n  display: flex;\n  flex-direction: column;\n"], ["\n  background: #fff;\n  box-shadow: ", ";\n  border-radius: 10px;\n  padding: 2rem;\n  max-width: 30rem;\n  height: 23rem;\n  display: flex;\n  flex-direction: column;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  fill: ", ";\n"], ["\n  cursor: pointer;\n  fill: ", ";\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _InfoCard = __webpack_require__(286);
	
	var _InfoCard2 = _interopRequireDefault(_InfoCard);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _Icon = __webpack_require__(26);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _chevronLeft = __webpack_require__(551);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(552);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Card = _styledComponents2.default.div(_templateObject2, _baseStyles2.default.layers.l5);
	
	var Chevron = (0, _styledComponents2.default)(_Icon2.default)(_templateObject3, _baseStyles2.default.color.lightGray);
	
	var InfoCardCarousel = function (_Component) {
	  _inherits(InfoCardCarousel, _Component);
	
	  function InfoCardCarousel() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InfoCardCarousel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderCountries = function (countries) {
	      return countries.map(function (_ref, index) {
	        var id = _ref.id,
	            name = _ref.name,
	            description = _ref.description,
	            url = _ref.icon.url;
	        return _this.props.selectedCountryIndex === index ? _react2.default.createElement(_InfoCard2.default, { key: id, name: name, description: description, url: url }) : null;
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  InfoCardCarousel.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(Chevron, {
	        iconRef: _chevronLeft2.default,
	        size: 3,
	        color: _baseStyles2.default.color.lightGray,
	        onClick: function onClick() {
	          return _this2.props.onCountryChange(_this2.props.selectedCountryIndex - 1);
	        }
	      }),
	      _react2.default.createElement(
	        Card,
	        null,
	        this.renderCountries(this.props.countries)
	      ),
	      _react2.default.createElement(Chevron, {
	        iconRef: _chevronRight2.default,
	        size: 3,
	        color: _baseStyles2.default.color.lightGray,
	        onClick: function onClick() {
	          return _this2.props.onCountryChange(_this2.props.selectedCountryIndex + 1);
	        }
	      })
	    );
	  };
	
	  return InfoCardCarousel;
	}(_react.Component);
	
	exports.default = InfoCardCarousel;
	module.exports = exports["default"];

/***/ }),
/* 288 */,
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  fill: ", ";\n  stroke: transparent;\n  stroke-width: 5;\n  outline: none;\n  transition: 0.3s fill ease;\n  :hover {\n    fill: ", ";\n  }\n  :active {\n    outline: none;\n  }\n"], ["\n  fill: ", ";\n  stroke: transparent;\n  stroke-width: 5;\n  outline: none;\n  transition: 0.3s fill ease;\n  :hover {\n    fill: ", ";\n  }\n  :active {\n    outline: none;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  font-family: Lato;\n  font-size: 12px;\n  fill: ", ";\n  font-weight: 600;\n  -webkit-text-stroke-color: #fff;\n  -webkit-text-stroke-width: 2px;\n"], ["\n  font-family: Lato;\n  font-size: 12px;\n  fill: ", ";\n  font-weight: 600;\n  -webkit-text-stroke-color: #fff;\n  -webkit-text-stroke-width: 2px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nordics = __webpack_require__(475);
	
	var _nordics2 = _interopRequireDefault(_nordics);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactSimpleMaps = __webpack_require__(537);
	
	var _reactMotion = __webpack_require__(502);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var wrapperStyles = {
	  width: "100%",
	  maxWidth: 980,
	  margin: "0 auto"
	};
	
	var cities = [{ name: "Stockholm", coordinates: [18.06324, 59.334591] }, { name: "Gothenburg", coordinates: [11.966667, 57.7] }, { name: "Copenhagen", coordinates: [12.568337, 55.676098] }, { name: "Oslo", coordinates: [10.757933, 59.911491] }, { name: "Helsinki", coordinates: [24.9375, 60.170833] }, { name: "Reykjavík", coordinates: [-21.933333, 64.133333]
	  // More to add, maybe putting that info outside where we already have a list of cities. will make linking them to the routing easier
	}];
	
	var defaultMapCenter = [4, 63];
	var defaultZoom = 3;
	
	// We can easily add a menu with the cities, onClick on a city triggers handleCityClick and goes to the right city
	var defs = _react2.default.createElement(
	  "defs",
	  null,
	  _react2.default.createElement(
	    "linearGradient",
	    { id: "primaryGradient" },
	    _react2.default.createElement("stop", { offset: "0%", stopColor: "#32A7CF" }),
	    _react2.default.createElement("stop", { offset: "100%", stopColor: "#2886A6" })
	  ),
	  _react2.default.createElement(
	    "filter",
	    { id: "boxShadow", x: "0", y: "0" },
	    _react2.default.createElement("feDropShadow", {
	      dx: "0",
	      dy: "3",
	      stdDeviation: "2",
	      floodColor: "#515555",
	      floodOpacity: "0.3"
	    })
	  )
	);
	
	var Country = (0, _styledComponents2.default)(_reactSimpleMaps.Geography)(_templateObject, function (props) {
	  return props.active ? "url(#primaryGradient)" : "#eceff1";
	}, function (props) {
	  return props.active ? "url(#primaryGradient)" : _baseStyles2.default.color.lightGray;
	});
	
	var StyledMarker = (0, _styledComponents2.default)(_reactSimpleMaps.Marker)(_templateObject2);
	
	var MarkerLabel = _styledComponents2.default.text(_templateObject3, _baseStyles2.default.color.lightGray);
	
	var Map = function (_Component) {
	  _inherits(Map, _Component);
	
	  function Map() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Map);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      center: defaultMapCenter,
	      zoom: defaultZoom
	    }, _this.handleCountryClick = function (country) {
	      _this.props.onSelectCountry(country.properties.ADMIN);
	      // this.setState({
	      //   zoom: 3,
	      //   center: country.geometry.coordinates
	      // });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Map.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      "div",
	      { style: wrapperStyles },
	      _react2.default.createElement(
	        _reactMotion.Motion,
	        {
	          defaultStyle: {
	            zoom: defaultZoom,
	            x: defaultMapCenter[0],
	            y: defaultMapCenter[1]
	          },
	          style: {
	            zoom: (0, _reactMotion.spring)(this.state.zoom, { stiffness: 210, damping: 20 }),
	            x: (0, _reactMotion.spring)(this.state.center[0], { stiffness: 210, damping: 20 }),
	            y: (0, _reactMotion.spring)(this.state.center[1], { stiffness: 210, damping: 20 })
	          }
	        },
	        function (_ref) {
	          var zoom = _ref.zoom,
	              x = _ref.x,
	              y = _ref.y;
	          return _react2.default.createElement(
	            _reactSimpleMaps.ComposableMap,
	            {
	              projectionConfig: { scale: 500 },
	              width: 980,
	              height: 551,
	              defs: defs,
	              style: {
	                width: "100%",
	                height: "auto"
	              }
	            },
	            _react2.default.createElement(
	              _reactSimpleMaps.ZoomableGroup,
	              { center: [x, y], zoom: zoom, disablePanning: true },
	              _react2.default.createElement(
	                _reactSimpleMaps.Geographies,
	                { geography: _nordics2.default, disableOptimization: true },
	                function (geographies, projection) {
	                  return geographies.map(function (geography, i) {
	                    var active = geography.properties.ADMIN === _this2.props.selectedCountry;
	                    return geography.id !== "010" && _react2.default.createElement(Country, {
	                      active: active,
	                      onClick: _this2.handleCountryClick,
	                      key: geography.properties.ADMIN + i,
	                      cacheId: geography.properties.ADMIN + active,
	                      geography: geography,
	                      projection: projection
	                    });
	                  });
	                }
	              ),
	              _react2.default.createElement(
	                _reactSimpleMaps.Markers,
	                null,
	                cities.map(function (city, i) {
	                  return _react2.default.createElement(
	                    StyledMarker,
	                    { key: i, marker: city },
	                    _react2.default.createElement("circle", {
	                      cx: 0,
	                      cy: 0,
	                      r: 2,
	                      fill: "none",
	                      stroke: _baseStyles2.default.color.gray,
	                      strokeWidth: 2
	                    }),
	                    _react2.default.createElement(
	                      MarkerLabel,
	                      { x: 7, y: 3.5 },
	                      city.name
	                    )
	                  );
	                })
	              )
	            )
	          );
	        }
	      )
	    );
	  };
	
	  return Map;
	}(_react.Component);
	
	exports.default = Map;
	module.exports = exports["default"];

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.MapSection = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 64rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin: auto;\n  text-align: center;\n  position: relative;\n"], ["\n  max-width: 64rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin: auto;\n  text-align: center;\n  position: relative;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  font-family: Poppins;\n  letter-spacing: 0.1em;\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n"], ["\n  text-transform: uppercase;\n  font-family: Poppins;\n  letter-spacing: 0.1em;\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  text-align: center;\n  margin-bottom: 8rem;\n"], ["\n  color: ", ";\n  text-align: center;\n  margin-bottom: 8rem;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _InfoCardCarousel = __webpack_require__(287);
	
	var _InfoCardCarousel2 = _interopRequireDefault(_InfoCardCarousel);
	
	var _Map = __webpack_require__(289);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.section(_templateObject);
	
	var Title = _styledComponents2.default.h2(_templateObject2);
	
	var TitleDark = Title.extend(_templateObject3, _baseStyles2.default.color.darkGray);
	
	var MapSection = exports.MapSection = function (_Component) {
	  _inherits(MapSection, _Component);
	
	  function MapSection() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MapSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      selectedCountryIndex: 0
	    }, _this.onSelectCountry = function (countryName) {
	      var selectedCountryIndex = _this.props.countries.findIndex(function (country) {
	        return country.name === countryName;
	      });
	
	      if (selectedCountryIndex >= 0) {
	        _this.setState({
	          selectedCountryIndex: selectedCountryIndex
	        });
	      }
	    }, _this.onCountryChange = function (newIndex) {
	      var length = _this.props.countries.length;
	      if (newIndex === length) {
	        _this.setState({
	          selectedCountryIndex: 0
	        });
	      } else if (newIndex < 0) {
	        _this.setState({
	          selectedCountryIndex: length - 1
	        });
	      } else {
	        _this.setState({
	          selectedCountryIndex: newIndex
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MapSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        TitleDark,
	        null,
	        "Nordics"
	      ),
	      _react2.default.createElement(_InfoCardCarousel2.default, {
	        selectedCountryIndex: this.state.selectedCountryIndex,
	        countries: this.props.countries,
	        onCountryChange: this.onCountryChange
	      }),
	      _react2.default.createElement(_Map2.default, {
	        selectedCountry: this.props.countries[this.state.selectedCountryIndex].name,
	        onSelectCountry: this.onSelectCountry
	      })
	    );
	  };
	
	  return MapSection;
	}(_react.Component);
	
	exports.default = MapSection;

/***/ }),
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n"], ["\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  max-width: 64rem;\n  text-align: center;\n  position: relative;\n  background: transparent;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  @media screen and (max-width: 64em) {\n    padding: 0 2rem;\n  }\n  @media screen and (max-width: 20em) {\n    padding: 0 1rem;\n  }\n  @media screen and (max-width: 425px) {\n    align-items: stretch;\n  }\n"], ["\n  max-width: 64rem;\n  text-align: center;\n  position: relative;\n  background: transparent;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  @media screen and (max-width: 64em) {\n    padding: 0 2rem;\n  }\n  @media screen and (max-width: 20em) {\n    padding: 0 1rem;\n  }\n  @media screen and (max-width: 425px) {\n    align-items: stretch;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  font-family: Poppins;\n  letter-spacing: 0.1em;\n  line-height: 1;\n  font-size: 3rem;\n  margin: 0;\n  @media screen and (max-width: 425px) {\n    font-size: 2.25rem;\n  }\n"], ["\n  text-transform: uppercase;\n  font-family: Poppins;\n  letter-spacing: 0.1em;\n  line-height: 1;\n  font-size: 3rem;\n  margin: 0;\n  @media screen and (max-width: 425px) {\n    font-size: 2.25rem;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"], ["\n  color: ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  font-family: Poppins;\n  letter-spacing: 0.1em;\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n"], ["\n  text-transform: uppercase;\n  font-family: Poppins;\n  letter-spacing: 0.1em;\n  font-size: 2.25rem;\n  margin-bottom: 1rem;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  text-align: center;\n"], ["\n  color: ", ";\n  text-align: center;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  font-family: Lato;\n  letter-spacing: 0.1em;\n  font-size: 1rem;\n  text-transform: uppercase;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  font-weight: 400;\n"], ["\n  font-family: Lato;\n  letter-spacing: 0.1em;\n  font-size: 1rem;\n  text-transform: uppercase;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  font-weight: 400;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  max-width: 64rem;\n  width: 100%;\n  margin: auto;\n  margin-top: 6rem;\n  text-align: center;\n  @media screen and (max-width: 64em) {\n    width: calc(100vw - 4rem);\n    margin: auto;\n  }\n  @media screen and (max-width: 20em) {\n    width: calc(100vw - 2rem);\n  }\n"], ["\n  max-width: 64rem;\n  width: 100%;\n  margin: auto;\n  margin-top: 6rem;\n  text-align: center;\n  @media screen and (max-width: 64em) {\n    width: calc(100vw - 4rem);\n    margin: auto;\n  }\n  @media screen and (max-width: 20em) {\n    width: calc(100vw - 2rem);\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _Button = __webpack_require__(218);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _baseStyles = __webpack_require__(7);
	
	var _baseStyles2 = _interopRequireDefault(_baseStyles);
	
	var _JobCardList = __webpack_require__(168);
	
	var _JobCardList2 = _interopRequireDefault(_JobCardList);
	
	var _EventCardList = __webpack_require__(166);
	
	var _EventCardList2 = _interopRequireDefault(_EventCardList);
	
	var _Carousel = __webpack_require__(278);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _MapSection = __webpack_require__(290);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.main(_templateObject);
	
	var HeroContent = _styledComponents2.default.div(_templateObject2);
	
	var Display = _styledComponents2.default.h1(_templateObject3);
	
	var DisplayWhite = (0, _styledComponents2.default)(Display)(_templateObject4, _baseStyles2.default.color.white.o100);
	
	var Title = _styledComponents2.default.h2(_templateObject5);
	
	var TitleDark = Title.extend(_templateObject6, _baseStyles2.default.color.darkGray);
	
	var Subtitle = _styledComponents2.default.h4(_templateObject7);
	
	var SubtitleWhite = (0, _styledComponents2.default)(Subtitle)(_templateObject4, _baseStyles2.default.color.white.o100);
	
	var Section = _styledComponents2.default.section(_templateObject8);
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      _Carousel2.default,
	      { images: data.heroImages.edges.map(function (e) {
	          return e.node;
	        }) },
	      _react2.default.createElement(
	        HeroContent,
	        null,
	        _react2.default.createElement(
	          DisplayWhite,
	          null,
	          "Move To Nordics"
	        ),
	        _react2.default.createElement(
	          SubtitleWhite,
	          null,
	          "Your portal to the best tech ecosystem in the world."
	        )
	      )
	    ),
	    _react2.default.createElement(_MapSection.MapSection, { countries: data.countries.edges.map(function (e) {
	        return e.node;
	      }) }),
	    _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        TitleDark,
	        null,
	        "Tech Jobs"
	      ),
	      _react2.default.createElement(_JobCardList2.default, { jobs: data.jobs.edges.map(function (e) {
	          return e.node;
	        }) }),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          onClick: function onClick() {
	            return (0, _gatsbyLink.navigateTo)("/jobs");
	          },
	          style: { alignSelf: "center", marginTop: "2rem" },
	          primary: true
	        },
	        "See more jobs"
	      )
	    ),
	    _react2.default.createElement(
	      Section,
	      null,
	      _react2.default.createElement(
	        TitleDark,
	        null,
	        "Events in the Nordics"
	      ),
	      _react2.default.createElement(_EventCardList2.default, {
	        events: data.events.edges.filter(function (_ref2) {
	          var node = _ref2.node;
	          return new Date(node.date) > new Date();
	        }).slice(0, 2)
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          onClick: function onClick() {
	            return (0, _gatsbyLink.navigateTo)("/events");
	          },
	          style: { alignSelf: "center", marginTop: "2rem" },
	          primary: true
	        },
	        "See all events"
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = IndexPage;

/***/ }),
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.2.3 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex3 = /^#([0-9a-f]{3})$/,
	    reHex6 = /^#([0-9a-f]{6})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: function() {
	    return this.rgb().hex();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: function() {
	    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.lch = lch;
	exports.gray = gray;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ v1.0.5 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI,
	    halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11,
	    b2 = 6 / 11,
	    b3 = 8 / 11,
	    b4 = 3 / 4,
	    b5 = 9 / 11,
	    b6 = 10 / 11,
	    b7 = 15 / 16,
	    b8 = 21 / 22,
	    b9 = 63 / 64,
	    b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI,
	    amplitude = 1,
	    period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-geo-projection/ Version 1.2.2. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(23), __webpack_require__(243)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-geo', 'd3-array'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3));
	}(this, (function (exports,d3Geo,d3Array) { 'use strict';
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	
	var cos = Math.cos;
	var exp = Math.exp;
	var floor = Math.floor;
	var log = Math.log;
	var max = Math.max;
	var min = Math.min;
	var pow = Math.pow;
	var round = Math.round;
	var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sin = Math.sin;
	var tan = Math.tan;
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var quarterPi = pi / 4;
	var sqrt1_2 = Math.SQRT1_2;
	var sqrt2 = sqrt(2);
	var sqrtPi = sqrt(pi);
	var tau = pi * 2;
	var degrees = 180 / pi;
	var radians = pi / 180;
	
	function sinci(x) {
	  return x ? x / Math.sin(x) : 1;
	}
	
	function asin(x) {
	  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	}
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function sqrt(x) {
	  return x > 0 ? Math.sqrt(x) : 0;
	}
	
	function tanh(x) {
	  x = exp(2 * x);
	  return (x - 1) / (x + 1);
	}
	
	function sinh(x) {
	  return (exp(x) - exp(-x)) / 2;
	}
	
	function cosh(x) {
	  return (exp(x) + exp(-x)) / 2;
	}
	
	function arsinh(x) {
	  return log(x + sqrt(x * x + 1));
	}
	
	function arcosh(x) {
	  return log(x + sqrt(x * x - 1));
	}
	
	function airyRaw(beta) {
	  var tanBeta_2 = tan(beta / 2),
	      b = 2 * log(cos(beta / 2)) / (tanBeta_2 * tanBeta_2);
	
	  function forward(x, y) {
	    var cosx = cos(x),
	        cosy = cos(y),
	        siny = sin(y),
	        cosz = cosy * cosx,
	        k = -((1 - cosz ? log((1 + cosz) / 2) / (1 - cosz) : -0.5) + b / (1 + cosz));
	    return [k * cosy * sin(x), k * siny];
	  }
	
	  forward.invert = function(x, y) {
	    var r = sqrt(x * x + y * y),
	        z = -beta / 2,
	        i = 50, delta;
	    if (!r) return [0, 0];
	    do {
	      var z_2 = z / 2,
	          cosz_2 = cos(z_2),
	          sinz_2 = sin(z_2),
	          tanz_2 = tan(z_2),
	          lnsecz_2 = log(1 / cosz_2);
	      z -= delta = (2 / tanz_2 * lnsecz_2 - b * tanz_2 - r) / (-lnsecz_2 / (sinz_2 * sinz_2) + 1 - b / (2 * cosz_2 * cosz_2));
	    } while (abs(delta) > epsilon && --i > 0);
	    var sinz = sin(z);
	    return [atan2(x * sinz, r * cos(z)), asin(y * sinz / r)];
	  };
	
	  return forward;
	}
	
	var airy = function() {
	  var beta = halfPi,
	      m = d3Geo.geoProjectionMutator(airyRaw),
	      p = m(beta);
	
	  p.radius = function(_) {
	    return arguments.length ? m(beta = _ * radians) : beta * degrees;
	  };
	
	  return p
	      .scale(179.976)
	      .clipAngle(147);
	};
	
	function aitoffRaw(x, y) {
	  var cosy = cos(y), sincia = sinci(acos(cosy * cos(x /= 2)));
	  return [2 * cosy * sin(x) * sincia, sin(y) * sincia];
	}
	
	// Abort if [x, y] is not within an ellipse centered at [0, 0] with
	// semi-major axis pi and semi-minor axis pi/2.
	aitoffRaw.invert = function(x, y) {
	  if (x * x + 4 * y * y > pi * pi + epsilon) return;
	  var x1 = x, y1 = y, i = 25;
	  do {
	    var sinx = sin(x1),
	        sinx_2 = sin(x1 / 2),
	        cosx_2 = cos(x1 / 2),
	        siny = sin(y1),
	        cosy = cos(y1),
	        sin_2y = sin(2 * y1),
	        sin2y = siny * siny,
	        cos2y = cosy * cosy,
	        sin2x_2 = sinx_2 * sinx_2,
	        c = 1 - cos2y * cosx_2 * cosx_2,
	        e = c ? acos(cosy * cosx_2) * sqrt(f = 1 / c) : f = 0,
	        f,
	        fx = 2 * e * cosy * sinx_2 - x,
	        fy = e * siny - y,
	        dxdx = f * (cos2y * sin2x_2 + e * cosy * cosx_2 * sin2y),
	        dxdy = f * (0.5 * sinx * sin_2y - e * 2 * siny * sinx_2),
	        dydx = f * 0.25 * (sin_2y * sinx_2 - e * siny * cos2y * sinx),
	        dydy = f * (sin2y * cosx_2 + e * sin2x_2 * cosy),
	        z = dxdy * dydx - dydy * dxdx;
	    if (!z) break;
	    var dx = (fy * dxdy - fx * dydy) / z,
	        dy = (fx * dydx - fy * dxdx) / z;
	    x1 -= dx, y1 -= dy;
	  } while ((abs(dx) > epsilon || abs(dy) > epsilon) && --i > 0);
	  return [x1, y1];
	};
	
	var aitoff = function() {
	  return d3Geo.geoProjection(aitoffRaw)
	      .scale(152.63);
	};
	
	function armadilloRaw(phi0) {
	  var sinPhi0 = sin(phi0),
	      cosPhi0 = cos(phi0),
	      sPhi0 = phi0 >= 0 ? 1 : -1,
	      tanPhi0 = tan(sPhi0 * phi0),
	      k = (1 + sinPhi0 - cosPhi0) / 2;
	
	  function forward(lambda, phi) {
	    var cosPhi = cos(phi),
	        cosLambda = cos(lambda /= 2);
	    return [
	      (1 + cosPhi) * sin(lambda),
	      (sPhi0 * phi > -atan2(cosLambda, tanPhi0) - 1e-3 ? 0 : -sPhi0 * 10) + k + sin(phi) * cosPhi0 - (1 + cosPhi) * sinPhi0 * cosLambda // TODO D3 core should allow null or [NaN, NaN] to be returned.
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var lambda = 0,
	        phi = 0,
	        i = 50;
	    do {
	      var cosLambda = cos(lambda),
	          sinLambda = sin(lambda),
	          cosPhi = cos(phi),
	          sinPhi = sin(phi),
	          A = 1 + cosPhi,
	          fx = A * sinLambda - x,
	          fy = k + sinPhi * cosPhi0 - A * sinPhi0 * cosLambda - y,
	          dxdLambda = A * cosLambda / 2,
	          dxdPhi = -sinLambda * sinPhi,
	          dydLambda = sinPhi0 * A * sinLambda / 2,
	          dydPhi = cosPhi0 * cosPhi + sinPhi0 * cosLambda * sinPhi,
	          denominator = dxdPhi * dydLambda - dydPhi * dxdLambda,
	          dLambda = (fy * dxdPhi - fx * dydPhi) / denominator / 2,
	          dPhi = (fx * dydLambda - fy * dxdLambda) / denominator;
	      lambda -= dLambda, phi -= dPhi;
	    } while ((abs(dLambda) > epsilon || abs(dPhi) > epsilon) && --i > 0);
	    return sPhi0 * phi > -atan2(cos(lambda), tanPhi0) - 1e-3 ? [lambda * 2, phi] : null;
	  };
	
	  return forward;
	}
	
	var armadillo = function() {
	  var phi0 = 20 * radians,
	      sPhi0 = phi0 >= 0 ? 1 : -1,
	      tanPhi0 = tan(sPhi0 * phi0),
	      m = d3Geo.geoProjectionMutator(armadilloRaw),
	      p = m(phi0),
	      stream_ = p.stream;
	
	  p.parallel = function(_) {
	    if (!arguments.length) return phi0 * degrees;
	    tanPhi0 = tan((sPhi0 = (phi0 = _ * radians) >= 0 ? 1 : -1) * phi0);
	    return m(phi0);
	  };
	
	  p.stream = function(stream) {
	    var rotate = p.rotate(),
	        rotateStream = stream_(stream),
	        sphereStream = (p.rotate([0, 0]), stream_(stream));
	    p.rotate(rotate);
	    rotateStream.sphere = function() {
	      sphereStream.polygonStart(), sphereStream.lineStart();
	      for (var lambda = sPhi0 * -180; sPhi0 * lambda < 180; lambda += sPhi0 * 90) sphereStream.point(lambda, sPhi0 * 90);
	      while (sPhi0 * (lambda -= phi0) >= -180) { // TODO precision?
	        sphereStream.point(lambda, sPhi0 * -atan2(cos(lambda * radians / 2), tanPhi0) * degrees);
	      }
	      sphereStream.lineEnd(), sphereStream.polygonEnd();
	    };
	    return rotateStream;
	  };
	
	  return p
	      .scale(218.695)
	      .center([0, 28.0974]);
	};
	
	function augustRaw(lambda, phi) {
	  var tanPhi = tan(phi / 2),
	      k = sqrt(1 - tanPhi * tanPhi),
	      c = 1 + k * cos(lambda /= 2),
	      x = sin(lambda) * k / c,
	      y = tanPhi / c,
	      x2 = x * x,
	      y2 = y * y;
	  return [
	    4 / 3 * x * (3 + x2 - 3 * y2),
	    4 / 3 * y * (3 + 3 * x2 - y2)
	  ];
	}
	
	augustRaw.invert = function(x, y) {
	  x *= 3 / 8, y *= 3 / 8;
	  if (!x && abs(y) > 1) return null;
	  var x2 = x * x,
	      y2 = y * y,
	      s = 1 + x2 + y2,
	      sin3Eta = sqrt((s - sqrt(s * s - 4 * y * y)) / 2),
	      eta = asin(sin3Eta) / 3,
	      xi = sin3Eta ? arcosh(abs(y / sin3Eta)) / 3 : arsinh(abs(x)) / 3,
	      cosEta = cos(eta),
	      coshXi = cosh(xi),
	      d = coshXi * coshXi - cosEta * cosEta;
	  return [
	    sign(x) * 2 * atan2(sinh(xi) * cosEta, 0.25 - d),
	    sign(y) * 2 * atan2(coshXi * sin(eta), 0.25 + d)
	  ];
	};
	
	var august = function() {
	  return d3Geo.geoProjection(augustRaw)
	      .scale(66.1603);
	};
	
	var sqrt8 = sqrt(8);
	var phi0 = log(1 + sqrt2);
	
	function bakerRaw(lambda, phi) {
	  var phi0 = abs(phi);
	  return phi0 < quarterPi
	      ? [lambda, log(tan(quarterPi + phi / 2))]
	      : [lambda * cos(phi0) * (2 * sqrt2 - 1 / sin(phi0)), sign(phi) * (2 * sqrt2 * (phi0 - quarterPi) - log(tan(phi0 / 2)))];
	}
	
	bakerRaw.invert = function(x, y) {
	  if ((y0 = abs(y)) < phi0) return [x, 2 * atan(exp(y)) - halfPi];
	  var phi = quarterPi, i = 25, delta, y0;
	  do {
	    var cosPhi_2 = cos(phi / 2), tanPhi_2 = tan(phi / 2);
	    phi -= delta = (sqrt8 * (phi - quarterPi) - log(tanPhi_2) - y0) / (sqrt8 - cosPhi_2 * cosPhi_2 / (2 * tanPhi_2));
	  } while (abs(delta) > epsilon2 && --i > 0);
	  return [x / (cos(phi) * (sqrt8 - 1 / sin(phi))), sign(y) * phi];
	};
	
	var baker = function() {
	  return d3Geo.geoProjection(bakerRaw)
	      .scale(112.314);
	};
	
	function berghausRaw(lobes) {
	  var k = 2 * pi / lobes;
	
	  function forward(lambda, phi) {
	    var p = d3Geo.geoAzimuthalEquidistantRaw(lambda, phi);
	    if (abs(lambda) > halfPi) { // back hemisphere
	      var theta = atan2(p[1], p[0]),
	          r = sqrt(p[0] * p[0] + p[1] * p[1]),
	          theta0 = k * round((theta - halfPi) / k) + halfPi,
	          α = atan2(sin(theta -= theta0), 2 - cos(theta)); // angle relative to lobe end
	      theta = theta0 + asin(pi / r * sin(α)) - α;
	      p[0] = r * cos(theta);
	      p[1] = r * sin(theta);
	    }
	    return p;
	  }
	
	  forward.invert = function(x, y) {
	    var r = sqrt(x * x + y * y);
	    if (r > halfPi) {
	      var theta = atan2(y, x),
	          theta0 = k * round((theta - halfPi) / k) + halfPi,
	          s = theta > theta0 ? -1 : 1,
	          A = r * cos(theta0 - theta),
	          cotα = 1 / tan(s * acos((A - pi) / sqrt(pi * (pi - 2 * A) + r * r)));
	      theta = theta0 + 2 * atan((cotα + s * sqrt(cotα * cotα - 3)) / 3);
	      x = r * cos(theta), y = r * sin(theta);
	    }
	    return d3Geo.geoAzimuthalEquidistantRaw.invert(x, y);
	  };
	
	  return forward;
	}
	
	var berghaus = function() {
	  var lobes = 5,
	      m = d3Geo.geoProjectionMutator(berghausRaw),
	      p = m(lobes),
	      projectionStream = p.stream,
	      epsilon$$1 = 1e-2,
	      cr = -cos(epsilon$$1 * radians),
	      sr = sin(epsilon$$1 * radians);
	
	  p.lobes = function(_) {
	    return arguments.length ? m(lobes = +_) : lobes;
	  };
	
	  p.stream = function(stream) {
	    var rotate = p.rotate(),
	        rotateStream = projectionStream(stream),
	        sphereStream = (p.rotate([0, 0]), projectionStream(stream));
	    p.rotate(rotate);
	    rotateStream.sphere = function() {
	      sphereStream.polygonStart(), sphereStream.lineStart();
	      for (var i = 0, delta = 360 / lobes, delta0 = 2 * pi / lobes, phi = 90 - 180 / lobes, phi0 = halfPi; i < lobes; ++i, phi -= delta, phi0 -= delta0) {
	        sphereStream.point(atan2(sr * cos(phi0), cr) * degrees, asin(sr * sin(phi0)) * degrees);
	        if (phi < -90) {
	          sphereStream.point(-90, -180 - phi - epsilon$$1);
	          sphereStream.point(-90, -180 - phi + epsilon$$1);
	        } else {
	          sphereStream.point(90, phi + epsilon$$1);
	          sphereStream.point(90, phi - epsilon$$1);
	        }
	      }
	      sphereStream.lineEnd(), sphereStream.polygonEnd();
	    };
	    return rotateStream;
	  };
	
	  return p
	      .scale(87.8076)
	      .center([0, 17.1875])
	      .clipAngle(180 - 1e-3);
	};
	
	function mollweideBromleyTheta(cp, phi) {
	  var cpsinPhi = cp * sin(phi), i = 30, delta;
	  do phi -= delta = (phi + sin(phi) - cpsinPhi) / (1 + cos(phi));
	  while (abs(delta) > epsilon && --i > 0);
	  return phi / 2;
	}
	
	function mollweideBromleyRaw(cx, cy, cp) {
	
	  function forward(lambda, phi) {
	    return [cx * lambda * cos(phi = mollweideBromleyTheta(cp, phi)), cy * sin(phi)];
	  }
	
	  forward.invert = function(x, y) {
	    return y = asin(y / cy), [x / (cx * cos(y)), asin((2 * y + sin(2 * y)) / cp)];
	  };
	
	  return forward;
	}
	
	var mollweideRaw = mollweideBromleyRaw(sqrt2 / halfPi, sqrt2, pi);
	
	var mollweide = function() {
	  return d3Geo.geoProjection(mollweideRaw)
	      .scale(169.529);
	};
	
	var k = 2.00276;
	var w = 1.11072;
	
	function boggsRaw(lambda, phi) {
	  var theta = mollweideBromleyTheta(pi, phi);
	  return [k * lambda / (1 / cos(phi) + w / cos(theta)), (phi + sqrt2 * sin(theta)) / k];
	}
	
	boggsRaw.invert = function(x, y) {
	  var ky = k * y, theta = y < 0 ? -quarterPi : quarterPi, i = 25, delta, phi;
	  do {
	    phi = ky - sqrt2 * sin(theta);
	    theta -= delta = (sin(2 * theta) + 2 * theta - pi * sin(phi)) / (2 * cos(2 * theta) + 2 + pi * cos(phi) * sqrt2 * cos(theta));
	  } while (abs(delta) > epsilon && --i > 0);
	  phi = ky - sqrt2 * sin(theta);
	  return [x * (1 / cos(phi) + w / cos(theta)) / k, phi];
	};
	
	var boggs = function() {
	  return d3Geo.geoProjection(boggsRaw)
	      .scale(160.857);
	};
	
	var parallel1 = function(projectAt) {
	  var phi0 = 0,
	      m = d3Geo.geoProjectionMutator(projectAt),
	      p = m(phi0);
	
	  p.parallel = function(_) {
	    return arguments.length ? m(phi0 = _ * radians) : phi0 * degrees;
	  };
	
	  return p;
	};
	
	function sinusoidalRaw(lambda, phi) {
	  return [lambda * cos(phi), phi];
	}
	
	sinusoidalRaw.invert = function(x, y) {
	  return [x / cos(y), y];
	};
	
	var sinusoidal = function() {
	  return d3Geo.geoProjection(sinusoidalRaw)
	      .scale(152.63);
	};
	
	function bonneRaw(phi0) {
	  if (!phi0) return sinusoidalRaw;
	  var cotPhi0 = 1 / tan(phi0);
	
	  function forward(lambda, phi) {
	    var rho = cotPhi0 + phi0 - phi,
	        e = rho ? lambda * cos(phi) / rho : rho;
	    return [rho * sin(e), cotPhi0 - rho * cos(e)];
	  }
	
	  forward.invert = function(x, y) {
	    var rho = sqrt(x * x + (y = cotPhi0 - y) * y),
	        phi = cotPhi0 + phi0 - rho;
	    return [rho / cos(phi) * atan2(x, y), phi];
	  };
	
	  return forward;
	}
	
	var bonne = function() {
	  return parallel1(bonneRaw)
	      .scale(123.082)
	      .center([0, 26.1441])
	      .parallel(45);
	};
	
	function bottomleyRaw(sinPsi) {
	
	  function forward(lambda, phi) {
	    var rho = halfPi - phi,
	        eta = rho ? lambda * sinPsi * sin(rho) / rho : rho;
	    return [rho * sin(eta) / sinPsi, halfPi - rho * cos(eta)];
	  }
	
	  forward.invert = function(x, y) {
	    var x1 = x * sinPsi,
	        y1 = halfPi - y,
	        rho = sqrt(x1 * x1 + y1 * y1),
	        eta = atan2(x1, y1);
	    return [(rho ? rho / sin(rho) : 1) * eta / sinPsi, halfPi - rho];
	  };
	
	  return forward;
	}
	
	var bottomley = function() {
	  var sinPsi = 0.5,
	      m = d3Geo.geoProjectionMutator(bottomleyRaw),
	      p = m(sinPsi);
	
	  p.fraction = function(_) {
	    return arguments.length ? m(sinPsi = +_) : sinPsi;
	  };
	
	  return p
	      .scale(158.837);
	};
	
	var bromleyRaw = mollweideBromleyRaw(1, 4 / pi, pi);
	
	var bromley = function() {
	  return d3Geo.geoProjection(bromleyRaw)
	      .scale(152.63);
	};
	
	// Azimuthal distance.
	function distance(dPhi, c1, s1, c2, s2, dLambda) {
	  var cosdLambda = cos(dLambda), r;
	  if (abs(dPhi) > 1 || abs(dLambda) > 1) {
	    r = acos(s1 * s2 + c1 * c2 * cosdLambda);
	  } else {
	    var sindPhi = sin(dPhi / 2), sindLambda = sin(dLambda / 2);
	    r = 2 * asin(sqrt(sindPhi * sindPhi + c1 * c2 * sindLambda * sindLambda));
	  }
	  return abs(r) > epsilon ? [r, atan2(c2 * sin(dLambda), c1 * s2 - s1 * c2 * cosdLambda)] : [0, 0];
	}
	
	// Angle opposite a, and contained between sides of lengths b and c.
	function angle(b, c, a) {
	  return acos((b * b + c * c - a * a) / (2 * b * c));
	}
	
	// Normalize longitude.
	function longitude(lambda) {
	  return lambda - 2 * pi * floor((lambda + pi) / (2 * pi));
	}
	
	function chamberlinRaw(p0, p1, p2) {
	  var points = [
	    [p0[0], p0[1], sin(p0[1]), cos(p0[1])],
	    [p1[0], p1[1], sin(p1[1]), cos(p1[1])],
	    [p2[0], p2[1], sin(p2[1]), cos(p2[1])]
	  ];
	
	  for (var a = points[2], b, i = 0; i < 3; ++i, a = b) {
	    b = points[i];
	    a.v = distance(b[1] - a[1], a[3], a[2], b[3], b[2], b[0] - a[0]);
	    a.point = [0, 0];
	  }
	
	  var beta0 = angle(points[0].v[0], points[2].v[0], points[1].v[0]),
	      beta1 = angle(points[0].v[0], points[1].v[0], points[2].v[0]),
	      beta2 = pi - beta0;
	
	  points[2].point[1] = 0;
	  points[0].point[0] = -(points[1].point[0] = points[0].v[0] / 2);
	
	  var mean = [
	    points[2].point[0] = points[0].point[0] + points[2].v[0] * cos(beta0),
	    2 * (points[0].point[1] = points[1].point[1] = points[2].v[0] * sin(beta0))
	  ];
	
	  function forward(lambda, phi) {
	    var sinPhi = sin(phi),
	        cosPhi = cos(phi),
	        v = new Array(3), i;
	
	    // Compute distance and azimuth from control points.
	    for (i = 0; i < 3; ++i) {
	      var p = points[i];
	      v[i] = distance(phi - p[1], p[3], p[2], cosPhi, sinPhi, lambda - p[0]);
	      if (!v[i][0]) return p.point;
	      v[i][1] = longitude(v[i][1] - p.v[1]);
	    }
	
	    // Arithmetic mean of interception points.
	    var point = mean.slice();
	    for (i = 0; i < 3; ++i) {
	      var j = i == 2 ? 0 : i + 1;
	      var a = angle(points[i].v[0], v[i][0], v[j][0]);
	      if (v[i][1] < 0) a = -a;
	
	      if (!i) {
	        point[0] += v[i][0] * cos(a);
	        point[1] -= v[i][0] * sin(a);
	      } else if (i == 1) {
	        a = beta1 - a;
	        point[0] -= v[i][0] * cos(a);
	        point[1] -= v[i][0] * sin(a);
	      } else {
	        a = beta2 - a;
	        point[0] += v[i][0] * cos(a);
	        point[1] += v[i][0] * sin(a);
	      }
	    }
	
	    point[0] /= 3, point[1] /= 3;
	    return point;
	  }
	
	  return forward;
	}
	
	function pointRadians(p) {
	  return p[0] *= radians, p[1] *= radians, p;
	}
	
	function chamberlinAfrica() {
	  return chamberlin([0, 22], [45, 22], [22.5, -22])
	      .scale(380)
	      .center([22.5, 2]);
	}
	
	function chamberlin(p0, p1, p2) { // TODO order matters!
	  var c = d3Geo.geoCentroid({type: "MultiPoint", coordinates: [p0, p1, p2]}),
	      R = [-c[0], -c[1]],
	      r = d3Geo.geoRotation(R),
	      p = d3Geo.geoProjection(chamberlinRaw(pointRadians(r(p0)), pointRadians(r(p1)), pointRadians(r(p2)))).rotate(R),
	      center = p.center;
	
	  delete p.rotate;
	
	  p.center = function(_) {
	    return arguments.length ? center(r(_)) : r.invert(center());
	  };
	
	  return p
	      .clipAngle(90);
	}
	
	function collignonRaw(lambda, phi) {
	  var alpha = sqrt(1 - sin(phi));
	  return [(2 / sqrtPi) * lambda * alpha, sqrtPi * (1 - alpha)];
	}
	
	collignonRaw.invert = function(x, y) {
	  var lambda = (lambda = y / sqrtPi - 1) * lambda;
	  return [lambda > 0 ? x * sqrt(pi / lambda) / 2 : 0, asin(1 - lambda)];
	};
	
	var collignon = function() {
	  return d3Geo.geoProjection(collignonRaw)
	      .scale(95.6464)
	      .center([0, 30]);
	};
	
	function craigRaw(phi0) {
	  var tanPhi0 = tan(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda, (lambda ? lambda / sin(lambda) : 1) * (sin(phi) * cos(lambda) - tanPhi0 * cos(phi))];
	  }
	
	  forward.invert = tanPhi0 ? function(x, y) {
	    if (x) y *= sin(x) / x;
	    var cosλ = cos(x);
	    return [x, 2 * atan2(sqrt(cosλ * cosλ + tanPhi0 * tanPhi0 - y * y) - cosλ, tanPhi0 - y)];
	  } : function(x, y) {
	    return [x, asin(x ? y * tan(x) / x : y)];
	  };
	
	  return forward;
	}
	
	var craig = function() {
	  return parallel1(craigRaw)
	      .scale(249.828)
	      .clipAngle(90);
	};
	
	var sqrt3 = sqrt(3);
	
	function crasterRaw(lambda, phi) {
	  return [sqrt3 * lambda * (2 * cos(2 * phi / 3) - 1) / sqrtPi, sqrt3 * sqrtPi * sin(phi / 3)];
	}
	
	crasterRaw.invert = function(x, y) {
	  var phi = 3 * asin(y / (sqrt3 * sqrtPi));
	  return [sqrtPi * x / (sqrt3 * (2 * cos(2 * phi / 3) - 1)), phi];
	};
	
	var craster = function() {
	  return d3Geo.geoProjection(crasterRaw)
	      .scale(156.19);
	};
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	var cylindricalEqualArea = function() {
	  return parallel1(cylindricalEqualAreaRaw)
	      .parallel(38.58) // acos(sqrt(width / height / pi)) * radians
	      .scale(195.044); // width / (sqrt(width / height / pi) * 2 * pi)
	};
	
	function cylindricalStereographicRaw(phi0) {
	  var cosPhi0 = cos(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, (1 + cosPhi0) * tan(phi / 2)];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, atan(y / (1 + cosPhi0)) * 2];
	  };
	
	  return forward;
	}
	
	var cylindricalStereographic = function() {
	  return parallel1(cylindricalStereographicRaw)
	      .scale(124.75);
	};
	
	function eckert1Raw(lambda, phi) {
	  var alpha = sqrt(8 / (3 * pi));
	  return [
	    alpha * lambda * (1 - abs(phi) / pi),
	    alpha * phi
	  ];
	}
	
	eckert1Raw.invert = function(x, y) {
	  var alpha = sqrt(8 / (3 * pi)),
	      phi = y / alpha;
	  return [
	    x / (alpha * (1 - abs(phi) / pi)),
	    phi
	  ];
	};
	
	var eckert1 = function() {
	  return d3Geo.geoProjection(eckert1Raw)
	      .scale(165.664);
	};
	
	function eckert2Raw(lambda, phi) {
	  var alpha = sqrt(4 - 3 * sin(abs(phi)));
	  return [
	    2 / sqrt(6 * pi) * lambda * alpha,
	    sign(phi) * sqrt(2 * pi / 3) * (2 - alpha)
	  ];
	}
	
	eckert2Raw.invert = function(x, y) {
	  var alpha = 2 - abs(y) / sqrt(2 * pi / 3);
	  return [
	    x * sqrt(6 * pi) / (2 * alpha),
	    sign(y) * asin((4 - alpha * alpha) / 3)
	  ];
	};
	
	var eckert2 = function() {
	  return d3Geo.geoProjection(eckert2Raw)
	      .scale(165.664);
	};
	
	function eckert3Raw(lambda, phi) {
	  var k = sqrt(pi * (4 + pi));
	  return [
	    2 / k * lambda * (1 + sqrt(1 - 4 * phi * phi / (pi * pi))),
	    4 / k * phi
	  ];
	}
	
	eckert3Raw.invert = function(x, y) {
	  var k = sqrt(pi * (4 + pi)) / 2;
	  return [
	    x * k / (1 + sqrt(1 - y * y * (4 + pi) / (4 * pi))),
	    y * k / 2
	  ];
	};
	
	var eckert3 = function() {
	  return d3Geo.geoProjection(eckert3Raw)
	      .scale(180.739);
	};
	
	function eckert4Raw(lambda, phi) {
	  var k = (2 + halfPi) * sin(phi);
	  phi /= 2;
	  for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; i++) {
	    var cosPhi = cos(phi);
	    phi -= delta = (phi + sin(phi) * (cosPhi + 2) - k) / (2 * cosPhi * (1 + cosPhi));
	  }
	  return [
	    2 / sqrt(pi * (4 + pi)) * lambda * (1 + cos(phi)),
	    2 * sqrt(pi / (4 + pi)) * sin(phi)
	  ];
	}
	
	eckert4Raw.invert = function(x, y) {
	  var A = y * sqrt((4 + pi) / pi) / 2,
	      k = asin(A),
	      c = cos(k);
	  return [
	    x / (2 / sqrt(pi * (4 + pi)) * (1 + c)),
	    asin((k + A * (c + 2)) / (2 + halfPi))
	  ];
	};
	
	var eckert4 = function() {
	  return d3Geo.geoProjection(eckert4Raw)
	      .scale(180.739);
	};
	
	function eckert5Raw(lambda, phi) {
	  return [
	    lambda * (1 + cos(phi)) / sqrt(2 + pi),
	    2 * phi / sqrt(2 + pi)
	  ];
	}
	
	eckert5Raw.invert = function(x, y) {
	  var k = sqrt(2 + pi),
	      phi = y * k / 2;
	  return [
	    k * x / (1 + cos(phi)),
	    phi
	  ];
	};
	
	var eckert5 = function() {
	  return d3Geo.geoProjection(eckert5Raw)
	      .scale(173.044);
	};
	
	function eckert6Raw(lambda, phi) {
	  var k = (1 + halfPi) * sin(phi);
	  for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; i++) {
	    phi -= delta = (phi + sin(phi) - k) / (1 + cos(phi));
	  }
	  k = sqrt(2 + pi);
	  return [
	    lambda * (1 + cos(phi)) / k,
	    2 * phi / k
	  ];
	}
	
	eckert6Raw.invert = function(x, y) {
	  var j = 1 + halfPi,
	      k = sqrt(j / 2);
	  return [
	    x * 2 * k / (1 + cos(y *= k)),
	    asin((y + sin(y)) / j)
	  ];
	};
	
	var eckert6 = function() {
	  return d3Geo.geoProjection(eckert6Raw)
	      .scale(173.044);
	};
	
	var eisenlohrK = 3 + 2 * sqrt2;
	
	function eisenlohrRaw(lambda, phi) {
	  var s0 = sin(lambda /= 2),
	      c0 = cos(lambda),
	      k = sqrt(cos(phi)),
	      c1 = cos(phi /= 2),
	      t = sin(phi) / (c1 + sqrt2 * c0 * k),
	      c = sqrt(2 / (1 + t * t)),
	      v = sqrt((sqrt2 * c1 + (c0 + s0) * k) / (sqrt2 * c1 + (c0 - s0) * k));
	  return [
	    eisenlohrK * (c * (v - 1 / v) - 2 * log(v)),
	    eisenlohrK * (c * t * (v + 1 / v) - 2 * atan(t))
	  ];
	}
	
	eisenlohrRaw.invert = function(x, y) {
	  if (!(p = augustRaw.invert(x / 1.2, y * 1.065))) return null;
	  var lambda = p[0], phi = p[1], i = 20, p;
	  x /= eisenlohrK, y /= eisenlohrK;
	  do {
	    var _0 = lambda / 2,
	        _1 = phi / 2,
	        s0 = sin(_0),
	        c0 = cos(_0),
	        s1 = sin(_1),
	        c1 = cos(_1),
	        cos1 = cos(phi),
	        k = sqrt(cos1),
	        t = s1 / (c1 + sqrt2 * c0 * k),
	        t2 = t * t,
	        c = sqrt(2 / (1 + t2)),
	        v0 = (sqrt2 * c1 + (c0 + s0) * k),
	        v1 = (sqrt2 * c1 + (c0 - s0) * k),
	        v2 = v0 / v1,
	        v = sqrt(v2),
	        vm1v = v - 1 / v,
	        vp1v = v + 1 / v,
	        fx = c * vm1v - 2 * log(v) - x,
	        fy = c * t * vp1v - 2 * atan(t) - y,
	        deltatDeltaLambda = s1 && sqrt1_2 * k * s0 * t2 / s1,
	        deltatDeltaPhi = (sqrt2 * c0 * c1 + k) / (2 * (c1 + sqrt2 * c0 * k) * (c1 + sqrt2 * c0 * k) * k),
	        deltacDeltat = -0.5 * t * c * c * c,
	        deltacDeltaLambda = deltacDeltat * deltatDeltaLambda,
	        deltacDeltaPhi = deltacDeltat * deltatDeltaPhi,
	        A = (A = 2 * c1 + sqrt2 * k * (c0 - s0)) * A * v,
	        deltavDeltaLambda = (sqrt2 * c0 * c1 * k + cos1) / A,
	        deltavDeltaPhi = -(sqrt2 * s0 * s1) / (k * A),
	        deltaxDeltaLambda = vm1v * deltacDeltaLambda - 2 * deltavDeltaLambda / v + c * (deltavDeltaLambda + deltavDeltaLambda / v2),
	        deltaxDeltaPhi = vm1v * deltacDeltaPhi - 2 * deltavDeltaPhi / v + c * (deltavDeltaPhi + deltavDeltaPhi / v2),
	        deltayDeltaLambda = t * vp1v * deltacDeltaLambda - 2 * deltatDeltaLambda / (1 + t2) + c * vp1v * deltatDeltaLambda + c * t * (deltavDeltaLambda - deltavDeltaLambda / v2),
	        deltayDeltaPhi = t * vp1v * deltacDeltaPhi - 2 * deltatDeltaPhi / (1 + t2) + c * vp1v * deltatDeltaPhi + c * t * (deltavDeltaPhi - deltavDeltaPhi / v2),
	        denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
	    if (!denominator) break;
	    var deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator,
	        deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
	    lambda -= deltaLambda;
	    phi = max(-halfPi, min(halfPi, phi - deltaPhi));
	  } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
	  return abs(abs(phi) - halfPi) < epsilon ? [0, phi] : i && [lambda, phi];
	};
	
	var eisenlohr = function() {
	  return d3Geo.geoProjection(eisenlohrRaw)
	      .scale(62.5271);
	};
	
	var faheyK = cos(35 * radians);
	
	function faheyRaw(lambda, phi) {
	  var t = tan(phi / 2);
	  return [lambda * faheyK * sqrt(1 - t * t), (1 + faheyK) * t];
	}
	
	faheyRaw.invert = function(x, y) {
	  var t = y / (1 + faheyK);
	  return [x && x / (faheyK * sqrt(1 - t * t)), 2 * atan(t)];
	};
	
	var fahey = function() {
	  return d3Geo.geoProjection(faheyRaw)
	      .scale(137.152);
	};
	
	function foucautRaw(lambda, phi) {
	  var k = phi / 2, cosk = cos(k);
	  return [ 2 * lambda / sqrtPi * cos(phi) * cosk * cosk, sqrtPi * tan(k)];
	}
	
	foucautRaw.invert = function(x, y) {
	  var k = atan(y / sqrtPi), cosk = cos(k), phi = 2 * k;
	  return [x * sqrtPi / 2 / (cos(phi) * cosk * cosk), phi];
	};
	
	var foucaut = function() {
	  return d3Geo.geoProjection(foucautRaw)
	      .scale(135.264);
	};
	
	function gilbertForward(point) {
	  return [point[0] / 2, asin(tan(point[1] / 2 * radians)) * degrees];
	}
	
	function gilbertInvert(point) {
	  return [point[0] * 2, 2 * atan(sin(point[1] * radians)) * degrees];
	}
	
	var gilbert = function(projectionType) {
	  if (projectionType == null) projectionType = d3Geo.geoOrthographic;
	  var projection = projectionType(),
	      equirectangular = d3Geo.geoEquirectangular().scale(degrees).precision(0).clipAngle(null).translate([0, 0]); // antimeridian cutting
	
	  function gilbert(point) {
	    return projection(gilbertForward(point));
	  }
	
	  if (projection.invert) gilbert.invert = function(point) {
	    return gilbertInvert(projection.invert(point));
	  };
	
	  gilbert.stream = function(stream) {
	    var s1 = projection.stream(stream), s0 = equirectangular.stream({
	      point: function(lambda, phi) { s1.point(lambda / 2, asin(tan(-phi / 2 * radians)) * degrees); },
	      lineStart: function() { s1.lineStart(); },
	      lineEnd: function() { s1.lineEnd(); },
	      polygonStart: function() { s1.polygonStart(); },
	      polygonEnd: function() { s1.polygonEnd(); }
	    });
	    s0.sphere = s1.sphere;
	    return s0;
	  };
	
	  function property(name) {
	    gilbert[name] = function(_) {
	      return arguments.length ? (projection[name](_), gilbert) : projection[name]();
	    };
	  }
	
	  gilbert.rotate = function(_) {
	    return arguments.length ? (equirectangular.rotate(_), gilbert) : equirectangular.rotate();
	  };
	
	  gilbert.center = function(_) {
	    return arguments.length ? (projection.center(gilbertForward(_)), gilbert) : gilbertInvert(projection.center());
	  };
	
	  property("clipAngle");
	  property("clipExtent");
	  property("scale");
	  property("translate");
	  property("precision");
	
	  return gilbert
	      .scale(249.5);
	};
	
	function gingeryRaw(rho, n) {
	  var k = 2 * pi / n,
	      rho2 = rho * rho;
	
	  function forward(lambda, phi) {
	    var p = d3Geo.geoAzimuthalEquidistantRaw(lambda, phi),
	        x = p[0],
	        y = p[1],
	        r2 = x * x + y * y;
	
	    if (r2 > rho2) {
	      var r = sqrt(r2),
	          theta = atan2(y, x),
	          theta0 = k * round(theta / k),
	          alpha = theta - theta0,
	          rhoCosAlpha = rho * cos(alpha),
	          k_ = (rho * sin(alpha) - alpha * sin(rhoCosAlpha)) / (halfPi - rhoCosAlpha),
	          s_ = gingeryLength(alpha, k_),
	          e = (pi - rho) / gingeryIntegrate(s_, rhoCosAlpha, pi);
	
	      x = r;
	      var i = 50, delta;
	      do {
	        x -= delta = (rho + gingeryIntegrate(s_, rhoCosAlpha, x) * e - r) / (s_(x) * e);
	      } while (abs(delta) > epsilon && --i > 0);
	
	      y = alpha * sin(x);
	      if (x < halfPi) y -= k_ * (x - halfPi);
	
	      var s = sin(theta0),
	          c = cos(theta0);
	      p[0] = x * c - y * s;
	      p[1] = x * s + y * c;
	    }
	    return p;
	  }
	
	  forward.invert = function(x, y) {
	    var r2 = x * x + y * y;
	    if (r2 > rho2) {
	      var r = sqrt(r2),
	          theta = atan2(y, x),
	          theta0 = k * round(theta / k),
	          dTheta = theta - theta0;
	
	      x = r * cos(dTheta);
	      y = r * sin(dTheta);
	
	      var x_halfPi = x - halfPi,
	          sinx = sin(x),
	          alpha = y / sinx,
	          delta = x < halfPi ? Infinity : 0,
	          i = 10;
	
	      while (true) {
	        var rhosinAlpha = rho * sin(alpha),
	            rhoCosAlpha = rho * cos(alpha),
	            sinRhoCosAlpha = sin(rhoCosAlpha),
	            halfPi_RhoCosAlpha = halfPi - rhoCosAlpha,
	            k_ = (rhosinAlpha - alpha * sinRhoCosAlpha) / halfPi_RhoCosAlpha,
	            s_ = gingeryLength(alpha, k_);
	
	        if (abs(delta) < epsilon2 || !--i) break;
	
	        alpha -= delta = (alpha * sinx - k_ * x_halfPi - y) / (
	          sinx - x_halfPi * 2 * (
	            halfPi_RhoCosAlpha * (rhoCosAlpha + alpha * rhosinAlpha * cos(rhoCosAlpha) - sinRhoCosAlpha) -
	            rhosinAlpha * (rhosinAlpha - alpha * sinRhoCosAlpha)
	          ) / (halfPi_RhoCosAlpha * halfPi_RhoCosAlpha));
	      }
	      r = rho + gingeryIntegrate(s_, rhoCosAlpha, x) * (pi - rho) / gingeryIntegrate(s_, rhoCosAlpha, pi);
	      theta = theta0 + alpha;
	      x = r * cos(theta);
	      y = r * sin(theta);
	    }
	    return d3Geo.geoAzimuthalEquidistantRaw.invert(x, y);
	  };
	
	  return forward;
	}
	
	function gingeryLength(alpha, k) {
	  return function(x) {
	    var y_ = alpha * cos(x);
	    if (x < halfPi) y_ -= k;
	    return sqrt(1 + y_ * y_);
	  };
	}
	
	// Numerical integration: trapezoidal rule.
	function gingeryIntegrate(f, a, b) {
	  var n = 50,
	      h = (b - a) / n,
	      s = f(a) + f(b);
	  for (var i = 1, x = a; i < n; ++i) s += 2 * f(x += h);
	  return s * 0.5 * h;
	}
	
	var gingery = function() {
	  var n = 6,
	      rho = 30 * radians,
	      cRho = cos(rho),
	      sRho = sin(rho),
	      m = d3Geo.geoProjectionMutator(gingeryRaw),
	      p = m(rho, n),
	      stream_ = p.stream,
	      epsilon$$1 = 1e-2,
	      cr = -cos(epsilon$$1 * radians),
	      sr = sin(epsilon$$1 * radians);
	
	  p.radius = function(_) {
	    if (!arguments.length) return rho * degrees;
	    cRho = cos(rho = _ * radians);
	    sRho = sin(rho);
	    return m(rho, n);
	  };
	
	  p.lobes = function(_) {
	    if (!arguments.length) return n;
	    return m(rho, n = +_);
	  };
	
	  p.stream = function(stream) {
	    var rotate = p.rotate(),
	        rotateStream = stream_(stream),
	        sphereStream = (p.rotate([0, 0]), stream_(stream));
	    p.rotate(rotate);
	    rotateStream.sphere = function() {
	      sphereStream.polygonStart(), sphereStream.lineStart();
	      for (var i = 0, delta = 2 * pi / n, phi = 0; i < n; ++i, phi -= delta) {
	        sphereStream.point(atan2(sr * cos(phi), cr) * degrees, asin(sr * sin(phi)) * degrees);
	        sphereStream.point(atan2(sRho * cos(phi - delta / 2), cRho) * degrees, asin(sRho * sin(phi - delta / 2)) * degrees);
	      }
	      sphereStream.lineEnd(), sphereStream.polygonEnd();
	    };
	    return rotateStream;
	  };
	
	  return p
	      .rotate([90, -40])
	      .scale(91.7095)
	      .clipAngle(180 - 1e-3);
	};
	
	var ginzburgPolyconicRaw = function(a, b, c, d, e, f, g, h) {
	  if (arguments.length < 8) h = 0;
	
	  function forward(lambda, phi) {
	    if (!phi) return [a * lambda / pi, 0];
	    var phi2 = phi * phi,
	        xB = a + phi2 * (b + phi2 * (c + phi2 * d)),
	        yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)),
	        m = (xB * xB + yB * yB) / (2 * yB),
	        alpha = lambda * asin(xB / m) / pi;
	    return [m * sin(alpha), phi * (1 + phi2 * h) + m * (1 - cos(alpha))];
	  }
	
	  forward.invert = function(x, y) {
	    var lambda = pi * x / a,
	        phi = y,
	        deltaLambda, deltaPhi, i = 50;
	    do {
	      var phi2 = phi * phi,
	          xB = a + phi2 * (b + phi2 * (c + phi2 * d)),
	          yB = phi * (e - 1 + phi2 * (f - h + phi2 * g)),
	          p = xB * xB + yB * yB,
	          q = 2 * yB,
	          m = p / q,
	          m2 = m * m,
	          dAlphadLambda = asin(xB / m) / pi,
	          alpha = lambda * dAlphadLambda,
	          xB2 = xB * xB,
	          dxBdPhi = (2 * b + phi2 * (4 * c + phi2 * 6 * d)) * phi,
	          dyBdPhi = e + phi2 * (3 * f + phi2 * 5 * g),
	          dpdPhi = 2 * (xB * dxBdPhi + yB * (dyBdPhi - 1)),
	          dqdPhi = 2 * (dyBdPhi - 1),
	          dmdPhi = (dpdPhi * q - p * dqdPhi) / (q * q),
	          cosAlpha = cos(alpha),
	          sinAlpha = sin(alpha),
	          mcosAlpha = m * cosAlpha,
	          msinAlpha = m * sinAlpha,
	          dAlphadPhi = ((lambda / pi) * (1 / sqrt(1 - xB2 / m2)) * (dxBdPhi * m - xB * dmdPhi)) / m2,
	          fx = msinAlpha - x,
	          fy = phi * (1 + phi2 * h) + m - mcosAlpha - y,
	          deltaxDeltaPhi = dmdPhi * sinAlpha + mcosAlpha * dAlphadPhi,
	          deltaxDeltaLambda = mcosAlpha * dAlphadLambda,
	          deltayDeltaPhi = 1 + dmdPhi - (dmdPhi * cosAlpha - msinAlpha * dAlphadPhi),
	          deltayDeltaLambda = msinAlpha * dAlphadLambda,
	          denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda;
	      if (!denominator) break;
	      lambda -= deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator;
	      phi -= deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
	    } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
	    return [lambda, phi];
	  };
	
	  return forward;
	};
	
	var ginzburg4Raw = ginzburgPolyconicRaw(2.8284, -1.6988, 0.75432, -0.18071, 1.76003, -0.38914, 0.042555);
	
	var ginzburg4 = function() {
	  return d3Geo.geoProjection(ginzburg4Raw)
	      .scale(149.995);
	};
	
	var ginzburg5Raw = ginzburgPolyconicRaw(2.583819, -0.835827, 0.170354, -0.038094, 1.543313, -0.411435,0.082742);
	
	var ginzburg5 = function() {
	  return d3Geo.geoProjection(ginzburg5Raw)
	      .scale(153.93);
	};
	
	var ginzburg6Raw = ginzburgPolyconicRaw(5 / 6 * pi, -0.62636, -0.0344, 0, 1.3493, -0.05524, 0, 0.045);
	
	var ginzburg6 = function() {
	  return d3Geo.geoProjection(ginzburg6Raw)
	      .scale(130.945);
	};
	
	function ginzburg8Raw(lambda, phi) {
	  var lambda2 = lambda * lambda,
	      phi2 = phi * phi;
	  return [
	    lambda * (1 - 0.162388 * phi2) * (0.87 - 0.000952426 * lambda2 * lambda2),
	    phi * (1 + phi2 / 12)
	  ];
	}
	
	ginzburg8Raw.invert = function(x, y) {
	  var lambda = x,
	      phi = y,
	      i = 50, delta;
	  do {
	    var phi2 = phi * phi;
	    phi -= delta = (phi * (1 + phi2 / 12) - y) / (1 + phi2 / 4);
	  } while (abs(delta) > epsilon && --i > 0);
	  i = 50;
	  x /= 1 -0.162388 * phi2;
	  do {
	    var lambda4 = (lambda4 = lambda * lambda) * lambda4;
	    lambda -= delta = (lambda * (0.87 - 0.000952426 * lambda4) - x) / (0.87 - 0.00476213 * lambda4);
	  } while (abs(delta) > epsilon && --i > 0);
	  return [lambda, phi];
	};
	
	var ginzburg8 = function() {
	  return d3Geo.geoProjection(ginzburg8Raw)
	      .scale(131.747);
	};
	
	var ginzburg9Raw = ginzburgPolyconicRaw(2.6516, -0.76534, 0.19123, -0.047094, 1.36289, -0.13965,0.031762);
	
	var ginzburg9 = function() {
	  return d3Geo.geoProjection(ginzburg9Raw)
	      .scale(131.087);
	};
	
	var squareRaw = function(project) {
	  var dx = project(halfPi, 0)[0] - project(-halfPi, 0)[0];
	
	  function projectSquare(lambda, phi) {
	    var s = lambda > 0 ? -0.5 : 0.5,
	        point = project(lambda + s * pi, phi);
	    point[0] -= s * dx;
	    return point;
	  }
	
	  if (project.invert) projectSquare.invert = function(x, y) {
	    var s = x > 0 ? -0.5 : 0.5,
	        location = project.invert(x + s * dx, y),
	        lambda = location[0] - s * pi;
	    if (lambda < -pi) lambda += 2 * pi;
	    else if (lambda > pi) lambda -= 2 * pi;
	    location[0] = lambda;
	    return location;
	  };
	
	  return projectSquare;
	};
	
	function gringortenRaw(lambda, phi) {
	  var sLambda = sign(lambda),
	      sPhi = sign(phi),
	      cosPhi = cos(phi),
	      x = cos(lambda) * cosPhi,
	      y = sin(lambda) * cosPhi,
	      z = sin(sPhi * phi);
	  lambda = abs(atan2(y, z));
	  phi = asin(x);
	  if (abs(lambda - halfPi) > epsilon) lambda %= halfPi;
	  var point = gringortenHexadecant(lambda > pi / 4 ? halfPi - lambda : lambda, phi);
	  if (lambda > pi / 4) z = point[0], point[0] = -point[1], point[1] = -z;
	  return (point[0] *= sLambda, point[1] *= -sPhi, point);
	}
	
	gringortenRaw.invert = function(x, y) {
	  var sx = sign(x),
	      sy = sign(y),
	      x0 = -sx * x,
	      y0 = -sy * y,
	      t = y0 / x0 < 1,
	      p = gringortenHexadecantInvert(t ? y0 : x0, t ? x0 : y0),
	      lambda = p[0],
	      phi = p[1],
	      cosPhi = cos(phi);
	  if (t) lambda = -halfPi - lambda;
	  return [sx * (atan2(sin(lambda) * cosPhi, -sin(phi)) + pi), sy * asin(cos(lambda) * cosPhi)];
	};
	
	function gringortenHexadecant(lambda, phi) {
	  if (phi === halfPi) return [0, 0];
	
	  var sinPhi = sin(phi),
	      r = sinPhi * sinPhi,
	      r2 = r * r,
	      j = 1 + r2,
	      k = 1 + 3 * r2,
	      q = 1 - r2,
	      z = asin(1 / sqrt(j)),
	      v = q + r * j * z,
	      p2 = (1 - sinPhi) / v,
	      p = sqrt(p2),
	      a2 = p2 * j,
	      a = sqrt(a2),
	      h = p * q,
	      x,
	      i;
	
	  if (lambda === 0) return [0, -(h + r * a)];
	
	  var cosPhi = cos(phi),
	      secPhi = 1 / cosPhi,
	      drdPhi = 2 * sinPhi * cosPhi,
	      dvdPhi = (-3 * r + z * k) * drdPhi,
	      dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v),
	      dpdPhi = (0.5 * dp2dPhi) / p,
	      dhdPhi = q * dpdPhi - 2 * r * p * drdPhi,
	      dra2dPhi = r * j * dp2dPhi + p2 * k * drdPhi,
	      mu = -secPhi * drdPhi,
	      nu = -secPhi * dra2dPhi,
	      zeta = -2 * secPhi * dhdPhi,
	      lambda1 = 4 * lambda / pi,
	      delta;
	
	  // Slower but accurate bisection method.
	  if (lambda > 0.222 * pi || phi < pi / 4 && lambda > 0.175 * pi) {
	    x = (h + r * sqrt(a2 * (1 + r2) - h * h)) / (1 + r2);
	    if (lambda > pi / 4) return [x, x];
	    var x1 = x, x0 = 0.5 * x;
	    x = 0.5 * (x0 + x1), i = 50;
	    do {
	      var g = sqrt(a2 - x * x),
	          f = (x * (zeta + mu * g) + nu * asin(x / a)) - lambda1;
	      if (!f) break;
	      if (f < 0) x0 = x;
	      else x1 = x;
	      x = 0.5 * (x0 + x1);
	    } while (abs(x1 - x0) > epsilon && --i > 0);
	  }
	
	  // Newton-Raphson.
	  else {
	    x = epsilon, i = 25;
	    do {
	      var x2 = x * x,
	          g2 = sqrt(a2 - x2),
	          zetaMug = zeta + mu * g2,
	          f2 = x * zetaMug + nu * asin(x / a) - lambda1,
	          df = zetaMug + (nu - mu * x2) / g2;
	      x -= delta = g2 ? f2 / df : 0;
	    } while (abs(delta) > epsilon && --i > 0);
	  }
	
	  return [x, -h - r * sqrt(a2 - x * x)];
	}
	
	function gringortenHexadecantInvert(x, y) {
	  var x0 = 0,
	      x1 = 1,
	      r = 0.5,
	      i = 50;
	
	  while (true) {
	    var r2 = r * r,
	        sinPhi = sqrt(r),
	        z = asin(1 / sqrt(1 + r2)),
	        v = (1 - r2) + r * (1 + r2) * z,
	        p2 = (1 - sinPhi) / v,
	        p = sqrt(p2),
	        a2 = p2 * (1 + r2),
	        h = p * (1 - r2),
	        g2 = a2 - x * x,
	        g = sqrt(g2),
	        y0 = y + h + r * g;
	    if (abs(x1 - x0) < epsilon2 || --i === 0 || y0 === 0) break;
	    if (y0 > 0) x0 = r;
	    else x1 = r;
	    r = 0.5 * (x0 + x1);
	  }
	
	  if (!i) return null;
	
	  var phi = asin(sinPhi),
	      cosPhi = cos(phi),
	      secPhi = 1 / cosPhi,
	      drdPhi = 2 * sinPhi * cosPhi,
	      dvdPhi = (-3 * r + z * (1 + 3 * r2)) * drdPhi,
	      dp2dPhi = (-v * cosPhi - (1 - sinPhi) * dvdPhi) / (v * v),
	      dpdPhi = 0.5 * dp2dPhi / p,
	      dhdPhi = (1 - r2) * dpdPhi - 2 * r * p * drdPhi,
	      zeta = -2 * secPhi * dhdPhi,
	      mu = -secPhi * drdPhi,
	      nu = -secPhi * (r * (1 + r2) * dp2dPhi + p2 * (1 + 3 * r2) * drdPhi);
	
	  return [pi / 4 * (x * (zeta + mu * g) + nu * asin(x / sqrt(a2))), phi];
	}
	
	var gringorten = function() {
	  return d3Geo.geoProjection(squareRaw(gringortenRaw))
	      .scale(239.75);
	};
	
	// Returns [sn, cn, dn](u + iv|m).
	function ellipticJi(u, v, m) {
	  var a, b, c;
	  if (!u) {
	    b = ellipticJ(v, 1 - m);
	    return [
	      [0, b[0] / b[1]],
	      [1 / b[1], 0],
	      [b[2] / b[1], 0]
	    ];
	  }
	  a = ellipticJ(u, m);
	  if (!v) return [[a[0], 0], [a[1], 0], [a[2], 0]];
	  b = ellipticJ(v, 1 - m);
	  c = b[1] * b[1] + m * a[0] * a[0] * b[0] * b[0];
	  return [
	    [a[0] * b[2] / c, a[1] * a[2] * b[0] * b[1] / c],
	    [a[1] * b[1] / c, -a[0] * a[2] * b[0] * b[2] / c],
	    [a[2] * b[1] * b[2] / c, -m * a[0] * a[1] * b[0] / c]
	  ];
	}
	
	// Returns [sn, cn, dn, ph](u|m).
	function ellipticJ(u, m) {
	  var ai, b, phi, t, twon;
	  if (m < epsilon) {
	    t = sin(u);
	    b = cos(u);
	    ai = m * (u - t * b) / 4;
	    return [
	      t - ai * b,
	      b + ai * t,
	      1 - m * t * t / 2,
	      u - ai
	    ];
	  }
	  if (m >= 1 - epsilon) {
	    ai = (1 - m) / 4;
	    b = cosh(u);
	    t = tanh(u);
	    phi = 1 / b;
	    twon = b * sinh(u);
	    return [
	      t + ai * (twon - u) / (b * b),
	      phi - ai * t * phi * (twon - u),
	      phi + ai * t * phi * (twon + u),
	      2 * atan(exp(u)) - halfPi + ai * (twon - u) / b
	    ];
	  }
	
	  var a = [1, 0, 0, 0, 0, 0, 0, 0, 0],
	      c = [sqrt(m), 0, 0, 0, 0, 0, 0, 0, 0],
	      i = 0;
	  b = sqrt(1 - m);
	  twon = 1;
	
	  while (abs(c[i] / a[i]) > epsilon && i < 8) {
	    ai = a[i++];
	    c[i] = (ai - b) / 2;
	    a[i] = (ai + b) / 2;
	    b = sqrt(ai * b);
	    twon *= 2;
	  }
	
	  phi = twon * a[i] * u;
	  do {
	    t = c[i] * sin(b = phi) / a[i];
	    phi = (asin(t) + phi) / 2;
	  } while (--i);
	
	  return [sin(phi), t = cos(phi), t / cos(phi - b), phi];
	}
	
	// Calculate F(phi+iPsi|m).
	// See Abramowitz and Stegun, 17.4.11.
	function ellipticFi(phi, psi, m) {
	  var r = abs(phi),
	      i = abs(psi),
	      sinhPsi = sinh(i);
	  if (r) {
	    var cscPhi = 1 / sin(r),
	        cotPhi2 = 1 / (tan(r) * tan(r)),
	        b = -(cotPhi2 + m * (sinhPsi * sinhPsi * cscPhi * cscPhi) - 1 + m),
	        c = (m - 1) * cotPhi2,
	        cotLambda2 = (-b + sqrt(b * b - 4 * c)) / 2;
	    return [
	      ellipticF(atan(1 / sqrt(cotLambda2)), m) * sign(phi),
	      ellipticF(atan(sqrt((cotLambda2 / cotPhi2 - 1) / m)), 1 - m) * sign(psi)
	    ];
	  }
	  return [
	    0,
	    ellipticF(atan(sinhPsi), 1 - m) * sign(psi)
	  ];
	}
	
	// Calculate F(phi|m) where m = k² = sin²α.
	// See Abramowitz and Stegun, 17.6.7.
	function ellipticF(phi, m) {
	  if (!m) return phi;
	  if (m === 1) return log(tan(phi / 2 + quarterPi));
	  var a = 1,
	      b = sqrt(1 - m),
	      c = sqrt(m);
	  for (var i = 0; abs(c) > epsilon; i++) {
	    if (phi % pi) {
	      var dPhi = atan(b * tan(phi) / a);
	      if (dPhi < 0) dPhi += pi;
	      phi += dPhi + ~~(phi / pi) * pi;
	    } else phi += phi;
	    c = (a + b) / 2;
	    b = sqrt(a * b);
	    c = ((a = c) - b) / 2;
	  }
	  return phi / (pow(2, i) * a);
	}
	
	function guyouRaw(lambda, phi) {
	  var k_ = (sqrt2 - 1) / (sqrt2 + 1),
	      k = sqrt(1 - k_ * k_),
	      K = ellipticF(halfPi, k * k),
	      f = -1,
	      psi = log(tan(pi / 4 + abs(phi) / 2)),
	      r = exp(f * psi) / sqrt(k_),
	      at = guyouComplexAtan(r * cos(f * lambda), r * sin(f * lambda)),
	      t = ellipticFi(at[0], at[1], k * k);
	  return [-t[1], (phi >= 0 ? 1 : -1) * (0.5 * K - t[0])];
	}
	
	function guyouComplexAtan(x, y) {
	  var x2 = x * x,
	      y_1 = y + 1,
	      t = 1 - x2 - y * y;
	  return [
	   0.5 * ((x >= 0 ? halfPi : -halfPi) - atan2(t, 2 * x)),
	    -0.25 * log(t * t + 4 * x2) +0.5 * log(y_1 * y_1 + x2)
	  ];
	}
	
	function guyouComplexDivide(a, b) {
	  var denominator = b[0] * b[0] + b[1] * b[1];
	  return [
	    (a[0] * b[0] + a[1] * b[1]) / denominator,
	    (a[1] * b[0] - a[0] * b[1]) / denominator
	  ];
	}
	
	guyouRaw.invert = function(x, y) {
	  var k_ = (sqrt2 - 1) / (sqrt2 + 1),
	      k = sqrt(1 - k_ * k_),
	      K = ellipticF(halfPi, k * k),
	      f = -1,
	      j = ellipticJi(0.5 * K - y, -x, k * k),
	      tn = guyouComplexDivide(j[0], j[1]),
	      lambda = atan2(tn[1], tn[0]) / f;
	  return [
	    lambda,
	    2 * atan(exp(0.5 / f * log(k_ * tn[0] * tn[0] + k_ * tn[1] * tn[1]))) - halfPi
	  ];
	};
	
	var guyou = function() {
	  return d3Geo.geoProjection(squareRaw(guyouRaw))
	      .scale(151.496);
	};
	
	function hammerRaw(A, B) {
	  if (arguments.length < 2) B = A;
	  if (B === 1) return d3Geo.geoAzimuthalEqualAreaRaw;
	  if (B === Infinity) return hammerQuarticAuthalicRaw;
	
	  function forward(lambda, phi) {
	    var coordinates = d3Geo.geoAzimuthalEqualAreaRaw(lambda / B, phi);
	    coordinates[0] *= A;
	    return coordinates;
	  }
	
	  forward.invert = function(x, y) {
	    var coordinates = d3Geo.geoAzimuthalEqualAreaRaw.invert(x / A, y);
	    coordinates[0] *= B;
	    return coordinates;
	  };
	
	  return forward;
	}
	
	function hammerQuarticAuthalicRaw(lambda, phi) {
	  return [
	    lambda * cos(phi) / cos(phi /= 2),
	    2 * sin(phi)
	  ];
	}
	
	hammerQuarticAuthalicRaw.invert = function(x, y) {
	  var phi = 2 * asin(y / 2);
	  return [
	    x * cos(phi / 2) / cos(phi),
	    phi
	  ];
	};
	
	var hammer = function() {
	  var B = 2,
	      m = d3Geo.geoProjectionMutator(hammerRaw),
	      p = m(B);
	
	  p.coefficient = function(_) {
	    if (!arguments.length) return B;
	    return m(B = +_);
	  };
	
	  return p
	    .scale(169.529);
	};
	
	function hammerRetroazimuthalRaw(phi0) {
	  var sinPhi0 = sin(phi0),
	      cosPhi0 = cos(phi0),
	      rotate = hammerRetroazimuthalRotation(phi0);
	
	  rotate.invert = hammerRetroazimuthalRotation(-phi0);
	
	  function forward(lambda, phi) {
	    var p = rotate(lambda, phi);
	    lambda = p[0], phi = p[1];
	    var sinPhi = sin(phi),
	        cosPhi = cos(phi),
	        cosLambda = cos(lambda),
	        z = acos(sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosLambda),
	        sinz = sin(z),
	        K = abs(sinz) > epsilon ? z / sinz : 1;
	    return [
	      K * cosPhi0 * sin(lambda),
	      (abs(lambda) > halfPi ? K : -K) // rotate for back hemisphere
	        * (sinPhi0 * cosPhi - cosPhi0 * sinPhi * cosLambda)
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var rho = sqrt(x * x + y * y),
	        sinz = -sin(rho),
	        cosz = cos(rho),
	        a = rho * cosz,
	        b = -y * sinz,
	        c = rho * sinPhi0,
	        d = sqrt(a * a + b * b - c * c),
	        phi = atan2(a * c + b * d, b * c - a * d),
	        lambda = (rho > halfPi ? -1 : 1) * atan2(x * sinz, rho * cos(phi) * cosz + y * sin(phi) * sinz);
	    return rotate.invert(lambda, phi);
	  };
	
	  return forward;
	}
	
	// Latitudinal rotation by phi0.
	// Temporary hack until D3 supports arbitrary small-circle clipping origins.
	function hammerRetroazimuthalRotation(phi0) {
	  var sinPhi0 = sin(phi0),
	      cosPhi0 = cos(phi0);
	
	  return function(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi);
	    return [
	      atan2(y, x * cosPhi0 - z * sinPhi0),
	      asin(z * cosPhi0 + x * sinPhi0)
	    ];
	  };
	}
	
	var hammerRetroazimuthal = function() {
	  var phi0 = 0,
	      m = d3Geo.geoProjectionMutator(hammerRetroazimuthalRaw),
	      p = m(phi0),
	      rotate_ = p.rotate,
	      stream_ = p.stream,
	      circle = d3Geo.geoCircle();
	
	  p.parallel = function(_) {
	    if (!arguments.length) return phi0 * degrees;
	    var r = p.rotate();
	    return m(phi0 = _ * radians).rotate(r);
	  };
	
	  // Temporary hack; see hammerRetroazimuthalRotation.
	  p.rotate = function(_) {
	    if (!arguments.length) return (_ = rotate_.call(p), _[1] += phi0 * degrees, _);
	    rotate_.call(p, [_[0], _[1] - phi0 * degrees]);
	    circle.center([-_[0], -_[1]]);
	    return p;
	  };
	
	  p.stream = function(stream) {
	    stream = stream_(stream);
	    stream.sphere = function() {
	      stream.polygonStart();
	      var epsilon$$1 = 1e-2,
	          ring = circle.radius(90 - epsilon$$1)().coordinates[0],
	          n = ring.length - 1,
	          i = -1,
	          p;
	      stream.lineStart();
	      while (++i < n) stream.point((p = ring[i])[0], p[1]);
	      stream.lineEnd();
	      ring = circle.radius(90 + epsilon$$1)().coordinates[0];
	      n = ring.length - 1;
	      stream.lineStart();
	      while (--i >= 0) stream.point((p = ring[i])[0], p[1]);
	      stream.lineEnd();
	      stream.polygonEnd();
	    };
	    return stream;
	  };
	
	  return p
	      .scale(79.4187)
	      .parallel(45)
	      .clipAngle(180 - 1e-3);
	};
	
	var healpixParallel = 41 + 48 / 36 + 37 / 3600;
	var healpixLambert = cylindricalEqualAreaRaw(0);
	
	function healpixRaw(H) {
	  var phi0 = healpixParallel * radians,
	      dx = collignonRaw(pi, phi0)[0] - collignonRaw(-pi, phi0)[0],
	      y0 = healpixLambert(0, phi0)[1],
	      y1 = collignonRaw(0, phi0)[1],
	      dy1 = sqrtPi - y1,
	      k = tau / H,
	      w = 4 / tau,
	      h = y0 + (dy1 * dy1 * 4) / tau;
	
	  function forward(lambda, phi) {
	    var point,
	        phi2 = abs(phi);
	    if (phi2 > phi0) {
	      var i = min(H - 1, max(0, floor((lambda + pi) / k)));
	      lambda += pi * (H - 1) / H - i * k;
	      point = collignonRaw(lambda, phi2);
	      point[0] = point[0] * tau / dx - tau * (H - 1) / (2 * H) + i * tau / H;
	      point[1] = y0 + (point[1] - y1) * 4 * dy1 / tau;
	      if (phi < 0) point[1] = -point[1];
	    } else {
	      point = healpixLambert(lambda, phi);
	    }
	    point[0] *= w, point[1] /= h;
	    return point;
	  }
	
	  forward.invert = function(x, y) {
	    x /= w, y *= h;
	    var y2 = abs(y);
	    if (y2 > y0) {
	      var i = min(H - 1, max(0, floor((x + pi) / k)));
	      x = (x + pi * (H - 1) / H - i * k) * dx / tau;
	      var point = collignonRaw.invert(x, 0.25 * (y2 - y0) * tau / dy1 + y1);
	      point[0] -= pi * (H - 1) / H - i * k;
	      if (y < 0) point[1] = -point[1];
	      return point;
	    }
	    return healpixLambert.invert(x, y);
	  };
	
	  return forward;
	}
	
	function sphere(step) {
	  return {
	    type: "Polygon",
	    coordinates: [
	      d3Array.range(-180, 180 + step / 2, step).map(function(x, i) { return [x, i & 1 ? 90 - 1e-6 : healpixParallel]; })
	      .concat(d3Array.range(180, -180 - step / 2, -step).map(function(x, i) { return [x, i & 1 ? -90 + 1e-6 : -healpixParallel]; }))
	    ]
	  };
	}
	
	var healpix = function() {
	  var H = 4,
	      m = d3Geo.geoProjectionMutator(healpixRaw),
	      p = m(H),
	      stream_ = p.stream;
	
	  p.lobes = function(_) {
	    return arguments.length ? m(H = +_) : H;
	  };
	
	  p.stream = function(stream) {
	    var rotate = p.rotate(),
	        rotateStream = stream_(stream),
	        sphereStream = (p.rotate([0, 0]), stream_(stream));
	    p.rotate(rotate);
	    rotateStream.sphere = function() { d3Geo.geoStream(sphere(180 / H), sphereStream); };
	    return rotateStream;
	  };
	
	  return p
	      .scale(239.75);
	};
	
	function hillRaw(K) {
	  var L = 1 + K,
	      sinBt = sin(1 / L),
	      Bt = asin(sinBt),
	      A = 2 * sqrt(pi / (B = pi + 4 * Bt * L)),
	      B,
	      rho0 = 0.5 * A * (L + sqrt(K * (2 + K))),
	      K2 = K * K,
	      L2 = L * L;
	
	  function forward(lambda, phi) {
	    var t = 1 - sin(phi),
	        rho,
	        omega;
	    if (t && t < 2) {
	      var theta = halfPi - phi, i = 25, delta;
	      do {
	        var sinTheta = sin(theta),
	            cosTheta = cos(theta),
	            Bt_Bt1 = Bt + atan2(sinTheta, L - cosTheta),
	            C = 1 + L2 - 2 * L * cosTheta;
	        theta -= delta = (theta - K2 * Bt - L * sinTheta + C * Bt_Bt1 -0.5 * t * B) / (2 * L * sinTheta * Bt_Bt1);
	      } while (abs(delta) > epsilon2 && --i > 0);
	      rho = A * sqrt(C);
	      omega = lambda * Bt_Bt1 / pi;
	    } else {
	      rho = A * (K + t);
	      omega = lambda * Bt / pi;
	    }
	    return [
	      rho * sin(omega),
	      rho0 - rho * cos(omega)
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var rho2 = x * x + (y -= rho0) * y,
	        cosTheta = (1 + L2 - rho2 / (A * A)) / (2 * L),
	        theta = acos(cosTheta),
	        sinTheta = sin(theta),
	        Bt_Bt1 = Bt + atan2(sinTheta, L - cosTheta);
	    return [
	      asin(x / sqrt(rho2)) * pi / Bt_Bt1,
	      asin(1 - 2 * (theta - K2 * Bt - L * sinTheta + (1 + L2 - 2 * L * cosTheta) * Bt_Bt1) / B)
	    ];
	  };
	
	  return forward;
	}
	
	var hill = function() {
	  var K = 1,
	      m = d3Geo.geoProjectionMutator(hillRaw),
	      p = m(K);
	
	  p.ratio = function(_) {
	    return arguments.length ? m(K = +_) : K;
	  };
	
	  return p
	      .scale(167.774)
	      .center([0, 18.67]);
	};
	
	var sinuMollweidePhi = 0.7109889596207567;
	
	var sinuMollweideY = 0.0528035274542;
	
	function sinuMollweideRaw(lambda, phi) {
	  return phi > -sinuMollweidePhi
	      ? (lambda = mollweideRaw(lambda, phi), lambda[1] += sinuMollweideY, lambda)
	      : sinusoidalRaw(lambda, phi);
	}
	
	sinuMollweideRaw.invert = function(x, y) {
	  return y > -sinuMollweidePhi
	      ? mollweideRaw.invert(x, y - sinuMollweideY)
	      : sinusoidalRaw.invert(x, y);
	};
	
	var sinuMollweide = function() {
	  return d3Geo.geoProjection(sinuMollweideRaw)
	      .rotate([-20, -55])
	      .scale(164.263)
	      .center([0, -5.4036]);
	};
	
	function homolosineRaw(lambda, phi) {
	  return abs(phi) > sinuMollweidePhi
	      ? (lambda = mollweideRaw(lambda, phi), lambda[1] -= phi > 0 ? sinuMollweideY : -sinuMollweideY, lambda)
	      : sinusoidalRaw(lambda, phi);
	}
	
	homolosineRaw.invert = function(x, y) {
	  return abs(y) > sinuMollweidePhi
	      ? mollweideRaw.invert(x, y + (y > 0 ? sinuMollweideY : -sinuMollweideY))
	      : sinusoidalRaw.invert(x, y);
	};
	
	var homolosine = function() {
	  return d3Geo.geoProjection(homolosineRaw)
	      .scale(152.63);
	};
	
	function pointEqual(a, b) {
	  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
	}
	
	function interpolateLine(coordinates, m) {
	  var i = -1,
	      n = coordinates.length,
	      p0 = coordinates[0],
	      p1,
	      dx,
	      dy,
	      resampled = [];
	  while (++i < n) {
	    p1 = coordinates[i];
	    dx = (p1[0] - p0[0]) / m;
	    dy = (p1[1] - p0[1]) / m;
	    for (var j = 0; j < m; ++j) resampled.push([p0[0] + j * dx, p0[1] + j * dy]);
	    p0 = p1;
	  }
	  resampled.push(p1);
	  return resampled;
	}
	
	function interpolateSphere(lobes) {
	  var coordinates = [],
	      lobe,
	      lambda0, phi0, phi1,
	      lambda2, phi2,
	      i, n = lobes[0].length;
	
	  // Northern Hemisphere
	  for (i = 0; i < n; ++i) {
	    lobe = lobes[0][i];
	    lambda0 = lobe[0][0], phi0 = lobe[0][1], phi1 = lobe[1][1];
	    lambda2 = lobe[2][0], phi2 = lobe[2][1];
	    coordinates.push(interpolateLine([
	      [lambda0 + epsilon, phi0 + epsilon],
	      [lambda0 + epsilon, phi1 - epsilon],
	      [lambda2 - epsilon, phi1 - epsilon],
	      [lambda2 - epsilon, phi2 + epsilon]
	    ], 30));
	  }
	
	  // Southern Hemisphere
	  for (i = lobes[1].length - 1; i >= 0; --i) {
	    lobe = lobes[1][i];
	    lambda0 = lobe[0][0], phi0 = lobe[0][1], phi1 = lobe[1][1];
	    lambda2 = lobe[2][0], phi2 = lobe[2][1];
	    coordinates.push(interpolateLine([
	      [lambda2 - epsilon, phi2 - epsilon],
	      [lambda2 - epsilon, phi1 + epsilon],
	      [lambda0 + epsilon, phi1 + epsilon],
	      [lambda0 + epsilon, phi0 - epsilon]
	    ], 30));
	  }
	
	  return {
	    type: "Polygon",
	    coordinates: [d3Array.merge(coordinates)]
	  };
	}
	
	var interrupt = function(project, lobes) {
	  var sphere = interpolateSphere(lobes);
	
	  lobes = lobes.map(function(lobe) {
	    return lobe.map(function(l) {
	      return [
	        [l[0][0] * radians, l[0][1] * radians],
	        [l[1][0] * radians, l[1][1] * radians],
	        [l[2][0] * radians, l[2][1] * radians]
	      ];
	    });
	  });
	
	  var bounds = lobes.map(function(lobe) {
	    return lobe.map(function(l) {
	      var x0 = project(l[0][0], l[0][1])[0],
	          x1 = project(l[2][0], l[2][1])[0],
	          y0 = project(l[1][0], l[0][1])[1],
	          y1 = project(l[1][0], l[1][1])[1],
	          t;
	      if (y0 > y1) t = y0, y0 = y1, y1 = t;
	      return [[x0, y0], [x1, y1]];
	    });
	  });
	
	  function forward(lambda, phi) {
	    var sign$$1 = phi < 0 ? -1 : +1, lobe = lobes[+(phi < 0)];
	    for (var i = 0, n = lobe.length - 1; i < n && lambda > lobe[i][2][0]; ++i);
	    var p = project(lambda - lobe[i][1][0], phi);
	    p[0] += project(lobe[i][1][0], sign$$1 * phi > sign$$1 * lobe[i][0][1] ? lobe[i][0][1] : phi)[0];
	    return p;
	  }
	
	  // Assumes mutually exclusive bounding boxes for lobes.
	  if (project.invert) forward.invert = function(x, y) {
	    var bound = bounds[+(y < 0)], lobe = lobes[+(y < 0)];
	    for (var i = 0, n = bound.length; i < n; ++i) {
	      var b = bound[i];
	      if (b[0][0] <= x && x < b[1][0] && b[0][1] <= y && y < b[1][1]) {
	        var p = project.invert(x - project(lobe[i][1][0], 0)[0], y);
	        p[0] += lobe[i][1][0];
	        return pointEqual(forward(p[0], p[1]), [x, y]) ? p : null;
	      }
	    }
	  };
	
	  var p = d3Geo.geoProjection(forward),
	      stream_ = p.stream;
	
	  p.stream = function(stream) {
	    var rotate = p.rotate(),
	        rotateStream = stream_(stream),
	        sphereStream = (p.rotate([0, 0]), stream_(stream));
	    p.rotate(rotate);
	    rotateStream.sphere = function() { d3Geo.geoStream(sphere, sphereStream); };
	    return rotateStream;
	  };
	
	  return p;
	};
	
	var lobes = [[ // northern hemisphere
	  [[-180,   0], [-100,  90], [ -40,   0]],
	  [[ -40,   0], [  30,  90], [ 180,   0]]
	], [ // southern hemisphere
	  [[-180,   0], [-160, -90], [-100,   0]],
	  [[-100,   0], [ -60, -90], [ -20,   0]],
	  [[ -20,   0], [  20, -90], [  80,   0]],
	  [[  80,   0], [ 140, -90], [ 180,   0]]
	]];
	
	var boggs$1 = function() {
	  return interrupt(boggsRaw, lobes)
	      .scale(160.857);
	};
	
	var lobes$1 = [[ // northern hemisphere
	  [[-180,   0], [-100,  90], [ -40,   0]],
	  [[ -40,   0], [  30,  90], [ 180,   0]]
	], [ // southern hemisphere
	  [[-180,   0], [-160, -90], [-100,   0]],
	  [[-100,   0], [ -60, -90], [ -20,   0]],
	  [[ -20,   0], [  20, -90], [  80,   0]],
	  [[  80,   0], [ 140, -90], [ 180,   0]]
	]];
	
	var homolosine$1 = function() {
	  return interrupt(homolosineRaw, lobes$1)
	      .scale(152.63);
	};
	
	var lobes$2 = [[ // northern hemisphere
	  [[-180,   0], [-100,  90], [ -40,   0]],
	  [[ -40,   0], [  30,  90], [ 180,   0]]
	], [ // southern hemisphere
	  [[-180,   0], [-160, -90], [-100,   0]],
	  [[-100,   0], [ -60, -90], [ -20,   0]],
	  [[ -20,   0], [  20, -90], [  80,   0]],
	  [[  80,   0], [ 140, -90], [ 180,   0]]
	]];
	
	var mollweide$1 = function() {
	  return interrupt(mollweideRaw, lobes$2)
	      .scale(169.529);
	};
	
	var lobes$3 = [[ // northern hemisphere
	  [[-180,   0], [ -90,  90], [   0,   0]],
	  [[   0,   0], [  90,  90], [ 180,   0]]
	], [ // southern hemisphere
	  [[-180,   0], [ -90, -90], [   0,   0]],
	  [[   0,   0], [  90, -90], [ 180,   0]]
	]];
	
	var mollweideHemispheres = function() {
	  return interrupt(mollweideRaw, lobes$3)
	      .scale(169.529)
	      .rotate([20, 0]);
	};
	
	var lobes$4 = [[ // northern hemisphere
	  [[-180,  35], [ -30,  90], [   0,  35]],
	  [[   0,  35], [  30,  90], [ 180,  35]]
	], [ // southern hemisphere
	  [[-180, -10], [-102, -90], [ -65, -10]],
	  [[ -65, -10], [   5, -90], [  77, -10]],
	  [[  77, -10], [ 103, -90], [ 180, -10]]
	]];
	
	var sinuMollweide$1 = function() {
	  return interrupt(sinuMollweideRaw, lobes$4)
	      .rotate([-20, -55])
	      .scale(164.263)
	      .center([0, -5.4036]);
	};
	
	var lobes$5 = [[ // northern hemisphere
	  [[-180,   0], [-110,  90], [ -40,   0]],
	  [[ -40,   0], [   0,  90], [  40,   0]],
	  [[  40,   0], [ 110,  90], [ 180,   0]]
	], [ // southern hemisphere
	  [[-180,   0], [-110, -90], [ -40,   0]],
	  [[ -40,   0], [   0, -90], [  40,   0]],
	  [[  40,   0], [ 110, -90], [ 180,   0]]
	]];
	
	var sinusoidal$1 = function() {
	  return interrupt(sinusoidalRaw, lobes$5)
	      .scale(152.63)
	      .rotate([-20, 0]);
	};
	
	function kavrayskiy7Raw(lambda, phi) {
	  return [3 / tau * lambda * sqrt(pi * pi / 3 - phi * phi), phi];
	}
	
	kavrayskiy7Raw.invert = function(x, y) {
	  return [tau / 3 * x / sqrt(pi * pi / 3 - y * y), y];
	};
	
	var kavrayskiy7 = function() {
	  return d3Geo.geoProjection(kavrayskiy7Raw)
	      .scale(158.837);
	};
	
	function lagrangeRaw(n) {
	
	  function forward(lambda, phi) {
	    if (abs(abs(phi) - halfPi) < epsilon) return [0, phi < 0 ? -2 : 2];
	    var sinPhi = sin(phi),
	        v = pow((1 + sinPhi) / (1 - sinPhi), n / 2),
	        c = 0.5 * (v + 1 / v) + cos(lambda *= n);
	    return [
	      2 * sin(lambda) / c,
	      (v - 1 / v) / c
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var y0 = abs(y);
	    if (abs(y0 - 2) < epsilon) return x ? null : [0, sign(y) * halfPi];
	    if (y0 > 2) return null;
	
	    x /= 2, y /= 2;
	    var x2 = x * x,
	        y2 = y * y,
	        t = 2 * y / (1 + x2 + y2); // tanh(nPhi)
	    t = pow((1 + t) / (1 - t), 1 / n);
	    return [
	      atan2(2 * x, 1 - x2 - y2) / n,
	      asin((t - 1) / (t + 1))
	    ];
	  };
	
	  return forward;
	}
	
	var lagrange = function() {
	  var n = 0.5,
	      m = d3Geo.geoProjectionMutator(lagrangeRaw),
	      p = m(n);
	
	  p.spacing = function(_) {
	    return arguments.length ? m(n = +_) : n;
	  };
	
	  return p
	      .scale(124.75);
	};
	
	var pi_sqrt2 = pi / sqrt2;
	
	function larriveeRaw(lambda, phi) {
	  return [
	    lambda * (1 + sqrt(cos(phi))) / 2,
	    phi / (cos(phi / 2) * cos(lambda / 6))
	  ];
	}
	
	larriveeRaw.invert = function(x, y) {
	  var x0 = abs(x),
	      y0 = abs(y),
	      lambda = epsilon,
	      phi = halfPi;
	  if (y0 < pi_sqrt2) phi *= y0 / pi_sqrt2;
	  else lambda += 6 * acos(pi_sqrt2 / y0);
	  for (var i = 0; i < 25; i++) {
	    var sinPhi = sin(phi),
	        sqrtcosPhi = sqrt(cos(phi)),
	        sinPhi_2 = sin(phi / 2),
	        cosPhi_2 = cos(phi / 2),
	        sinLambda_6 = sin(lambda / 6),
	        cosLambda_6 = cos(lambda / 6),
	        f0 = 0.5 * lambda * (1 + sqrtcosPhi) - x0,
	        f1 = phi / (cosPhi_2 * cosLambda_6) - y0,
	        df0dPhi = sqrtcosPhi ? -0.25 * lambda * sinPhi / sqrtcosPhi : 0,
	        df0dLambda = 0.5 * (1 + sqrtcosPhi),
	        df1dPhi = (1 +0.5 * phi * sinPhi_2 / cosPhi_2) / (cosPhi_2 * cosLambda_6),
	        df1dLambda = (phi / cosPhi_2) * (sinLambda_6 / 6) / (cosLambda_6 * cosLambda_6),
	        denom = df0dPhi * df1dLambda - df1dPhi * df0dLambda,
	        dPhi = (f0 * df1dLambda - f1 * df0dLambda) / denom,
	        dLambda = (f1 * df0dPhi - f0 * df1dPhi) / denom;
	    phi -= dPhi;
	    lambda -= dLambda;
	    if (abs(dPhi) < epsilon && abs(dLambda) < epsilon) break;
	  }
	  return [x < 0 ? -lambda : lambda, y < 0 ? -phi : phi];
	};
	
	var larrivee = function() {
	  return d3Geo.geoProjection(larriveeRaw)
	      .scale(97.2672);
	};
	
	function laskowskiRaw(lambda, phi) {
	  var lambda2 = lambda * lambda, phi2 = phi * phi;
	  return [
	    lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)),
	    phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 0.000199025) + phi2 * (0.0998909 + phi2 * -0.0491032))
	  ];
	}
	
	laskowskiRaw.invert = function(x, y) {
	  var lambda = sign(x) * pi,
	      phi = y / 2,
	      i = 50;
	  do {
	    var lambda2 = lambda * lambda,
	        phi2 = phi * phi,
	        lambdaPhi = lambda * phi,
	        fx = lambda * (0.975534 + phi2 * (-0.119161 + lambda2 * -0.0143059 + phi2 * -0.0547009)) - x,
	        fy = phi * (1.00384 + lambda2 * (0.0802894 + phi2 * -0.02855 + lambda2 * 0.000199025) + phi2 * (0.0998909 + phi2 * -0.0491032)) - y,
	        deltaxDeltaLambda = 0.975534 - phi2 * (0.119161 + 3 * lambda2 * 0.0143059 + phi2 * 0.0547009),
	        deltaxDeltaPhi = -lambdaPhi * (2 * 0.119161 + 4 * 0.0547009 * phi2 + 2 * 0.0143059 * lambda2),
	        deltayDeltaLambda = lambdaPhi * (2 * 0.0802894 + 4 * 0.000199025 * lambda2 + 2 * -0.02855 * phi2),
	        deltayDeltaPhi = 1.00384 + lambda2 * (0.0802894 + 0.000199025 * lambda2) + phi2 * (3 * (0.0998909 - 0.02855 * lambda2) - 5 * 0.0491032 * phi2),
	        denominator = deltaxDeltaPhi * deltayDeltaLambda - deltayDeltaPhi * deltaxDeltaLambda,
	        deltaLambda = (fy * deltaxDeltaPhi - fx * deltayDeltaPhi) / denominator,
	        deltaPhi = (fx * deltayDeltaLambda - fy * deltaxDeltaLambda) / denominator;
	    lambda -= deltaLambda, phi -= deltaPhi;
	  } while ((abs(deltaLambda) > epsilon || abs(deltaPhi) > epsilon) && --i > 0);
	  return i && [lambda, phi];
	};
	
	var laskowski = function() {
	  return d3Geo.geoProjection(laskowskiRaw)
	      .scale(139.98);
	};
	
	function littrowRaw(lambda, phi) {
	  return [
	    sin(lambda) / cos(phi),
	    tan(phi) * cos(lambda)
	  ];
	}
	
	littrowRaw.invert = function(x, y) {
	  var x2 = x * x,
	      y2 = y * y,
	      y2_1 = y2 + 1,
	      cosPhi = x
	          ? sqrt1_2 * sqrt((y2_1 - sqrt(x2 * x2 + 2 * x2 * (y2 - 1) + y2_1 * y2_1)) / x2 + 1)
	          : 1 / sqrt(y2_1);
	  return [
	    asin(x * cosPhi),
	    sign(y) * acos(cosPhi)
	  ];
	};
	
	var littrow = function() {
	  return d3Geo.geoProjection(littrowRaw)
	      .scale(144.049)
	      .clipAngle(90 - 1e-3);
	};
	
	function loximuthalRaw(phi0) {
	  var cosPhi0 = cos(phi0),
	      tanPhi0 = tan(quarterPi + phi0 / 2);
	
	  function forward(lambda, phi) {
	    var y = phi - phi0,
	        x = abs(y) < epsilon ? lambda * cosPhi0
	            : abs(x = quarterPi + phi / 2) < epsilon || abs(abs(x) - halfPi) < epsilon
	            ? 0 : lambda * y / log(tan(x) / tanPhi0);
	    return [x, y];
	  }
	
	  forward.invert = function(x, y) {
	    var lambda,
	        phi = y + phi0;
	    return [
	      abs(y) < epsilon ? x / cosPhi0
	          : (abs(lambda = quarterPi + phi / 2) < epsilon || abs(abs(lambda) - halfPi) < epsilon) ? 0
	          : x * log(tan(lambda) / tanPhi0) / y,
	      phi
	    ];
	  };
	
	  return forward;
	}
	
	var loximuthal = function() {
	  return parallel1(loximuthalRaw)
	      .parallel(40)
	      .scale(158.837);
	};
	
	function millerRaw(lambda, phi) {
	  return [lambda, 1.25 * log(tan(quarterPi + 0.4 * phi))];
	}
	
	millerRaw.invert = function(x, y) {
	  return [x, 2.5 * atan(exp(0.8 * y)) - 0.625 * pi];
	};
	
	var miller = function() {
	  return d3Geo.geoProjection(millerRaw)
	      .scale(108.318);
	};
	
	function modifiedStereographicRaw(C) {
	  var m = C.length - 1;
	
	  function forward(lambda, phi) {
	    var cosPhi = cos(phi),
	        k = 2 / (1 + cosPhi * cos(lambda)),
	        zr = k * cosPhi * sin(lambda),
	        zi = k * sin(phi),
	        i = m,
	        w = C[i],
	        ar = w[0],
	        ai = w[1],
	        t;
	    while (--i >= 0) {
	      w = C[i];
	      ar = w[0] + zr * (t = ar) - zi * ai;
	      ai = w[1] + zr * ai + zi * t;
	    }
	    ar = zr * (t = ar) - zi * ai;
	    ai = zr * ai + zi * t;
	    return [ar, ai];
	  }
	
	  forward.invert = function(x, y) {
	    var i = 20,
	        zr = x,
	        zi = y;
	    do {
	      var j = m,
	          w = C[j],
	          ar = w[0],
	          ai = w[1],
	          br = 0,
	          bi = 0,
	          t;
	
	      while (--j >= 0) {
	        w = C[j];
	        br = ar + zr * (t = br) - zi * bi;
	        bi = ai + zr * bi + zi * t;
	        ar = w[0] + zr * (t = ar) - zi * ai;
	        ai = w[1] + zr * ai + zi * t;
	      }
	      br = ar + zr * (t = br) - zi * bi;
	      bi = ai + zr * bi + zi * t;
	      ar = zr * (t = ar) - zi * ai - x;
	      ai = zr * ai + zi * t - y;
	
	      var denominator = br * br + bi * bi, deltar, deltai;
	      zr -= deltar = (ar * br + ai * bi) / denominator;
	      zi -= deltai = (ai * br - ar * bi) / denominator;
	    } while (abs(deltar) + abs(deltai) > epsilon * epsilon && --i > 0);
	
	    if (i) {
	      var rho = sqrt(zr * zr + zi * zi),
	          c = 2 * atan(rho * 0.5),
	          sinc = sin(c);
	      return [atan2(zr * sinc, rho * cos(c)), rho ? asin(zi * sinc / rho) : 0];
	    }
	  };
	
	  return forward;
	}
	
	var alaska = [[0.9972523, 0], [0.0052513, -0.0041175], [0.0074606, 0.0048125], [-0.0153783, -0.1968253], [0.0636871, -0.1408027], [0.3660976, -0.2937382]];
	var gs48 = [[0.98879, 0], [0, 0], [-0.050909, 0], [0, 0], [0.075528, 0]];
	var gs50 = [[0.9842990, 0], [0.0211642, 0.0037608], [-0.1036018, -0.0575102], [-0.0329095, -0.0320119], [0.0499471, 0.1223335], [0.0260460, 0.0899805], [0.0007388, -0.1435792], [0.0075848, -0.1334108], [-0.0216473, 0.0776645], [-0.0225161, 0.0853673]];
	var miller$1 = [[0.9245, 0], [0, 0], [0.01943, 0]];
	var lee = [[0.721316, 0], [0, 0], [-0.00881625, -0.00617325]];
	
	function modifiedStereographicAlaska() {
	  return modifiedStereographic(alaska, [152, -64])
	      .scale(1500)
	      .center([-160.908, 62.4864])
	      .clipAngle(25);
	}
	
	function modifiedStereographicGs48() {
	  return modifiedStereographic(gs48, [95, -38])
	      .scale(1000)
	      .clipAngle(55)
	      .center([-96.5563, 38.8675]);
	}
	
	function modifiedStereographicGs50() {
	  return modifiedStereographic(gs50, [120, -45])
	      .scale(359.513)
	      .clipAngle(55)
	      .center([-117.474, 53.0628]);
	}
	
	function modifiedStereographicMiller() {
	  return modifiedStereographic(miller$1, [-20, -18])
	      .scale(209.091)
	      .center([20, 16.7214])
	      .clipAngle(82);
	}
	
	function modifiedStereographicLee() {
	  return modifiedStereographic(lee, [165, 10])
	      .scale(250)
	      .clipAngle(130)
	      .center([-165, -10]);
	}
	
	function modifiedStereographic(coefficients, rotate) {
	  var p = d3Geo.geoProjection(modifiedStereographicRaw(coefficients)).rotate(rotate).clipAngle(90),
	      r = d3Geo.geoRotation(rotate),
	      center = p.center;
	
	  delete p.rotate;
	
	  p.center = function(_) {
	    return arguments.length ? center(r(_)) : r.invert(center());
	  };
	
	  return p;
	}
	
	var sqrt6 = sqrt(6);
	var sqrt7 = sqrt(7);
	
	function mtFlatPolarParabolicRaw(lambda, phi) {
	  var theta = asin(7 * sin(phi) / (3 * sqrt6));
	  return [
	    sqrt6 * lambda * (2 * cos(2 * theta / 3) - 1) / sqrt7,
	    9 * sin(theta / 3) / sqrt7
	  ];
	}
	
	mtFlatPolarParabolicRaw.invert = function(x, y) {
	  var theta = 3 * asin(y * sqrt7 / 9);
	  return [
	    x * sqrt7 / (sqrt6 * (2 * cos(2 * theta / 3) - 1)),
	    asin(sin(theta) * 3 * sqrt6 / 7)
	  ];
	};
	
	var mtFlatPolarParabolic = function() {
	  return d3Geo.geoProjection(mtFlatPolarParabolicRaw)
	      .scale(164.859);
	};
	
	function mtFlatPolarQuarticRaw(lambda, phi) {
	  var k = (1 + sqrt1_2) * sin(phi),
	      theta = phi;
	  for (var i = 0, delta; i < 25; i++) {
	    theta -= delta = (sin(theta / 2) + sin(theta) - k) / (0.5 * cos(theta / 2) + cos(theta));
	    if (abs(delta) < epsilon) break;
	  }
	  return [
	    lambda * (1 + 2 * cos(theta) / cos(theta / 2)) / (3 * sqrt2),
	    2 * sqrt(3) * sin(theta / 2) / sqrt(2 + sqrt2)
	  ];
	}
	
	mtFlatPolarQuarticRaw.invert = function(x, y) {
	  var sinTheta_2 = y * sqrt(2 + sqrt2) / (2 * sqrt(3)),
	      theta = 2 * asin(sinTheta_2);
	  return [
	    3 * sqrt2 * x / (1 + 2 * cos(theta) / cos(theta / 2)),
	    asin((sinTheta_2 + sin(theta)) / (1 + sqrt1_2))
	  ];
	};
	
	var mtFlatPolarQuartic = function() {
	  return d3Geo.geoProjection(mtFlatPolarQuarticRaw)
	      .scale(188.209);
	};
	
	function mtFlatPolarSinusoidalRaw(lambda, phi) {
	  var A = sqrt(6 / (4 + pi)),
	      k = (1 + pi / 4) * sin(phi),
	      theta = phi / 2;
	  for (var i = 0, delta; i < 25; i++) {
	    theta -= delta = (theta / 2 + sin(theta) - k) / (0.5 + cos(theta));
	    if (abs(delta) < epsilon) break;
	  }
	  return [
	    A * (0.5 + cos(theta)) * lambda / 1.5,
	    A * theta
	  ];
	}
	
	mtFlatPolarSinusoidalRaw.invert = function(x, y) {
	  var A = sqrt(6 / (4 + pi)),
	      theta = y / A;
	  if (abs(abs(theta) - halfPi) < epsilon) theta = theta < 0 ? -halfPi : halfPi;
	  return [
	    1.5 * x / (A * (0.5 + cos(theta))),
	    asin((theta / 2 + sin(theta)) / (1 + pi / 4))
	  ];
	};
	
	var mtFlatPolarSinusoidal = function() {
	  return d3Geo.geoProjection(mtFlatPolarSinusoidalRaw)
	      .scale(166.518);
	};
	
	function naturalEarthRaw(lambda, phi) {
	  var phi2 = phi * phi, phi4 = phi2 * phi2;
	  return [
	    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
	    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
	  ];
	}
	
	naturalEarthRaw.invert = function(x, y) {
	  var phi = y, i = 25, delta;
	  do {
	    var phi2 = phi * phi, phi4 = phi2 * phi2;
	    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
	        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
	  } while (abs(delta) > epsilon && --i > 0);
	  return [
	    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
	    phi
	  ];
	};
	
	var naturalEarth = function() {
	  return d3Geo.geoProjection(naturalEarthRaw)
	      .scale(175.295);
	};
	
	function nellHammerRaw(lambda, phi) {
	  return [
	    lambda * (1 + cos(phi)) / 2,
	    2 * (phi - tan(phi / 2))
	  ];
	}
	
	nellHammerRaw.invert = function(x, y) {
	  var p = y / 2;
	  for (var i = 0, delta = Infinity; i < 10 && abs(delta) > epsilon; ++i) {
	    var c = cos(y / 2);
	    y -= delta = (y - tan(y / 2) - p) / (1 - 0.5 / (c * c));
	  }
	  return [
	    2 * x / (1 + cos(y)),
	    y
	  ];
	};
	
	var nellHammer = function() {
	  return d3Geo.geoProjection(nellHammerRaw)
	      .scale(152.63);
	};
	
	// Based on Java implementation by Bojan Savric.
	// https://github.com/OSUCartography/JMapProjLib/blob/master/src/com/jhlabs/map/proj/PattersonProjection.java
	
	var pattersonK1 = 1.0148;
	var pattersonK2 = 0.23185;
	var pattersonK3 = -0.14499;
	var pattersonK4 = 0.02406;
	var pattersonC1 = pattersonK1;
	var pattersonC2 = 5 * pattersonK2;
	var pattersonC3 = 7 * pattersonK3;
	var pattersonC4 = 9 * pattersonK4;
	var pattersonYmax = 1.790857183;
	
	function pattersonRaw(lambda, phi) {
	  var phi2 = phi * phi;
	  return [
	    lambda,
	    phi * (pattersonK1 + phi2 * phi2 * (pattersonK2 + phi2 * (pattersonK3 + pattersonK4 * phi2)))
	  ];
	}
	
	pattersonRaw.invert = function(x, y) {
	  if (y > pattersonYmax) y = pattersonYmax;
	  else if (y < -pattersonYmax) y = -pattersonYmax;
	  var yc = y, delta;
	
	  do { // Newton-Raphson
	    var y2 = yc * yc;
	    yc -= delta = ((yc * (pattersonK1 + y2 * y2 * (pattersonK2 + y2 * (pattersonK3 + pattersonK4 * y2)))) - y) / (pattersonC1 + y2 * y2 * (pattersonC2 + y2 * (pattersonC3 + pattersonC4 * y2)));
	  } while (abs(delta) > epsilon);
	
	  return [x, yc];
	};
	
	var patterson = function() {
	  return d3Geo.geoProjection(pattersonRaw)
	      .scale(139.319);
	};
	
	function polyconicRaw(lambda, phi) {
	  if (abs(phi) < epsilon) return [lambda, 0];
	  var tanPhi = tan(phi),
	      k = lambda * sin(phi);
	  return [
	    sin(k) / tanPhi,
	    phi + (1 - cos(k)) / tanPhi
	  ];
	}
	
	polyconicRaw.invert = function(x, y) {
	  if (abs(y) < epsilon) return [x, 0];
	  var k = x * x + y * y,
	      phi = y * 0.5,
	      i = 10, delta;
	  do {
	    var tanPhi = tan(phi),
	        secPhi = 1 / cos(phi),
	        j = k - 2 * y * phi + phi * phi;
	    phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
	  } while (abs(delta) > epsilon && --i > 0);
	  tanPhi = tan(phi);
	  return [
	    (abs(y) < abs(phi + 1 / tanPhi) ? asin(x * tanPhi) : sign(x) * (acos(abs(x * tanPhi)) + halfPi)) / sin(phi),
	    phi
	  ];
	};
	
	var polyconic = function() {
	  return d3Geo.geoProjection(polyconicRaw)
	      .scale(103.74);
	};
	
	// Note: 6-element arrays are used to denote the 3x3 affine transform matrix:
	// [a, b, c,
	//  d, e, f,
	//  0, 0, 1] - this redundant row is left out.
	
	// Transform matrix for [a0, a1] -> [b0, b1].
	var matrix = function(a, b) {
	  var u = subtract(a[1], a[0]),
	      v = subtract(b[1], b[0]),
	      phi = angle$1(u, v),
	      s = length(u) / length(v);
	
	  return multiply([
	    1, 0, a[0][0],
	    0, 1, a[0][1]
	  ], multiply([
	    s, 0, 0,
	    0, s, 0
	  ], multiply([
	    cos(phi), sin(phi), 0,
	    -sin(phi), cos(phi), 0
	  ], [
	    1, 0, -b[0][0],
	    0, 1, -b[0][1]
	  ])));
	};
	
	// Inverts a transform matrix.
	function inverse(m) {
	  var k = 1 / (m[0] * m[4] - m[1] * m[3]);
	  return [
	    k * m[4], -k * m[1], k * (m[1] * m[5] - m[2] * m[4]),
	    -k * m[3], k * m[0], k * (m[2] * m[3] - m[0] * m[5])
	  ];
	}
	
	// Multiplies two 3x2 matrices.
	function multiply(a, b) {
	  return [
	    a[0] * b[0] + a[1] * b[3],
	    a[0] * b[1] + a[1] * b[4],
	    a[0] * b[2] + a[1] * b[5] + a[2],
	    a[3] * b[0] + a[4] * b[3],
	    a[3] * b[1] + a[4] * b[4],
	    a[3] * b[2] + a[4] * b[5] + a[5]
	  ];
	}
	
	// Subtracts 2D vectors.
	function subtract(a, b) {
	  return [a[0] - b[0], a[1] - b[1]];
	}
	
	// Magnitude of a 2D vector.
	function length(v) {
	  return sqrt(v[0] * v[0] + v[1] * v[1]);
	}
	
	// Angle between two 2D vectors.
	function angle$1(a, b) {
	  return atan2(a[0] * b[1] - a[1] * b[0], a[0] * b[0] + a[1] * b[1]);
	}
	
	// Creates a polyhedral projection.
	//  * root: a spanning tree of polygon faces.  Nodes are automatically
	//    augmented with a transform matrix.
	//  * face: a function that returns the appropriate node for a given {lambda, phi}
	//    point (radians).
	//  * r: rotation angle for final polyhedral net.  Defaults to -pi / 6 (for
	//    butterflies).
	var polyhedral = function(root, face, r) {
	
	  r = r == null ? -pi / 6 : r; // TODO automate
	
	  recurse(root, {transform: [
	    cos(r), sin(r), 0,
	    -sin(r), cos(r), 0
	  ]});
	
	  function recurse(node, parent) {
	    node.edges = faceEdges(node.face);
	    // Find shared edge.
	    if (parent.face) {
	      var shared = node.shared = sharedEdge(node.face, parent.face),
	          m = matrix(shared.map(parent.project), shared.map(node.project));
	      node.transform = parent.transform ? multiply(parent.transform, m) : m;
	      // Replace shared edge in parent edges array.
	      var edges = parent.edges;
	      for (var i = 0, n = edges.length; i < n; ++i) {
	        if (pointEqual$1(shared[0], edges[i][1]) && pointEqual$1(shared[1], edges[i][0])) edges[i] = node;
	        if (pointEqual$1(shared[0], edges[i][0]) && pointEqual$1(shared[1], edges[i][1])) edges[i] = node;
	      }
	      edges = node.edges;
	      for (i = 0, n = edges.length; i < n; ++i) {
	        if (pointEqual$1(shared[0], edges[i][0]) && pointEqual$1(shared[1], edges[i][1])) edges[i] = parent;
	        if (pointEqual$1(shared[0], edges[i][1]) && pointEqual$1(shared[1], edges[i][0])) edges[i] = parent;
	      }
	    } else {
	      node.transform = parent.transform;
	    }
	    if (node.children) {
	      node.children.forEach(function(child) {
	        recurse(child, node);
	      });
	    }
	    return node;
	  }
	
	  function forward(lambda, phi) {
	    var node = face(lambda, phi),
	        point = node.project([lambda * degrees, phi * degrees]),
	        t;
	    if (t = node.transform) {
	      return [
	        t[0] * point[0] + t[1] * point[1] + t[2],
	        -(t[3] * point[0] + t[4] * point[1] + t[5])
	      ];
	    }
	    point[1] = -point[1];
	    return point;
	  }
	
	  // Naive inverse!  A faster solution would use bounding boxes, or even a
	  // polygonal quadtree.
	  if (hasInverse(root)) forward.invert = function(x, y) {
	    var coordinates = faceInvert(root, [x, -y]);
	    return coordinates && (coordinates[0] *= radians, coordinates[1] *= radians, coordinates);
	  };
	
	  function faceInvert(node, coordinates) {
	    var invert = node.project.invert,
	        t = node.transform,
	        point = coordinates;
	    if (t) {
	      t = inverse(t);
	      point = [
	        t[0] * point[0] + t[1] * point[1] + t[2],
	        (t[3] * point[0] + t[4] * point[1] + t[5])
	      ];
	    }
	    if (invert && node === faceDegrees(p = invert(point))) return p;
	    var p,
	        children = node.children;
	    for (var i = 0, n = children && children.length; i < n; ++i) {
	      if (p = faceInvert(children[i], coordinates)) return p;
	    }
	  }
	
	  function faceDegrees(coordinates) {
	    return face(coordinates[0] * radians, coordinates[1] * radians);
	  }
	
	  var proj = d3Geo.geoProjection(forward),
	      stream_ = proj.stream;
	
	  proj.stream = function(stream) {
	    var rotate = proj.rotate(),
	        rotateStream = stream_(stream),
	        sphereStream = (proj.rotate([0, 0]), stream_(stream));
	    proj.rotate(rotate);
	    rotateStream.sphere = function() {
	      sphereStream.polygonStart();
	      sphereStream.lineStart();
	      outline(sphereStream, root);
	      sphereStream.lineEnd();
	      sphereStream.polygonEnd();
	    };
	    return rotateStream;
	  };
	
	  return proj;
	};
	
	function outline(stream, node, parent) {
	  var point,
	      edges = node.edges,
	      n = edges.length,
	      edge,
	      multiPoint = {type: "MultiPoint", coordinates: node.face},
	      notPoles = node.face.filter(function(d) { return abs(d[1]) !== 90; }),
	      b = d3Geo.geoBounds({type: "MultiPoint", coordinates: notPoles}),
	      inside = false,
	      j = -1,
	      dx = b[1][0] - b[0][0];
	  // TODO
	  var c = dx === 180 || dx === 360
	      ? [(b[0][0] + b[1][0]) / 2, (b[0][1] + b[1][1]) / 2]
	      : d3Geo.geoCentroid(multiPoint);
	  // First find the shared edge…
	  if (parent) while (++j < n) {
	    if (edges[j] === parent) break;
	  }
	  ++j;
	  for (var i = 0; i < n; ++i) {
	    edge = edges[(i + j) % n];
	    if (Array.isArray(edge)) {
	      if (!inside) {
	        stream.point((point = d3Geo.geoInterpolate(edge[0], c)(epsilon))[0], point[1]);
	        inside = true;
	      }
	      stream.point((point = d3Geo.geoInterpolate(edge[1], c)(epsilon))[0], point[1]);
	    } else {
	      inside = false;
	      if (edge !== parent) outline(stream, edge, node);
	    }
	  }
	}
	
	// Tests equality of two spherical points.
	function pointEqual$1(a, b) {
	  return a && b && a[0] === b[0] && a[1] === b[1];
	}
	
	// Finds a shared edge given two clockwise polygons.
	function sharedEdge(a, b) {
	  var x, y, n = a.length, found = null;
	  for (var i = 0; i < n; ++i) {
	    x = a[i];
	    for (var j = b.length; --j >= 0;) {
	      y = b[j];
	      if (x[0] === y[0] && x[1] === y[1]) {
	        if (found) return [found, x];
	        found = x;
	      }
	    }
	  }
	}
	
	// Converts an array of n face vertices to an array of n + 1 edges.
	function faceEdges(face) {
	  var n = face.length,
	      edges = [];
	  for (var a = face[n - 1], i = 0; i < n; ++i) edges.push([a, a = face[i]]);
	  return edges;
	}
	
	function hasInverse(node) {
	  return node.project.invert || node.children && node.children.some(hasInverse);
	}
	
	// TODO generate on-the-fly to avoid external modification.
	var octahedron = [
	  [0, 90],
	  [-90, 0], [0, 0], [90, 0], [180, 0],
	  [0, -90]
	];
	
	var octahedron$1 = [
	  [0, 2, 1],
	  [0, 3, 2],
	  [5, 1, 2],
	  [5, 2, 3],
	  [0, 1, 4],
	  [0, 4, 3],
	  [5, 4, 1],
	  [5, 3, 4]
	].map(function(face) {
	  return face.map(function(i) {
	    return octahedron[i];
	  });
	});
	
	var butterfly = function(faceProjection) {
	
	  faceProjection = faceProjection || function(face) {
	    var c = d3Geo.geoCentroid({type: "MultiPoint", coordinates: face});
	    return d3Geo.geoGnomonic().scale(1).translate([0, 0]).rotate([-c[0], -c[1]]);
	  };
	
	  var faces = octahedron$1.map(function(face) {
	    return {face: face, project: faceProjection(face)};
	  });
	
	  [-1, 0, 0, 1, 0, 1, 4, 5].forEach(function(d, i) {
	    var node = faces[d];
	    node && (node.children || (node.children = [])).push(faces[i]);
	  });
	
	  return polyhedral(faces[0], function(lambda, phi) {
	        return faces[lambda < -pi / 2 ? phi < 0 ? 6 : 4
	            : lambda < 0 ? phi < 0 ? 2 : 0
	            : lambda < pi / 2 ? phi < 0 ? 3 : 1
	            : phi < 0 ? 7 : 5];
	      })
	      .scale(101.858)
	      .center([0, 45]);
	};
	
	var kx = 2 / sqrt(3);
	
	function collignonK(a, b) {
	  var p = collignonRaw(a, b);
	  return [p[0] * kx, p[1]];
	}
	
	collignonK.invert = function(x,y) {
	  return collignonRaw.invert(x / kx, y);
	};
	
	var collignon$1 = function(faceProjection) {
	
	  faceProjection = faceProjection || function(face) {
	    var c = d3Geo.geoCentroid({type: "MultiPoint", coordinates: face});
	    return d3Geo.geoProjection(collignonK).translate([0, 0]).scale(1).rotate(c[1] > 0 ? [-c[0], 0] : [180 - c[0], 180]);
	  };
	
	  var faces = octahedron$1.map(function(face) {
	    return {face: face, project: faceProjection(face)};
	  });
	
	  [-1, 0, 0, 1, 0, 1, 4, 5].forEach(function(d, i) {
	    var node = faces[d];
	    node && (node.children || (node.children = [])).push(faces[i]);
	  });
	
	  return polyhedral(faces[0], function(lambda, phi) {
	        return faces[lambda < -pi / 2 ? phi < 0 ? 6 : 4
	            : lambda < 0 ? phi < 0 ? 2 : 0
	            : lambda < pi / 2 ? phi < 0 ? 3 : 1
	            : phi < 0 ? 7 : 5];
	      })
	      .scale(121.906)
	      .center([0, 48.5904]);
	};
	
	var waterman = function(faceProjection) {
	
	  faceProjection = faceProjection || function(face) {
	    var c = face.length === 6 ? d3Geo.geoCentroid({type: "MultiPoint", coordinates: face}) : face[0];
	    return d3Geo.geoGnomonic().scale(1).translate([0, 0]).rotate([-c[0], -c[1]]);
	  };
	
	  var w5 = octahedron$1.map(function(face) {
	    var xyz = face.map(cartesian),
	        n = xyz.length,
	        a = xyz[n - 1],
	        b,
	        hexagon = [];
	    for (var i = 0; i < n; ++i) {
	      b = xyz[i];
	      hexagon.push(spherical([
	        a[0] * 0.9486832980505138 + b[0] * 0.31622776601683794,
	        a[1] * 0.9486832980505138 + b[1] * 0.31622776601683794,
	        a[2] * 0.9486832980505138 + b[2] * 0.31622776601683794
	      ]), spherical([
	        b[0] * 0.9486832980505138 + a[0] * 0.31622776601683794,
	        b[1] * 0.9486832980505138 + a[1] * 0.31622776601683794,
	        b[2] * 0.9486832980505138 + a[2] * 0.31622776601683794
	      ]));
	      a = b;
	    }
	    return hexagon;
	  });
	
	  var cornerNormals = [];
	
	  var parents = [-1, 0, 0, 1, 0, 1, 4, 5];
	
	  w5.forEach(function(hexagon, j) {
	    var face = octahedron$1[j],
	        n = face.length,
	        normals = cornerNormals[j] = [];
	    for (var i = 0; i < n; ++i) {
	      w5.push([
	        face[i],
	        hexagon[(i * 2 + 2) % (2 * n)],
	        hexagon[(i * 2 + 1) % (2 * n)]
	      ]);
	      parents.push(j);
	      normals.push(cross(
	        cartesian(hexagon[(i * 2 + 2) % (2 * n)]),
	        cartesian(hexagon[(i * 2 + 1) % (2 * n)])
	      ));
	    }
	  });
	
	  var faces = w5.map(function(face) {
	    return {
	      project: faceProjection(face),
	      face: face
	    };
	  });
	
	  parents.forEach(function(d, i) {
	    var parent = faces[d];
	    parent && (parent.children || (parent.children = [])).push(faces[i]);
	  });
	
	  function face(lambda, phi) {
	    var cosphi = cos(phi),
	        p = [cosphi * cos(lambda), cosphi * sin(lambda), sin(phi)];
	
	    var hexagon = lambda < -pi / 2 ? phi < 0 ? 6 : 4
	        : lambda < 0 ? phi < 0 ? 2 : 0
	        : lambda < pi / 2 ? phi < 0 ? 3 : 1
	        : phi < 0 ? 7 : 5;
	
	    var n = cornerNormals[hexagon];
	
	    return faces[dot(n[0], p) < 0 ? 8 + 3 * hexagon
	        : dot(n[1], p) < 0 ? 8 + 3 * hexagon + 1
	        : dot(n[2], p) < 0 ? 8 + 3 * hexagon + 2
	        : hexagon];
	  }
	
	  return polyhedral(faces[0], face)
	      .scale(110.625)
	      .center([0,45]);
	};
	
	function dot(a, b) {
	  for (var i = 0, n = a.length, s = 0; i < n; ++i) s += a[i] * b[i];
	  return s;
	}
	
	function cross(a, b) {
	  return [
	    a[1] * b[2] - a[2] * b[1],
	    a[2] * b[0] - a[0] * b[2],
	    a[0] * b[1] - a[1] * b[0]
	  ];
	}
	
	// Converts 3D Cartesian to spherical coordinates (degrees).
	function spherical(cartesian) {
	  return [
	    atan2(cartesian[1], cartesian[0]) * degrees,
	    asin(max(-1, min(1, cartesian[2]))) * degrees
	  ];
	}
	
	// Converts spherical coordinates (degrees) to 3D Cartesian.
	function cartesian(coordinates) {
	  var lambda = coordinates[0] * radians,
	      phi = coordinates[1] * radians,
	      cosphi = cos(phi);
	  return [
	    cosphi * cos(lambda),
	    cosphi * sin(lambda),
	    sin(phi)
	  ];
	}
	
	var noop = function() {};
	
	var clockwise = function(ring) {
	  if ((n = ring.length) < 4) return false;
	  var i = 0,
	      n,
	      area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
	  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
	  return area <= 0;
	};
	
	var contains = function(ring, point) {
	  var x = point[0],
	      y = point[1],
	      contains = false;
	  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
	    var pi = ring[i], xi = pi[0], yi = pi[1],
	        pj = ring[j], xj = pj[0], yj = pj[1];
	    if (((yi > y) ^ (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) contains = !contains;
	  }
	  return contains;
	};
	
	var index = function(object, projection) {
	  var stream = projection.stream, project;
	  if (!stream) throw new Error("invalid projection");
	  switch (object && object.type) {
	    case "Feature": project = projectFeature; break;
	    case "FeatureCollection": project = projectFeatureCollection; break;
	    default: project = projectGeometry; break;
	  }
	  return project(object, stream);
	};
	
	function projectFeatureCollection(o, stream) {
	  return {
	    type: "FeatureCollection",
	    features: o.features.map(function(f) {
	      return projectFeature(f, stream);
	    })
	  };
	}
	
	function projectFeature(o, stream) {
	  return {
	    type: "Feature",
	    id: o.id,
	    properties: o.properties,
	    geometry: projectGeometry(o.geometry, stream)
	  };
	}
	
	function projectGeometryCollection(o, stream) {
	  return {
	    type: "GeometryCollection",
	    geometries: o.geometries.map(function(o) {
	      return projectGeometry(o, stream);
	    })
	  };
	}
	
	function projectGeometry(o, stream) {
	  if (!o) return null;
	  if (o.type === "GeometryCollection") return projectGeometryCollection(o, stream);
	  var sink;
	  switch (o.type) {
	    case "Point": sink = sinkPoint; break;
	    case "MultiPoint": sink = sinkPoint; break;
	    case "LineString": sink = sinkLine; break;
	    case "MultiLineString": sink = sinkLine; break;
	    case "Polygon": sink = sinkPolygon; break;
	    case "MultiPolygon": sink = sinkPolygon; break;
	    case "Sphere": sink = sinkPolygon; break;
	    default: return null;
	  }
	  d3Geo.geoStream(o, stream(sink));
	  return sink.result();
	}
	
	var points = [];
	var lines = [];
	
	var sinkPoint = {
	  point: function(x, y) {
	    points.push([x, y]);
	  },
	  result: function() {
	    var result = !points.length ? null
	        : points.length < 2 ? {type: "Point", coordinates: points[0]}
	        : {type: "MultiPoint", coordinates: points};
	    points = [];
	    return result;
	  }
	};
	
	var sinkLine = {
	  lineStart: noop,
	  point: function(x, y) {
	    points.push([x, y]);
	  },
	  lineEnd: function() {
	    if (points.length) lines.push(points), points = [];
	  },
	  result: function() {
	    var result = !lines.length ? null
	        : lines.length < 2 ? {type: "LineString", coordinates: lines[0]}
	        : {type: "MultiLineString", coordinates: lines};
	    lines = [];
	    return result;
	  }
	};
	
	var sinkPolygon = {
	  polygonStart: noop,
	  lineStart: noop,
	  point: function(x, y) {
	    points.push([x, y]);
	  },
	  lineEnd: function() {
	    var n = points.length;
	    if (n) {
	      do points.push(points[0].slice()); while (++n < 4);
	      lines.push(points), points = [];
	    }
	  },
	  polygonEnd: noop,
	  result: function() {
	    if (!lines.length) return null;
	    var polygons = [],
	        holes = [];
	
	    // https://github.com/d3/d3/issues/1558
	    lines.forEach(function(ring) {
	      if (clockwise(ring)) polygons.push([ring]);
	      else holes.push(ring);
	    });
	
	    holes.forEach(function(hole) {
	      var point = hole[0];
	      polygons.some(function(polygon) {
	        if (contains(polygon[0], point)) {
	          polygon.push(hole);
	          return true;
	        }
	      }) || polygons.push([hole]);
	    });
	
	    lines = [];
	
	    return !polygons.length ? null
	        : polygons.length > 1 ? {type: "MultiPolygon", coordinates: polygons}
	        : {type: "Polygon", coordinates: polygons[0]};
	  }
	};
	
	var quincuncial = function(project) {
	  var dx = project(halfPi, 0)[0] - project(-halfPi, 0)[0];
	
	  function projectQuincuncial(lambda, phi) {
	    var t = abs(lambda) < halfPi,
	        p = project(t ? lambda : lambda > 0 ? lambda - pi : lambda + pi, phi),
	        x = (p[0] - p[1]) * sqrt1_2,
	        y = (p[0] + p[1]) * sqrt1_2;
	    if (t) return [x, y];
	    var d = dx * sqrt1_2,
	        s = x > 0 ^ y > 0 ? -1 : 1;
	    return [s * x - sign(y) * d, s * y - sign(x) * d];
	  }
	
	  if (project.invert) projectQuincuncial.invert = function(x0, y0) {
	    var x = (x0 + y0) * sqrt1_2,
	        y = (y0 - x0) * sqrt1_2,
	        t = abs(x) < 0.5 * dx && abs(y) < 0.5 * dx;
	
	    if (!t) {
	      var d = dx * sqrt1_2,
	          s = x > 0 ^ y > 0 ? -1 : 1,
	          x1 = -s * (x0 + (y > 0 ? 1 : -1) * d),
	          y1 = -s * (y0 + (x > 0 ? 1 : -1) * d);
	      x = (-x1 - y1) * sqrt1_2;
	      y = (x1 - y1) * sqrt1_2;
	    }
	
	    var p = project.invert(x, y);
	    if (!t) p[0] += x > 0 ? pi : -pi;
	    return p;
	  };
	
	  return d3Geo.geoProjection(projectQuincuncial)
	      .rotate([-90, -90, 45])
	      .clipAngle(180 - 1e-3);
	};
	
	var gringorten$1 = function() {
	  return quincuncial(gringortenRaw)
	      .scale(176.423);
	};
	
	var peirce = function() {
	  return quincuncial(guyouRaw)
	      .scale(111.48);
	};
	
	var quantize = function(o, digits) {
	  if (!(0 <= (digits = +digits) && digits <= 20)) throw new Error("invalid digits");
	
	  function quantizePoint(coordinates) {
	    coordinates[0] = +coordinates[0].toFixed(digits);
	    coordinates[1] = +coordinates[1].toFixed(digits);
	  }
	
	  function quantizePoints(coordinates) {
	    coordinates.forEach(quantizePoint);
	  }
	
	  function quantizePolygon(coordinates) {
	    coordinates.forEach(quantizePoints);
	  }
	
	  function quantizeGeometry(o) {
	    if (o) switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(quantizeGeometry); break;
	      case "Point": quantizePoint(o.coordinates); break;
	      case "MultiPoint": case "LineString": quantizePoints(o.coordinates); break;
	      case "MultiLineString": case "Polygon": quantizePolygon(o.coordinates); break;
	      case "MultiPolygon": o.coordinates.forEach(quantizePolygon); break;
	      default: return;
	    }
	  }
	
	  function quantizeFeature(o) {
	    quantizeGeometry(o.geometry);
	  }
	
	  if (o) switch (o.type) {
	    case "Feature": quantizeFeature(o); break;
	    case "FeatureCollection": o.features.forEach(quantizeFeature); break;
	    default: quantizeGeometry(o); break;
	  }
	
	  return o;
	};
	
	function rectangularPolyconicRaw(phi0) {
	  var sinPhi0 = sin(phi0);
	
	  function forward(lambda, phi) {
	    var A = sinPhi0 ? tan(lambda * sinPhi0 / 2) / sinPhi0 : lambda / 2;
	    if (!phi) return [2 * A, -phi0];
	    var E = 2 * atan(A * sin(phi)),
	        cotPhi = 1 / tan(phi);
	    return [
	      sin(E) * cotPhi,
	      phi + (1 - cos(E)) * cotPhi - phi0
	    ];
	  }
	
	  // TODO return null for points outside outline.
	  forward.invert = function(x, y) {
	    if (abs(y += phi0) < epsilon) return [sinPhi0 ? 2 * atan(sinPhi0 * x / 2) / sinPhi0 : x, 0];
	    var k = x * x + y * y,
	        phi = 0,
	        i = 10, delta;
	    do {
	      var tanPhi = tan(phi),
	          secPhi = 1 / cos(phi),
	          j = k - 2 * y * phi + phi * phi;
	      phi -= delta = (tanPhi * j + 2 * (phi - y)) / (2 + j * secPhi * secPhi + 2 * (phi - y) * tanPhi);
	    } while (abs(delta) > epsilon && --i > 0);
	    var E = x * (tanPhi = tan(phi)),
	        A = tan(abs(y) < abs(phi + 1 / tanPhi) ? asin(E) * 0.5 : acos(E) * 0.5 + pi / 4) / sin(phi);
	    return [
	      sinPhi0 ? 2 * atan(sinPhi0 * A) / sinPhi0 : 2 * A,
	      phi
	    ];
	  };
	
	  return forward;
	}
	
	var rectangularPolyconic = function() {
	  return parallel1(rectangularPolyconicRaw)
	      .scale(131.215);
	};
	
	var K = [
	  [0.9986, -0.062],
	  [1.0000, 0.0000],
	  [0.9986, 0.0620],
	  [0.9954, 0.1240],
	  [0.9900, 0.1860],
	  [0.9822, 0.2480],
	  [0.9730, 0.3100],
	  [0.9600, 0.3720],
	  [0.9427, 0.4340],
	  [0.9216, 0.4958],
	  [0.8962, 0.5571],
	  [0.8679, 0.6176],
	  [0.8350, 0.6769],
	  [0.7986, 0.7346],
	  [0.7597, 0.7903],
	  [0.7186, 0.8435],
	  [0.6732, 0.8936],
	  [0.6213, 0.9394],
	  [0.5722, 0.9761],
	  [0.5322, 1.0000]
	];
	
	K.forEach(function(d) {
	  d[1] *= 1.0144;
	});
	
	function robinsonRaw(lambda, phi) {
	  var i = min(18, abs(phi) * 36 / pi),
	      i0 = floor(i),
	      di = i - i0,
	      ax = (k = K[i0])[0],
	      ay = k[1],
	      bx = (k = K[++i0])[0],
	      by = k[1],
	      cx = (k = K[min(19, ++i0)])[0],
	      cy = k[1],
	      k;
	  return [
	    lambda * (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
	    (phi > 0 ? halfPi : -halfPi) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2)
	  ];
	}
	
	robinsonRaw.invert = function(x, y) {
	  var yy = y / halfPi,
	      phi = yy * 90,
	      i = min(18, abs(phi / 5)),
	      i0 = max(0, floor(i));
	  do {
	    var ay = K[i0][1],
	        by = K[i0 + 1][1],
	        cy = K[min(19, i0 + 2)][1],
	        u = cy - ay,
	        v = cy - 2 * by + ay,
	        t = 2 * (abs(yy) - by) / u,
	        c = v / u,
	        di = t * (1 - c * t * (1 - 2 * c * t));
	    if (di >= 0 || i0 === 1) {
	      phi = (y >= 0 ? 5 : -5) * (di + i);
	      var j = 50, delta;
	      do {
	        i = min(18, abs(phi) / 5);
	        i0 = floor(i);
	        di = i - i0;
	        ay = K[i0][1];
	        by = K[i0 + 1][1];
	        cy = K[min(19, i0 + 2)][1];
	        phi -= (delta = (y >= 0 ? halfPi : -halfPi) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2) - y) * degrees;
	      } while (abs(delta) > epsilon2 && --j > 0);
	      break;
	    }
	  } while (--i0 >= 0);
	  var ax = K[i0][0],
	      bx = K[i0 + 1][0],
	      cx = K[min(19, i0 + 2)][0];
	  return [
	    x / (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2),
	    phi * radians
	  ];
	};
	
	var robinson = function() {
	  return d3Geo.geoProjection(robinsonRaw)
	      .scale(152.63);
	};
	
	function satelliteVerticalRaw(P) {
	  function forward(lambda, phi) {
	    var cosPhi = cos(phi),
	        k = (P - 1) / (P - cosPhi * cos(lambda));
	    return [
	      k * cosPhi * sin(lambda),
	      k * sin(phi)
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var rho2 = x * x + y * y,
	        rho = sqrt(rho2),
	        sinc = (P - sqrt(1 - rho2 * (P + 1) / (P - 1))) / ((P - 1) / rho + rho / (P - 1));
	    return [
	      atan2(x * sinc, rho * sqrt(1 - sinc * sinc)),
	      rho ? asin(y * sinc / rho) : 0
	    ];
	  };
	
	  return forward;
	}
	
	function satelliteRaw(P, omega) {
	  var vertical = satelliteVerticalRaw(P);
	  if (!omega) return vertical;
	  var cosOmega = cos(omega),
	      sinOmega = sin(omega);
	
	  function forward(lambda, phi) {
	    var coordinates = vertical(lambda, phi),
	        y = coordinates[1],
	        A = y * sinOmega / (P - 1) + cosOmega;
	    return [
	      coordinates[0] * cosOmega / A,
	      y / A
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var k = (P - 1) / (P - 1 - y * sinOmega);
	    return vertical.invert(k * x, k * y * cosOmega);
	  };
	
	  return forward;
	}
	
	var satellite = function() {
	  var distance = 2,
	      omega = 0,
	      m = d3Geo.geoProjectionMutator(satelliteRaw),
	      p = m(distance, omega);
	
	  // As a multiple of radius.
	  p.distance = function(_) {
	    if (!arguments.length) return distance;
	    return m(distance = +_, omega);
	  };
	
	  p.tilt = function(_) {
	    if (!arguments.length) return omega * degrees;
	    return m(distance, omega = _ * radians);
	  };
	
	  return p
	      .scale(432.147)
	      .clipAngle(acos(1 / distance) * degrees - 1e-6);
	};
	
	var epsilon$1 = 1e-4;
	var epsilonInverse = 1e4;
	var x0 = -180;
	var x0e = x0 + epsilon$1;
	var x1 = 180;
	var x1e = x1 - epsilon$1;
	var y0 = -90;
	var y0e = y0 + epsilon$1;
	var y1 = 90;
	var y1e = y1 - epsilon$1;
	
	function quantize$1(x) {
	  return Math.floor(x * epsilonInverse) / epsilonInverse;
	}
	
	function normalizePoint(y) {
	  return y === y0 || y === y1
	      ? [0, y] // pole
	      : [x0, quantize$1(y)]; // antimeridian
	}
	
	function clampPoint(p) {
	  if (p[0] <= x0e) p[0] = x0;
	  else if (p[0] >= x1e) p[0] = x1;
	  if (p[1] <= y0e) p[1] = y0;
	  else if (p[1] >= y1e) p[1] = y1;
	}
	
	function clampPoints(points) {
	  points.forEach(clampPoint);
	}
	
	// For each ring, detect where it crosses the antimeridian or pole.
	function extractFragments(polygon, fragments) {
	  for (var j = 0, m = polygon.length; j < m; ++j) {
	    var ring = polygon[j];
	    ring.polygon = polygon;
	
	    // By default, assume that this ring doesn’t need any stitching.
	    fragments.push(ring);
	
	    for (var i = 0, n = ring.length; i < n; ++i) {
	      var point = ring[i],
	          x = point[0],
	          y = point[1];
	
	      // If this is an antimeridian or polar point…
	      if (x <= x0e || x >= x1e || y <= y0e || y >= y1e) {
	        clampPoint(point);
	
	        // Advance through any antimeridian or polar points…
	        for (var k = i + 1; k < n; ++k) {
	          var pointk = ring[k],
	              xk = pointk[0],
	              yk = pointk[1];
	          if (xk > x0e && xk < x1e && yk > y0e && yk < y1e) break;
	        }
	
	        // If this was just a single antimeridian or polar point,
	        // we don’t need to cut this ring into a fragment;
	        // we can just leave it as-is.
	        if (k === i + 1) continue;
	
	        // Otherwise, if this is not the first point in the ring,
	        // cut the current fragment so that it ends at the current point.
	        // The current point is also normalized for later joining.
	        if (i) {
	          var fragmentBefore = ring.slice(0, i + 1);
	          fragmentBefore.polygon = polygon;
	          fragmentBefore[fragmentBefore.length - 1] = normalizePoint(y);
	          fragments[fragments.length - 1] = fragmentBefore;
	        }
	
	        // If the ring started with an antimeridian fragment,
	        // we can ignore that fragment entirely.
	        else fragments.pop();
	
	        // If the remainder of the ring is an antimeridian fragment,
	        // move on to the next ring.
	        if (k >= n) break;
	
	        // Otherwise, add the remaining ring fragment and continue.
	        fragments.push(ring = ring.slice(k - 1));
	        ring[0] = normalizePoint(ring[0][1]);
	        ring.polygon = polygon;
	        i = -1;
	        n = ring.length;
	      }
	    }
	  }
	  polygon.length = 0;
	}
	
	// Now stitch the fragments back together into rings.
	// TODO remove empty polygons.
	function stitchFragments(fragments) {
	  var i, n = fragments.length;
	
	  // To connect the fragments start-to-end, create a simple index by end.
	  var fragmentByStart = {},
	      fragmentByEnd = {},
	      fragment,
	      start,
	      startFragment,
	      end,
	      endFragment;
	
	  // For each fragment…
	  for (i = 0; i < n; ++i) {
	    fragment = fragments[i];
	    start = fragment[0];
	    end = fragment[fragment.length - 1];
	
	    // If this fragment is closed, add it as a standalone ring.
	    if (start[0] === end[0] && start[1] === end[1]) {
	      fragment.polygon.push(fragment);
	      fragments[i] = null;
	      continue;
	    }
	
	    fragment.index = i;
	    fragmentByStart[start] = fragmentByEnd[end] = fragment;
	  }
	
	  // For each open fragment…
	  for (i = 0; i < n; ++i) {
	    fragment = fragments[i];
	    if (fragment) {
	      start = fragment[0];
	      end = fragment[fragment.length - 1];
	      startFragment = fragmentByEnd[start];
	      endFragment = fragmentByStart[end];
	
	      delete fragmentByStart[start];
	      delete fragmentByEnd[end];
	
	      // If this fragment is closed, add it as a standalone ring.
	      if (start[0] === end[0] && start[1] === end[1]) {
	        fragment.polygon.push(fragment);
	        continue;
	      }
	
	      if (startFragment) {
	        delete fragmentByEnd[start];
	        delete fragmentByStart[startFragment[0]];
	        startFragment.pop(); // drop the shared coordinate
	        fragments[startFragment.index] = null;
	        fragment = startFragment.concat(fragment);
	        fragment.polygon = startFragment.polygon;
	
	        if (startFragment === endFragment) {
	          // Connect both ends to this single fragment to create a ring.
	          fragment.polygon.push(fragment);
	        } else {
	          fragment.index = n++;
	          fragments.push(fragmentByStart[fragment[0]] = fragmentByEnd[fragment[fragment.length - 1]] = fragment);
	        }
	      } else if (endFragment) {
	        delete fragmentByStart[end];
	        delete fragmentByEnd[endFragment[endFragment.length - 1]];
	        fragment.pop(); // drop the shared coordinate
	        fragment = fragment.concat(endFragment);
	        fragment.polygon = endFragment.polygon;
	        fragment.index = n++;
	        fragments[endFragment.index] = null;
	        fragments.push(fragmentByStart[fragment[0]] = fragmentByEnd[fragment[fragment.length - 1]] = fragment);
	      } else {
	        fragment.push(fragment[0]); // close ring
	        fragment.polygon.push(fragment);
	      }
	    }
	  }
	}
	
	function stitchFeature(o) {
	  stitchGeometry(o.geometry);
	}
	
	function stitchGeometry(o) {
	  if (!o) return;
	  var fragments, i, n;
	
	  switch (o.type) {
	    case "GeometryCollection": {
	      o.geometries.forEach(stitchGeometry);
	      return;
	    }
	    case "Point": {
	      clampPoint(o.coordinates);
	      break;
	    }
	    case "MultiPoint":
	    case "LineString": {
	      clampPoints(o.coordinates);
	      break;
	    }
	    case "MultiLineString": {
	      o.coordinates.forEach(clampPoints);
	      break;
	    }
	    case "Polygon": {
	      extractFragments(o.coordinates, fragments = []);
	      break;
	    }
	    case "MultiPolygon": {
	      fragments = [], i = -1, n = o.coordinates.length;
	      while (++i < n) extractFragments(o.coordinates[i], fragments);
	      break;
	    }
	    default: return;
	  }
	
	  stitchFragments(fragments);
	}
	
	var stitch = function(o) {
	  if (o) switch (o.type) {
	    case "Feature": stitchFeature(o); break;
	    case "FeatureCollection": o.features.forEach(stitchFeature); break;
	    default: stitchGeometry(o); break;
	  }
	  return o;
	};
	
	function timesRaw(lambda, phi) {
	  var t = tan(phi / 2),
	      s = sin(quarterPi * t);
	  return [
	    lambda * (0.74482 - 0.34588 * s * s),
	    1.70711 * t
	  ];
	}
	
	timesRaw.invert = function(x, y) {
	  var t = y / 1.70711,
	      s = sin(quarterPi * t);
	  return [
	    x / (0.74482 - 0.34588 * s * s),
	    2 * atan(t)
	  ];
	};
	
	var times = function() {
	  return d3Geo.geoProjection(timesRaw)
	      .scale(146.153);
	};
	
	// Compute the origin as the midpoint of the two reference points.
	// Rotate one of the reference points by the origin.
	// Apply the spherical law of sines to compute gamma rotation.
	var twoPoint = function(raw, p0, p1) {
	  var i = d3Geo.geoInterpolate(p0, p1),
	      o = i(0.5),
	      a = d3Geo.geoRotation([-o[0], -o[1]])(p0),
	      b = i.distance / 2,
	      y = -asin(sin(a[1] * radians) / sin(b)),
	      R = [-o[0], -o[1], -(a[0] > 0 ? pi - y : y) * degrees],
	      p = d3Geo.geoProjection(raw(b)).rotate(R),
	      r = d3Geo.geoRotation(R),
	      center = p.center;
	
	  delete p.rotate;
	
	  p.center = function(_) {
	    return arguments.length ? center(r(_)) : r.invert(center());
	  };
	
	  return p
	      .clipAngle(90);
	};
	
	function twoPointAzimuthalRaw(d) {
	  var cosd = cos(d);
	
	  function forward(lambda, phi) {
	    var coordinates = d3Geo.geoGnomonicRaw(lambda, phi);
	    coordinates[0] *= cosd;
	    return coordinates;
	  }
	
	  forward.invert = function(x, y) {
	    return d3Geo.geoGnomonicRaw.invert(x / cosd, y);
	  };
	
	  return forward;
	}
	
	function twoPointAzimuthalUsa() {
	  return twoPointAzimuthal([-158, 21.5], [-77, 39])
	      .clipAngle(60)
	      .scale(400);
	}
	
	function twoPointAzimuthal(p0, p1) {
	  return twoPoint(twoPointAzimuthalRaw, p0, p1);
	}
	
	// TODO clip to ellipse
	function twoPointEquidistantRaw(z0) {
	  if (!(z0 *= 2)) return d3Geo.geoAzimuthalEquidistantRaw;
	  var lambdaa = -z0 / 2,
	      lambdab = -lambdaa,
	      z02 = z0 * z0,
	      tanLambda0 = tan(lambdab),
	      S = 0.5 / sin(lambdab);
	
	  function forward(lambda, phi) {
	    var za = acos(cos(phi) * cos(lambda - lambdaa)),
	        zb = acos(cos(phi) * cos(lambda - lambdab)),
	        ys = phi < 0 ? -1 : 1;
	    za *= za, zb *= zb;
	    return [
	      (za - zb) / (2 * z0),
	      ys * sqrt(4 * z02 * zb - (z02 - za + zb) * (z02 - za + zb)) / (2 * z0)
	    ];
	  }
	
	  forward.invert = function(x, y) {
	    var y2 = y * y,
	        cosza = cos(sqrt(y2 + (t = x + lambdaa) * t)),
	        coszb = cos(sqrt(y2 + (t = x + lambdab) * t)),
	        t,
	        d;
	    return [
	      atan2(d = cosza - coszb, t = (cosza + coszb) * tanLambda0),
	      (y < 0 ? -1 : 1) * acos(sqrt(t * t + d * d) * S)
	    ];
	  };
	
	  return forward;
	}
	
	function twoPointEquidistantUsa() {
	  return twoPointEquidistant([-158, 21.5], [-77, 39])
	      .clipAngle(130)
	      .scale(122.571);
	}
	
	function twoPointEquidistant(p0, p1) {
	  return twoPoint(twoPointEquidistantRaw, p0, p1);
	}
	
	function vanDerGrintenRaw(lambda, phi) {
	  if (abs(phi) < epsilon) return [lambda, 0];
	  var sinTheta = abs(phi / halfPi),
	      theta = asin(sinTheta);
	  if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, sign(phi) * pi * tan(theta / 2)];
	  var cosTheta = cos(theta),
	      A = abs(pi / lambda - lambda / pi) / 2,
	      A2 = A * A,
	      G = cosTheta / (sinTheta + cosTheta - 1),
	      P = G * (2 / sinTheta - 1),
	      P2 = P * P,
	      P2_A2 = P2 + A2,
	      G_P2 = G - P2,
	      Q = A2 + G;
	  return [
	    sign(lambda) * pi * (A * G_P2 + sqrt(A2 * G_P2 * G_P2 - P2_A2 * (G * G - P2))) / P2_A2,
	    sign(phi) * pi * (P * Q - A * sqrt((A2 + 1) * P2_A2 - Q * Q)) / P2_A2
	  ];
	}
	
	vanDerGrintenRaw.invert = function(x, y) {
	  if (abs(y) < epsilon) return [x, 0];
	  if (abs(x) < epsilon) return [0, halfPi * sin(2 * atan(y / pi))];
	  var x2 = (x /= pi) * x,
	      y2 = (y /= pi) * y,
	      x2_y2 = x2 + y2,
	      z = x2_y2 * x2_y2,
	      c1 = -abs(y) * (1 + x2_y2),
	      c2 = c1 - 2 * y2 + x2,
	      c3 = -2 * c1 + 1 + 2 * y2 + z,
	      d = y2 / c3 + (2 * c2 * c2 * c2 / (c3 * c3 * c3) - 9 * c1 * c2 / (c3 * c3)) / 27,
	      a1 = (c1 - c2 * c2 / (3 * c3)) / c3,
	      m1 = 2 * sqrt(-a1 / 3),
	      theta1 = acos(3 * d / (a1 * m1)) / 3;
	  return [
	    pi * (x2_y2 - 1 + sqrt(1 + 2 * (x2 - y2) + z)) / (2 * x),
	    sign(y) * pi * (-m1 * cos(theta1 + pi / 3) - c2 / (3 * c3))
	  ];
	};
	
	var vanDerGrinten = function() {
	  return d3Geo.geoProjection(vanDerGrintenRaw)
	      .scale(79.4183);
	};
	
	function vanDerGrinten2Raw(lambda, phi) {
	  if (abs(phi) < epsilon) return [lambda, 0];
	  var sinTheta = abs(phi / halfPi),
	      theta = asin(sinTheta);
	  if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, sign(phi) * pi * tan(theta / 2)];
	  var cosTheta = cos(theta),
	      A = abs(pi / lambda - lambda / pi) / 2,
	      A2 = A * A,
	      x1 = cosTheta * (sqrt(1 + A2) - A * cosTheta) / (1 + A2 * sinTheta * sinTheta);
	  return [
	    sign(lambda) * pi * x1,
	    sign(phi) * pi * sqrt(1 - x1 * (2 * A + x1))
	  ];
	}
	
	vanDerGrinten2Raw.invert = function(x, y) {
	  if (!x) return [0, halfPi * sin(2 * atan(y / pi))];
	  var x1 = abs(x / pi),
	      A = (1 - x1 * x1 - (y /= pi) * y) / (2 * x1),
	      A2 = A * A,
	      B = sqrt(A2 + 1);
	  return [
	    sign(x) * pi * (B - A),
	    sign(y) * halfPi * sin(2 * atan2(sqrt((1 - 2 * A * x1) * (A + B) - x1), sqrt(B + A + x1)))
	  ];
	};
	
	var vanDerGrinten2 = function() {
	  return d3Geo.geoProjection(vanDerGrinten2Raw)
	      .scale(79.4183);
	};
	
	function vanDerGrinten3Raw(lambda, phi) {
	  if (abs(phi) < epsilon) return [lambda, 0];
	  var sinTheta = phi / halfPi,
	      theta = asin(sinTheta);
	  if (abs(lambda) < epsilon || abs(abs(phi) - halfPi) < epsilon) return [0, pi * tan(theta / 2)];
	  var A = (pi / lambda - lambda / pi) / 2,
	      y1 = sinTheta / (1 + cos(theta));
	  return [
	    pi * (sign(lambda) * sqrt(A * A + 1 - y1 * y1) - A),
	    pi * y1
	  ];
	}
	
	vanDerGrinten3Raw.invert = function(x, y) {
	  if (!y) return [x, 0];
	  var y1 = y / pi,
	      A = (pi * pi * (1 - y1 * y1) - x * x) / (2 * pi * x);
	  return [
	    x ? pi * (sign(x) * sqrt(A * A + 1) - A) : 0,
	    halfPi * sin(2 * atan(y1))
	  ];
	};
	
	var vanDerGrinten3 = function() {
	  return d3Geo.geoProjection(vanDerGrinten3Raw)
	        .scale(79.4183);
	};
	
	function vanDerGrinten4Raw(lambda, phi) {
	  if (!phi) return [lambda, 0];
	  var phi0 = abs(phi);
	  if (!lambda || phi0 === halfPi) return [0, phi];
	  var B = phi0 / halfPi,
	      B2 = B * B,
	      C = (8 * B - B2 * (B2 + 2) - 5) / (2 * B2 * (B - 1)),
	      C2 = C * C,
	      BC = B * C,
	      B_C2 = B2 + C2 + 2 * BC,
	      B_3C = B + 3 * C,
	      lambda0 = lambda / halfPi,
	      lambda1 = lambda0 + 1 / lambda0,
	      D = sign(abs(lambda) - halfPi) * sqrt(lambda1 * lambda1 - 4),
	      D2 = D * D,
	      F = B_C2 * (B2 + C2 * D2 - 1) + (1 - B2) * (B2 * (B_3C * B_3C + 4 * C2) + 12 * BC * C2 + 4 * C2 * C2),
	      x1 = (D * (B_C2 + C2 - 1) + 2 * sqrt(F)) / (4 * B_C2 + D2);
	  return [
	    sign(lambda) * halfPi * x1,
	    sign(phi) * halfPi * sqrt(1 + D * abs(x1) - x1 * x1)
	  ];
	}
	
	vanDerGrinten4Raw.invert = function(x, y) {
	  var delta;
	  if (!x || !y) return [x, y];
	  y /= pi;
	  var x1 = sign(x) * x / halfPi,
	      D = (x1 * x1 - 1 + 4 * y * y) / abs(x1),
	      D2 = D * D,
	      B = 2 * y,
	      i = 50;
	  do {
	    var B2 = B * B,
	        C = (8 * B - B2 * (B2 + 2) - 5) / (2 * B2 * (B - 1)),
	        C_ = (3 * B - B2 * B - 10) / (2 * B2 * B),
	        C2 = C * C,
	        BC = B * C,
	        B_C = B + C,
	        B_C2 = B_C * B_C,
	        B_3C = B + 3 * C,
	        F = B_C2 * (B2 + C2 * D2 - 1) + (1 - B2) * (B2 * (B_3C * B_3C + 4 * C2) + C2 * (12 * BC + 4 * C2)),
	        F_ = -2 * B_C * (4 * BC * C2 + (1 - 4 * B2 + 3 * B2 * B2) * (1 + C_) + C2 * (-6 + 14 * B2 - D2 + (-8 + 8 * B2 - 2 * D2) * C_) + BC * (-8 + 12 * B2 + (-10 + 10 * B2 - D2) * C_)),
	        sqrtF = sqrt(F),
	        f = D * (B_C2 + C2 - 1) + 2 * sqrtF - x1 * (4 * B_C2 + D2),
	        f_ = D * (2 * C * C_ + 2 * B_C * (1 + C_)) + F_ / sqrtF - 8 * B_C * (D * (-1 + C2 + B_C2) + 2 * sqrtF) * (1 + C_) / (D2 + 4 * B_C2);
	    B -= delta = f / f_;
	  } while (delta > epsilon && --i > 0);
	  return [
	    sign(x) * (sqrt(D * D + 4) + D) * pi / 4,
	    halfPi * B
	  ];
	};
	
	var vanDerGrinten4 = function() {
	  return d3Geo.geoProjection(vanDerGrinten4Raw)
	      .scale(127.16);
	};
	
	var A = 4 * pi + 3 * sqrt(3);
	var B = 2 * sqrt(2 * pi * sqrt(3) / A);
	
	var wagner4Raw = mollweideBromleyRaw(B * sqrt(3) / pi, B, A / 6);
	
	var wagner4 = function() {
	  return d3Geo.geoProjection(wagner4Raw)
	      .scale(176.84);
	};
	
	function wagner6Raw(lambda, phi) {
	  return [lambda * sqrt(1 - 3 * phi * phi / (pi * pi)), phi];
	}
	
	wagner6Raw.invert = function(x, y) {
	  return [x / sqrt(1 - 3 * y * y / (pi * pi)), y];
	};
	
	var wagner6 = function() {
	  return d3Geo.geoProjection(wagner6Raw)
	      .scale(152.63);
	};
	
	function wagner7Raw(lambda, phi) {
	  var s = 0.90631 * sin(phi),
	      c0 = sqrt(1 - s * s),
	      c1 = sqrt(2 / (1 + c0 * cos(lambda /= 3)));
	  return [
	    2.66723 * c0 * c1 * sin(lambda),
	    1.24104 * s * c1
	  ];
	}
	
	wagner7Raw.invert = function(x, y) {
	  var t1 = x / 2.66723,
	      t2 = y / 1.24104,
	      p = sqrt(t1 * t1 + t2 * t2),
	      c = 2 * asin(p / 2);
	  return [
	    3 * atan2(x * tan(c), 2.66723 * p),
	    p && asin(y * sin(c) / (1.24104 * 0.90631 * p))
	  ];
	};
	
	var wagner7 = function() {
	  return d3Geo.geoProjection(wagner7Raw)
	      .scale(172.632);
	};
	
	function wiechelRaw(lambda, phi) {
	  var cosPhi = cos(phi),
	      sinPhi = cos(lambda) * cosPhi,
	      sin1_Phi = 1 - sinPhi,
	      cosLambda = cos(lambda = atan2(sin(lambda) * cosPhi, -sin(phi))),
	      sinLambda = sin(lambda);
	  cosPhi = sqrt(1 - sinPhi * sinPhi);
	  return [
	    sinLambda * cosPhi - cosLambda * sin1_Phi,
	    -cosLambda * cosPhi - sinLambda * sin1_Phi
	  ];
	}
	
	wiechelRaw.invert = function(x, y) {
	  var w = (x * x + y * y) / -2,
	      k = sqrt(-w * (2 + w)),
	      b = y * w + x * k,
	      a = x * w - y * k,
	      D = sqrt(a * a + b * b);
	  return [
	    atan2(k * b, D * (1 + w)),
	    D ? -asin(k * a / D) : 0
	  ];
	};
	
	var wiechel = function() {
	  return d3Geo.geoProjection(wiechelRaw)
	      .rotate([0, -90, 45])
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	};
	
	function winkel3Raw(lambda, phi) {
	  var coordinates = aitoffRaw(lambda, phi);
	  return [
	    (coordinates[0] + lambda / halfPi) / 2,
	    (coordinates[1] + phi) / 2
	  ];
	}
	
	winkel3Raw.invert = function(x, y) {
	  var lambda = x, phi = y, i = 25;
	  do {
	    var cosphi = cos(phi),
	        sinphi = sin(phi),
	        sin_2phi = sin(2 * phi),
	        sin2phi = sinphi * sinphi,
	        cos2phi = cosphi * cosphi,
	        sinlambda = sin(lambda),
	        coslambda_2 = cos(lambda / 2),
	        sinlambda_2 = sin(lambda / 2),
	        sin2lambda_2 = sinlambda_2 * sinlambda_2,
	        C = 1 - cos2phi * coslambda_2 * coslambda_2,
	        E = C ? acos(cosphi * coslambda_2) * sqrt(F = 1 / C) : F = 0,
	        F,
	        fx = 0.5 * (2 * E * cosphi * sinlambda_2 + lambda / halfPi) - x,
	        fy = 0.5 * (E * sinphi + phi) - y,
	        dxdlambda = 0.5 * F * (cos2phi * sin2lambda_2 + E * cosphi * coslambda_2 * sin2phi) + 0.5 / halfPi,
	        dxdphi = F * (sinlambda * sin_2phi / 4 - E * sinphi * sinlambda_2),
	        dydlambda = 0.125 * F * (sin_2phi * sinlambda_2 - E * sinphi * cos2phi * sinlambda),
	        dydphi = 0.5 * F * (sin2phi * coslambda_2 + E * sin2lambda_2 * cosphi) + 0.5,
	        denominator = dxdphi * dydlambda - dydphi * dxdlambda,
	        dlambda = (fy * dxdphi - fx * dydphi) / denominator,
	        dphi = (fx * dydlambda - fy * dxdlambda) / denominator;
	    lambda -= dlambda, phi -= dphi;
	  } while ((abs(dlambda) > epsilon || abs(dphi) > epsilon) && --i > 0);
	  return [lambda, phi];
	};
	
	var winkel3 = function() {
	  return d3Geo.geoProjection(winkel3Raw)
	      .scale(158.837);
	};
	
	exports.geoAiry = airy;
	exports.geoAiryRaw = airyRaw;
	exports.geoAitoff = aitoff;
	exports.geoAitoffRaw = aitoffRaw;
	exports.geoArmadillo = armadillo;
	exports.geoArmadilloRaw = armadilloRaw;
	exports.geoAugust = august;
	exports.geoAugustRaw = augustRaw;
	exports.geoBaker = baker;
	exports.geoBakerRaw = bakerRaw;
	exports.geoBerghaus = berghaus;
	exports.geoBerghausRaw = berghausRaw;
	exports.geoBoggs = boggs;
	exports.geoBoggsRaw = boggsRaw;
	exports.geoBonne = bonne;
	exports.geoBonneRaw = bonneRaw;
	exports.geoBottomley = bottomley;
	exports.geoBottomleyRaw = bottomleyRaw;
	exports.geoBromley = bromley;
	exports.geoBromleyRaw = bromleyRaw;
	exports.geoChamberlin = chamberlin;
	exports.geoChamberlinRaw = chamberlinRaw;
	exports.geoChamberlinAfrica = chamberlinAfrica;
	exports.geoCollignon = collignon;
	exports.geoCollignonRaw = collignonRaw;
	exports.geoCraig = craig;
	exports.geoCraigRaw = craigRaw;
	exports.geoCraster = craster;
	exports.geoCrasterRaw = crasterRaw;
	exports.geoCylindricalEqualArea = cylindricalEqualArea;
	exports.geoCylindricalEqualAreaRaw = cylindricalEqualAreaRaw;
	exports.geoCylindricalStereographic = cylindricalStereographic;
	exports.geoCylindricalStereographicRaw = cylindricalStereographicRaw;
	exports.geoEckert1 = eckert1;
	exports.geoEckert1Raw = eckert1Raw;
	exports.geoEckert2 = eckert2;
	exports.geoEckert2Raw = eckert2Raw;
	exports.geoEckert3 = eckert3;
	exports.geoEckert3Raw = eckert3Raw;
	exports.geoEckert4 = eckert4;
	exports.geoEckert4Raw = eckert4Raw;
	exports.geoEckert5 = eckert5;
	exports.geoEckert5Raw = eckert5Raw;
	exports.geoEckert6 = eckert6;
	exports.geoEckert6Raw = eckert6Raw;
	exports.geoEisenlohr = eisenlohr;
	exports.geoEisenlohrRaw = eisenlohrRaw;
	exports.geoFahey = fahey;
	exports.geoFaheyRaw = faheyRaw;
	exports.geoFoucaut = foucaut;
	exports.geoFoucautRaw = foucautRaw;
	exports.geoGilbert = gilbert;
	exports.geoGingery = gingery;
	exports.geoGingeryRaw = gingeryRaw;
	exports.geoGinzburg4 = ginzburg4;
	exports.geoGinzburg4Raw = ginzburg4Raw;
	exports.geoGinzburg5 = ginzburg5;
	exports.geoGinzburg5Raw = ginzburg5Raw;
	exports.geoGinzburg6 = ginzburg6;
	exports.geoGinzburg6Raw = ginzburg6Raw;
	exports.geoGinzburg8 = ginzburg8;
	exports.geoGinzburg8Raw = ginzburg8Raw;
	exports.geoGinzburg9 = ginzburg9;
	exports.geoGinzburg9Raw = ginzburg9Raw;
	exports.geoGringorten = gringorten;
	exports.geoGringortenRaw = gringortenRaw;
	exports.geoGuyou = guyou;
	exports.geoGuyouRaw = guyouRaw;
	exports.geoHammer = hammer;
	exports.geoHammerRaw = hammerRaw;
	exports.geoHammerRetroazimuthal = hammerRetroazimuthal;
	exports.geoHammerRetroazimuthalRaw = hammerRetroazimuthalRaw;
	exports.geoHealpix = healpix;
	exports.geoHealpixRaw = healpixRaw;
	exports.geoHill = hill;
	exports.geoHillRaw = hillRaw;
	exports.geoHomolosine = homolosine;
	exports.geoHomolosineRaw = homolosineRaw;
	exports.geoInterrupt = interrupt;
	exports.geoInterruptedBoggs = boggs$1;
	exports.geoInterruptedHomolosine = homolosine$1;
	exports.geoInterruptedMollweide = mollweide$1;
	exports.geoInterruptedMollweideHemispheres = mollweideHemispheres;
	exports.geoInterruptedSinuMollweide = sinuMollweide$1;
	exports.geoInterruptedSinusoidal = sinusoidal$1;
	exports.geoKavrayskiy7 = kavrayskiy7;
	exports.geoKavrayskiy7Raw = kavrayskiy7Raw;
	exports.geoLagrange = lagrange;
	exports.geoLagrangeRaw = lagrangeRaw;
	exports.geoLarrivee = larrivee;
	exports.geoLarriveeRaw = larriveeRaw;
	exports.geoLaskowski = laskowski;
	exports.geoLaskowskiRaw = laskowskiRaw;
	exports.geoLittrow = littrow;
	exports.geoLittrowRaw = littrowRaw;
	exports.geoLoximuthal = loximuthal;
	exports.geoLoximuthalRaw = loximuthalRaw;
	exports.geoMiller = miller;
	exports.geoMillerRaw = millerRaw;
	exports.geoModifiedStereographic = modifiedStereographic;
	exports.geoModifiedStereographicRaw = modifiedStereographicRaw;
	exports.geoModifiedStereographicAlaska = modifiedStereographicAlaska;
	exports.geoModifiedStereographicGs48 = modifiedStereographicGs48;
	exports.geoModifiedStereographicGs50 = modifiedStereographicGs50;
	exports.geoModifiedStereographicMiller = modifiedStereographicMiller;
	exports.geoModifiedStereographicLee = modifiedStereographicLee;
	exports.geoMollweide = mollweide;
	exports.geoMollweideRaw = mollweideRaw;
	exports.geoMtFlatPolarParabolic = mtFlatPolarParabolic;
	exports.geoMtFlatPolarParabolicRaw = mtFlatPolarParabolicRaw;
	exports.geoMtFlatPolarQuartic = mtFlatPolarQuartic;
	exports.geoMtFlatPolarQuarticRaw = mtFlatPolarQuarticRaw;
	exports.geoMtFlatPolarSinusoidal = mtFlatPolarSinusoidal;
	exports.geoMtFlatPolarSinusoidalRaw = mtFlatPolarSinusoidalRaw;
	exports.geoNaturalEarth = naturalEarth;
	exports.geoNaturalEarthRaw = naturalEarthRaw;
	exports.geoNellHammer = nellHammer;
	exports.geoNellHammerRaw = nellHammerRaw;
	exports.geoPatterson = patterson;
	exports.geoPattersonRaw = pattersonRaw;
	exports.geoPolyconic = polyconic;
	exports.geoPolyconicRaw = polyconicRaw;
	exports.geoPolyhedral = polyhedral;
	exports.geoPolyhedralButterfly = butterfly;
	exports.geoPolyhedralCollignon = collignon$1;
	exports.geoPolyhedralWaterman = waterman;
	exports.geoProject = index;
	exports.geoGringortenQuincuncial = gringorten$1;
	exports.geoPeirceQuincuncial = peirce;
	exports.geoPierceQuincuncial = peirce;
	exports.geoQuantize = quantize;
	exports.geoQuincuncial = quincuncial;
	exports.geoRectangularPolyconic = rectangularPolyconic;
	exports.geoRectangularPolyconicRaw = rectangularPolyconicRaw;
	exports.geoRobinson = robinson;
	exports.geoRobinsonRaw = robinsonRaw;
	exports.geoSatellite = satellite;
	exports.geoSatelliteRaw = satelliteRaw;
	exports.geoSinuMollweide = sinuMollweide;
	exports.geoSinuMollweideRaw = sinuMollweideRaw;
	exports.geoSinusoidal = sinusoidal;
	exports.geoSinusoidalRaw = sinusoidalRaw;
	exports.geoStitch = stitch;
	exports.geoTimes = times;
	exports.geoTimesRaw = timesRaw;
	exports.geoTwoPointAzimuthal = twoPointAzimuthal;
	exports.geoTwoPointAzimuthalRaw = twoPointAzimuthalRaw;
	exports.geoTwoPointAzimuthalUsa = twoPointAzimuthalUsa;
	exports.geoTwoPointEquidistant = twoPointEquidistant;
	exports.geoTwoPointEquidistantRaw = twoPointEquidistantRaw;
	exports.geoTwoPointEquidistantUsa = twoPointEquidistantUsa;
	exports.geoVanDerGrinten = vanDerGrinten;
	exports.geoVanDerGrintenRaw = vanDerGrintenRaw;
	exports.geoVanDerGrinten2 = vanDerGrinten2;
	exports.geoVanDerGrinten2Raw = vanDerGrinten2Raw;
	exports.geoVanDerGrinten3 = vanDerGrinten3;
	exports.geoVanDerGrinten3Raw = vanDerGrinten3Raw;
	exports.geoVanDerGrinten4 = vanDerGrinten4;
	exports.geoVanDerGrinten4Raw = vanDerGrinten4Raw;
	exports.geoWagner4 = wagner4;
	exports.geoWagner4Raw = wagner4Raw;
	exports.geoWagner6 = wagner6;
	exports.geoWagner6Raw = wagner6Raw;
	exports.geoWagner7 = wagner7;
	exports.geoWagner7Raw = wagner7Raw;
	exports.geoWiechel = wiechel;
	exports.geoWiechelRaw = wiechelRaw;
	exports.geoWinkel3 = winkel3;
	exports.geoWinkel3Raw = winkel3Raw;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(381)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function array(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHue = hue$1;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */
/***/ (function(module, exports) {

	module.exports = {"type":"Topology","objects":{"nordics":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[0]],[[1]],[[2,3,4]],[[5]],[[6]],[[7]]],"properties":{"featurecla":"Admin-0 country","scalerank":3,"LABELRANK":3,"SOVEREIGNT":"Sweden","SOV_A3":"SWE","ADM0_DIF":0,"LEVEL":2,"TYPE":"Sovereign country","ADMIN":"Sweden","ADM0_A3":"SWE","GEOU_DIF":0,"GEOUNIT":"Sweden","GU_A3":"SWE","SU_DIF":0,"SUBUNIT":"Sweden","SU_A3":"SWE","BRK_DIFF":0,"NAME":"Sweden","NAME_LONG":"Sweden","BRK_A3":"SWE","BRK_NAME":"Sweden","BRK_GROUP":null,"ABBREV":"Swe.","POSTAL":"S","FORMAL_EN":"Kingdom of Sweden","FORMAL_FR":null,"NAME_CIAWF":"Sweden","NOTE_ADM0":null,"NOTE_BRK":null,"NAME_SORT":"Sweden","NAME_ALT":null,"MAPCOLOR7":1,"MAPCOLOR8":4,"MAPCOLOR9":2,"MAPCOLOR13":4,"POP_EST":9960487,"POP_RANK":13,"GDP_MD_EST":498100,"POP_YEAR":2017,"LASTCENSUS":-99,"GDP_YEAR":2016,"ECONOMY":"2. Developed region: nonG7","INCOME_GRP":"1. High income: OECD","WIKIPEDIA":-99,"FIPS_10_":"SW","ISO_A2":"SE","ISO_A3":"SWE","ISO_A3_EH":"SWE","ISO_N3":"752","UN_A3":"752","WB_A2":"SE","WB_A3":"SWE","WOE_ID":23424954,"WOE_ID_EH":23424954,"WOE_NOTE":"Exact WOE match as country","ADM0_A3_IS":"SWE","ADM0_A3_US":"SWE","ADM0_A3_UN":-99,"ADM0_A3_WB":-99,"CONTINENT":"Europe","REGION_UN":"Europe","SUBREGION":"Northern Europe","REGION_WB":"Europe & Central Asia","NAME_LEN":6,"LONG_LEN":6,"ABBREV_LEN":4,"TINY":-99,"HOMEPART":1,"MIN_ZOOM":0,"MIN_LABEL":3,"MAX_LABEL":7,"NE_ID":1159321287,"WIKIDATAID":"Q34","NAME_AR":"السويد","NAME_BN":"সুইডেন","NAME_DE":"Schweden","NAME_EN":"Sweden","NAME_ES":"Suecia","NAME_FR":"Suède","NAME_EL":"Σουηδία","NAME_HI":"स्वीडन","NAME_HU":"Svédország","NAME_ID":"Swedia","NAME_IT":"Svezia","NAME_JA":"スウェーデン","NAME_KO":"스웨덴","NAME_NL":"Zweden","NAME_PL":"Szwecja","NAME_PT":"Suécia","NAME_RU":"Швеция","NAME_SV":"Sverige","NAME_TR":"İsveç","NAME_VI":"Thụy Điển","NAME_ZH":"瑞典"}},{"type":"MultiPolygon","arcs":[[[-3,8,9]],[[10]],[[11]],[[12]],[[13]],[[14]],[[15]],[[16]],[[17]],[[18]],[[19]],[[20]],[[21]],[[22]],[[23]],[[24]],[[25]],[[26]],[[27]],[[28]],[[29]],[[30]],[[31]],[[32]],[[33]],[[34]],[[35]],[[36]],[[37]],[[38]],[[39]],[[40]]],"properties":{"featurecla":"Admin-0 country","scalerank":1,"LABELRANK":3,"SOVEREIGNT":"Norway","SOV_A3":"NOR","ADM0_DIF":0,"LEVEL":2,"TYPE":"Sovereign country","ADMIN":"Norway","ADM0_A3":"NOR","GEOU_DIF":0,"GEOUNIT":"Norway","GU_A3":"NOR","SU_DIF":0,"SUBUNIT":"Norway","SU_A3":"NOR","BRK_DIFF":0,"NAME":"Norway","NAME_LONG":"Norway","BRK_A3":"NOR","BRK_NAME":"Norway","BRK_GROUP":null,"ABBREV":"Nor.","POSTAL":"N","FORMAL_EN":"Kingdom of Norway","FORMAL_FR":null,"NAME_CIAWF":"Norway","NOTE_ADM0":null,"NOTE_BRK":null,"NAME_SORT":"Norway","NAME_ALT":null,"MAPCOLOR7":5,"MAPCOLOR8":3,"MAPCOLOR9":8,"MAPCOLOR13":12,"POP_EST":5320045,"POP_RANK":13,"GDP_MD_EST":364700,"POP_YEAR":2017,"LASTCENSUS":2001,"GDP_YEAR":2016,"ECONOMY":"2. Developed region: nonG7","INCOME_GRP":"1. High income: OECD","WIKIPEDIA":-99,"FIPS_10_":"-99","ISO_A2":"-99","ISO_A3":"-99","ISO_A3_EH":"-99","ISO_N3":"-99","UN_A3":"-99","WB_A2":"-99","WB_A3":"-99","WOE_ID":-90,"WOE_ID_EH":23424910,"WOE_NOTE":"Does not include Svalbard, Jan Mayen, or Bouvet Islands (28289410).","ADM0_A3_IS":"NOR","ADM0_A3_US":"NOR","ADM0_A3_UN":-99,"ADM0_A3_WB":-99,"CONTINENT":"Europe","REGION_UN":"Europe","SUBREGION":"Northern Europe","REGION_WB":"Europe & Central Asia","NAME_LEN":6,"LONG_LEN":6,"ABBREV_LEN":4,"TINY":-99,"HOMEPART":1,"MIN_ZOOM":0,"MIN_LABEL":3,"MAX_LABEL":7,"NE_ID":1159321109,"WIKIDATAID":"Q20","NAME_AR":"النرويج","NAME_BN":"নরওয়ে","NAME_DE":"Norwegen","NAME_EN":"Norway","NAME_ES":"Noruega","NAME_FR":"Norvège","NAME_EL":"Νορβηγία","NAME_HI":"नॉर्वे","NAME_HU":"Norvégia","NAME_ID":"Norwegia","NAME_IT":"Norvegia","NAME_JA":"ノルウェー","NAME_KO":"노르웨이","NAME_NL":"Noorwegen","NAME_PL":"Norwegia","NAME_PT":"Noruega","NAME_RU":"Норвегия","NAME_SV":"Norge","NAME_TR":"Norveç","NAME_VI":"Na Uy","NAME_ZH":"挪威"}},{"type":"Polygon","arcs":[[41]],"properties":{"featurecla":"Admin-0 country","scalerank":1,"LABELRANK":3,"SOVEREIGNT":"Iceland","SOV_A3":"ISL","ADM0_DIF":0,"LEVEL":2,"TYPE":"Sovereign country","ADMIN":"Iceland","ADM0_A3":"ISL","GEOU_DIF":0,"GEOUNIT":"Iceland","GU_A3":"ISL","SU_DIF":0,"SUBUNIT":"Iceland","SU_A3":"ISL","BRK_DIFF":0,"NAME":"Iceland","NAME_LONG":"Iceland","BRK_A3":"ISL","BRK_NAME":"Iceland","BRK_GROUP":null,"ABBREV":"Iceland","POSTAL":"IS","FORMAL_EN":"Republic of Iceland","FORMAL_FR":null,"NAME_CIAWF":"Iceland","NOTE_ADM0":null,"NOTE_BRK":null,"NAME_SORT":"Iceland","NAME_ALT":null,"MAPCOLOR7":1,"MAPCOLOR8":4,"MAPCOLOR9":4,"MAPCOLOR13":9,"POP_EST":339747,"POP_RANK":10,"GDP_MD_EST":16150,"POP_YEAR":2017,"LASTCENSUS":-99,"GDP_YEAR":2016,"ECONOMY":"2. Developed region: nonG7","INCOME_GRP":"1. High income: OECD","WIKIPEDIA":-99,"FIPS_10_":"IC","ISO_A2":"IS","ISO_A3":"ISL","ISO_A3_EH":"ISL","ISO_N3":"352","UN_A3":"352","WB_A2":"IS","WB_A3":"ISL","WOE_ID":23424845,"WOE_ID_EH":23424845,"WOE_NOTE":"Exact WOE match as country","ADM0_A3_IS":"ISL","ADM0_A3_US":"ISL","ADM0_A3_UN":-99,"ADM0_A3_WB":-99,"CONTINENT":"Europe","REGION_UN":"Europe","SUBREGION":"Northern Europe","REGION_WB":"Europe & Central Asia","NAME_LEN":7,"LONG_LEN":7,"ABBREV_LEN":7,"TINY":-99,"HOMEPART":1,"MIN_ZOOM":0,"MIN_LABEL":2,"MAX_LABEL":7,"NE_ID":1159320917,"WIKIDATAID":"Q189","NAME_AR":"آيسلندا","NAME_BN":"আইসল্যান্ড","NAME_DE":"Island","NAME_EN":"Iceland","NAME_ES":"Islandia","NAME_FR":"Islande","NAME_EL":"Ισλανδία","NAME_HI":"आइसलैण्ड","NAME_HU":"Izland","NAME_ID":"Islandia","NAME_IT":"Islanda","NAME_JA":"アイスランド","NAME_KO":"아이슬란드","NAME_NL":"IJsland","NAME_PL":"Islandia","NAME_PT":"Islândia","NAME_RU":"Исландия","NAME_SV":"Island","NAME_TR":"İzlanda","NAME_VI":"Iceland","NAME_ZH":"冰岛"}},{"type":"MultiPolygon","arcs":[[[-4,-10,42]],[[43]],[[44]],[[45]],[[46]],[[47]],[[48]],[[49]]],"properties":{"featurecla":"Admin-0 country","scalerank":1,"LABELRANK":3,"SOVEREIGNT":"Finland","SOV_A3":"FI1","ADM0_DIF":1,"LEVEL":2,"TYPE":"Country","ADMIN":"Finland","ADM0_A3":"FIN","GEOU_DIF":0,"GEOUNIT":"Finland","GU_A3":"FIN","SU_DIF":0,"SUBUNIT":"Finland","SU_A3":"FIN","BRK_DIFF":0,"NAME":"Finland","NAME_LONG":"Finland","BRK_A3":"FIN","BRK_NAME":"Finland","BRK_GROUP":null,"ABBREV":"Fin.","POSTAL":"FIN","FORMAL_EN":"Republic of Finland","FORMAL_FR":null,"NAME_CIAWF":"Finland","NOTE_ADM0":null,"NOTE_BRK":null,"NAME_SORT":"Finland","NAME_ALT":null,"MAPCOLOR7":4,"MAPCOLOR8":1,"MAPCOLOR9":4,"MAPCOLOR13":6,"POP_EST":5491218,"POP_RANK":13,"GDP_MD_EST":224137,"POP_YEAR":2017,"LASTCENSUS":2010,"GDP_YEAR":2016,"ECONOMY":"2. Developed region: nonG7","INCOME_GRP":"1. High income: OECD","WIKIPEDIA":-99,"FIPS_10_":"FI","ISO_A2":"FI","ISO_A3":"FIN","ISO_A3_EH":"FIN","ISO_N3":"246","UN_A3":"246","WB_A2":"FI","WB_A3":"FIN","WOE_ID":23424812,"WOE_ID_EH":23424812,"WOE_NOTE":"Exact WOE match as country","ADM0_A3_IS":"FIN","ADM0_A3_US":"FIN","ADM0_A3_UN":-99,"ADM0_A3_WB":-99,"CONTINENT":"Europe","REGION_UN":"Europe","SUBREGION":"Northern Europe","REGION_WB":"Europe & Central Asia","NAME_LEN":7,"LONG_LEN":7,"ABBREV_LEN":4,"TINY":-99,"HOMEPART":1,"MIN_ZOOM":0,"MIN_LABEL":3,"MAX_LABEL":8,"NE_ID":1159320623,"WIKIDATAID":"Q33","NAME_AR":"فنلندا","NAME_BN":"ফিনল্যান্ড","NAME_DE":"Finnland","NAME_EN":"Finland","NAME_ES":"Finlandia","NAME_FR":"Finlande","NAME_EL":"Φινλανδία","NAME_HI":"फ़िनलैण्ड","NAME_HU":"Finnország","NAME_ID":"Finlandia","NAME_IT":"Finlandia","NAME_JA":"フィンランド","NAME_KO":"핀란드","NAME_NL":"Finland","NAME_PL":"Finlandia","NAME_PT":"Finlândia","NAME_RU":"Финляндия","NAME_SV":"Finland","NAME_TR":"Finlandiya","NAME_VI":"Phần Lan","NAME_ZH":"芬兰"}},{"type":"MultiPolygon","arcs":[[[50]],[[51]],[[52]],[[53]],[[54]],[[55]],[[56]],[[57]],[[58]],[[59]],[[60]],[[61]]],"properties":{"featurecla":"Admin-0 country","scalerank":1,"LABELRANK":4,"SOVEREIGNT":"Denmark","SOV_A3":"DN1","ADM0_DIF":1,"LEVEL":2,"TYPE":"Country","ADMIN":"Denmark","ADM0_A3":"DNK","GEOU_DIF":0,"GEOUNIT":"Denmark","GU_A3":"DNK","SU_DIF":0,"SUBUNIT":"Denmark","SU_A3":"DNK","BRK_DIFF":0,"NAME":"Denmark","NAME_LONG":"Denmark","BRK_A3":"DNK","BRK_NAME":"Denmark","BRK_GROUP":null,"ABBREV":"Den.","POSTAL":"DK","FORMAL_EN":"Kingdom of Denmark","FORMAL_FR":null,"NAME_CIAWF":"Denmark","NOTE_ADM0":null,"NOTE_BRK":null,"NAME_SORT":"Denmark","NAME_ALT":null,"MAPCOLOR7":4,"MAPCOLOR8":1,"MAPCOLOR9":3,"MAPCOLOR13":12,"POP_EST":5605948,"POP_RANK":13,"GDP_MD_EST":264800,"POP_YEAR":2017,"LASTCENSUS":2011,"GDP_YEAR":2016,"ECONOMY":"2. Developed region: nonG7","INCOME_GRP":"1. High income: OECD","WIKIPEDIA":-99,"FIPS_10_":"DA","ISO_A2":"DK","ISO_A3":"DNK","ISO_A3_EH":"DNK","ISO_N3":"208","UN_A3":"208","WB_A2":"DK","WB_A3":"DNK","WOE_ID":23424796,"WOE_ID_EH":23424796,"WOE_NOTE":"Exact WOE match as country","ADM0_A3_IS":"DNK","ADM0_A3_US":"DNK","ADM0_A3_UN":-99,"ADM0_A3_WB":-99,"CONTINENT":"Europe","REGION_UN":"Europe","SUBREGION":"Northern Europe","REGION_WB":"Europe & Central Asia","NAME_LEN":7,"LONG_LEN":7,"ABBREV_LEN":4,"TINY":-99,"HOMEPART":1,"MIN_ZOOM":0,"MIN_LABEL":3,"MAX_LABEL":8,"NE_ID":1159320547,"WIKIDATAID":"Q35","NAME_AR":"الدنمارك","NAME_BN":"ডেনমার্ক","NAME_DE":"Dänemark","NAME_EN":"Denmark","NAME_ES":"Dinamarca","NAME_FR":"Danemark","NAME_EL":"Δανία","NAME_HI":"डेनमार्क","NAME_HU":"Dánia","NAME_ID":"Denmark","NAME_IT":"Danimarca","NAME_JA":"デンマーク","NAME_KO":"덴마크","NAME_NL":"Denemarken","NAME_PL":"Dania","NAME_PT":"Dinamarca","NAME_RU":"Дания","NAME_SV":"Danmark","NAME_TR":"Danimarka","NAME_VI":"Đan Mạch","NAME_ZH":"丹麦"}}]}},"arcs":[[[19.076464843750017,57.8359375],[18.99375,57.812109375],[18.945117187500017,57.7416015625],[18.878125,57.7296875],[18.813867187500023,57.706201171875],[18.790917968750023,57.48310546875],[18.90791015625001,57.39833984375],[18.843652343750023,57.386474609375],[18.78486328125001,57.361083984375],[18.74287109375001,57.323535156249996],[18.69990234375001,57.242724609374996],[18.538476562500023,57.196923828125],[18.477343750000017,57.163037109375],[18.38720703125,57.087646484375],[18.340234375000023,56.97822265625],[18.248925781250023,56.93154296875],[18.146386718750023,56.9205078125],[18.20654296875,57.01015625],[18.28535156250001,57.083203125],[18.209570312500006,57.13330078125],[18.163964843750023,57.21171875],[18.105078125,57.271875],[18.151953125,57.3390625],[18.12890625,57.449169921875],[18.136523437500017,57.556640625],[18.204882812500017,57.610888671874996],[18.283203125,57.655126953125],[18.405175781250023,57.7568359375],[18.537402343750017,57.83056640625],[18.721875,57.863720703125],[18.80517578125,57.833154296875],[18.841113281250017,57.900195312499996],[18.90058593750001,57.915478515625],[18.956445312500023,57.9],[19.076464843750017,57.8359375]],[[16.52851562500001,56.29052734375],[16.477148437500006,56.240185546875],[16.431640625,56.24375],[16.401269531250023,56.310888671875],[16.394140625,56.483642578125],[16.41230468750001,56.568994140625],[16.63037109375,56.87685546875],[16.72773437500001,56.902001953125],[16.864648437500023,57.090673828125],[16.90156250000001,57.174609375],[16.9609375,57.2501953125],[16.995996093750023,57.3177734375],[17.025390625,57.345068359375],[17.089257812500023,57.332275390625],[17.11767578125,57.31982421875],[17.050390625,57.28046875],[17.058203125,57.229248046875],[17.053515625000017,57.2080078125],[16.883691406250023,56.985205078125],[16.838281250000023,56.84052734375],[16.77802734375001,56.805224609374996],[16.52851562500001,56.29052734375]],[[11.38828125,59.036523437499994],[11.470703125,58.909521484375],[11.543554687500006,58.893017578125],[11.642773437500011,58.92607421875],[11.712207031250017,59.01865234375],[11.751855468750023,59.157568359375],[11.798144531250017,59.289892578125],[11.743359375000011,59.4314453125],[11.684863281250017,59.55576171875],[11.680761718750006,59.59228515625],[11.834277343750017,59.697167968749994],[11.88125,59.782470703125],[11.93212890625,59.86367187499999],[11.98828125,59.89130859375],[12.071875,59.897607421874994],[12.169238281250017,59.912890625],[12.2919921875,59.967236328125],[12.402050781250011,60.0400390625],[12.486132812500017,60.106787109375],[12.5146484375,60.2388671875],[12.515820312500011,60.305224609375],[12.552832031250006,60.3544921875],[12.588671875000017,60.450732421875],[12.553808593750006,60.545654296875],[12.4453125,60.6896484375],[12.314648437500011,60.892138671875],[12.294140625000011,61.002685546875],[12.353710937500011,61.023193359375],[12.467578125000017,61.04150390625],[12.683007812500023,61.046826171875],[12.7060546875,61.05986328125],[12.727832031250017,61.108251953125],[12.7763671875,61.173974609374994],[12.828222656250006,61.221826171874994],[12.863671875000023,61.290283203125],[12.880761718750023,61.352294921875],[12.757519531250011,61.44570312499999],[12.596093750000023,61.54130859375],[12.48681640625,61.572998046875],[12.292089843750006,61.653466796874994],[12.155371093750006,61.720751953125],[12.233691406250017,61.97685546875],[12.2919921875,62.167431640625],[12.301367187500006,62.213769531249994],[12.303515625000017,62.285595703125],[12.114550781250017,62.59189453125],[12.121875,62.660009765625],[12.139843750000011,62.721337890624994],[12.11962890625,62.825927734375],[12.108593750000011,62.919482421875],[12.141015625000023,62.9478515625],[12.218164062500023,63.000634765624994],[12.144628906250006,63.08251953125],[12.138671875,63.08916015625],[11.999902343750023,63.29169921875],[12.212109375000011,63.492236328125],[12.175195312500023,63.595947265625],[12.301953125000011,63.67119140625],[12.53271484375,63.8435546875],[12.6625,63.940478515625],[12.690039062500006,63.95742187499999],[12.792773437500017,64],[12.987597656250017,64.05048828125],[13.203515625000023,64.07509765625],[13.299609375000017,64.0748046875],[13.670703125000017,64.040625],[13.960546875,64.014013671875],[14.002734375000017,64.04072265625],[14.063281250000017,64.0955078125],[14.141210937500006,64.17353515625],[14.148046875,64.260302734375],[14.119921875000017,64.387744140625],[14.07763671875,64.464013671875],[13.87353515625,64.51357421875],[13.650292968750023,64.58154296875],[13.9248046875,64.79677734375],[14.115136718750023,64.946142578125],[14.352441406250023,65.170849609375],[14.42626953125,65.26435546875],[14.479687500000011,65.30146484375],[14.549511718750011,65.64638671875],[14.595800781250006,65.74287109375],[14.634570312500017,65.79326171875],[14.635156250000023,65.84501953125],[14.609960937500006,65.932275390625],[14.543261718750017,66.129345703125],[14.91796875,66.1537109375],[15.0400390625,66.167529296875],[15.1533203125,66.191064453125],[15.374902343750023,66.25205078125],[15.483789062500023,66.30595703125],[15.422949218750006,66.48984375],[15.557031250000023,66.552099609375],[15.884179687500023,66.76884765625],[16.237695312500023,66.976416015625],[16.40351562500001,67.05498046875],[16.420703125000017,67.093359375],[16.43427734375001,67.155078125],[16.360644531250017,67.252001953125],[16.281542968750017,67.312060546875],[16.12744140625,67.425830078125],[16.19355468750001,67.50517578125],[16.30712890625,67.52060546875],[16.457128906250006,67.5517578125],[16.574121093750023,67.619580078125],[16.585546875,67.6283203125],[16.783593750000023,67.89501953125],[17.170507812500006,68.030126953125],[17.324609375000023,68.10380859375],[17.564746093750017,68.0484375],[17.91669921875001,67.964892578125],[18.0732421875,68.087841796875],[18.125,68.133447265625],[18.176660156250023,68.200634765625],[18.15595703125001,68.316845703125],[18.147070312500006,68.4677734375],[18.16259765625,68.52841796875],[18.303027343750017,68.555419921875],[18.37861328125001,68.56240234375],[18.769824218750017,68.500048828125],[18.868261718750006,68.501123046875],[19.052636718750023,68.492724609375],[19.25898437500001,68.46533203125],[19.691210937500017,68.392431640625],[19.870019531250023,68.362255859375],[19.969824218750006,68.356396484375],[20.055957031250017,68.390380859375],[20.240039062500017,68.4775390625],[19.968847656250006,68.542041015625],[20.1474609375,68.60732421875],[20.240039062500017,68.67314453125],[20.319433593750006,68.754052734375],[20.348046875000023,68.84873046875],[20.33710937500001,68.899658203125],[20.282324218750006,68.934326171875],[20.11669921875,69.0208984375],[20.491992187500017,69.03330078125],[20.622167968750006,69.036865234375]],[[20.622167968750006,69.036865234375],[20.895117187500006,68.979833984375],[20.907031250000017,68.96748046875],[20.908984375000017,68.937744140625],[20.918554687500006,68.90693359375],[21.183398437500017,68.82880859375],[21.259765625,68.787451171875],[21.42236328125,68.724609375],[21.465429687500006,68.690673828125],[21.616015625000017,68.6509765625],[21.724023437500023,68.608544921875],[21.850195312500006,68.57412109375],[21.997460937500023,68.52060546875],[22.195117187500017,68.477978515625],[22.362109375000017,68.4640625],[22.78242187500001,68.391015625],[22.854101562500006,68.367333984375],[22.975390625000017,68.316455078125],[23.09785156250001,68.257568359375],[23.182519531250023,68.13662109375],[23.31855468750001,68.130322265625],[23.35546875,68.088671875],[23.47421875,68.017333984375],[23.63886718750001,67.95439453125],[23.632910156250006,67.933203125],[23.501855468750023,67.8751953125],[23.48779296875,67.79658203125],[23.50019531250001,67.69619140625],[23.541308593750017,67.614306640625],[23.537011718750023,67.590380859375],[23.504492187500006,67.562158203125],[23.465429687500006,67.51787109375],[23.451464843750017,67.47919921875],[23.454882812500017,67.46025390625],[23.468066406250017,67.449951171875],[23.537109375,67.449169921875],[23.66083984375001,67.4400390625],[23.73359375000001,67.422900390625],[23.77490234375,67.32861328125],[23.76093750000001,67.310498046875],[23.656640625000023,67.267822265625],[23.626074218750006,67.233935546875],[23.623046875,67.184130859375],[23.641503906250023,67.12939453125],[23.67734375,67.068115234375],[23.75898437500001,67.002587890625],[23.86933593750001,66.934033203125],[23.941796875000023,66.87783203125],[23.97607421875,66.838232421875],[23.988574218750017,66.810546875],[23.938867187500023,66.775732421875],[23.894140625,66.706884765625],[23.885839843750006,66.62802734375],[23.865527343750017,66.576611328125],[23.768359375000017,66.505859375],[23.701171875,66.48076171875],[23.682031250000023,66.443408203125],[23.673828125,66.380712890625],[23.69355468750001,66.304296875],[23.700292968750006,66.25263671875],[23.720996093750017,66.2154296875],[23.75146484375,66.191162109375],[23.907324218750006,66.1482421875],[23.99462890625,66.0603515625],[24.04902343750001,65.98984375],[24.15546875000001,65.8052734375]],[[24.15546875000001,65.8052734375],[23.890527343750023,65.7822265625],[23.69140625,65.828515625],[23.592089843750017,65.805322265625],[23.418359375000023,65.804345703125],[23.221093750000023,65.7861328125],[23.154589843750017,65.74990234375],[23.102343750000017,65.7353515625],[22.919335937500023,65.786474609375],[22.74658203125,65.870947265625],[22.62031250000001,65.80654296875],[22.53857421875,65.7943359375],[22.465136718750017,65.85263671875],[22.400976562500006,65.862109375],[22.366308593750006,65.84267578125],[22.3359375,65.791162109375],[22.28759765625,65.750634765625],[22.275,65.725],[22.2666015625,65.621533203125],[22.254003906250006,65.59755859375],[22.086230468750017,65.6109375],[22.096289062500006,65.5837890625],[22.1328125,65.5701171875],[22.147558593750006,65.552880859375],[22.086718750000017,65.530224609375],[21.92011718750001,65.532373046875],[21.903125,65.508349609375],[21.95,65.470361328125],[21.913476562500023,65.437109375],[21.87958984375001,65.4240234375],[21.6806640625,65.403369140625],[21.565527343750006,65.40810546875],[21.532617187500023,65.386572265625],[21.5234375,65.35859375],[21.545214843750017,65.33115234375],[21.595996093750017,65.316552734375],[21.612695312500023,65.29912109375],[21.609179687500017,65.261376953125],[21.56689453125,65.254541015625],[21.446875,65.320849609375],[21.41035156250001,65.317431640625],[21.437792968750017,65.282958984375],[21.50634765625,65.245361328125],[21.545996093750006,65.206982421875],[21.580664062500006,65.160791015625],[21.57392578125001,65.12578125],[21.424902343750006,65.0126953125],[21.29375,64.941259765625],[21.195898437500006,64.876904296875],[21.13818359375,64.80869140625],[21.204980468750023,64.77431640625],[21.279296875,64.72470703125],[21.33154296875,64.629345703125],[21.393847656250017,64.5443359375],[21.519628906250006,64.4630859375],[21.49433593750001,64.41611328125],[21.46503906250001,64.37958984375],[21.255761718750023,64.299169921875],[21.018457031250023,64.177978515625],[20.7626953125,63.867822265624994],[20.677636718750023,63.82626953125],[20.453710937500006,63.77373046875],[20.371386718750017,63.722900390625],[20.2046875,63.662451171875],[19.913671875,63.610546875],[19.781640625000023,63.53818359375],[19.722070312500023,63.463330078125],[19.65576171875,63.4580078125],[19.59003906250001,63.487255859375],[19.502343750000023,63.509033203125],[19.49091796875001,63.460205078125],[19.49462890625,63.424365234375],[19.354296875000017,63.477490234375],[19.2880859375,63.428759765625],[19.236328125,63.34736328125],[19.034375,63.237744140625],[18.816699218750017,63.257470703124994],[18.792285156250017,63.238134765625],[18.850195312500006,63.22412109375],[18.858984375,63.206591796875],[18.819433593750006,63.197265625],[18.759570312500017,63.1982421875],[18.66718750000001,63.1765625],[18.6064453125,63.178271484375],[18.57763671875,63.126416015625],[18.530664062500023,63.063525390625],[18.40771484375,63.0375],[18.34423828125,63.032128906249994],[18.312890625000023,62.99638671875],[18.502050781250006,62.9888671875],[18.486914062500006,62.95859375],[18.48261718750001,62.9283203125],[18.46308593750001,62.895849609375],[18.248046875,62.849072265625],[18.214941406250006,62.81220703125],[18.170019531250006,62.78935546875],[18.07441406250001,62.790673828124994],[18.077929687500017,62.811962890625],[18.093554687500017,62.83603515625],[17.951074218750023,62.833886718749994],[17.906640625000023,62.886767578125],[17.87958984375001,62.873193359374994],[17.895605468750006,62.830517578125],[17.932910156250017,62.7861328125],[17.974414062500017,62.721044921875],[17.940722656250017,62.6798828125],[17.90302734375001,62.65947265625],[17.930468750000017,62.640625],[18.00654296875001,62.62626953125],[18.03730468750001,62.600537109375],[17.947070312500017,62.578466796875],[17.83447265625,62.502734375],[17.7177734375,62.500878906249994],[17.646386718750023,62.45087890625],[17.570605468750017,62.451025390625],[17.50898437500001,62.48251953125],[17.410253906250006,62.5083984375],[17.37841796875,62.462792968749994],[17.373339843750017,62.426513671875],[17.429003906250017,62.334716796875],[17.535253906250006,62.263671875],[17.633691406250023,62.2330078125],[17.562890625000023,62.212304687499994],[17.510156250000023,62.16630859375],[17.446582031250017,62.02265625],[17.412011718750023,61.96611328125],[17.37451171875,61.86630859375],[17.398242187500017,61.782080078125],[17.417285156250017,61.740673828125],[17.465429687500006,61.684472656249994],[17.334570312500006,61.69169921875],[17.196386718750006,61.724560546875],[17.215625,61.65634765625],[17.130761718750023,61.575732421875],[17.146582031250006,61.504638671875],[17.16425781250001,61.45830078125],[17.137988281250017,61.381689453125],[17.17792968750001,61.3576171875],[17.199609375000023,61.311962890625],[17.163867187500017,61.278271484375],[17.179785156250006,61.249267578125],[17.18574218750001,61.146533203125],[17.212890625,60.98583984375],[17.202929687500017,60.95185546875],[17.27890625,60.812158203124994],[17.26123046875,60.76318359375],[17.2509765625,60.70078125],[17.35986328125,60.6408203125],[17.45703125,60.641796875],[17.555468750000017,60.642724609374994],[17.593066406250017,60.627685546875],[17.630761718750023,60.58525390625],[17.6611328125,60.53515625],[17.7421875,60.539306640625],[17.87158203125,60.580078125],[17.95576171875001,60.589794921875],[18.011328125,60.51142578125],[18.1625,60.40791015625],[18.25048828125,60.3615234375],[18.4,60.337109375],[18.557519531250023,60.253564453124994],[18.535449218750017,60.152880859375],[18.601171875,60.11923828125],[18.787011718750023,60.079492187499994],[18.85273437500001,60.02587890625],[18.88427734375,59.98017578125],[18.933203125,59.942285156249994],[18.99042968750001,59.827783203124994],[18.970507812500017,59.757226562499994],[18.895605468750006,59.732958984375],[18.71875,59.657373046874994],[18.639941406250017,59.600927734375],[18.578125,59.565771484375],[18.402441406250006,59.490380859374994],[18.33808593750001,59.47685546875],[18.276464843750006,59.437646484374994],[18.216894531250006,59.4205078125],[18.16357421875,59.43037109375],[17.964257812500023,59.359375],[17.979785156250017,59.329052734375],[18.132617187500017,59.3162109375],[18.210546875,59.331445312499994],[18.2705078125,59.367138671875],[18.336035156250006,59.375341796875],[18.395800781250017,59.368603515625],[18.45917968750001,59.396728515625],[18.508886718750006,59.407958984375],[18.56025390625001,59.394482421875],[18.617578125000023,59.327050781249994],[18.498632812500006,59.291943359375],[18.41425781250001,59.29033203125],[18.373046875,59.179736328125],[18.32197265625001,59.132226562499994],[18.28535156250001,59.109375],[18.09814453125,59.0623046875],[17.974609375,59.00263671875],[17.829003906250023,58.95458984375],[17.765429687500017,58.9650390625],[17.66962890625001,58.9162109375],[17.45673828125001,58.8583984375],[17.34765625,58.780517578125],[17.102832031250017,58.710839843749994],[16.978125,58.654150390625],[16.63935546875001,58.651171875],[16.315820312500023,58.663623046875],[16.214257812500023,58.636669921875],[16.31806640625001,58.628320312499994],[16.39082031250001,58.60185546875],[16.47802734375,58.612890625],[16.683007812500023,58.599658203125],[16.788476562500023,58.58525390625],[16.923828125,58.49257812499999],[16.824316406250006,58.459619140624994],[16.651953125,58.434326171875],[16.716601562500017,58.302880859374994],[16.769921875000023,58.214257812499994],[16.700097656250023,58.160791015624994],[16.694921875,57.917529296874996],[16.596972656250017,57.912890625],[16.55537109375001,57.812255859375],[16.586230468750017,57.7609375],[16.583789062500017,57.641748046875],[16.60419921875001,57.568310546875],[16.652246093750023,57.50068359375],[16.630859375,57.43017578125],[16.475976562500023,57.26513671875],[16.4794921875,57.1876953125],[16.50732421875,57.14169921875],[16.527929687500006,57.068164062499996],[16.45751953125,56.926806640624996],[16.4078125,56.80869140625],[16.348730468750006,56.709277343749996],[16.21650390625001,56.589990234375],[16.150683593750017,56.500830078125],[15.996679687500006,56.222607421875],[15.920312500000023,56.1673828125],[15.82666015625,56.124951171875],[15.722265625,56.164208984375],[15.6265625,56.185595703124996],[15.509667968750023,56.1830078125],[15.326562500000023,56.150830078125],[15.051171875000023,56.172216796875],[14.782031250000017,56.161914062499996],[14.713964843750006,56.134130859375],[14.754785156250023,56.033154296875],[14.655566406250017,56.019921875],[14.55859375,56.048632812499996],[14.473242187500006,56.01435546875],[14.401953125,55.9767578125],[14.261914062500011,55.887548828125],[14.215039062500011,55.8326171875],[14.202929687500017,55.729150390625],[14.276464843750006,55.636376953125],[14.341699218750023,55.527734375],[14.173730468750023,55.396630859375],[14.079980468750023,55.3921875],[13.806347656250011,55.428564453125],[13.321386718750006,55.34638671875],[12.885839843750006,55.411376953125],[12.940625,55.481591796875],[12.938769531250017,55.533203125],[12.96337890625,55.612597656249996],[12.97802734375,55.693798828125],[12.973925781250017,55.74814453125],[12.941992187500006,55.8060546875],[12.834570312500006,55.8818359375],[12.592578125000017,56.13759765625],[12.52099609375,56.245556640625],[12.47119140625,56.29052734375],[12.507031250000011,56.29296875],[12.706347656250017,56.235009765625],[12.752832031250023,56.242138671875],[12.801660156250023,56.263916015625],[12.7421875,56.346875],[12.691113281250011,56.384423828125],[12.656445312500011,56.440576171875],[12.773144531250011,56.45576171875],[12.857421875,56.452392578125],[12.91953125,56.515576171875],[12.883691406250023,56.617724609374996],[12.793164062500011,56.649169921875],[12.717578125000017,56.662841796875],[12.572656250000023,56.823291015624996],[12.421484375,56.906396484375],[12.15185546875,57.226953125],[12.05322265625,57.44697265625],[11.961523437500006,57.426074218749996],[11.9169921875,57.521923828125],[11.885058593750017,57.6126953125],[11.878710937500017,57.679443359375],[11.734960937500006,57.71767578125],[11.729101562500006,57.764453125],[11.703222656250006,57.973193359374996],[11.549023437500011,58.001220703125],[11.449316406250006,58.118359375],[11.431542968750023,58.339990234374994],[11.329980468750023,58.380322265625],[11.248242187500011,58.369140625],[11.252050781250006,58.424072265625],[11.271582031250006,58.475634765625],[11.223828125000011,58.679931640625],[11.207910156250023,58.86640625],[11.169140625000011,58.922705078125],[11.147167968750011,58.988623046875],[11.166894531250023,59.045556640624994],[11.19580078125,59.078271484374994],[11.295312500000023,59.086865234375],[11.38828125,59.036523437499994]],[[19.156347656250006,57.922607421875],[19.13837890625001,57.86025390625],[19.086523437500006,57.864990234375],[19.03925781250001,57.91103515625],[19.134863281250006,57.98134765625],[19.281152343750023,57.9775390625],[19.331445312500023,57.962890625],[19.156347656250006,57.922607421875]],[[18.41621093750001,59.0291015625],[18.371875,59.019580078125],[18.349902343750017,59.022607421874994],[18.377246093750017,59.06904296875],[18.397558593750006,59.089111328125],[18.464941406250006,59.107861328125],[18.48554687500001,59.10458984375],[18.41621093750001,59.0291015625]],[[18.59541015625001,59.470361328124994],[18.5703125,59.437255859375],[18.54511718750001,59.47783203125],[18.55517578125,59.485791015625],[18.572363281250006,59.525830078125],[18.620898437500017,59.547802734375],[18.69843750000001,59.534619140625],[18.69794921875001,59.524609375],[18.623828125000017,59.4921875],[18.59541015625001,59.470361328124994]],[[11.38828125,59.036523437499994],[11.386425781250011,59.06572265625],[11.365917968750011,59.104541015625],[11.132128906250017,59.143212890624994],[11.0908203125,59.141796875],[10.998925781250023,59.16445312499999],[10.945019531250011,59.170849609375],[10.83447265625,59.183935546875],[10.742578125000023,59.29599609375],[10.644921875000023,59.389208984375],[10.631054687500011,59.428173828125],[10.634375,59.602490234375],[10.6044921875,59.680029296875],[10.5953125,59.764550781249994],[10.533886718750011,59.69580078125],[10.569531250000011,59.587109375],[10.49375,59.54150390625],[10.398144531250011,59.5193359375],[10.407128906250023,59.4556640625],[10.446386718750006,59.443603515625],[10.45458984375,59.377490234375],[10.431347656250011,59.279638671875],[10.2431640625,59.062060546875],[10.205175781250006,59.038671875],[10.179394531250011,59.00927734375],[10.083105468750006,59.02880859375],[9.959570312500006,58.968212890625],[9.842578125000017,58.95849609375],[9.800195312500023,59.02705078125],[9.635156250000023,59.1177734375],[9.557226562500006,59.112695312499994],[9.627148437500011,59.067919921875],[9.696093750000017,59.009716796875],[9.656933593750011,58.97119140625],[9.618457031250017,58.946044921875],[9.551074218750017,58.933007812499994],[9.309960937500023,58.856835937499994],[9.395800781250017,58.8056640625],[9.322949218750011,58.74755859375],[9.238671875000023,58.739013671875],[9.19375,58.711865234375],[9.178125,58.675],[8.928417968750011,58.569970703124994],[8.521386718750023,58.3005859375],[8.312207031250011,58.224462890625],[8.166113281250006,58.1453125],[8.037402343750017,58.147265625],[7.875585937500006,58.079980468749994],[7.465917968750006,58.020947265625],[7.194140625000017,58.04765625],[7.0048828125,58.02421875],[6.903417968750006,58.0705078125],[6.890234375,58.102294921875],[6.895312500000017,58.120751953124994],[6.912304687500011,58.14287109375],[6.877050781250006,58.150732421875],[6.802832031250006,58.154541015625],[6.77109375,58.132226562499994],[6.766796875000011,58.08154296875],[6.7314453125,58.068310546875],[6.590527343750011,58.097314453124994],[6.555078125000023,58.1234375],[6.605761718750017,58.1763671875],[6.692480468750006,58.224023437499994],[6.6767578125,58.233789062499994],[6.659863281250011,58.262744140625],[6.617578125000023,58.26640625],[6.491503906250017,58.259423828124994],[6.389062500000023,58.26796875],[6.0546875,58.375146484374994],[5.9765625,58.43232421875],[5.706835937500017,58.5236328125],[5.5859375,58.62041015625],[5.517285156250011,58.726513671875],[5.5224609375,58.82265625],[5.555566406250023,58.9751953125],[5.612207031250023,59.012890625],[5.854296875000017,58.95947265625],[6.099023437500023,58.870263671874994],[6.137304687500006,58.874658203124994],[6.214160156250017,58.944677734375],[6.36328125,59.000927734375],[6.321093750000017,59.016455078125],[6.099414062500017,58.951953125],[6.016992187500023,58.987695312499994],[5.88916015625,59.060498046875],[5.88916015625,59.09794921875],[5.94873046875,59.13544921875],[5.968554687500017,59.1861328125],[5.937304687500017,59.233984375],[5.951855468750011,59.299072265625],[6.050683593750023,59.3681640625],[6.198925781250011,59.4380859375],[6.3056640625,59.50556640625],[6.415332031250017,59.547119140625],[6.40390625,59.560986328125],[6.278515625000011,59.534521484375],[6.158593750000023,59.489648437499994],[6.017382812500017,59.41445312499999],[5.84521484375,59.353466796875],[5.717968750000011,59.329833984375],[5.657324218750006,59.31025390625],[5.5640625,59.2912109375],[5.467578125000017,59.20380859375],[5.3623046875,59.166357421875],[5.173242187500023,59.162548828125],[5.131640625000017,59.226464843749994],[5.18505859375,59.453662109375],[5.2421875,59.564306640625],[5.304882812500011,59.642578125],[5.403515625000011,59.65576171875],[5.472460937500017,59.7130859375],[5.529687500000023,59.7130859375],[5.579492187500023,59.68662109375],[5.772167968750011,59.6609375],[5.867285156250006,59.733984375],[5.991015625000017,59.744677734375],[6.216601562500017,59.818359375],[6.2119140625,59.831787109375],[6.059277343750011,59.815576171874994],[5.966699218750023,59.81318359375],[5.833984375,59.794677734375],[5.763476562500017,59.80791015625],[5.73046875,59.8630859375],[5.783593750000023,59.91279296875],[5.996484375000023,60.031494140625],[6.069921875,60.08349609375],[6.11181640625,60.132080078125],[6.105175781250011,60.16513671875],[6.140527343750023,60.23349609375],[6.348730468750006,60.352978515625],[6.51806640625,60.407568359375],[6.573632812500023,60.360595703125],[6.5263671875,60.213623046875],[6.52685546875,60.1529296875],[6.660937500000017,60.367236328125],[6.719921875000011,60.4181640625],[6.787109375,60.4541015625],[6.94970703125,60.47822265625],[6.995703125,60.511962890625],[6.806347656250011,60.50078125],[6.346972656250017,60.419091796874994],[6.1533203125,60.346240234375],[6.101757812500011,60.29013671875],[5.967382812500006,60.20556640625],[5.904394531250006,60.150634765625],[5.8765625,60.07001953125],[5.800878906250006,60.026220703125],[5.698828125,60.010009765625],[5.557031250000023,59.907763671875],[5.494531250000023,59.825585937499994],[5.353417968750023,59.760107421875],[5.263867187500011,59.709765625],[5.234472656250006,59.69179687499999],[5.18603515625,59.64228515625],[5.145800781250017,59.638818359374994],[5.110742187500023,59.667822265625],[5.104882812500023,59.731689453125],[5.119238281250006,59.83369140625],[5.187109375,59.907080078125],[5.219531250000017,59.978759765625],[5.174414062500006,60.045703125],[5.205664062500006,60.087939453125],[5.265429687500017,60.086474609375],[5.37646484375,60.067236328125],[5.494531250000023,60.0703125],[5.688574218750006,60.123193359374994],[5.657617187500023,60.1541015625],[5.573828125,60.15849609375],[5.417382812500023,60.1541015625],[5.285839843750011,60.205712890624994],[5.18359375,60.3083984375],[5.137109375000023,60.44560546875],[5.168164062500011,60.484814453125],[5.546484375,60.624560546875],[5.648339843750023,60.68798828125],[5.58935546875,60.694287109375],[5.447363281250006,60.617333984374994],[5.244042968750023,60.569580078125],[5.115820312500006,60.635986328125],[5.049121093750017,60.70751953125],[5.0107421875,60.858544921874994],[5.024609375000011,60.9361328125],[5.008593750000017,61.03818359375],[5.095410156250011,61.071337890625],[5.192480468750006,61.0537109375],[5.288183593750006,61.04716796875],[5.505273437500023,61.056103515625],[5.983984375,61.117333984374994],[6.292578125,61.080957031249994],[6.41796875,61.08427734375],[6.60986328125,61.13701171875],[6.77783203125,61.142431640625],[6.903417968750006,61.1021484375],[6.972070312500023,61.05595703125],[6.980566406250006,60.994140625],[7.038671875,60.9529296875],[7.077929687500017,60.96630859375],[7.046679687500017,61.015283203124994],[7.040136718750006,61.091162109375],[7.545019531250006,61.177148437499994],[7.6044921875,61.210546875],[7.40390625,61.22216796875],[7.346582031250023,61.3005859375],[7.452539062500023,61.41923828125],[7.442578125000011,61.434619140625],[7.331152343750006,61.372021484375],[7.276269531250023,61.283935546875],[7.298046875000011,61.213623046875],[7.275976562500006,61.18095703125],[7.173535156250011,61.165966796875],[6.942578125000011,61.16054687499999],[6.794335937500023,61.190380859375],[6.657031250000017,61.206591796875],[6.610253906250023,61.2291015625],[6.625878906250023,61.279296875],[6.599902343750017,61.2896484375],[6.543066406250006,61.24453125],[6.492578125000023,61.15458984375],[6.383496093750011,61.13388671875],[6.08251953125,61.16728515625],[5.646777343750017,61.147607421874994],[5.451269531250006,61.10234375],[5.324609375000023,61.108251953125],[5.106738281250017,61.187548828125],[5.021679687500011,61.2505859375],[4.989941406250011,61.377685546875],[5.002734375000017,61.43359375],[5.172460937500006,61.45712890625],[5.25830078125,61.45546875],[5.338671875000017,61.485498046874994],[5.267578125,61.505029296874994],[5.167578125,61.54335937499999],[5.099414062500017,61.620166015625],[4.996679687500006,61.64521484375],[4.927832031250006,61.710693359375],[4.910351562500011,61.8095703125],[4.930078125000023,61.878320312499994],[4.985058593750011,61.900439453125],[5.116992187500017,61.885400390624994],[5.46533203125,61.896923828125],[5.793261718750017,61.827099609375],[6.015820312500011,61.7875],[6.466699218750023,61.807421875],[6.730761718750017,61.869775390624994],[6.682324218750011,61.88701171875],[6.395898437500023,61.850976562499994],[6.131152343750017,61.852441406249994],[5.664453125000023,61.922900390625],[5.473046875000023,61.94560546875],[5.266894531250017,61.935595703125],[5.159570312500023,61.956982421875],[5.096484375000017,62.02666015625],[5.143164062500006,62.159912109375],[5.240917968750011,62.188671875],[5.293847656250023,62.15390625],[5.357714843750017,62.151708984375],[5.42236328125,62.207373046875],[5.484277343750023,62.239111328125],[5.533300781250006,62.310888671875],[5.718164062500023,62.37890625],[5.796289062500023,62.384667968749994],[5.908300781250006,62.416015625],[5.979785156250017,62.407128906249994],[6.025585937500011,62.37568359375],[6.08349609375,62.349609375],[6.208984375,62.352783203125],[6.580078125,62.407275390625],[6.620019531250023,62.423291015625],[6.6923828125,62.46806640625],[6.457128906250006,62.448095703125],[6.26171875,62.41630859375],[6.136132812500023,62.407470703125],[6.118457031250017,62.447167968749994],[6.164746093750011,62.482421875],[6.2375,62.51992187499999],[6.272851562500023,62.583837890625],[6.352929687500023,62.6111328125],[6.439453125,62.60966796875],[6.618359375000011,62.6212890625],[6.74462890625,62.637890625],[6.961132812500011,62.6267578125],[7.283789062500006,62.602294921875],[7.491796875,62.542822265625],[7.570117187500017,62.548193359375],[7.653125,62.564013671875],[7.690722656250017,62.585595703124994],[7.527441406250006,62.610302734375],[7.518164062500006,62.6455078125],[7.538378906250017,62.6720703125],[7.8046875,62.72099609375],[8.095507812500017,62.731835937499994],[8.045507812500006,62.771240234375],[7.408398437500011,62.711767578125],[7.242089843750023,62.75234375],[7.11083984375,62.752001953125],[7.02490234375,62.72880859375],[6.779980468750011,62.700732421875],[6.734960937500006,62.720703125],[6.781542968750017,62.7896484375],[6.92822265625,62.90273437499999],[6.9404296875,62.93046875],[7.008496093750011,62.957666015624994],[7.389062500000023,63.023291015625],[7.571875,63.099511718749994],[7.654296875,63.1091796875],[7.736035156250011,63.103857421875],[7.8603515625,63.11279296875],[8.1005859375,63.090966796874994],[8.211132812500011,62.995507812499994],[8.310546875,62.96552734375],[8.623144531250006,62.846240234375],[8.609179687500017,62.88056640625],[8.338574218750011,63.0421875],[8.235156250000017,63.082177734374994],[8.158007812500017,63.161523437499994],[8.184472656250023,63.2365234375],[8.271484375,63.286572265625],[8.580175781250006,63.313378906249994],[8.635546875000017,63.342333984375],[8.641015625000023,63.39208984375],[8.59375,63.426123046875],[8.480175781250011,63.424169921875],[8.386523437500017,63.445263671875],[8.360742187500023,63.498876953125],[8.398144531250011,63.535107421875],[8.576171875,63.601171875],[8.673632812500017,63.622607421875],[8.842382812500006,63.645898437499994],[9.135839843750006,63.593652343749994],[9.158105468750023,63.566259765625],[9.075878906250011,63.50039062499999],[9.084179687500011,63.463427734375],[9.156054687500017,63.459326171875],[9.323632812500023,63.570361328125],[9.520703125000011,63.585693359375],[9.602246093750011,63.6095703125],[9.696875,63.624560546875],[9.832226562500011,63.524169921875],[9.891503906250023,63.492041015625],[9.93603515625,63.478857421875],[9.979199218750011,63.395263671875],[10.02099609375,63.3908203125],[10.08056640625,63.43271484375],[10.188574218750006,63.45478515625],[10.340039062500011,63.4693359375],[10.590917968750006,63.447216796875],[10.704492187500023,63.46357421875],[10.760156250000023,63.461279296875],[10.706738281250011,63.536328125],[10.673632812500017,63.558007812499994],[10.725292968750011,63.625],[10.779199218750023,63.651171875],[10.952539062500023,63.698193359375],[11.117871093750011,63.719189453125],[11.225781250000011,63.763818359374994],[11.370703125,63.804833984374994],[11.347949218750017,63.8376953125],[11.3076171875,63.875732421875],[11.2138671875,63.878125],[11.175585937500017,63.898876953125],[11.294628906250011,63.948193359375],[11.457617187500006,64.002978515625],[11.42919921875,64.02451171875],[11.306640625,64.048876953125],[11.213574218750011,64.030517578125],[11.0751953125,63.988134765625],[10.914257812500011,63.92109375],[10.966699218750023,63.9015625],[11.047265625000023,63.84521484375],[10.934863281250017,63.77021484375],[10.339160156250017,63.571044921875],[10.055078125000023,63.5126953125],[9.924023437500011,63.52177734375],[9.892773437500011,63.576220703125],[9.832324218750017,63.61650390625],[9.767480468750023,63.69951171875],[9.6572265625,63.697314453125],[9.594628906250023,63.678955078125],[9.567285156250023,63.70615234375],[9.61474609375,63.794824218749994],[9.7080078125,63.864892578124994],[9.864453125000011,63.917822265625],[9.939453125,63.98173828125],[10.009960937500011,64.083154296875],[10.236230468750023,64.179638671875],[10.565625,64.418310546875],[10.833984375,64.494482421875],[10.932324218750011,64.577734375],[11.090429687500006,64.61455078125],[11.225390625000017,64.6794921875],[11.331347656250017,64.6859375],[11.523828125000023,64.744384765625],[11.632910156250006,64.813916015625],[11.561718750000011,64.81826171875],[11.392480468750023,64.772998046875],[11.296777343750023,64.75478515625],[11.303515625000017,64.82939453125],[11.349902343750017,64.905908203125],[11.489355468750006,64.975830078125],[12.15966796875,65.178955078125],[12.2265625,65.145361328125],[12.306542968750023,65.085986328125],[12.508398437500006,65.0994140625],[12.738378906250006,65.214404296875],[12.91552734375,65.3392578125],[12.81982421875,65.31748046875],[12.71533203125,65.266357421875],[12.51171875,65.1953125],[12.417578125,65.18408203125],[12.363867187500006,65.193310546875],[12.333984375,65.24072265625],[12.263378906250011,65.256103515625],[12.199609375000023,65.245458984375],[12.133886718750006,65.279150390625],[12.122167968750006,65.362353515625],[12.20625,65.48623046875],[12.272851562500023,65.5681640625],[12.344824218750006,65.63017578125],[12.627734375000017,65.80615234375],[12.688867187500023,65.902197265625],[12.816796875000023,65.952880859375],[12.983007812500006,65.9416015625],[13.033105468750023,65.95625],[12.97607421875,66.019189453125],[12.794921875,66.069091796875],[12.783789062500006,66.100439453125],[13.387109375000023,66.182763671875],[13.674414062500006,66.17998046875],[13.759667968750023,66.221044921875],[13.915820312500017,66.24736328125],[14.0341796875,66.29755859375],[13.97314453125,66.3197265625],[13.681347656250011,66.273583984375],[13.498925781250023,66.251904296875],[13.416406250000023,66.252587890625],[13.35205078125,66.23671875],[13.118847656250011,66.2306640625],[13.068164062500017,66.430810546875],[13.104687500000011,66.539404296875],[13.191601562500011,66.537158203125],[13.21142578125,66.6408203125],[13.311816406250017,66.70185546875],[13.450390625000011,66.71552734375],[13.520214843750011,66.741650390625],[13.62109375,66.79482421875],[13.787988281250023,66.782470703125],[13.95947265625,66.7943359375],[13.9169921875,66.819384765625],[13.7041015625,66.85166015625],[13.651562500000011,66.907080078125],[13.726660156250006,66.938037109375],[13.808398437500017,66.960791015625],[13.880175781250017,66.964892578125],[14.022363281250023,67.073095703125],[14.108789062500023,67.11923828125],[14.20556640625,67.11123046875],[14.34033203125,67.158935546875],[14.47265625,67.14267578125],[14.600683593750006,67.173876953125],[14.775585937500011,67.194482421875],[15.415722656250011,67.20244140625],[15.434765625000011,67.2466796875],[15.300097656250017,67.25693359375],[14.824414062500011,67.268310546875],[14.58154296875,67.267431640625],[14.479296875000017,67.25595703125],[14.441699218750017,67.27138671875],[14.448339843750006,67.2978515625],[14.53662109375,67.33974609375],[14.578515625000023,67.38603515625],[14.754980468750006,67.4990234375],[14.9619140625,67.574267578125],[15.120507812500023,67.555029296875],[15.289160156250006,67.483154296875],[15.409375,67.474169921875],[15.46533203125,67.450927734375],[15.552929687500011,67.3517578125],[15.594433593750011,67.34853515625],[15.57568359375,67.44384765625],[15.691503906250006,67.52138671875],[15.661328125000011,67.542822265625],[15.4873046875,67.514794921875],[15.35400390625,67.5439453125],[15.248730468750011,67.6021484375],[15.218652343750023,67.65537109375],[15.284082031250023,67.707958984375],[15.345800781250006,67.734423828125],[15.303906250000011,67.765283203125],[15.040820312500017,67.682568359375],[14.854687500000011,67.663330078125],[14.781347656250006,67.67490234375],[14.821093750000017,67.749853515625],[14.798925781250006,67.809326171875],[15.0484375,67.95576171875],[15.13427734375,67.972705078125],[15.2744140625,67.9609375],[15.40087890625,67.91962890625],[15.506640625000017,67.926220703125],[15.621386718750017,67.948291015625],[15.605761718750017,67.987890625],[15.35693359375,68.00361328125],[15.292871093750023,68.036474609375],[15.316015625,68.06875],[15.48681640625,68.10283203125],[15.656640625000023,68.16435546875],[15.851269531250011,68.182177734375],[16.007910156250006,68.2287109375],[16.0380859375,68.2181640625],[16.064550781250006,68.19990234375],[16.12080078125001,68.02734375],[16.2607421875,67.886572265625],[16.312304687500017,67.8814453125],[16.258593750000017,68.001220703125],[16.308691406250006,68.03564453125],[16.372167968750006,68.06181640625],[16.391992187500023,68.0916015625],[16.319238281250023,68.1017578125],[16.259765625,68.14453125],[16.1748046875,68.28125],[16.20380859375001,68.316748046875],[16.38789062500001,68.38955078125],[16.61884765625001,68.406298828125],[16.86494140625001,68.3552734375],[16.95136718750001,68.3546875],[17.094042968750017,68.368408203125],[17.33613281250001,68.4103515625],[17.478515625,68.426318359375],[17.552832031250006,68.42626953125],[17.571191406250023,68.4474609375],[17.502343750000023,68.461083984375],[17.48017578125001,68.47431640625],[17.426171875000023,68.48193359375],[17.20234375000001,68.45927734375],[16.584863281250023,68.466455078125],[16.525292968750023,68.490673828125],[16.51435546875001,68.532568359375],[16.579882812500017,68.59267578125],[16.65185546875,68.62578125],[16.884667968750023,68.685400390625],[17.131152343750017,68.69345703125],[17.39082031250001,68.799365234375],[17.490039062500017,68.878759765625],[17.546289062500023,69.001123046875],[17.70458984375,69.100048828125],[18.101464843750023,69.156298828125],[18.117480468750017,69.181201171875],[18.07539062500001,69.2326171875],[18.078710937500006,69.325244140625],[18.1875,69.43310546875],[18.259765625,69.47060546875],[18.29316406250001,69.47509765625],[18.378710937500017,69.43984375],[18.48261718750001,69.36484375],[18.6455078125,69.321875],[18.858984375,69.314453125],[18.915917968750023,69.335595703125],[18.75,69.37841796875],[18.624414062500023,69.434375],[18.61445312500001,69.490576171875],[18.67402343750001,69.520361328125],[18.7666015625,69.517041015625],[18.8828125,69.52333984375],[18.991113281250023,69.5611328125],[19.0068359375,69.5876953125],[19.011328125,69.62373046875],[19.038378906250017,69.660400390625],[19.197265625,69.7478515625],[19.68701171875,69.804736328125],[19.722460937500017,69.781640625],[19.69599609375001,69.612939453125],[19.639746093750006,69.50380859375],[19.641503906250023,69.4240234375],[19.73681640625,69.50380859375],[19.864648437500023,69.722119140625],[19.960546875,69.824609375],[20.068945312500006,69.883447265625],[20.146386718750023,69.896728515625],[20.223046875000023,69.927197265625],[20.32421875,69.9453125],[20.35517578125001,69.921923828125],[20.38720703125,69.867626953125],[20.33271484375001,69.676953125],[20.338183593750017,69.616650390625],[20.277148437500017,69.53583984375],[20.04375,69.3556640625],[20.054492187500017,69.332666015625],[20.107226562500017,69.3412109375],[20.197656250000023,69.370947265625],[20.486718750000023,69.54208984375],[20.73945312500001,69.5205078125],[20.742578125000023,69.534521484375],[20.661523437500023,69.584716796875],[20.5625,69.6328125],[20.53271484375,69.692333984375],[20.545996093750006,69.85107421875],[20.6220703125,69.913916015625],[20.84033203125,69.90732421875],[20.971093750000023,69.916015625],[21.032128906250023,69.887451171875],[21.1630859375,69.889501953125],[21.253710937500017,70.00322265625],[21.432910156250017,70.01318359375],[21.590234375000023,69.938037109375],[21.779589843750017,69.887451171875],[21.931738281250006,69.814697265625],[21.974707031250006,69.8345703125],[21.892578125,70.004248046875],[21.802734375,70.066064453125],[21.607812500000023,70.098193359375],[21.400390625,70.174462890625],[21.346289062500006,70.208251953125],[21.355761718750017,70.2333984375],[21.53876953125001,70.257666015625],[21.7802734375,70.2298828125],[21.995507812500023,70.293359375],[22.05439453125001,70.2759765625],[22.21943359375001,70.3091796875],[22.32197265625001,70.264501953125],[22.384765625,70.277734375],[22.421191406250017,70.33759765625],[22.6845703125,70.374755859375],[22.851660156250006,70.340478515625],[22.941210937500017,70.30498046875],[22.982812500000023,70.236767578125],[23.046484375,70.10185546875],[23.17695312500001,70.029052734375],[23.257910156250006,69.993310546875],[23.353906250000023,69.9833984375],[23.400195312500017,70.019775390625],[23.31025390625001,70.06357421875],[23.286035156250023,70.104833984375],[23.3291015625,70.2072265625],[23.37939453125,70.2474609375],[23.661230468750006,70.399755859375],[23.89716796875001,70.478759765625],[24.038476562500023,70.4853515625],[24.285546875000023,70.66240234375],[24.355566406250006,70.694580078125],[24.420019531250006,70.702001953125],[24.40351562500001,70.7453125],[24.268164062500006,70.772705078125],[24.263476562500017,70.826318359375],[24.441796875000023,70.891552734375],[24.658007812500017,71.001025390625],[24.764746093750006,71.008447265625],[24.831640625,70.97802734375],[25.04218750000001,70.92861328125],[25.171191406250017,70.872021484375],[25.2646484375,70.843505859375],[25.32539062500001,70.8494140625],[25.375585937500006,70.891943359375],[25.435937500000023,70.911865234375],[25.56982421875,70.90068359375],[25.649707031250017,70.87333984375],[25.7119140625,70.8697265625],[25.768164062500006,70.853173828125],[25.78144531250001,70.816796875],[25.665625,70.7771484375],[25.46826171875,70.67197265625],[25.273535156250006,70.552392578125],[25.209277343750017,70.489404296875],[25.146386718750023,70.3240234375],[24.994238281250006,70.218212890625],[24.982714843750017,70.143994140625],[25.043847656250023,70.109033203125],[25.211816406250023,70.136474609375],[25.418847656250023,70.235498046875],[25.470507812500017,70.340576171875],[25.988085937500017,70.625390625],[26.230859375000023,70.7826171875],[26.506933593750006,70.91279296875],[26.66132812500001,70.93974609375],[26.733984375,70.853564453125],[26.67548828125001,70.740966796875],[26.558203125,70.669140625],[26.644628906250006,70.63623046875],[26.628125,70.55087890625],[26.601171875,70.503466796875],[26.583984375,70.45380859375],[26.585058593750006,70.410009765625],[26.666113281250006,70.4216796875],[26.989355468750006,70.511376953125],[27.0712890625,70.608447265625],[27.147265625000017,70.681201171875],[27.183691406250006,70.74404296875],[27.309375,70.803564453125],[27.546484375,70.80400390625],[27.5556640625,70.827392578125],[27.26904296875,70.910009765625],[27.235253906250023,70.947216796875],[27.331640625,70.996728515625],[27.597070312500023,71.09130859375],[27.733496093750006,71.080859375],[27.815039062500006,71.059375],[28.141699218750006,71.043017578125],[28.39228515625001,70.97529296875],[28.382714843750023,70.86943359375],[28.32685546875001,70.8251953125],[28.271875,70.79794921875],[27.950976562500017,70.717578125],[27.898046875,70.6779296875],[27.998828125000017,70.6642578125],[28.215625,70.704345703125],[28.271777343750017,70.66796875],[28.202734375,70.576904296875],[28.191015625,70.440185546875],[28.166015625,70.360400390625],[28.166015625,70.287646484375],[28.19296875,70.248583984375],[28.280078125000017,70.40341796875],[28.309863281250017,70.44306640625],[28.437304687500017,70.5013671875],[28.484765625000023,70.618798828125],[28.609375,70.75966796875],[28.749804687500017,70.84150390625],[28.83154296875,70.86396484375],[29.102343750000017,70.8607421875],[29.218554687500017,70.829931640625],[29.321093750000017,70.761474609375],[29.39765625000001,70.734130859375],[29.639062500000023,70.705029296875],[29.721972656250017,70.6685546875],[29.7375,70.646826171875],[29.796484375,70.642529296875],[29.959375,70.694384765625],[30.06513671875001,70.702978515625],[30.237695312500023,70.62216796875],[30.203027343750023,70.5623046875],[30.213183593750017,70.543310546875],[30.42207031250001,70.54716796875],[30.59589843750001,70.523681640625],[30.926367187500006,70.401123046875],[30.96064453125001,70.34384765625],[30.944140625000017,70.2744140625],[30.46894531250001,70.1978515625],[30.262988281250017,70.12470703125],[29.925878906250006,70.096484375],[28.781152343750023,70.14541015625],[28.804296875,70.092529296875],[29.601367187500017,69.9767578125],[29.646875,69.943701171875],[29.621386718750017,69.874072265625],[29.620996093750023,69.818212890625],[29.63593750000001,69.780126953125],[29.694628906250017,69.744580078125],[29.792089843750006,69.727880859375],[29.990332031250006,69.736669921875],[30.088281250000023,69.717578125],[30.155175781250023,69.745947265625],[30.180078125000023,69.841162109375],[30.237597656250017,69.86220703125],[30.34882812500001,69.8345703125],[30.397265625000017,69.7328125],[30.428320312500006,69.722265625],[30.484375,69.794873046875],[30.594531250000017,69.7896484375],[30.714453125,69.795703125],[30.869726562500006,69.783447265625],[30.924121093750017,69.6517578125],[30.922460937500006,69.605810546875],[30.89667968750001,69.56123046875],[30.860742187500023,69.538427734375],[30.788867187500017,69.528515625],[30.61542968750001,69.532568359375],[30.379687500000017,69.584716796875],[30.2275390625,69.6337890625],[30.18017578125,69.63583984375],[30.159765625,69.6298828125],[30.19648437500001,69.58056640625],[30.18671875000001,69.5427734375],[30.16376953125001,69.501611328125],[30.1318359375,69.4642578125],[30.087304687500023,69.432861328125],[29.994042968750023,69.39248046875],[29.83271484375001,69.36044921875],[29.38828125,69.29814453125],[29.35302734375,69.27060546875],[29.2099609375,69.097021484375],[29.1708984375,69.071533203125],[29.118554687500023,69.049951171875],[28.9658203125,69.02197265625]],[[28.9658203125,69.02197265625],[28.891894531250017,69.060595703125],[28.832617187500006,69.118994140625],[28.846289062500006,69.176904296875],[29.02490234375,69.28798828125],[29.191796875000023,69.36669921875],[29.238867187500006,69.3939453125],[29.333398437500023,69.472998046875],[29.1416015625,69.671435546875],[28.800390625,69.731494140625],[28.41171875,69.82275390625],[28.269140625,69.871435546875],[28.047265625000023,69.9716796875],[27.889941406250017,70.061669921875],[27.747851562500017,70.06484375],[27.591699218750023,70.042236328125],[27.348046875000023,69.96005859375],[27.205664062500006,69.918701171875],[27.127539062500006,69.906494140625],[27.108691406250017,69.9046875],[26.93427734375001,69.928125],[26.740234375,69.933056640625],[26.584277343750017,69.926318359375],[26.525390625,69.9150390625],[26.308203125,69.78193359375],[26.156152343750023,69.714697265625],[26.07246093750001,69.691552734375],[26.011523437500017,69.65263671875],[25.961523437500006,69.588623046875],[25.850195312500006,69.36650390625],[25.7671875,69.282666015625],[25.748632812500006,69.2314453125],[25.768164062500006,69.076123046875],[25.748339843750017,68.99013671875],[25.64667968750001,68.919140625],[25.575292968750006,68.887158203125],[25.480859375000023,68.880615234375],[25.35712890625001,68.862451171875],[25.249121093750006,68.821337890625],[25.1728515625,68.765283203125],[25.0869140625,68.639599609375],[24.94140625,68.59326171875],[24.80244140625001,68.606494140625],[24.703222656250006,68.65283203125],[24.490527343750017,68.688671875],[24.33203125,68.7115234375],[24.154101562500017,68.760888671875],[23.997363281250017,68.7984375],[23.85400390625,68.805908203125],[23.772558593750006,68.7583984375],[23.70703125,68.7138671875],[23.4625,68.67763671875],[23.324023437500017,68.648974609375],[23.144335937500017,68.642578125],[23.071679687500023,68.674365234375],[22.81103515625,68.6953125],[22.50068359375001,68.72021484375],[22.410937500000017,68.719873046875],[22.382910156250006,68.776611328125],[22.300390625,68.855859375],[22.0796875,68.9927734375],[21.98945312500001,69.04111328125],[21.819726562500023,69.1544921875],[21.62177734375001,69.270703125],[21.59375,69.273583984375],[21.461230468750017,69.277490234375],[21.26679687500001,69.273681640625],[21.14375,69.247265625],[21.06611328125001,69.214111328125],[21.052636718750023,69.186572265625],[21.127832031250023,69.080810546875],[21.1044921875,69.054443359375],[21.065722656250017,69.041748046875],[20.889257812500006,69.071435546875],[20.675878906250006,69.069482421875],[20.622167968750006,69.036865234375]],[[4.958691406250011,61.0845703125],[4.8701171875,61.071923828124994],[4.799023437500011,61.08271484375],[4.824414062500011,61.17822265625],[4.861621093750017,61.19384765625],[4.915429687500023,61.199365234374994],[4.973242187500006,61.1482421875],[4.958691406250011,61.0845703125]],[[5.085839843750023,60.307568359375],[5.089062500000011,60.18876953125],[4.996972656250023,60.19775390625],[4.95556640625,60.243310546874994],[4.943554687500011,60.272412109375],[4.95078125,60.341162109375],[4.930078125000023,60.412060546875],[4.957226562500011,60.447265625],[4.990625,60.452050781249994],[5.050195312500023,60.38896484375],[5.085839843750023,60.307568359375]],[[29.956152343750006,69.79677734375],[29.766210937500006,69.767529296875],[29.744238281250006,69.7916015625],[29.785937500000017,69.829052734375],[29.835839843750023,69.90556640625],[29.913964843750023,69.90244140625],[29.992968750000017,69.8732421875],[30.05517578125,69.83837890625],[29.956152343750006,69.79677734375]],[[11.967968750000011,65.626513671875],[11.90185546875,65.595703125],[11.7783203125,65.604541015625],[11.76513671875,65.63095703125],[11.800390625,65.68388671875],[11.875390625000023,65.705908203125],[11.972363281250011,65.7015625],[12.003222656250017,65.679443359375],[11.967968750000011,65.626513671875]],[[8.470800781250006,63.667138671874994],[8.356152343750011,63.664794921875],[8.287109375,63.687158203124994],[8.451269531250006,63.731835937499994],[8.708886718750023,63.774316406249994],[8.7333984375,63.801318359375],[8.7646484375,63.804638671875],[8.809179687500006,63.771435546875],[8.814843750000023,63.725976562499994],[8.786523437500023,63.703466796875],[8.470800781250006,63.667138671874994]],[[8.102734375000011,63.33759765625],[8.004687500000017,63.3369140625],[7.88828125,63.35234375],[7.815332031250023,63.38505859375],[7.804003906250017,63.413916015625],[7.938378906250023,63.4498046875],[8.073535156250017,63.47080078125],[8.136132812500023,63.43134765625],[8.140917968750017,63.36640625],[8.102734375000011,63.33759765625]],[[23.440527343750006,70.815771484375],[23.4208984375,70.784423828125],[23.387109375000023,70.75390625],[23.30517578125,70.7216796875],[23.068164062500017,70.594091796875],[22.92890625000001,70.57353515625],[22.884765625,70.553515625],[22.8291015625,70.541552734375],[22.656054687500017,70.559033203125],[22.605371093750023,70.533154296875],[22.557519531250023,70.515869140625],[22.432226562500006,70.5091796875],[22.358691406250017,70.514794921875],[22.16875,70.562109375],[22.055761718750006,70.613330078125],[21.994531250000023,70.65712890625],[22.170019531250006,70.656298828125],[22.23261718750001,70.66689453125],[22.35029296875001,70.657666015625],[22.420996093750006,70.702587890625],[22.570703125000023,70.69716796875],[22.85810546875001,70.72841796875],[22.96357421875001,70.710986328125],[23.2046875,70.815478515625],[23.280175781250023,70.812744140625],[23.395605468750006,70.842578125],[23.440527343750006,70.815771484375]],[[25.586328125000023,71.14208984375],[25.853515625,71.103857421875],[25.94501953125001,71.104638671875],[26.07763671875,71.033154296875],[26.146875,71.039501953125],[26.1337890625,70.99580078125],[25.99970703125001,70.97509765625],[25.791308593750017,70.9625],[25.760156250000023,70.95380859375],[25.58203125,70.960791015625],[25.48203125,71.019580078125],[25.31494140625,71.034130859375],[25.315234375000017,71.052978515625],[25.4234375,71.097412109375],[25.586328125000023,71.14208984375]],[[23.615332031250006,70.54931640625],[23.63398437500001,70.5025390625],[23.641015625000023,70.46396484375],[23.547753906250023,70.408154296875],[23.332812500000017,70.3349609375],[23.345117187500023,70.315283203125],[23.27070312500001,70.296484375],[23.1591796875,70.2826171875],[23.10029296875001,70.29609375],[23.1083984375,70.358837890625],[23.090625,70.37763671875],[23.005957031250006,70.352783203125],[22.917871093750023,70.38466796875],[22.917773437500017,70.416748046875],[22.941015625,70.444580078125],[23.0224609375,70.4869140625],[23.15839843750001,70.516064453125],[23.248046875,70.505126953125],[23.546679687500017,70.61708984375],[23.578906250000017,70.59365234375],[23.615332031250006,70.54931640625]],[[24.017578125,70.5673828125],[23.8271484375,70.527490234375],[23.716601562500017,70.561865234375],[23.67011718750001,70.5970703125],[23.66328125000001,70.675244140625],[23.68916015625001,70.722802734375],[23.778417968750006,70.74736328125],[23.836523437500006,70.72939453125],[23.85205078125,70.71435546875],[23.956445312500023,70.699609375],[24.07832031250001,70.6505859375],[24.017578125,70.5673828125]],[[13.872851562500017,68.26533203125],[13.932324218750011,68.2482421875],[14.087695312500017,68.25322265625],[14.118847656250011,68.246826171875],[14.096777343750006,68.218603515625],[14.029296875,68.187548828125],[13.8876953125,68.168505859375],[13.824023437500017,68.12109375],[13.778417968750006,68.10498046875],[13.656152343750023,68.10478515625],[13.583984375,68.09384765625],[13.495214843750006,68.05166015625],[13.424218750000023,68.082763671875],[13.404394531250006,68.060693359375],[13.391503906250023,68.021240234375],[13.35205078125,68.00966796875],[13.229394531250023,67.995361328125],[13.199511718750017,68.087255859375],[13.255957031250006,68.12060546875],[13.300195312500023,68.16044921875],[13.367968750000017,68.166552734375],[13.4287109375,68.163232421875],[13.537988281250023,68.2490234375],[13.687695312500011,68.273388671875],[13.784082031250023,68.276123046875],[13.872851562500017,68.26533203125]],[[12.971777343750006,67.87412109375],[12.824023437500017,67.821240234375],[12.8779296875,67.9177734375],[12.957714843750011,68.015478515625],[13.068066406250011,68.071337890625],[13.122851562500017,68.0494140625],[13.097753906250006,68.002685546875],[13.098242187500006,67.9564453125],[13.074609375000023,67.9345703125],[12.971777343750006,67.87412109375]],[[15.207128906250006,68.943115234375],[15.337207031250017,68.842431640625],[15.396582031250006,68.78359375],[15.348437500000017,68.672412109375],[15.222070312500023,68.61630859375],[15.027050781250011,68.60634765625],[14.890234375,68.610986328125],[14.804003906250017,68.63798828125],[14.793261718750017,68.66826171875],[14.743457031250017,68.677197265625],[14.612109375000017,68.638330078125],[14.520800781250017,68.633056640625],[14.404687500000023,68.663232421875],[14.373437500000023,68.71142578125],[14.496679687500006,68.771875],[14.5537109375,68.81884765625],[14.6904296875,68.814697265625],[14.724609375,68.80009765625],[14.801855468750006,68.790966796875],[14.848828125000011,68.84755859375],[14.837988281250006,68.886669921875],[14.872363281250017,68.9138671875],[15.0375,68.894287109375],[15.037792968750011,69.000537109375],[15.101855468750017,69.0080078125],[15.128125,69.003955078125],[15.175585937500017,68.98154296875],[15.207128906250006,68.943115234375]],[[19.767480468750023,70.21669921875],[19.818359375,70.20498046875],[19.86865234375,70.212255859375],[19.910449218750017,70.201904296875],[19.994140625,70.149267578125],[20.084277343750017,70.128564453125],[20.088476562500006,70.10205078125],[20.005957031250006,70.076220703125],[19.897265625000017,70.06845703125],[19.780859375,70.07744140625],[19.746679687500006,70.110498046875],[19.710839843750023,70.16533203125],[19.61347656250001,70.219091796875],[19.599023437500023,70.266162109375],[19.68378906250001,70.273583984375],[19.767480468750023,70.21669921875]],[[20.779199218750023,70.08974609375],[20.72529296875001,70.06650390625],[20.642578125,70.05703125],[20.598046875000023,70.071435546875],[20.53466796875,70.080908203125],[20.464257812500023,70.0765625],[20.405078125000017,70.119140625],[20.41171875,70.1548828125],[20.492773437500006,70.2033203125],[20.654882812500006,70.230859375],[20.786035156250023,70.21953125],[20.819433593750006,70.20546875],[20.779199218750023,70.08974609375]],[[19.25507812500001,70.06640625],[19.34375,70.011962890625],[19.422265625000023,70.0171875],[19.445898437500006,70.037744140625],[19.49951171875,70.047900390625],[19.607812500000023,70.019140625],[19.59228515625,69.970166015625],[19.4423828125,69.9083984375],[19.334765625000017,69.820263671875],[19.197070312500017,69.7998046875],[19.130859375,69.81044921875],[19.0078125,69.7595703125],[18.9091796875,69.706689453125],[18.806933593750017,69.63984375],[18.800683593750023,69.60537109375],[18.784765625,69.57900390625],[18.410253906250006,69.55283203125],[18.27412109375001,69.535498046875],[18.1298828125,69.557861328125],[18.0615234375,69.602099609375],[18.08349609375,69.626123046875],[18.227441406250023,69.6357421875],[18.23203125,69.6767578125],[18.268457031250023,69.701806640625],[18.315039062500006,69.715478515625],[18.34931640625001,69.76787109375],[18.40625,69.78154296875],[18.51240234375001,69.76865234375],[18.583984375,69.806591796875],[18.624316406250017,69.813037109375],[18.67402343750001,69.781640625],[18.69794921875001,69.824853515625],[18.67402343750001,69.864306640625],[18.6865234375,69.89091796875],[18.823828125,69.960107421875],[18.883203125000023,70.010546875],[18.968652343750023,70.043017578125],[19.05097656250001,70.037841796875],[19.07490234375001,70.085693359375],[19.05097656250001,70.13466796875],[19.06005859375,70.1666015625],[19.132714843750023,70.244140625],[19.212695312500017,70.2474609375],[19.249414062500023,70.178564453125],[19.25507812500001,70.06640625]],[[12.509570312500017,65.901953125],[12.429492187500017,65.899072265625],[12.43017578125,65.93994140625],[12.47607421875,65.977099609375],[12.548828125,66.001904296875],[12.642382812500017,66.008544921875],[12.7470703125,66.011376953125],[12.77880859375,65.99169921875],[12.718652343750023,65.9638671875],[12.509570312500017,65.901953125]],[[12.419921875,66.04326171875],[12.327343750000011,66.03662109375],[12.3427734375,66.08076171875],[12.417675781250011,66.12265625],[12.446386718750006,66.151318359375],[12.461328125000023,66.185009765625],[12.527441406250006,66.210546875],[12.620800781250011,66.1779296875],[12.62265625,66.1224609375],[12.576367187500011,66.071923828125],[12.419921875,66.04326171875]],[[11.2314453125,64.865869140625],[11.179003906250017,64.838037109375],[11.0625,64.860400390625],[10.83251953125,64.843115234375],[10.73984375,64.8703125],[10.8134765625,64.9232421875],[11.02099609375,64.9787109375],[11.132617187500017,64.976171875],[11.246191406250006,64.90791015625],[11.2314453125,64.865869140625]],[[17.503027343750006,69.596240234375],[17.62324218750001,69.5390625],[17.67734375,69.55654296875],[17.78369140625,69.563037109375],[17.86279296875,69.54296875],[17.92744140625001,69.506640625],[18.00410156250001,69.50498046875],[18.05224609375,69.45751953125],[18.076757812500006,69.395751953125],[18.02109375,69.349609375],[17.94208984375001,69.3287109375],[17.920703125000017,69.27431640625],[17.95068359375,69.19814453125],[17.773535156250006,69.172021484375],[17.568164062500017,69.160400390625],[17.487890625,69.196826171875],[17.323632812500023,69.130029296875],[17.160937500000017,69.025927734375],[17.08251953125,69.013671875],[17.077050781250023,69.046630859375],[16.96015625000001,69.069384765625],[16.810449218750023,69.070703125],[16.8154296875,69.0951171875],[16.842578125000017,69.112353515625],[16.971777343750006,69.137890625],[16.99755859375,69.190625],[16.97412109375,69.284716796875],[16.996875,69.33037109375],[17.001757812500017,69.3619140625],[17.0830078125,69.398828125],[17.36083984375,69.381494140625],[17.39453125,69.41669921875],[17.373437500000023,69.4388671875],[17.229882812500023,69.477685546875],[17.251953125,69.50380859375],[17.355566406250006,69.5271484375],[17.45361328125,69.53017578125],[17.48310546875001,69.569677734375],[17.488183593750023,69.586865234375],[17.503027343750006,69.596240234375]],[[15.760351562500006,68.56123046875],[15.772363281250023,68.55419921875],[15.908593750000023,68.65048828125],[16.0595703125,68.680517578125],[16.068945312500006,68.714013671875],[16.12744140625,68.746435546875],[16.12080078125001,68.799365234375],[16.15058593750001,68.8423828125],[16.2275390625,68.853759765625],[16.27558593750001,68.868310546875],[16.328906250000017,68.876318359375],[16.425195312500023,68.841552734375],[16.47968750000001,68.8029296875],[16.54736328125,68.716552734375],[16.51923828125001,68.6330078125],[16.337988281250006,68.56787109375],[16.193945312500006,68.5384765625],[16.0484375,68.463671875],[15.975292968750011,68.402490234375],[15.9125,68.3892578125],[15.872753906250011,68.39423828125],[15.83740234375,68.409033203125],[15.763671875,68.40908203125],[15.682519531250023,68.356005859375],[15.4375,68.312841796875],[15.34140625,68.32529296875],[15.337011718750006,68.37822265625],[15.279687500000023,68.373828125],[15.187890625000023,68.310400390625],[15.098046875000023,68.289208984375],[15.037695312500006,68.28271484375],[14.926855468750006,68.306591796875],[14.62890625,68.198486328125],[14.349511718750023,68.178271484375],[14.257519531250011,68.190771484375],[14.257226562500023,68.25693359375],[14.437792968750017,68.341552734375],[14.585839843750023,68.400341796875],[15.0953125,68.44140625],[15.41259765625,68.6158203125],[15.4892578125,68.805322265625],[15.564257812500017,68.87373046875],[15.529003906250011,68.91240234375],[15.443652343750017,68.919189453125],[15.4384765625,68.978564453125],[15.483007812500006,69.04345703125],[15.649511718750006,69.132568359375],[15.741992187500017,69.1705078125],[15.892675781250006,69.277880859375],[15.96533203125,69.30205078125],[16.04804687500001,69.30205078125],[16.129492187500006,69.27392578125],[16.11484375,69.21640625],[15.99267578125,69.112646484375],[15.811718750000011,69.02421875],[15.833789062500017,68.9607421875],[15.905859375,68.90849609375],[15.923535156250011,68.819189453125],[15.927929687500011,68.733203125],[15.790722656250011,68.617041015625],[15.760351562500006,68.56123046875]],[[-8.953564453124983,70.83916015625],[-9.045800781249994,70.832666015625],[-9.098876953125,70.8548828125],[-8.964648437499989,70.91591796875],[-8.520800781249989,71.0306640625],[-8.343701171874983,71.14013671875],[-8.001367187499994,71.177685546875],[-7.978808593749989,71.11689453125],[-8.002099609374994,71.041259765625],[-8.302343749999977,70.98115234375],[-8.635351562499977,70.9404296875],[-8.953564453124983,70.83916015625]],[[19.219335937500006,74.391015625],[19.098535156250023,74.3521484375],[18.917578125,74.41064453125],[18.797460937500006,74.485693359375],[18.861230468750023,74.51416015625],[19.182910156250017,74.517919921875],[19.261523437500017,74.478955078125],[19.274707031250017,74.45673828125],[19.219335937500006,74.391015625]],[[26.8759765625,78.64892578125],[26.7294921875,78.646484375],[26.459570312500006,78.720263671875],[26.40771484375,78.784326171875],[26.45576171875001,78.810498046875],[26.5859375,78.811474609375],[26.78876953125001,78.723974609375],[27.007617187500017,78.697509765625],[26.8759765625,78.64892578125]],[[32.525976562500006,80.119140625],[31.57763671875,80.0814453125],[31.48193359375,80.10791015625],[33.019140625,80.21796875],[33.0986328125,80.2287109375],[33.38398437500001,80.242333984375],[33.62929687500002,80.217431640625],[33.556640625,80.19814453125],[32.525976562500006,80.119140625]],[[21.60810546875001,78.595703125],[21.74560546875,78.572021484375],[22.04316406250001,78.576953125],[22.207324218750017,78.407666015625],[22.29951171875001,78.228173828125],[22.449316406250006,78.215234375],[22.73457031250001,78.23994140625],[22.988867187500006,78.251953125],[23.119238281250006,78.238623046875],[23.351660156250006,78.186279296875],[23.451953125000017,78.149462890625],[23.364648437500023,78.1205078125],[23.151953125,78.0880859375],[23.11669921875,77.99150390625],[23.33056640625,77.957861328125],[23.683984375000023,77.875439453125],[23.88300781250001,77.86474609375],[24.23828125,77.89853515625],[24.57148437500001,77.834423828125],[24.90185546875,77.756591796875],[24.129785156250023,77.658251953125],[24.061914062500023,77.630615234375],[23.954980468750023,77.55771484375],[23.841210937500023,77.49775390625],[23.736132812500017,77.462353515625],[23.505175781250017,77.401416015625],[23.380859375,77.380322265625],[23.101367187500017,77.38505859375],[22.996679687500006,77.360791015625],[22.899511718750006,77.311376953125],[22.8017578125,77.27578125],[22.5537109375,77.266650390625],[22.42695312500001,77.31591796875],[22.468847656250006,77.331103515625],[22.486621093750017,77.360107421875],[22.442480468750006,77.429345703125],[22.67890625000001,77.500146484375],[22.73261718750001,77.53935546875],[22.685351562500017,77.553515625],[22.62031250000001,77.549609375],[22.4482421875,77.571142578125],[22.397265625000017,77.5701171875],[22.25458984375001,77.528857421875],[22.05683593750001,77.501171875],[21.85615234375001,77.494140625],[21.049902343750006,77.440966796875],[20.928125,77.45966796875],[20.873144531250006,77.56533203125],[21.201074218750023,77.619482421875],[21.25146484375,77.7109375],[21.33417968750001,77.77177734375],[21.43085937500001,77.812109375],[21.6083984375,77.916064453125],[21.653125,77.92353515625],[21.21044921875,78.00576171875],[21.035449218750017,78.0591796875],[20.84492187500001,78.165869140625],[20.786425781250017,78.2521484375],[20.5283203125,78.3255859375],[20.56025390625001,78.419384765625],[20.37275390625001,78.41201171875],[20.227929687500023,78.47783203125],[20.362695312500023,78.514794921875],[21.046875,78.55673828125],[21.45478515625001,78.59755859375],[21.60810546875001,78.595703125]],[[20.897851562500023,80.249951171875],[20.998437500000023,80.238818359375],[21.549218750000023,80.242919921875],[21.654882812500006,80.21845703125],[21.696679687500023,80.1591796875],[21.780664062500023,80.13876953125],[21.897753906250017,80.132470703125],[22.190234375000017,80.059716796875],[22.28974609375001,80.04921875],[22.376367187500023,80.0896484375],[22.442675781250017,80.190283203125],[22.446191406250023,80.308349609375],[22.417871093750023,80.36552734375],[22.45078125,80.40224609375],[22.548828125,80.416455078125],[22.67207031250001,80.412646484375],[22.792578125,80.4330078125],[22.896875,80.468994140625],[23.00800781250001,80.473974609375],[23.251367187500023,80.4466796875],[23.3154296875,80.425244140625],[23.250097656250006,80.380859375],[23.224609375,80.317626953125],[23.114550781250017,80.186962890625],[23.353320312500017,80.178857421875],[23.68798828125,80.20654296875],[23.77294921875,80.244384765625],[23.952929687500017,80.30458984375],[24.142968750000023,80.295166015625],[24.23408203125001,80.303125],[24.280175781250023,80.329296875],[24.29755859375001,80.360400390625],[24.402636718750017,80.35517578125],[24.546679687500017,80.295166015625],[24.613671875000023,80.28583984375],[24.736328125,80.301318359375],[24.785937500000017,80.30068359375],[24.907031250000017,80.27666015625],[25.471289062500006,80.23310546875],[25.666894531250023,80.209765625],[25.75117187500001,80.188037109375],[25.836328125000023,80.175146484375],[26.43671875000001,80.17548828125],[26.86083984375,80.160009765625],[27.0171875,80.12548828125],[27.148339843750023,80.059228515625],[27.198632812500023,79.906591796875],[27.079882812500017,79.865380859375],[26.221093750000023,79.67744140625],[26.005859375,79.617041015625],[25.90205078125001,79.561376953125],[25.726367187500017,79.43974609375],[25.641210937500006,79.40302734375],[25.239062500000017,79.345068359375],[25.145117187500006,79.3388671875],[24.842871093750006,79.367236328125],[24.750585937500006,79.364599609375],[24.383398437500006,79.301611328125],[24.2568359375,79.2634765625],[24.132910156250006,79.215478515625],[23.94775390625,79.194287109375],[23.7587890625,79.205615234375],[22.903710937500023,79.2306640625],[22.789160156250006,79.26435546875],[22.695703125000023,79.329052734375],[22.865527343750017,79.411865234375],[21.911425781250017,79.3810546875],[20.861132812500017,79.3978515625],[20.805566406250023,79.409521484375],[20.760839843750006,79.44150390625],[20.399511718750006,79.46337890625],[20.128222656250017,79.489599609375],[19.900195312500017,79.5337890625],[19.674609375000017,79.591162109375],[19.746679687500006,79.61796875],[19.821093750000017,79.633642578125],[20.01484375000001,79.640234375],[20.187109375,79.632275390625],[20.493457031250017,79.632763671875],[20.564843750000023,79.69052734375],[20.686816406250017,79.707177734375],[20.784082031250023,79.748583984375],[20.460742187500017,79.774658203125],[20.123437500000023,79.778564453125],[19.89863281250001,79.744189453125],[19.638085937500023,79.72861328125],[19.4,79.7265625],[18.94208984375001,79.736328125],[18.725,79.7607421875],[18.428027343750017,79.82451171875],[18.32470703125,79.859716796875],[18.284765625,79.887353515625],[18.25537109375,79.92919921875],[18.594628906250023,79.96669921875],[18.726464843750023,79.996240234375],[18.85595703125,80.03662109375],[18.343847656250006,80.0595703125],[18.129492187500006,80.093408203125],[17.916894531250023,80.143115234375],[18.089453125,80.171142578125],[18.779296875,80.193505859375],[18.9619140625,80.1748046875],[19.142968750000023,80.138671875],[19.343359375,80.11640625],[19.537109375,80.163232421875],[19.35468750000001,80.185400390625],[19.19140625,80.263232421875],[19.15693359375001,80.30185546875],[19.178320312500006,80.33154296875],[19.263769531250006,80.335986328125],[19.327441406250017,80.323095703125],[19.568457031250006,80.25],[19.751074218750006,80.227197265625],[19.80224609375,80.2947265625],[19.810351562500017,80.326806640625],[19.777148437500017,80.353369140625],[19.691308593750023,80.40234375],[19.614355468750006,80.462548828125],[19.733300781250023,80.47783203125],[19.851171875,80.47119140625],[20.104296875000017,80.42998046875],[20.359375,80.400927734375],[20.475878906250017,80.371630859375],[20.693457031250006,80.298681640625],[20.897851562500023,80.249951171875]],[[16.78671875,79.90673828125],[16.838476562500006,79.90478515625],[16.888964843750017,79.9154296875],[16.925585937500017,79.94345703125],[16.96640625,79.958935546875],[17.21943359375001,79.940771484375],[17.578222656250006,79.88466796875],[17.68476562500001,79.85703125],[17.834570312500006,79.800048828125],[17.956152343750006,79.704248046875],[17.859765625000023,79.635009765625],[17.73261718750001,79.56953125],[17.6875,79.533349609375],[17.733984375,79.48134765625],[17.71503906250001,79.43076171875],[17.66875,79.3859375],[17.86103515625001,79.437060546875],[18.272070312500006,79.6005859375],[18.333300781250017,79.610693359375],[18.397363281250023,79.60517578125],[18.581445312500023,79.57158203125],[18.748437500000023,79.48818359375],[18.785253906250006,79.460595703125],[18.815234375000017,79.42666015625],[18.832421875000023,79.384765625],[18.82294921875001,79.336669921875],[18.807421875000017,79.303173828125],[18.720019531250017,79.281494140625],[18.677832031250006,79.26171875],[18.772265625000017,79.26025390625],[18.88007812500001,79.23427734375],[18.97900390625,79.179150390625],[19.089453125,79.15703125],[19.490234375,79.17568359375],[19.750878906250023,79.146826171875],[19.8935546875,79.056201171875],[20.11376953125,79.076708984375],[20.11445312500001,79.125],[20.162695312500006,79.145654296875],[20.45820312500001,79.129248046875],[20.61103515625001,79.106640625],[20.7671875,79.059130859375],[20.50068359375001,78.981396484375],[20.7203125,78.906689453125],[21.089648437500017,78.85263671875],[21.31220703125001,78.795849609375],[21.3525390625,78.772021484375],[21.388769531250006,78.7404296875],[21.243945312500017,78.6994140625],[21.096289062500006,78.67626953125],[20.72480468750001,78.672314453125],[20.387011718750017,78.64326171875],[19.76875,78.622705078125],[19.6767578125,78.6095703125],[19.65498046875001,78.5978515625],[19.618554687500023,78.562158203125],[19.380664062500017,78.47978515625],[19.150488281250006,78.37939453125],[19.0556640625,78.3189453125],[18.983789062500023,78.234228515625],[18.957617187500006,78.182470703125],[19.008691406250023,78.132275390625],[18.9951171875,78.081494140625],[18.822070312500017,78.04169921875],[18.712304687500023,78.040087890625],[18.574609375000023,78.047998046875],[18.439257812500017,78.025048828125],[18.4306640625,77.990576171875],[18.43867187500001,77.942041015625],[18.40400390625001,77.7939453125],[18.361914062500006,77.682275390625],[18.298730468750023,77.578564453125],[18.227929687500023,77.522607421875],[18.13740234375001,77.50703125],[17.847070312500023,77.49677734375],[17.623339843750017,77.399365234375],[17.442480468750006,77.225244140625],[17.3486328125,77.156884765625],[17.15253906250001,77.04892578125],[17.187890625000023,77.01064453125],[17.2490234375,76.969189453125],[17.141992187500023,76.894921875],[16.976660156250006,76.81162109375],[16.979882812500023,76.77939453125],[17.035546875000023,76.720361328125],[17.06269531250001,76.658984375],[16.93515625,76.60615234375],[16.700488281250017,76.579296875],[16.4619140625,76.609326171875],[16.345800781250006,76.644775390625],[16.238085937500017,76.701513671875],[16.123828125000017,76.738525390625],[16.004492187500006,76.7607421875],[15.546777343750023,76.88642578125],[15.124218750000011,77.085107421875],[14.738476562500011,77.162353515625],[14.486914062500006,77.1990234375],[14.365820312500006,77.23447265625],[14.24755859375,77.28212890625],[14.145312500000017,77.335595703125],[14.050390625,77.40322265625],[14.004199218750017,77.44521484375],[13.995703125,77.508203125],[14.026074218750011,77.545166015625],[14.0712890625,77.564111328125],[14.377636718750011,77.579638671875],[14.48779296875,77.570849609375],[14.596289062500006,77.537939453125],[14.695019531250011,77.525048828125],[14.920800781250023,77.688818359375],[16.205957031250023,77.782470703125],[16.619140625,77.798681640625],[17.033300781250006,77.797705078125],[16.96875,77.841943359375],[16.9140625,77.897998046875],[16.852929687500023,77.911572265625],[16.539648437500006,77.880224609375],[16.06005859375,77.847119140625],[15.826367187500011,77.8470703125],[15.585351562500023,77.869140625],[15.344824218750006,77.856982421875],[15.096875,77.809033203125],[14.846875,77.778662109375],[14.603906250000023,77.766455078125],[14.089941406250006,77.77138671875],[13.9625,77.796240234375],[13.791113281250006,77.85380859375],[13.749609375,77.88330078125],[13.714160156250017,77.91943359375],[13.680566406250023,78.028125],[13.717675781250023,78.0576171875],[13.770117187500006,78.074609375],[13.824023437500017,78.085009765625],[13.936914062500023,78.085546875],[14.047753906250023,78.066845703125],[14.307226562500006,78.005078125],[14.248144531250006,78.07138671875],[14.994726562500006,78.151220703125],[15.34140625,78.220947265625],[15.519433593750023,78.23271484375],[15.698046875000017,78.227587890625],[15.65869140625,78.264697265625],[15.657128906250023,78.2990234375],[15.783886718750011,78.32705078125],[15.875390625000023,78.339111328125],[16.150292968750023,78.352880859375],[16.776953125,78.350439453125],[17.0029296875,78.369384765625],[17.171972656250006,78.417138671875],[16.991796875,78.40048828125],[16.81123046875001,78.397265625],[16.7265625,78.407177734375],[16.53535156250001,78.448876953125],[16.448632812500023,78.503564453125],[16.696582031250017,78.612890625],[16.782617187500023,78.663623046875],[16.53046875000001,78.656298828125],[16.4462890625,78.638525390625],[16.157519531250017,78.538134765625],[15.944042968750011,78.493017578125],[15.6806640625,78.471337890625],[15.417382812500023,78.4732421875],[15.359960937500006,78.487548828125],[15.279394531250006,78.5541015625],[15.254199218750017,78.5890625],[15.264941406250017,78.60830078125],[15.348339843750011,78.663134765625],[15.3916015625,78.72119140625],[15.384179687500023,78.77119140625],[15.32275390625,78.781201171875],[15.225292968750011,78.73232421875],[15.137304687500006,78.6642578125],[15.016308593750011,78.630126953125],[14.891796875000011,78.639453125],[14.838671875000017,78.665576171875],[14.792382812500023,78.70556640625],[14.743554687500023,78.720947265625],[14.689257812500017,78.720947265625],[14.57763671875,78.70498046875],[14.467187500000023,78.675390625],[14.505273437500023,78.630517578125],[14.515429687500017,78.58056640625],[14.4677734375,78.54091796875],[14.431835937500011,78.49248046875],[14.545605468750011,78.461962890625],[14.63828125,78.414599609375],[14.49951171875,78.3923828125],[14.36328125,78.359912109375],[14.23828125,78.30986328125],[14.110449218750006,78.2708984375],[13.907617187500023,78.266748046875],[13.654980468750011,78.245166015625],[13.150195312500017,78.2375],[12.912792968750011,78.30107421875],[12.869531250000023,78.33125],[12.822167968750023,78.35146484375],[12.664648437500006,78.384765625],[12.434765625000011,78.482958984375],[12.257910156250006,78.594677734375],[12.13828125,78.605517578125],[11.961718750000017,78.6423828125],[11.865527343750017,78.67421875],[11.773828125000023,78.71640625],[11.746289062500011,78.766259765625],[11.755175781250017,78.811669921875],[11.861035156250011,78.831884765625],[11.611035156250011,78.882958984375],[11.365429687500011,78.950390625],[11.456152343750006,78.972998046875],[11.547558593750011,78.982958984375],[12.27490234375,78.9044921875],[12.323437500000011,78.9142578125],[12.4033203125,78.95322265625],[12.375,78.966357421875],[12.253125,78.975341796875],[12.087304687500023,78.97509765625],[12.045800781250023,78.983154296875],[11.981835937500023,79.02529296875],[11.925683593750023,79.07724609375],[11.901953125,79.111865234375],[11.892773437500011,79.15234375],[12.01611328125,79.2130859375],[12.083984375,79.267529296875],[11.978320312500017,79.29267578125],[11.679296875,79.291162109375],[11.579785156250011,79.28349609375],[11.616406250000011,79.2052734375],[11.521191406250011,79.15126953125],[11.3388671875,79.109130859375],[11.208105468750006,79.129638671875],[11.107226562500017,79.232958984375],[10.975390625000017,79.3048828125],[10.92578125,79.3501953125],[10.888085937500023,79.4154296875],[10.834375,79.462841796875],[10.737597656250017,79.520166015625],[10.725,79.555517578125],[10.737011718750011,79.581640625],[10.810742187500011,79.64091796875],[10.754589843750011,79.69033203125],[10.686230468750011,79.73359375],[10.68212890625,79.758251953125],[10.746386718750017,79.788671875],[10.804003906250017,79.798779296875],[10.865917968750011,79.79658203125],[11.049609375000017,79.760302734375],[11.150390625,79.7169921875],[11.185253906250011,79.720458984375],[11.250585937500006,79.78486328125],[11.343652343750023,79.7994140625],[11.702343750000011,79.82060546875],[12.101757812500011,79.737548828125],[12.205175781250006,79.719091796875],[12.287792968750011,79.713134765625],[12.245214843750006,79.75],[12.219140625000023,79.797900390625],[12.279980468750011,79.815966796875],[12.602441406250023,79.7732421875],[12.753515625,79.77578125],[13.107519531250006,79.83173828125],[13.69287109375,79.860986328125],[13.914160156250006,79.816943359375],[13.925683593750023,79.793408203125],[13.921093750000011,79.76171875],[13.907031250000017,79.752197265625],[13.777539062500011,79.715283203125],[13.039257812500011,79.68515625],[12.555371093750011,79.569482421875],[13.215136718750017,79.5880859375],[13.333789062500017,79.5748046875],[13.383593750000017,79.48076171875],[13.431640625,79.4708984375],[13.601269531250011,79.4572265625],[13.716210937500023,79.429150390625],[13.833691406250011,79.37568359375],[13.957226562500011,79.3396484375],[14.029589843750017,79.344140625],[14.055859375000011,79.38310546875],[14.0263671875,79.429296875],[14.011132812500023,79.48193359375],[14.019824218750017,79.538671875],[14.039843750000017,79.58564453125],[14.178417968750011,79.618701171875],[14.379785156250023,79.7259765625],[14.593652343750023,79.79873046875],[14.831835937500017,79.76640625],[15.05234375,79.675341796875],[15.251269531250017,79.545458984375],[15.443945312500006,79.406787109375],[15.66015625,79.23486328125],[15.764062500000023,79.174267578125],[15.858496093750006,79.159912109375],[16.29453125,78.9810546875],[16.34375,78.976123046875],[16.253515625,79.112109375],[16.02753906250001,79.3423828125],[15.875097656250006,79.51923828125],[15.840722656250023,79.586865234375],[15.816113281250011,79.6818359375],[15.82578125,79.709033203125],[15.845117187500023,79.73359375],[15.955761718750011,79.835107421875],[16.100195312500006,79.884423828125],[16.056640625,79.953955078125],[16.093847656250006,80.00732421875],[16.245703125,80.049462890625],[16.386621093750023,80.052587890625],[16.524023437500006,80.0205078125],[16.78671875,79.90673828125]],[[11.250292968750017,78.610693359375],[11.26171875,78.54169921875],[11.424218750000023,78.548583984375],[11.616308593750006,78.47509765625],[11.82568359375,78.436083984375],[11.884863281250006,78.409326171875],[11.929394531250011,78.37490234375],[12.05615234375,78.305615234375],[12.116406250000011,78.232568359375],[11.965039062500011,78.224853515625],[11.756542968750011,78.32900390625],[11.586523437500006,78.388232421875],[11.372460937500023,78.43876953125],[11.19921875,78.441259765625],[11.121289062500011,78.46328125],[10.840625,78.6447265625],[10.788867187500017,78.6865234375],[10.62841796875,78.753857421875],[10.5576171875,78.8375],[10.558203125,78.9029296875],[10.772851562500023,78.8875],[10.960839843750023,78.84638671875],[11.123925781250023,78.753369140625],[11.152929687500006,78.724462890625],[11.078222656250006,78.68603515625],[11.154980468750011,78.640576171875],[11.250292968750017,78.610693359375]],[[18.741601562500023,80.300927734375],[18.525,80.24560546875],[18.162207031250006,80.28818359375],[18.20556640625,80.331787109375],[18.29169921875001,80.358349609375],[18.519335937500017,80.34833984375],[18.741601562500023,80.300927734375]],[[29.04707031250001,78.912060546875],[29.34541015625001,78.90576171875],[29.645117187500006,78.921630859375],[29.696679687500023,78.904736328125],[29.310546875,78.852099609375],[28.881152343750017,78.880078125],[28.494531250000023,78.88720703125],[28.037890625000017,78.8287109375],[27.889062500000023,78.8521484375],[28.120996093750023,78.908447265625],[28.3740234375,78.92705078125],[28.41474609375001,78.96142578125],[28.511132812500023,78.967333984375],[28.84521484375,78.970849609375],[29.04707031250001,78.912060546875]],[[-15.543115234374994,66.228515625],[-15.428466796875,66.2248046875],[-15.240917968749983,66.259130859375],[-15.162402343749989,66.281689453125],[-14.969970703125,66.359716796875],[-14.856103515624994,66.3814453125],[-14.6806640625,66.376123046875],[-14.595849609374994,66.38154296875],[-14.593896484374994,66.373974609375],[-14.70166015625,66.34228515625],[-14.788232421874994,66.3314453125],[-14.912207031249977,66.28427734375],[-15.029980468749983,66.177880859375],[-15.117382812499983,66.125634765625],[-15.116406249999983,66.10244140625],[-15.010302734374989,66.061279296875],[-14.89404296875,66.037890625],[-14.787158203124989,66.05908203125],[-14.740429687499983,66.050830078125],[-14.698193359374983,66.02021484375],[-14.674365234374989,65.989892578125],[-14.668994140624989,65.95986328125],[-14.688232421875,65.89697265625],[-14.752539062499977,65.8337890625],[-14.839306640624983,65.780908203125],[-14.827099609374983,65.7642578125],[-14.757519531249983,65.7556640625],[-14.426220703124983,65.78994140625],[-14.391845703125,65.78740234375],[-14.372802734375,65.770361328125],[-14.369091796874983,65.738720703125],[-14.350878906249989,65.710107421875],[-14.318164062499989,65.68447265625],[-14.328369140625,65.658251953125],[-14.473388671875,65.575341796875],[-14.302294921874989,65.6275390625],[-14.166943359374983,65.64228515625],[-13.935449218749994,65.616064453125],[-13.840722656249994,65.5859375],[-13.785253906249977,65.5330078125],[-13.705126953124989,65.550537109375],[-13.6703125,65.54951171875],[-13.617871093749983,65.5193359375],[-13.616015624999989,65.487158203125],[-13.654443359374994,65.44130859375],[-13.667773437499989,65.398974609375],[-13.7080078125,65.381591796875],[-13.783251953124989,65.368994140625],[-13.804785156249977,65.35478515625],[-13.771630859374994,65.322509765625],[-13.722851562499983,65.290966796875],[-13.653466796874994,65.289501953125],[-13.64111328125,65.275],[-13.639550781249994,65.257470703125],[-13.64892578125,65.236962890625],[-13.671582031249983,65.2228515625],[-13.70742187499999,65.21513671875],[-13.7548828125,65.192529296875],[-13.580810546875,65.143017578125],[-13.55859375,65.124658203125],[-13.556103515624983,65.09765625],[-13.569677734374977,65.068115234375],[-13.599316406249983,65.0359375],[-13.65185546875,65.016845703125],[-13.777246093749994,65.013720703125],[-13.85400390625,64.99287109375],[-13.827832031249983,64.9580078125],[-13.829833984375,64.914013671875],[-13.852929687499994,64.862158203125],[-13.95166015625,64.783642578125],[-14.04443359375,64.74189453125],[-14.13515625,64.714794921875],[-14.296972656249977,64.724365234375],[-14.385107421874977,64.74521484375],[-14.375292968749989,64.67744140625],[-14.465380859374989,64.635693359375],[-14.448339843749977,64.600830078125],[-14.4169921875,64.58310546875],[-14.432568359374983,64.538330078125],[-14.475390624999989,64.493994140625],[-14.547070312499983,64.445947265625],[-14.628222656249989,64.415966796875],[-14.78955078125,64.379833984375],[-14.927392578124994,64.319677734375],[-15.021582031249977,64.2958984375],[-15.255859375,64.296923828125],[-15.494970703124977,64.258203125],[-15.832910156249994,64.17666015625],[-16.060449218749994,64.11123046875],[-16.236035156249983,64.03720703125],[-16.46806640624999,63.916357421875],[-16.640332031249983,63.865478515625],[-16.739697265624983,63.8517578125],[-16.933056640624983,63.84091796875],[-17.095117187499994,63.80810546875],[-17.633447265624994,63.74658203125],[-17.81572265624999,63.71298828125],[-17.839257812499994,63.682373046875],[-17.91484374999999,63.636376953124994],[-17.919580078124994,63.6197265625],[-17.886376953124994,63.606884765625],[-17.880273437499994,63.590185546875],[-17.946923828124994,63.5357421875],[-18.080029296874983,63.496337890625],[-18.142919921874977,63.496972656249994],[-18.21904296874999,63.530859375],[-18.252197265625,63.5296875],[-18.265234374999977,63.52451171875],[-18.26601562499999,63.5138671875],[-18.222265624999977,63.473193359375],[-18.302832031249977,63.454248046874994],[-18.65361328124999,63.406689453125],[-19.250195312499983,63.4419921875],[-19.486572265625,63.478515625],[-19.778271484374983,63.536572265625],[-19.95195312499999,63.55205078125],[-20.198144531249994,63.555810546874994],[-20.40043945312499,63.63710937499999],[-20.494042968749994,63.687353515625],[-20.501562499999977,63.708203125],[-20.49101562499999,63.731982421875],[-20.469970703125,63.748193359374994],[-20.4384765625,63.756982421874994],[-20.371728515624994,63.757861328125],[-20.363037109375,63.76494140625],[-20.413964843749994,63.80517578125],[-20.46269531249999,63.792138671874994],[-20.592968749999983,63.7353515625],[-20.65092773437499,63.73740234375],[-20.72705078125,63.765771484374994],[-20.729931640624983,63.79335937499999],[-20.878759765624977,63.80390625],[-21.00810546874999,63.83837890625],[-21.136572265624977,63.887939453125],[-21.15576171875,63.9068359375],[-21.09404296874999,63.934423828125],[-21.10595703125,63.93984375],[-21.15239257812499,63.94453125],[-21.246240234374994,63.935449218749994],[-21.387597656249994,63.872802734375],[-21.448632812499994,63.8583984375],[-22.37255859375,63.84375],[-22.606884765624983,63.837255859375],[-22.652197265624977,63.827734375],[-22.693017578124994,63.868505859375],[-22.729394531249994,63.95947265625],[-22.74296874999999,64.019384765625],[-22.733642578125,64.048388671875],[-22.701171875,64.083203125],[-22.65092773437499,64.077294921875],[-22.60307617187499,64.049609375],[-22.559814453125,64.0103515625],[-22.51005859374999,63.991455078125],[-22.187597656249977,64.039208984375],[-22.056640625,64.071337890625],[-22.0009765625,64.10185546875],[-21.935449218749994,64.153759765625],[-21.865917968749983,64.180322265625],[-21.832763671875,64.205419921875],[-21.767578125,64.28486328125],[-21.722558593749994,64.32177734375],[-21.668652343749983,64.3490234375],[-21.60600585937499,64.3666015625],[-21.463330078124983,64.379150390625],[-21.55717773437499,64.3978515625],[-21.646679687499983,64.3978515625],[-21.95122070312499,64.313916015625],[-22.053369140624994,64.313916015625],[-22.049072265625,64.327001953125],[-22.006005859374994,64.35068359375],[-21.901269531249994,64.3916015625],[-21.97319335937499,64.394677734375],[-22.000683593749983,64.41318359375],[-22.003808593749994,64.452197265625],[-21.950341796874994,64.514990234375],[-21.702392578125,64.597802734375],[-21.616650390624983,64.610009765625],[-21.590625,64.6263671875],[-21.623144531249977,64.63974609375],[-21.674951171874994,64.647705078125],[-21.924414062499977,64.562548828125],[-22.10600585937499,64.533056640625],[-22.15996093749999,64.538818359375],[-22.25390625,64.571875],[-22.2841796875,64.586572265625],[-22.32470703125,64.6244140625],[-22.32011718749999,64.647216796875],[-22.233593749999983,64.71396484375],[-22.24755859375,64.726904296875],[-22.30703125,64.73349609375],[-22.467041015625,64.794970703125],[-22.720312499999977,64.788818359375],[-23.34697265624999,64.824365234375],[-23.476464843749994,64.80927734375],[-23.68994140625,64.75654296875],[-23.818994140624994,64.73916015625],[-23.878564453124994,64.750634765625],[-23.932763671874994,64.778515625],[-23.98198242187499,64.81611328125],[-24.02617187499999,64.863427734375],[-24.007031249999983,64.896435546875],[-23.924414062499977,64.915234375],[-23.86381835937499,64.924169921875],[-23.693212890624977,64.912744140625],[-23.485302734374983,64.945849609375],[-23.352685546874994,64.952783203125],[-23.314599609374994,64.9580078125],[-23.236523437499983,64.99326171875],[-23.197998046875,65.0021484375],[-23.137890624999983,64.989794921875],[-23.108837890624983,64.965869140625],[-22.899511718749977,65.00302734375],[-22.82768554687499,65.0216796875],[-22.819580078125,65.03310546875],[-22.7880859375,65.046484375],[-22.68398437499999,65.0263671875],[-22.599707031249977,65.025732421875],[-22.494482421874977,65.03955078125],[-22.308447265624977,65.045654296875],[-21.89213867187499,65.048779296875],[-21.829785156249983,65.0791015625],[-21.800439453124994,65.105908203125],[-21.76372070312499,65.17373046875],[-21.779980468749983,65.1876953125],[-22.039990234374983,65.125244140625],[-22.099316406249983,65.126220703125],[-22.400292968749994,65.159326171875],[-22.50908203124999,65.19677734375],[-22.47343749999999,65.22685546875],[-22.31396484375,65.2916015625],[-22.149316406249994,65.3435546875],[-21.906982421875,65.39970703125],[-21.850244140624994,65.421533203125],[-21.844384765624994,65.44736328125],[-22.005761718749994,65.49345703125],[-22.311474609374983,65.480712890625],[-22.38969726562499,65.535400390625],[-22.64360351562499,65.5677734375],[-22.812646484374994,65.547412109375],[-22.902490234374994,65.58046875],[-23.1220703125,65.534765625],[-23.60454101562499,65.468603515625],[-23.796484374999977,65.42275390625],[-23.89990234375,65.407568359375],[-24.018994140624983,65.44501953125],[-24.223974609374977,65.48720703125],[-24.454785156249983,65.500341796875],[-24.475683593749977,65.5251953125],[-24.341064453125,65.601220703125],[-24.248925781249994,65.614990234375],[-24.156103515624977,65.6080078125],[-23.97900390625,65.55498046875],[-23.85673828124999,65.53837890625],[-24.010009765625,65.6162109375],[-24.006005859374994,65.646142578125],[-24.017578125,65.69091796875],[-24.065039062499977,65.71015625],[-24.111914062499977,65.759716796875],[-24.092626953124977,65.77646484375],[-24.032421874999983,65.78232421875],[-23.909082031249994,65.765576171875],[-23.615917968749983,65.67958984375],[-23.47197265624999,65.69482421875],[-23.39296875,65.726513671875],[-23.285351562499983,65.75],[-23.31591796875,65.762255859375],[-23.569287109374983,65.763720703125],[-23.704736328124994,65.781201171875],[-23.77324218749999,65.80634765625],[-23.832617187499977,65.84921875],[-23.811718749999983,65.868896484375],[-23.741308593749977,65.8845703125],[-23.52495117187499,65.880029296875],[-23.66748046875,65.954296875],[-23.766552734374983,65.99697265625],[-23.77734375,66.017578125],[-23.77055664062499,66.04345703125],[-23.75712890624999,66.060791015625],[-23.737158203124977,66.06943359375],[-23.488867187499977,66.02607421875],[-23.434472656249994,66.02421875],[-23.48466796874999,66.05224609375],[-23.59355468749999,66.093408203125],[-23.598535156249994,66.108837890625],[-23.552636718749994,66.12158203125],[-23.529980468749983,66.14501953125],[-23.527929687499977,66.164404296875],[-23.452539062499994,66.181005859375],[-23.376562499999977,66.18173828125],[-23.3,66.1666015625],[-23.06254882812499,66.08623046875],[-23.028515624999983,66.063671875],[-23.017285156249983,66.033935546875],[-23.028906249999977,65.9970703125],[-23.018994140624983,65.98212890625],[-22.926220703124983,65.99482421875],[-22.852246093749983,65.979296875],[-22.815332031249994,65.98349609375],[-22.723339843749983,66.039013671875],[-22.659863281249983,66.025927734375],[-22.62158203125,65.999951171875],[-22.609716796874977,65.97646484375],[-22.60405273437499,65.944189453125],[-22.620214843749977,65.876953125],[-22.61601562499999,65.86748046875],[-22.55156249999999,65.905419921875],[-22.44169921874999,65.90830078125],[-22.42753906249999,65.927392578125],[-22.42421875,65.998095703125],[-22.43315429687499,66.057666015625],[-22.4453125,66.07001953125],[-22.80644531249999,66.152587890625],[-22.869238281249977,66.1720703125],[-22.947900390624994,66.212744140625],[-22.931982421874977,66.233203125],[-22.86162109374999,66.25146484375],[-22.755517578124994,66.258740234375],[-22.509375,66.257763671875],[-22.48442382812499,66.26630859375],[-22.532128906249994,66.287744140625],[-22.646093749999977,66.3015625],[-22.672753906249994,66.313916015625],[-22.686230468749983,66.3376953125],[-22.82133789062499,66.32470703125],[-22.972021484374977,66.324169921875],[-23.116943359375,66.338720703125],[-23.11992187499999,66.3572265625],[-23.062695312499983,66.384375],[-22.9443359375,66.429443359375],[-22.88920898437499,66.440625],[-22.723730468749977,66.432763671875],[-22.559326171875,66.44541015625],[-22.426123046874977,66.430126953125],[-22.320458984374994,66.385498046875],[-22.17021484374999,66.30712890625],[-21.966992187499983,66.256982421875],[-21.948388671874994,66.241259765625],[-21.84023437499999,66.2001953125],[-21.62529296874999,66.089697265625],[-21.406884765624994,66.0255859375],[-21.39677734374999,66.00927734375],[-21.432714843749977,65.990087890625],[-21.51665039062499,65.967578125],[-21.497460937499994,65.955078125],[-21.387792968749977,65.93876953125],[-21.308789062499983,65.8953125],[-21.303466796875,65.87646484375],[-21.374902343749994,65.74189453125],[-21.412841796875,65.713330078125],[-21.456640624999977,65.6982421875],[-21.658447265625,65.723583984375],[-21.6103515625,65.68076171875],[-21.466259765624983,65.63515625],[-21.43364257812499,65.60966796875],[-21.45512695312499,65.58466796875],[-21.439404296874983,65.57890625],[-21.386621093749994,65.592431640625],[-21.36474609375,65.57822265625],[-21.373876953124977,65.536376953125],[-21.396337890624977,65.50166015625],[-21.43217773437499,65.474072265625],[-21.421875,65.462158203125],[-21.365478515625,65.4658203125],[-21.31254882812499,65.45869140625],[-21.22998046875,65.42060546875],[-21.162988281249994,65.304248046875],[-21.12968749999999,65.2666015625],[-21.105712890625,65.3],[-21.075585937499994,65.3849609375],[-21.047314453124983,65.428369140625],[-21.020849609374977,65.4302734375],[-20.997998046874983,65.44453125],[-20.978857421874977,65.47119140625],[-20.93974609374999,65.565185546875],[-20.804345703124994,65.63642578125],[-20.739697265624983,65.658251953125],[-20.678955078125,65.6630859375],[-20.6494140625,65.65419921875],[-20.54814453124999,65.5794921875],[-20.486523437499983,65.566943359375],[-20.454833984375,65.571044921875],[-20.411523437499994,65.621728515625],[-20.356640624999983,65.71904296875],[-20.344091796874977,65.827734375],[-20.373925781249994,65.947705078125],[-20.356591796874994,66.033251953125],[-20.292138671874994,66.084375],[-20.20751953125,66.10009765625],[-20.102685546874994,66.08046875],[-20.026074218749983,66.049267578125],[-19.874755859375,65.930126953125],[-19.752636718749983,65.8677734375],[-19.647851562499994,65.80078125],[-19.59355468749999,65.779052734375],[-19.489697265624983,65.76806640625],[-19.461816406249994,65.77236328125],[-19.443261718749994,65.787841796875],[-19.43388671874999,65.814453125],[-19.45625,65.984912109375],[-19.42705078124999,66.03798828125],[-19.382958984374994,66.07568359375],[-19.1953125,66.097900390625],[-19.093212890624983,66.121533203125],[-18.99375,66.1603515625],[-18.911328124999983,66.18115234375],[-18.845898437499983,66.183935546875],[-18.777539062499983,66.168798828125],[-18.706201171874994,66.1357421875],[-18.594921874999983,66.071337890625],[-18.454931640624977,65.96455078125],[-18.276953124999977,65.884716796875],[-18.18364257812499,65.7580078125],[-18.163720703124994,65.736572265625],[-18.141943359374977,65.73408203125],[-18.118408203125,65.750537109375],[-18.10332031249999,65.77392578125],[-18.099023437499994,65.8302734375],[-18.148876953124983,65.905029296875],[-18.315332031249994,66.0931640625],[-18.318212890624977,66.12880859375],[-18.29716796874999,66.157421875],[-18.179882812499983,66.160546875],[-17.906982421875,66.143310546875],[-17.81982421875,66.114111328125],[-17.63432617187499,65.999169921875],[-17.582226562499983,65.97138671875],[-17.550439453124994,65.964404296875],[-17.539013671874983,65.9783203125],[-17.467041015625,65.999658203125],[-17.417236328125,66.025537109375],[-17.33427734374999,66.0888671875],[-17.153027343749983,66.20283203125],[-17.115380859374994,66.206201171875],[-17.062451171874983,66.197216796875],[-16.96953124999999,66.1673828125],[-16.925439453124994,66.14345703125],[-16.838037109374994,66.125244140625],[-16.7484375,66.131640625],[-16.624755859375,66.17158203125],[-16.485009765624994,66.195947265625],[-16.437109374999977,66.2525390625],[-16.428076171874977,66.278369140625],[-16.540673828124994,66.446728515625],[-16.493359374999983,66.48115234375],[-16.24931640624999,66.522900390625],[-16.035888671875,66.52607421875],[-15.985400390624989,66.5146484375],[-15.850927734374977,66.432861328125],[-15.759765625,66.39169921875],[-15.713769531249994,66.35859375],[-15.702783203124994,66.2857421875],[-15.647363281249994,66.2587890625],[-15.543115234374994,66.228515625]],[[28.9658203125,69.02197265625],[28.89892578125,69.00966796875],[28.692187500000017,68.96103515625],[28.566015625,68.92822265625],[28.4140625,68.904150390625],[28.453515625000023,68.872265625],[28.705957031250023,68.86552734375],[28.74482421875001,68.8564453125],[28.772851562500023,68.8400390625],[28.777636718750017,68.813818359375],[28.752050781250006,68.771435546875],[28.479296875000017,68.537646484375],[28.470703125,68.48837890625],[28.56015625,68.3513671875],[28.68515625,68.189794921875],[29.06298828125,68.11796875],[29.343847656250006,68.061865234375],[29.524218750000017,67.9291015625],[29.821582031250017,67.75400390625],[29.97919921875001,67.68857421875],[29.988085937500017,67.66826171875],[29.941210937500017,67.5474609375],[29.750585937500006,67.426416015625],[29.572265625,67.324365234375],[29.3876953125,67.201416015625],[29.24335937500001,67.09658203125],[29.087011718750006,66.970947265625],[29.06904296875001,66.930224609375],[29.066210937500017,66.891748046875],[29.093066406250017,66.84921875],[29.293261718750017,66.6955078125],[29.371191406250006,66.617041015625],[29.46435546875,66.532177734375],[29.544335937500023,66.439697265625],[29.590722656250023,66.3568359375],[29.6708984375,66.276123046875],[29.720703125,66.23486328125],[29.803515625000017,66.17705078125],[29.903417968750006,66.091064453125],[29.936621093750006,66.02294921875],[30.0875,65.7865234375],[30.10273437500001,65.72626953125],[30.0953125,65.681689453125],[30.02900390625001,65.670703125],[29.882617187500017,65.663623046875],[29.723925781250017,65.634375],[29.715917968750006,65.624560546875],[29.819433593750006,65.56875],[29.72802734375,65.4734375],[29.71484375,65.336962890625],[29.6171875,65.26533203125],[29.608007812500006,65.248681640625],[29.612402343750006,65.234765625],[29.629687500000017,65.223876953125],[29.810546875,65.204736328125],[29.826171875,65.185302734375],[29.826953125000017,65.145068359375],[29.810839843750017,65.10791015625],[29.720019531250017,65.080322265625],[29.622460937500023,65.039501953125],[29.600878906250017,65.001953125],[29.60419921875001,64.968408203125],[29.6375,64.911767578125],[29.70166015625,64.845751953125],[29.783203125,64.804296875],[30.072851562500006,64.7650390625],[30.110253906250023,64.732568359375],[30.12617187500001,64.6880859375],[30.1201171875,64.64462890625],[29.98554687500001,64.55771484375],[29.986621093750017,64.524267578125],[30.041894531250023,64.443359375],[30.10810546875001,64.36611328125],[30.390625,64.282421875],[30.487890625,64.2365234375],[30.513769531250006,64.2],[30.527929687500006,64.14111328125],[30.52607421875001,64.077294921875],[30.50390625,64.02060546875],[30.415332031250017,63.947509765625],[30.210253906250017,63.8033203125],[30.00410156250001,63.747314453125],[29.991503906250017,63.73515625],[30.05537109375001,63.689013671875],[30.418554687500006,63.504052734374994],[30.6552734375,63.41748046875],[30.97480468750001,63.300634765625],[31.18085937500001,63.20830078125],[31.247460937500023,63.14189453125],[31.336718750000017,63.06806640625],[31.43701171875,63.007714843749994],[31.50927734375,62.955322265625],[31.536523437500023,62.921630859375],[31.533984375000017,62.885400390624994],[31.437304687500017,62.776123046875],[31.382421875,62.691650390625],[31.28564453125,62.567822265625],[31.18671875000001,62.481396484375],[30.93574218750001,62.323779296875],[30.565625,62.127587890624994],[30.47968750000001,62.068212890625],[30.306445312500017,61.96484375],[30.00996093750001,61.757373046875],[29.933203125,61.711572265624994],[29.69013671875001,61.54609375],[29.579394531250017,61.49345703125],[29.49238281250001,61.444238281249994],[29.25166015625001,61.28779296875],[28.992968750000017,61.16904296875],[28.739062500000017,61.058740234374994],[28.662890625000017,61.002832031249994],[28.568164062500017,60.960205078125],[28.455078125,60.91962890625],[28.40742187500001,60.896923828125],[28.151953125,60.745849609375],[27.797656250000017,60.5361328125],[27.761621093750023,60.532861328124994],[27.669335937500023,60.498974609375],[27.52509765625001,60.490771484375],[27.46240234375,60.46484375],[27.24189453125001,60.538671875],[27.20527343750001,60.54345703125],[27.075585937500023,60.525146484375],[26.951171875,60.471484375],[26.721484375000017,60.455078125],[26.607421875,60.4376953125],[26.53466796875,60.412890625],[26.51972656250001,60.471582031249994],[26.551171875000023,60.54599609375],[26.60175781250001,60.595605468749994],[26.6064453125,60.6279296875],[26.5693359375,60.624560546875],[26.49580078125001,60.551806640625],[26.456445312500023,60.466796875],[26.377734375000017,60.424072265625],[26.2046875,60.406591796875],[26.036035156250023,60.47490234375],[25.955957031250023,60.47421875],[26.00625,60.42529296875],[26.04023437500001,60.37158203125],[26.03583984375001,60.34150390625],[25.945898437500006,60.34677734375],[25.845800781250006,60.314599609374994],[25.75800781250001,60.267529296875],[25.715429687500006,60.267431640625],[25.65644531250001,60.333203125],[25.548242187500023,60.302490234375],[25.45576171875001,60.26123046875],[25.267871093750017,60.24833984375],[25.155859375,60.194091796875],[24.957617187500006,60.157470703125],[24.848730468750006,60.158349609374994],[24.600488281250023,60.1142578125],[24.517968750000023,60.046289062499994],[24.445605468750017,60.0212890625],[24.342578125000017,60.042333984375],[24.025195312500017,60.009179687499994],[23.721777343750006,59.965673828125],[23.592675781250023,59.968164062499994],[23.46357421875001,59.986230468749994],[23.326757812500006,59.92578125],[23.181445312500017,59.844921875],[23.021289062500017,59.816015625],[22.9638671875,59.8263671875],[23.009765625,59.868798828124994],[23.11572265625,59.9126953125],[23.1884765625,59.972216796875],[23.19843750000001,60.021826171875],[23.1484375,60.04130859375],[23.080175781250006,60.04726562499999],[22.994140625,60.098535156249994],[22.91171875,60.209716796875],[22.867089843750023,60.2158203125],[22.84443359375001,60.18662109375],[22.819140625000017,60.1013671875],[22.79345703125,60.076806640624994],[22.749804687500017,60.057275390624994],[22.697363281250006,60.03759765625],[22.64619140625001,60.02802734375],[22.462695312500017,60.029199218749994],[22.438574218750006,60.072265625],[22.438574218750006,60.090283203125],[22.471093750000023,60.14697265625],[22.442675781250017,60.156884765624994],[22.4697265625,60.201318359374994],[22.512988281250017,60.19892578125],[22.564257812500017,60.205517578125],[22.589941406250006,60.228369140625],[22.587988281250006,60.2556640625],[22.516699218750006,60.262744140625],[22.512304687500006,60.28134765625],[22.57587890625001,60.35908203125],[22.5849609375,60.38056640625],[22.560351562500017,60.385009765625],[22.5205078125,60.3765625],[22.257910156250006,60.400927734375],[21.933984375000023,60.50029296875],[21.854296875000017,60.505419921875],[21.805273437500006,60.59414062499999],[21.727148437500006,60.582910156249994],[21.61328125,60.53095703125],[21.52783203125,60.57041015625],[21.43603515625,60.59638671875],[21.41064453125,60.636962890625],[21.411914062500017,60.696826171875],[21.40400390625001,60.767431640625],[21.37890625,60.850048828125],[21.36054687500001,60.96748046875],[21.377734375000017,61.059228515624994],[21.450976562500017,61.1271484375],[21.479101562500006,61.1705078125],[21.513476562500017,61.281201171875],[21.52119140625001,61.41083984375],[21.501757812500017,61.454980468749994],[21.506640625000017,61.484326171875],[21.565039062500006,61.484326171875],[21.55234375,61.509521484375],[21.526660156250017,61.523291015625],[21.49824218750001,61.551953125],[21.5224609375,61.567138671875],[21.592382812500006,61.568212890625],[21.598046875000023,61.577880859375],[21.60595703125,61.591552734375],[21.551855468750006,61.666845703125],[21.54560546875001,61.702734375],[21.470507812500017,61.811669921874994],[21.384863281250006,61.914941406249994],[21.255957031250006,61.989648437499994],[21.301660156250023,62.112646484375],[21.35371093750001,62.223828125],[21.343359375,62.277392578125],[21.32343750000001,62.342578125],[21.165625,62.4140625],[21.1421875,62.514794921874994],[21.103613281250006,62.622949218749994],[21.1181640625,62.6892578125],[21.143847656250017,62.739990234375],[21.195703125000023,62.79052734375],[21.45751953125,62.95],[21.473535156250023,63.033251953125],[21.650976562500006,63.039306640625],[21.568652343750017,63.113720703125],[21.549218750000023,63.155517578125],[21.54511718750001,63.204296875],[21.800390625,63.237695312499994],[21.89570312500001,63.21025390625],[22.12031250000001,63.244140625],[22.319726562500023,63.310449218749994],[22.316210937500017,63.345654296875],[22.285546875000023,63.377197265625],[22.243261718750006,63.437939453125],[22.273242187500017,63.45478515625],[22.345996093750017,63.4423828125],[22.312597656250006,63.472558593749994],[22.318652343750017,63.50439453125],[22.398046875,63.491162109375],[22.527636718750017,63.579980468749994],[22.532324218750006,63.647851562499994],[22.75625,63.683349609375],[23.014453125000017,63.821826171875],[23.133593750000017,63.86494140625],[23.24873046875001,63.896142578124994],[23.493945312500017,64.03447265625],[23.598925781250017,64.04091796875],[23.652929687500006,64.1341796875],[23.861425781250006,64.258251953125],[23.9248046875,64.27412109375],[24.022265625000017,64.385986328125],[24.2783203125,64.515283203125],[24.440625,64.680126953125],[24.530175781250023,64.738671875],[24.557910156250017,64.801025390625],[24.657617187500023,64.806298828125],[24.74755859375,64.852099609375],[24.942187500000017,64.884033203125],[25.13427734375,64.8751953125],[25.214257812500023,64.853466796875],[25.288183593750006,64.8603515625],[25.28076171875,64.91640625],[25.22802734375,64.951025390625],[25.27109375,64.98427734375],[25.37265625,65.00947265625],[25.3623046875,65.06513671875],[25.340234375000023,65.0986328125],[25.255859375,65.14326171875],[25.2978515625,65.243212890625],[25.307910156250017,65.352734375],[25.34785156250001,65.479248046875],[25.241796875,65.5462890625],[24.83935546875,65.6603515625],[24.764257812500006,65.656396484375],[24.674902343750006,65.670703125],[24.58154296875,65.75712890625],[24.62324218750001,65.831689453125],[24.628027343750006,65.8591796875],[24.591601562500017,65.858349609375],[24.532617187500023,65.822021484375],[24.404296875,65.78046875],[24.2375,65.812353515625],[24.15546875000001,65.8052734375]],[[21.994238281250006,60.336669921875],[21.921484375,60.332275390625],[21.818652343750017,60.3818359375],[21.8056640625,60.401220703125],[21.845996093750017,60.412451171875],[21.8193359375,60.452294921874994],[21.827246093750006,60.469921875],[21.906835937500006,60.4384765625],[21.950292968750006,60.401708984375],[21.9078125,60.3931640625],[21.979785156250017,60.355224609375],[21.994238281250006,60.336669921875]],[[21.2177734375,63.24130859375],[21.228515625,63.22265625],[21.287109375,63.227783203125],[21.366015625000017,63.261767578125],[21.421972656250006,63.2458984375],[21.415625,63.19736328125],[21.37763671875001,63.19921875],[21.3671875,63.2072265625],[21.318457031250006,63.1794921875],[21.30976562500001,63.1626953125],[21.25341796875,63.152001953124994],[21.149316406250023,63.199462890625],[21.083886718750023,63.2775390625],[21.236328125,63.27773437499999],[21.221777343750006,63.259130859375],[21.2177734375,63.24130859375]],[[22.175097656250017,60.370751953124994],[22.3017578125,60.347558593749994],[22.35498046875,60.35585937499999],[22.41552734375,60.303369140624994],[22.312890625000023,60.269970703125],[22.305761718750006,60.228564453125],[22.346289062500006,60.20283203125],[22.36054687500001,60.165576171875],[22.25830078125,60.165625],[22.209375,60.19697265625],[22.188085937500006,60.236767578125],[22.140527343750023,60.264892578125],[22.0771484375,60.286328125],[22.108203125000017,60.314892578125],[22.125878906250023,60.35585937499999],[22.175097656250017,60.370751953124994]],[[21.45087890625001,60.52958984375],[21.436914062500023,60.483056640624994],[21.369042968750023,60.488232421875],[21.3,60.47978515625],[21.24433593750001,60.5259765625],[21.21455078125001,60.603857421875],[21.224707031250006,60.62060546875],[21.26806640625,60.63828125],[21.30126953125,60.595556640625],[21.45087890625001,60.52958984375]],[[21.83320312500001,60.140527343749994],[21.73310546875001,60.10615234375],[21.69501953125001,60.11435546875],[21.70478515625001,60.172314453125],[21.764257812500006,60.198828125],[21.864355468750006,60.201806640624994],[21.83320312500001,60.140527343749994]],[[21.628320312500023,60.1078125],[21.540625,60.097900390625],[21.48603515625001,60.126806640625],[21.506738281250023,60.148339843749994],[21.56796875,60.172314453125],[21.634082031250017,60.168994140625],[21.64814453125001,60.140869140625],[21.628320312500023,60.1078125]],[[24.848242187500006,64.991015625],[24.69892578125001,64.9578125],[24.57861328125,64.978564453125],[24.576562500000023,65.04287109375],[24.651171875000017,65.073974609375],[24.786035156250023,65.08642578125],[24.970605468750023,65.055322265625],[24.99755859375,65.038720703125],[24.89179687500001,65.02626953125],[24.848242187500006,64.991015625]],[[12.56875,55.78505859375],[12.571191406250023,55.6849609375],[12.545214843750017,55.655810546874996],[12.507031250000011,55.63662109375],[12.407128906250023,55.616259765624996],[12.320605468750017,55.587841796875],[12.243457031250017,55.537890625],[12.215039062500011,55.46650390625],[12.275390625,55.4142578125],[12.385156250000023,55.38564453125],[12.4130859375,55.286181640624996],[12.322460937500011,55.237109375],[12.089941406250006,55.188134765625],[12.065527343750006,55.069921875],[12.073046875000017,54.9767578125],[12.06884765625,54.909033203125],[12.050390625,54.81533203125],[11.8623046875,54.772607421875],[11.740917968750011,54.915332031249996],[11.73984375,54.972460937499996],[11.70361328125,55.03916015625],[11.69677734375,55.095996093749996],[11.65380859375,55.1869140625],[11.475878906250017,55.2115234375],[11.406835937500006,55.21474609375],[11.310253906250011,55.1978515625],[11.286328125000011,55.204443359375],[11.170703125000017,55.32861328125],[11.189746093750017,55.465625],[11.128027343750006,55.534765625],[11.119531250000023,55.566064453125],[11.120996093750023,55.600732421875],[11.0703125,55.629296875],[11.0087890625,55.64443359375],[10.978906250000023,55.721533203125],[11.049609375000017,55.740234375],[11.224414062500017,55.731201171875],[11.275488281250006,55.736474609375],[11.322265625,55.7525390625],[11.463671875000017,55.879296875],[11.459570312500006,55.9072265625],[11.474707031250006,55.94345703125],[11.627734375000017,55.956884765625],[11.695898437500006,55.90791015625],[11.682226562500006,55.8294921875],[11.69091796875,55.72900390625],[11.783593750000023,55.70166015625],[11.819726562500023,55.69765625],[11.858300781250023,55.771875],[11.885351562500006,55.807958984375],[11.922070312500011,55.828076171875],[11.9345703125,55.8958984375],[11.912792968750011,55.937304687499996],[11.866406250000011,55.9681640625],[12.039648437500006,56.0521484375],[12.218945312500011,56.11865234375],[12.3232421875,56.122119140624996],[12.42822265625,56.105859375],[12.525781250000023,56.0833984375],[12.578710937500006,56.0640625],[12.6083984375,56.033007812499996],[12.54296875,55.958984375],[12.524804687500023,55.91845703125],[12.56875,55.78505859375]],[[9.73974609375,54.825537109375],[9.725,54.825537109375],[9.661230468750006,54.834375],[9.615820312500006,54.855419921875],[9.498730468750011,54.8404296875],[9.341992187500011,54.806298828125],[9.254980468750006,54.8080078125],[9.185839843750017,54.844677734375],[8.902929687500006,54.896923828125],[8.857226562500017,54.901123046875],[8.670703125000017,54.9033203125],[8.670312500000023,54.90341796875],[8.661425781250017,54.9859375],[8.63828125,55.045556640625],[8.572949218750011,55.13427734375],[8.669824218750023,55.1556640625],[8.651074218750011,55.328564453125],[8.615917968750011,55.418212890625],[8.3453125,55.510302734374996],[8.132128906250017,55.5998046875],[8.181347656250011,55.901171875],[8.202343750000011,55.982373046875],[8.121484375000023,56.139892578125],[8.1298828125,56.32119140625],[8.163964843750023,56.606884765625],[8.231738281250017,56.61806640625],[8.281445312500011,56.61669921875],[8.47314453125,56.5654296875],[8.552929687500011,56.560302734375],[8.607617187500011,56.514501953125],[8.671679687500017,56.495654296874996],[8.718066406250017,56.544287109375],[8.736132812500017,56.62744140625],[8.888085937500023,56.73505859375],[8.994531250000023,56.7748046875],[9.067089843750011,56.79384765625],[9.140332031250011,56.750439453125],[9.196386718750006,56.70166015625],[9.209667968750011,56.808398437499996],[9.2548828125,57.01171875],[9.110449218750006,57.04365234375],[8.992773437500006,57.01611328125],[8.876074218750006,56.887255859374996],[8.77197265625,56.72529296875],[8.603125,56.710400390625],[8.468359375,56.66455078125],[8.3466796875,56.712109375],[8.268261718750011,56.75400390625],[8.266308593750011,56.81533203125],[8.284082031250023,56.85234375],[8.427050781250017,56.984423828124996],[8.618554687500023,57.111279296875],[8.8115234375,57.11005859375],[8.952246093750006,57.1505859375],[9.036328125000011,57.155419921875],[9.298828125,57.146533203124996],[9.43359375,57.17431640625],[9.554296875,57.232470703124996],[9.815136718750011,57.47841796875],[9.962304687500023,57.58095703125],[10.259082031250017,57.617041015625],[10.533300781250006,57.735400390624996],[10.609960937500006,57.7369140625],[10.48095703125,57.648681640625],[10.460253906250017,57.614550781249996],[10.444628906250017,57.56220703125],[10.537109375,57.448535156249996],[10.517578125,57.379345703125],[10.524121093750011,57.243212890624996],[10.436914062500023,57.172265625],[10.338476562500006,57.021337890625],[10.296093750000011,56.99912109375],[10.287011718750023,56.82294921875],[10.296679687500017,56.780908203125],[10.28271484375,56.6205078125],[10.383593750000017,56.554833984375],[10.490234375,56.5205078125],[10.845898437500011,56.521728515625],[10.8828125,56.49287109375],[10.926171875000023,56.44326171875],[10.894433593750023,56.359033203125],[10.8564453125,56.2955078125],[10.75341796875,56.241992187499996],[10.621191406250006,56.202099609375],[10.538964843750023,56.200341796875],[10.426953125000011,56.276171875],[10.373730468750011,56.2515625],[10.31875,56.212890625],[10.226660156250006,56.00537109375],[10.183007812500023,55.865185546875],[10.159375,55.853808593749996],[10.107324218750023,55.874462890625],[10.017382812500017,55.87607421875],[9.903710937500023,55.842822265624996],[9.962011718750006,55.8130859375],[10.023632812500011,55.76142578125],[9.9990234375,55.735546875],[9.899023437500006,55.707568359374996],[9.810351562500017,55.6509765625],[9.773242187500017,55.608154296875],[9.661425781250017,55.557470703125],[9.591113281250017,55.493212890624996],[9.625585937500006,55.41357421875],[9.640234375,55.34365234375],[9.670996093750006,55.26640625],[9.643261718750011,55.204736328125],[9.504785156250023,55.116259765624996],[9.453710937500006,55.03955078125],[9.572363281250006,55.04052734375],[9.645410156250023,55.022802734375],[9.688183593750011,55.000146484375],[9.732324218750023,54.968017578125],[9.705273437500011,54.9283203125],[9.73974609375,54.825537109375]],[[10.645117187500006,55.609814453125],[10.686816406250017,55.5576171875],[10.738085937500017,55.446337890624996],[10.819238281250023,55.321875],[10.785351562500011,55.269775390625],[10.808398437500017,55.20302734375],[10.785253906250006,55.1333984375],[10.623828125000017,55.05244140625],[10.442773437500023,55.048779296875],[10.254589843750011,55.087890625],[9.98876953125,55.16318359375],[9.967382812500006,55.20546875],[9.930078125000023,55.22890625],[9.858984375,55.357226562499996],[9.860644531250017,55.515478515625],[9.994238281250006,55.535302734375],[10.2861328125,55.61083984375],[10.353613281250006,55.598974609375],[10.424023437500011,55.560351562499996],[10.505078125000011,55.558056640625],[10.622753906250011,55.612841796874996],[10.645117187500006,55.609814453125]],[[11.361425781250006,54.891650390624996],[11.538378906250017,54.82958984375],[11.658105468750023,54.833154296875],[11.739550781250017,54.807421875],[11.758984375000011,54.76767578125],[11.765917968750017,54.679443359375],[11.680371093750011,54.6537109375],[11.5859375,54.662451171875],[11.457421875000023,54.628857421875],[11.035546875000023,54.773095703125],[11.041699218750011,54.893359375],[11.05859375,54.940576171875],[11.258496093750011,54.951806640625],[11.361425781250006,54.891650390624996]],[[10.734082031250011,54.750732421875],[10.689746093750017,54.745068359375],[10.629492187500006,54.82607421875],[10.621679687500006,54.851416015625],[10.692480468750006,54.903271484375],[10.73828125,54.96201171875],[10.856738281250017,55.052197265625],[10.925,55.157861328125],[10.951074218750023,55.156201171875],[10.920800781250023,55.062109375],[10.765234375,54.799658203125],[10.734082031250011,54.750732421875]],[[12.549218750000023,54.965771484375],[12.511035156250017,54.95087890625],[12.357519531250006,54.96181640625],[12.184472656250023,54.89248046875],[12.118847656250011,54.914404296875],[12.143652343750006,54.95869140625],[12.16171875,54.9748046875],[12.219921875000011,54.993603515625],[12.2587890625,55.02109375],[12.274023437500006,55.064111328125],[12.31005859375,55.04091796875],[12.417187500000011,55.031201171875],[12.469531250000017,55.01748046875],[12.51328125,54.997314453125],[12.549218750000023,54.965771484375]],[[12.665722656250011,55.596533203125],[12.571582031250017,55.554003906249996],[12.550878906250006,55.55625],[12.520312500000017,55.614599609375],[12.569921875,55.65009765625],[12.59921875,55.680224609374996],[12.620019531250023,55.679345703125],[12.6484375,55.646777343749996],[12.665722656250011,55.596533203125]],[[10.484375,54.84755859375],[10.417285156250017,54.837158203125],[10.340527343750011,54.858935546874996],[10.215625,54.940966796874996],[10.199902343750011,54.962744140625],[10.265527343750023,54.948828125],[10.346972656250017,54.90595703125],[10.413671875,54.896826171875],[10.5048828125,54.860546875],[10.484375,54.84755859375]],[[10.061230468750011,54.886376953125],[9.957128906250006,54.8724609375],[9.90390625,54.896630859375],[9.80625,54.906005859375],[9.771191406250011,55.059912109375],[9.78125,55.06904296875],[9.830371093750017,55.058251953125],[9.998828125000017,54.986474609375],[10.057714843750006,54.90791015625],[10.061230468750011,54.886376953125]],[[10.607324218750023,55.783056640625],[10.59033203125,55.765087890625],[10.526953125,55.7837890625],[10.520312500000017,55.848486328125],[10.544335937500023,55.906591796875],[10.51611328125,55.958544921874996],[10.547167968750017,55.991943359375],[10.636328125,55.91416015625],[10.66171875,55.877587890625],[10.627343750000023,55.83388671875],[10.607324218750023,55.783056640625]],[[11.052148437500023,57.2525390625],[11.011425781250011,57.2291015625],[10.873828125000017,57.262255859374996],[10.9345703125,57.30859375],[11.085742187500017,57.329931640625],[11.174511718750011,57.322900390625],[11.076855468750011,57.276904296874996],[11.052148437500023,57.2525390625]],[[15.087695312500017,55.021875],[15.05078125,55.004931640624996],[14.885546875000017,55.032958984375],[14.684179687500006,55.10224609375],[14.713671875000017,55.238037109375],[14.765332031250011,55.296728515625],[15.132617187500017,55.14453125],[15.137109375000023,55.087158203125],[15.087695312500017,55.021875]]],"bbox":[-24.475683593749977,54.628857421875,33.62929687500002,80.47783203125]}

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(482).default;
	module.exports.default = module.exports;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _scrollTransition = _interopRequireDefault(__webpack_require__(484));
	
	var _fadeTransition = _interopRequireDefault(__webpack_require__(483));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  fade: _fadeTransition.default,
	  scroll: _scrollTransition.default
	};
	exports.default = _default;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnnounceSlide = function AnnounceSlide(_ref) {
	  var message = _ref.message;
	  var styles = {
	    position: 'absolute',
	    left: '-10000px',
	    top: 'auto',
	    width: '1px',
	    height: '1px',
	    overflow: 'hidden'
	  };
	  return _react.default.createElement("div", {
	    "aria-live": "polite",
	    "aria-atomic": "true",
	    style: styles,
	    tabIndex: -1
	  }, message);
	};
	
	var _default = AnnounceSlide;
	exports.default = _default;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PagingDots = exports.NextButton = exports.PreviousButton = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var defaultButtonStyles = function defaultButtonStyles(disabled) {
	  return {
	    border: 0,
	    background: 'rgba(0,0,0,0.4)',
	    color: 'white',
	    padding: 10,
	    opacity: disabled ? 0.3 : 1,
	    cursor: disabled ? 'not-allowed' : 'pointer'
	  };
	};
	
	var PreviousButton =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(PreviousButton, _React$Component);
	
	  function PreviousButton() {
	    var _this;
	
	    _classCallCheck(this, PreviousButton);
	
	    _this = _possibleConstructorReturn(this, (PreviousButton.__proto__ || Object.getPrototypeOf(PreviousButton)).apply(this, arguments));
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(PreviousButton, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.props.previousSlide();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var disabled = this.props.currentSlide === 0 && !this.props.wrapAround || this.props.slideCount === 0;
	      return _react.default.createElement("button", {
	        style: defaultButtonStyles(disabled),
	        disabled: disabled,
	        onClick: this.handleClick,
	        "aria-label": "previous"
	      }, "PREV");
	    }
	  }]);
	
	  return PreviousButton;
	}(_react.default.Component);
	
	exports.PreviousButton = PreviousButton;
	
	var NextButton =
	/*#__PURE__*/
	function (_React$Component2) {
	  _inherits(NextButton, _React$Component2);
	
	  function NextButton() {
	    var _this2;
	
	    _classCallCheck(this, NextButton);
	
	    _this2 = _possibleConstructorReturn(this, (NextButton.__proto__ || Object.getPrototypeOf(NextButton)).apply(this, arguments));
	    _this2.handleClick = _this2.handleClick.bind(_assertThisInitialized(_this2));
	    return _this2;
	  }
	
	  _createClass(NextButton, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.props.nextSlide();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var disabled = this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround;
	      return _react.default.createElement("button", {
	        style: defaultButtonStyles(disabled),
	        disabled: disabled,
	        onClick: this.handleClick,
	        "aria-label": "next"
	      }, "NEXT");
	    }
	  }]);
	
	  return NextButton;
	}(_react.default.Component);
	
	exports.NextButton = NextButton;
	
	var PagingDots =
	/*#__PURE__*/
	function (_React$Component3) {
	  _inherits(PagingDots, _React$Component3);
	
	  function PagingDots() {
	    _classCallCheck(this, PagingDots);
	
	    return _possibleConstructorReturn(this, (PagingDots.__proto__ || Object.getPrototypeOf(PagingDots)).apply(this, arguments));
	  }
	
	  _createClass(PagingDots, [{
	    key: "getIndexes",
	    value: function getIndexes(count, inc) {
	      var arr = [];
	
	      for (var i = 0; i < count; i += inc) {
	        arr.push(i);
	      }
	
	      return arr;
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles() {
	      return {
	        position: 'relative',
	        margin: 0,
	        top: -10,
	        padding: 0
	      };
	    }
	  }, {
	    key: "getListItemStyles",
	    value: function getListItemStyles() {
	      return {
	        listStyleType: 'none',
	        display: 'inline-block'
	      };
	    }
	  }, {
	    key: "getButtonStyles",
	    value: function getButtonStyles(active) {
	      return {
	        border: 0,
	        background: 'transparent',
	        color: 'black',
	        cursor: 'pointer',
	        padding: 10,
	        fontSize: 24,
	        opacity: active ? 1 : 0.5
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var indexes = this.getIndexes(this.props.slideCount, this.props.slidesToScroll);
	      return _react.default.createElement("ul", {
	        style: this.getListStyles()
	      }, indexes.map(function (index) {
	        return _react.default.createElement("li", {
	          style: _this3.getListItemStyles(),
	          key: index
	        }, _react.default.createElement("button", {
	          style: _this3.getButtonStyles(_this3.props.currentSlide === index),
	          onClick: _this3.props.goToSlide.bind(null, index),
	          "aria-label": "slide ".concat(index + 1, " bullet")
	        }, "\u2022"));
	      }));
	    }
	  }]);
	
	  return PagingDots;
	}(_react.default.Component);
	
	exports.PagingDots = PagingDots;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "PagingDots", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.PagingDots;
	  }
	});
	Object.defineProperty(exports, "PreviousButton", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.PreviousButton;
	  }
	});
	Object.defineProperty(exports, "NextButton", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.NextButton;
	  }
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _exenv = _interopRequireDefault(__webpack_require__(49));
	
	var _Animate = _interopRequireDefault(__webpack_require__(506));
	
	var easing = _interopRequireWildcard(__webpack_require__(382));
	
	var _defaultControls = __webpack_require__(481);
	
	var _allTransitions = _interopRequireDefault(__webpack_require__(479));
	
	var _announceSlide = _interopRequireDefault(__webpack_require__(480));
	
	var _utilities = __webpack_require__(487);
	
	var _styleUtilities = __webpack_require__(486);
	
	var _bootstrappingUtilities = __webpack_require__(485);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var Carousel =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  function Carousel() {
	    var _this;
	
	    _classCallCheck(this, Carousel);
	
	    _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).apply(this, arguments));
	    _this.displayName = 'Carousel';
	    _this.clickDisabled = false;
	    _this.isTransitioning = false;
	    _this.touchObject = {};
	    _this.controlsMap = [{
	      funcName: 'renderTopLeftControls',
	      key: 'TopLeft'
	    }, {
	      funcName: 'renderTopCenterControls',
	      key: 'TopCenter'
	    }, {
	      funcName: 'renderTopRightControls',
	      key: 'TopRight'
	    }, {
	      funcName: 'renderCenterLeftControls',
	      key: 'CenterLeft'
	    }, {
	      funcName: 'renderCenterCenterControls',
	      key: 'CenterCenter'
	    }, {
	      funcName: 'renderCenterRightControls',
	      key: 'CenterRight'
	    }, {
	      funcName: 'renderBottomLeftControls',
	      key: 'BottomLeft'
	    }, {
	      funcName: 'renderBottomCenterControls',
	      key: 'BottomCenter'
	    }, {
	      funcName: 'renderBottomRightControls',
	      key: 'BottomRight'
	    }];
	    _this.state = _objectSpread({
	      currentSlide: _this.props.slideIndex,
	      dragging: false,
	      left: 0,
	      slideCount: (0, _bootstrappingUtilities.getValidChildren)(_this.props.children).length,
	      top: 0,
	      easing: easing.easeCircleOut,
	      isWrappingAround: false,
	      wrapToIndex: null,
	      resetWrapAroundPosition: false
	    }, (0, _utilities.calcSomeInitialState)(_this.props));
	    _this.getTouchEvents = _this.getTouchEvents.bind(_assertThisInitialized(_this));
	    _this.getMouseEvents = _this.getMouseEvents.bind(_assertThisInitialized(_this));
	    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_this));
	    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
	    _this.handleSwipe = _this.handleSwipe.bind(_assertThisInitialized(_this));
	    _this.autoplayIterator = _this.autoplayIterator.bind(_assertThisInitialized(_this));
	    _this.startAutoplay = _this.startAutoplay.bind(_assertThisInitialized(_this));
	    _this.stopAutoplay = _this.stopAutoplay.bind(_assertThisInitialized(_this));
	    _this.resetAutoplay = _this.resetAutoplay.bind(_assertThisInitialized(_this));
	    _this.goToSlide = _this.goToSlide.bind(_assertThisInitialized(_this));
	    _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized(_this));
	    _this.previousSlide = _this.previousSlide.bind(_assertThisInitialized(_this));
	    _this.getTargetLeft = _this.getTargetLeft.bind(_assertThisInitialized(_this));
	    _this.onResize = _this.onResize.bind(_assertThisInitialized(_this));
	    _this.onReadyStateChange = _this.onReadyStateChange.bind(_assertThisInitialized(_this));
	    _this.onVisibilityChange = _this.onVisibilityChange.bind(_assertThisInitialized(_this));
	    _this.setDimensions = _this.setDimensions.bind(_assertThisInitialized(_this));
	    _this.setLeft = _this.setLeft.bind(_assertThisInitialized(_this));
	    _this.getOffsetDeltas = _this.getOffsetDeltas.bind(_assertThisInitialized(_this));
	    _this.getChildNodes = _this.getChildNodes.bind(_assertThisInitialized(_this));
	    _this.renderControls = _this.renderControls.bind(_assertThisInitialized(_this));
	    _this.setSlideHeightAndWidth = _this.setSlideHeightAndWidth.bind(_assertThisInitialized(_this));
	    _this.calcSlideHeightAndWidth = _this.calcSlideHeightAndWidth.bind(_assertThisInitialized(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	      this.mounted = true;
	      this.setLeft();
	      this.setDimensions();
	      this.bindEvents();
	
	      if (this.props.autoplay) {
	        this.startAutoplay();
	      }
	    } // @TODO Remove deprecated componentWillReceiveProps with getDerivedStateFromProps
	    // eslint-disable-next-line react/no-deprecated
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var slideCount = (0, _bootstrappingUtilities.getValidChildren)(nextProps.children).length;
	      var slideCountChanged = slideCount !== this.state.slideCount;
	      this.setState({
	        slideCount: slideCount,
	        currentSlide: slideCountChanged ? nextProps.slideIndex : this.state.currentSlide
	      });
	
	      if (slideCount <= this.state.currentSlide) {
	        this.goToSlide(Math.max(slideCount - 1, 0), nextProps);
	      }
	
	      var updateDimensions = slideCountChanged || (0, _utilities.shouldUpdate)(this.props, nextProps, ['cellSpacing', 'vertical', 'slideWidth', 'slideHeight', 'heightMode', 'slidesToScroll', 'slidesToShow', 'transitionMode', 'cellAlign']);
	
	      if (updateDimensions) {
	        this.setDimensions(nextProps);
	      }
	
	      if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide && !this.state.isWrappingAround) {
	        this.goToSlide(nextProps.slideIndex, this.props);
	      }
	
	      if (this.props.autoplay !== nextProps.autoplay) {
	        if (nextProps.autoplay) {
	          this.startAutoplay();
	        } else {
	          this.stopAutoplay();
	        }
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var slideChanged = prevState.currentSlide !== this.state.currentSlide;
	      var heightModeChanged = prevProps.heightMode !== this.props.heightMode;
	
	      if (slideChanged || heightModeChanged) {
	        this.setSlideHeightAndWidth();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unbindEvents();
	      this.stopAutoplay(); // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	
	      this.mounted = false;
	    }
	  }, {
	    key: "getTouchEvents",
	    value: function getTouchEvents() {
	      var _this2 = this;
	
	      if (this.props.swiping === false) {
	        return {
	          onTouchStart: function onTouchStart() {
	            _this2.handleMouseOver();
	          },
	          onTouchEnd: function onTouchEnd() {
	            _this2.handleMouseOut();
	          }
	        };
	      }
	
	      return {
	        onTouchStart: function onTouchStart(e) {
	          _this2.touchObject = {
	            startX: e.touches[0].pageX,
	            startY: e.touches[0].pageY
	          };
	
	          _this2.handleMouseOver();
	        },
	        onTouchMove: function onTouchMove(e) {
	          var direction = (0, _utilities.swipeDirection)(_this2.touchObject.startX, e.touches[0].pageX, _this2.touchObject.startY, e.touches[0].pageY, _this2.props.vertical);
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	
	          var length = _this2.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - _this2.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - _this2.touchObject.startX, 2)));
	          _this2.touchObject = {
	            startX: _this2.touchObject.startX,
	            startY: _this2.touchObject.startY,
	            endX: e.touches[0].pageX,
	            endY: e.touches[0].pageY,
	            length: length,
	            direction: direction
	          };
	
	          _this2.setState({
	            left: _this2.props.vertical ? 0 : _this2.getTargetLeft(_this2.touchObject.length * _this2.touchObject.direction),
	            top: _this2.props.vertical ? _this2.getTargetLeft(_this2.touchObject.length * _this2.touchObject.direction) : 0
	          });
	        },
	        onTouchEnd: function onTouchEnd(e) {
	          _this2.handleSwipe(e);
	
	          _this2.handleMouseOut();
	        },
	        onTouchCancel: function onTouchCancel(e) {
	          _this2.handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "getMouseEvents",
	    value: function getMouseEvents() {
	      var _this3 = this;
	
	      if (this.props.dragging === false) {
	        return {
	          onMouseOver: function onMouseOver() {
	            return _this3.handleMouseOver();
	          },
	          onMouseOut: function onMouseOut() {
	            return _this3.handleMouseOut();
	          }
	        };
	      }
	
	      return {
	        onMouseOver: function onMouseOver() {
	          return _this3.handleMouseOver();
	        },
	        onMouseOut: function onMouseOut() {
	          return _this3.handleMouseOut();
	        },
	        onMouseDown: function onMouseDown(e) {
	          if (e.preventDefault) {
	            e.preventDefault();
	          }
	
	          _this3.touchObject = {
	            startX: e.clientX,
	            startY: e.clientY
	          };
	
	          _this3.setState({
	            dragging: true
	          });
	        },
	        onMouseMove: function onMouseMove(e) {
	          if (!_this3.state.dragging) {
	            return;
	          }
	
	          var direction = (0, _utilities.swipeDirection)(_this3.touchObject.startX, e.clientX, _this3.touchObject.startY, e.clientY, _this3.props.vertical);
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	
	          var length = _this3.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - _this3.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - _this3.touchObject.startX, 2))); // prevents disabling click just because mouse moves a fraction of a pixel
	
	          if (length >= 10) _this3.clickDisabled = true;
	          _this3.touchObject = {
	            startX: _this3.touchObject.startX,
	            startY: _this3.touchObject.startY,
	            endX: e.clientX,
	            endY: e.clientY,
	            length: length,
	            direction: direction
	          };
	
	          _this3.setState({
	            left: _this3.props.vertical ? 0 : _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction),
	            top: _this3.props.vertical ? _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction) : 0
	          });
	        },
	        onMouseUp: function onMouseUp(e) {
	          if (!_this3.state.dragging) {
	            return;
	          }
	
	          _this3.handleSwipe(e);
	        },
	        onMouseLeave: function onMouseLeave(e) {
	          if (!_this3.state.dragging) {
	            return;
	          }
	
	          _this3.handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "pauseAutoplay",
	    value: function pauseAutoplay() {
	      if (this.props.autoplay) {
	        this.autoplayPaused = true;
	        this.stopAutoplay();
	      }
	    }
	  }, {
	    key: "unpauseAutoplay",
	    value: function unpauseAutoplay() {
	      if (this.props.autoplay && this.autoplayPaused) {
	        this.startAutoplay();
	        this.autoplayPaused = null;
	      }
	    }
	  }, {
	    key: "handleMouseOver",
	    value: function handleMouseOver() {
	      if (this.props.pauseOnHover) {
	        this.pauseAutoplay();
	      }
	    }
	  }, {
	    key: "handleMouseOut",
	    value: function handleMouseOut() {
	      if (this.autoplayPaused) {
	        this.unpauseAutoplay();
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      if (this.clickDisabled === true) {
	        if (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey) {
	          return;
	        }
	
	        event.preventDefault();
	        event.stopPropagation();
	
	        if (event.nativeEvent) {
	          event.nativeEvent.stopPropagation();
	        }
	      }
	    }
	  }, {
	    key: "handleSwipe",
	    value: function handleSwipe() {
	      var _this4 = this;
	
	      var slidesToShow = this.state.slidesToShow;
	
	      if (this.props.slidesToScroll === 'auto') {
	        slidesToShow = this.state.slidesToScroll;
	      }
	
	      if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
	        if (this.touchObject.direction === 1) {
	          if (this.state.currentSlide >= this.state.slideCount - slidesToShow && !this.props.wrapAround) {
	            this.setState({
	              easing: easing[this.props.edgeEasing]
	            });
	          } else {
	            this.nextSlide();
	          }
	        } else if (this.touchObject.direction === -1) {
	          if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	            this.setState({
	              easing: easing[this.props.edgeEasing]
	            });
	          } else {
	            this.previousSlide();
	          }
	        }
	      } else {
	        this.goToSlide(this.state.currentSlide);
	      } // wait for `handleClick` event before resetting clickDisabled
	
	
	      setTimeout(function () {
	        _this4.clickDisabled = false;
	      }, 0);
	      this.touchObject = {};
	      this.setState({
	        dragging: false
	      });
	    } // eslint-disable-next-line complexity
	
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(e) {
	      if (!this.props.disableKeyboardControls) {
	        switch (e.keyCode) {
	          case 39:
	          case 68:
	          case 38:
	          case 87:
	            this.nextSlide();
	            break;
	
	          case 37:
	          case 65:
	          case 40:
	          case 83:
	            this.previousSlide();
	            break;
	
	          case 81:
	            this.goToSlide(0, this.props);
	            break;
	
	          case 69:
	            this.goToSlide(this.state.slideCount - 1, this.props);
	            break;
	
	          case 32:
	            if (this.state.pauseOnHover && this.props.autoplay) {
	              this.setState({
	                pauseOnHover: false
	              });
	              this.pauseAutoplay();
	              break;
	            } else {
	              this.setState({
	                pauseOnHover: true
	              });
	              this.unpauseAutoplay();
	              break;
	            }
	
	        }
	      }
	    }
	  }, {
	    key: "autoplayIterator",
	    value: function autoplayIterator() {
	      if (this.props.wrapAround) {
	        this.nextSlide();
	        return;
	      }
	
	      if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
	        this.nextSlide();
	      } else {
	        this.stopAutoplay();
	      }
	    }
	  }, {
	    key: "startAutoplay",
	    value: function startAutoplay() {
	      this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
	    }
	  }, {
	    key: "resetAutoplay",
	    value: function resetAutoplay() {
	      if (this.props.autoplay && !this.autoplayPaused) {
	        this.stopAutoplay();
	        this.startAutoplay();
	      }
	    }
	  }, {
	    key: "stopAutoplay",
	    value: function stopAutoplay() {
	      if (this.autoplayID) {
	        clearInterval(this.autoplayID);
	      }
	    } // Animation Method
	
	  }, {
	    key: "getTargetLeft",
	    value: function getTargetLeft(touchOffset, slide) {
	      var offset;
	      var target = slide || this.state.currentSlide;
	
	      switch (this.state.cellAlign) {
	        case 'left':
	          {
	            offset = 0;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	
	        case 'center':
	          {
	            offset = (this.state.frameWidth - this.state.slideWidth) / 2;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	
	        case 'right':
	          {
	            offset = this.state.frameWidth - this.state.slideWidth;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	      }
	
	      var left = this.state.slideWidth * target;
	      var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;
	
	      if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
	        left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
	        offset = 0;
	        offset -= this.props.cellSpacing * (this.state.slideCount - 1);
	      }
	
	      offset -= touchOffset || 0;
	      return (left - offset) * -1;
	    }
	  }, {
	    key: "getOffsetDeltas",
	    value: function getOffsetDeltas() {
	      var offset = 0;
	
	      if (this.state.isWrappingAround) {
	        offset = this.getTargetLeft(null, this.state.wrapToIndex);
	      } else {
	        offset = this.getTargetLeft(this.touchObject.length * this.touchObject.direction);
	      }
	
	      return {
	        tx: [this.props.vertical ? 0 : offset],
	        ty: [this.props.vertical ? offset : 0]
	      };
	    } // Action Methods
	
	  }, {
	    key: "goToSlide",
	    value: function goToSlide(index, props) {
	      var _this5 = this;
	
	      if (props === undefined) {
	        props = this.props;
	      }
	
	      if (this.isTransitioning) {
	        return;
	      }
	
	      this.setState({
	        easing: easing[props.easing]
	      });
	      this.isTransitioning = true;
	
	      if (index >= this.state.slideCount || index < 0) {
	        if (!props.wrapAround) {
	          this.isTransitioning = false;
	          return;
	        }
	
	        if (index >= this.state.slideCount) {
	          props.beforeSlide(this.state.currentSlide, 0);
	          this.setState(function (prevState) {
	            return {
	              left: props.vertical ? 0 : _this5.getTargetLeft(_this5.state.slideWidth, prevState.currentSlide),
	              top: props.vertical ? _this5.getTargetLeft(_this5.state.slideWidth, prevState.currentSlide) : 0,
	              currentSlide: 0,
	              isWrappingAround: true,
	              wrapToIndex: index
	            };
	          }, function () {
	            return setTimeout(function () {
	              _this5.setState({
	                isWrappingAround: false,
	                resetWrapAroundPosition: true
	              }, function () {
	                _this5.setState({
	                  resetWrapAroundPosition: false
	                });
	
	                _this5.isTransitioning = false;
	                props.afterSlide(0);
	
	                _this5.resetAutoplay();
	              });
	            }, props.speed);
	          });
	          return;
	        } else {
	          var endSlide = this.state.slideCount - this.state.slidesToScroll;
	          props.beforeSlide(this.state.currentSlide, endSlide);
	          this.setState(function (prevState) {
	            return {
	              left: props.vertical ? 0 : _this5.getTargetLeft(0, prevState.currentSlide),
	              top: props.vertical ? _this5.getTargetLeft(0, prevState.currentSlide) : 0,
	              currentSlide: endSlide,
	              isWrappingAround: true,
	              wrapToIndex: index
	            };
	          }, function () {
	            return setTimeout(function () {
	              _this5.setState({
	                isWrappingAround: false,
	                resetWrapAroundPosition: true
	              }, function () {
	                _this5.setState({
	                  resetWrapAroundPosition: false
	                });
	
	                _this5.isTransitioning = false;
	                props.afterSlide(endSlide);
	
	                _this5.resetAutoplay();
	              });
	            }, props.speed);
	          });
	          return;
	        }
	      }
	
	      this.props.beforeSlide(this.state.currentSlide, index);
	      var previousSlide = this.state.currentSlide;
	      this.setState({
	        currentSlide: index
	      }, function () {
	        return setTimeout(function () {
	          _this5.resetAutoplay();
	
	          _this5.isTransitioning = false;
	
	          if (index !== previousSlide) {
	            _this5.props.afterSlide(index);
	          }
	        }, props.speed);
	      });
	    }
	  }, {
	    key: "nextSlide",
	    value: function nextSlide() {
	      var childrenCount = this.state.slideCount;
	      var slidesToShow = this.state.slidesToShow;
	
	      if (this.props.slidesToScroll === 'auto') {
	        slidesToShow = this.state.slidesToScroll;
	      }
	
	      if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround && this.props.cellAlign === 'left') {
	        return;
	      }
	
	      if (this.props.wrapAround) {
	        this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	      } else {
	        if (this.props.slideWidth !== 1) {
	          this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	          return;
	        }
	
	        var offset = this.state.currentSlide + this.state.slidesToScroll;
	        var nextSlideIndex = this.props.cellAlign !== 'left' ? offset : Math.min(offset, childrenCount - slidesToShow);
	        this.goToSlide(nextSlideIndex);
	      }
	    }
	  }, {
	    key: "previousSlide",
	    value: function previousSlide() {
	      if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	        return;
	      }
	
	      if (this.props.wrapAround) {
	        this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
	      } else {
	        this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
	      }
	    } // Bootstrapping
	
	  }, {
	    key: "bindEvents",
	    value: function bindEvents() {
	      if (_exenv.default.canUseDOM) {
	        (0, _utilities.addEvent)(window, 'resize', this.onResize);
	        (0, _utilities.addEvent)(document, 'readystatechange', this.onReadyStateChange);
	        (0, _utilities.addEvent)(document, 'visibilitychange', this.onVisibilityChange);
	        (0, _utilities.addEvent)(document, 'keydown', this.handleKeyPress);
	      }
	    }
	  }, {
	    key: "onResize",
	    value: function onResize() {
	      this.setDimensions(null, this.props.onResize);
	    }
	  }, {
	    key: "onReadyStateChange",
	    value: function onReadyStateChange() {
	      this.setDimensions();
	    }
	  }, {
	    key: "onVisibilityChange",
	    value: function onVisibilityChange() {
	      if (document.hidden) {
	        this.pauseAutoplay();
	      } else {
	        this.unpauseAutoplay();
	      }
	    }
	  }, {
	    key: "unbindEvents",
	    value: function unbindEvents() {
	      if (_exenv.default.canUseDOM) {
	        (0, _utilities.removeEvent)(window, 'resize', this.onResize);
	        (0, _utilities.removeEvent)(document, 'readystatechange', this.onReadyStateChange);
	        (0, _utilities.removeEvent)(document, 'visibilitychange', this.onVisibilityChange);
	        (0, _utilities.removeEvent)(document, 'keydown', this.handleKeyPress);
	      }
	    }
	  }, {
	    key: "calcSlideHeightAndWidth",
	    value: function calcSlideHeightAndWidth(props) {
	      // slide height
	      props = props || this.props;
	      var childNodes = this.getChildNodes();
	      var slideHeight = (0, _bootstrappingUtilities.getSlideHeight)(props, this.state, childNodes); //slide width
	
	      var _getPropsByTransition = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToShow']),
	          slidesToShow = _getPropsByTransition.slidesToShow;
	
	      var frame = this.frame;
	      var slideWidth;
	
	      if (typeof props.slideWidth !== 'number') {
	        slideWidth = parseInt(props.slideWidth);
	      } else if (props.vertical) {
	        slideWidth = slideHeight / slidesToShow * props.slideWidth;
	      } else {
	        slideWidth = frame.offsetWidth / slidesToShow * props.slideWidth;
	      }
	
	      if (!props.vertical) {
	        slideWidth -= props.cellSpacing * ((100 - 100 / slidesToShow) / 100);
	      }
	
	      return {
	        slideHeight: slideHeight,
	        slideWidth: slideWidth
	      };
	    }
	  }, {
	    key: "setSlideHeightAndWidth",
	    value: function setSlideHeightAndWidth() {
	      this.setState(this.calcSlideHeightAndWidth());
	    }
	  }, {
	    key: "setDimensions",
	    value: function setDimensions(props) {
	      var _this6 = this;
	
	      var stateCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	      props = props || this.props;
	
	      var _getPropsByTransition2 = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToShow', 'cellAlign']),
	          slidesToShow = _getPropsByTransition2.slidesToShow,
	          cellAlign = _getPropsByTransition2.cellAlign;
	
	      var frame = this.frame;
	
	      var _calcSlideHeightAndWi = this.calcSlideHeightAndWidth(props),
	          slideHeight = _calcSlideHeightAndWi.slideHeight,
	          slideWidth = _calcSlideHeightAndWi.slideWidth;
	
	      var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
	      var frameWidth = props.vertical ? frameHeight : frame.offsetWidth;
	
	      var _getPropsByTransition3 = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToScroll']),
	          slidesToScroll = _getPropsByTransition3.slidesToScroll;
	
	      if (slidesToScroll === 'auto') {
	        slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
	      }
	
	      this.setState({
	        frameWidth: frameWidth,
	        slideHeight: slideHeight,
	        slidesToScroll: slidesToScroll,
	        slidesToShow: slidesToShow,
	        slideWidth: slideWidth,
	        cellAlign: cellAlign,
	        left: props.vertical ? 0 : this.getTargetLeft(),
	        top: props.vertical ? this.getTargetLeft() : 0
	      }, function () {
	        stateCb();
	
	        _this6.setLeft();
	      });
	    }
	  }, {
	    key: "getChildNodes",
	    value: function getChildNodes() {
	      return this.frame.childNodes[0].childNodes;
	    }
	  }, {
	    key: "setLeft",
	    value: function setLeft() {
	      var newLeft = this.props.vertical ? 0 : this.getTargetLeft();
	      var newTop = this.props.vertical ? this.getTargetLeft() : 0;
	
	      if (newLeft !== this.state.left || newTop !== this.state.top) {
	        this.setState({
	          left: newLeft,
	          top: newTop
	        });
	      }
	    }
	  }, {
	    key: "renderControls",
	    value: function renderControls() {
	      var _this7 = this;
	
	      if (this.props.withoutControls) {
	        return this.controlsMap.map(function () {
	          return null;
	        });
	      } else {
	        return this.controlsMap.map(function (_ref) {
	          var funcName = _ref.funcName,
	              key = _ref.key;
	          var func = _this7.props[funcName];
	          return func && typeof func === 'function' && _react.default.createElement("div", {
	            className: "slider-control-".concat(key.toLowerCase()),
	            style: (0, _styleUtilities.getDecoratorStyles)(key),
	            key: key
	          }, func({
	            currentSlide: _this7.state.currentSlide,
	            slideCount: _this7.state.slideCount,
	            frameWidth: _this7.state.frameWidth,
	            slideWidth: _this7.state.slideWidth,
	            slidesToScroll: _this7.state.slidesToScroll,
	            cellSpacing: _this7.props.cellSpacing,
	            slidesToShow: _this7.state.slidesToShow,
	            wrapAround: _this7.props.wrapAround,
	            nextSlide: function nextSlide() {
	              return _this7.nextSlide();
	            },
	            previousSlide: function previousSlide() {
	              return _this7.previousSlide();
	            },
	            goToSlide: function goToSlide(index) {
	              return _this7.goToSlide(index);
	            }
	          }));
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      var _state = this.state,
	          currentSlide = _state.currentSlide,
	          slideCount = _state.slideCount,
	          frameWidth = _state.frameWidth;
	      var _props = this.props,
	          frameOverflow = _props.frameOverflow,
	          vertical = _props.vertical,
	          framePadding = _props.framePadding,
	          slidesToShow = _props.slidesToShow;
	      var duration = this.state.dragging || this.state.resetWrapAroundPosition ? 0 : this.props.speed;
	      var frameStyles = (0, _styleUtilities.getFrameStyles)(frameOverflow, vertical, framePadding, frameWidth);
	      var touchEvents = this.getTouchEvents();
	      var mouseEvents = this.getMouseEvents();
	      var TransitionControl = _allTransitions.default[this.props.transitionMode];
	      var validChildren = (0, _bootstrappingUtilities.getValidChildren)(this.props.children);
	      return _react.default.createElement("div", {
	        className: ['slider', this.props.className || ''].join(' '),
	        style: _extends({}, (0, _styleUtilities.getSliderStyles)(this.props.width, this.state.slideWidth), this.props.style)
	      }, !this.props.autoplay && _react.default.createElement(_announceSlide.default, {
	        message: "Slide ".concat(currentSlide + 1, " of ").concat(slideCount)
	      }), _react.default.createElement(_Animate.default, {
	        show: true,
	        start: {
	          tx: 0,
	          ty: 0
	        },
	        update: _extends({}, this.getOffsetDeltas(this.touchObject, this.props, this.state), {
	          timing: {
	            duration: duration,
	            ease: this.state.easing
	          },
	          events: {
	            end: this.setLeft
	          }
	        }),
	        children: function children(_ref2) {
	          var tx = _ref2.tx,
	              ty = _ref2.ty;
	          return _react.default.createElement("div", _extends({
	            className: "slider-frame",
	            ref: function ref(frame) {
	              return _this8.frame = frame;
	            },
	            style: frameStyles
	          }, touchEvents, mouseEvents, {
	            onClickCapture: _this8.handleClick
	          }), _react.default.createElement(TransitionControl, _extends({}, (0, _styleUtilities.getTransitionProps)(_this8.props, _this8.state), {
	            deltaX: tx,
	            deltaY: ty
	          }), (0, _bootstrappingUtilities.addAccessibility)(validChildren, slidesToShow, currentSlide)));
	        }
	      }), this.renderControls(), this.props.autoGenerateStyleTag && _react.default.createElement("style", {
	        type: "text/css",
	        dangerouslySetInnerHTML: {
	          __html: (0, _styleUtilities.getImgTagStyles)()
	        }
	      }));
	    }
	  }]);
	
	  return Carousel;
	}(_react.default.Component);
	
	exports.default = Carousel;
	Carousel.propTypes = {
	  afterSlide: _propTypes.default.func,
	  autoplay: _propTypes.default.bool,
	  autoplayInterval: _propTypes.default.number,
	  autoGenerateStyleTag: _propTypes.default.bool,
	  beforeSlide: _propTypes.default.func,
	  cellAlign: _propTypes.default.oneOf(['left', 'center', 'right']),
	  cellSpacing: _propTypes.default.number,
	  dragging: _propTypes.default.bool,
	  easing: _propTypes.default.string,
	  edgeEasing: _propTypes.default.string,
	  frameOverflow: _propTypes.default.string,
	  framePadding: _propTypes.default.string,
	  heightMode: _propTypes.default.oneOf(['first', 'current', 'max']),
	  disableKeyboardControls: _propTypes.default.bool,
	  transitionMode: _propTypes.default.oneOf(['scroll', 'fade']),
	  initialSlideHeight: _propTypes.default.number,
	  initialSlideWidth: _propTypes.default.number,
	  onResize: _propTypes.default.func,
	  pauseOnHover: _propTypes.default.bool,
	  renderTopLeftControls: _propTypes.default.func,
	  renderTopCenterControls: _propTypes.default.func,
	  renderTopRightControls: _propTypes.default.func,
	  renderCenterLeftControls: _propTypes.default.func,
	  renderCenterCenterControls: _propTypes.default.func,
	  renderCenterRightControls: _propTypes.default.func,
	  renderBottomLeftControls: _propTypes.default.func,
	  renderBottomCenterControls: _propTypes.default.func,
	  renderBottomRightControls: _propTypes.default.func,
	  slideIndex: _propTypes.default.number,
	  slidesToScroll: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
	  slidesToShow: _propTypes.default.number,
	  slideWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  speed: _propTypes.default.number,
	  swiping: _propTypes.default.bool,
	  vertical: _propTypes.default.bool,
	  width: _propTypes.default.string,
	  withoutControls: _propTypes.default.bool,
	  wrapAround: _propTypes.default.bool
	};
	Carousel.defaultProps = {
	  afterSlide: function afterSlide() {},
	  autoplay: false,
	  autoplayInterval: 3000,
	  autoGenerateStyleTag: true,
	  beforeSlide: function beforeSlide() {},
	  cellAlign: 'left',
	  cellSpacing: 0,
	  dragging: true,
	  easing: 'easeCircleOut',
	  edgeEasing: 'easeElasticOut',
	  framePadding: '0px',
	  frameOverflow: 'hidden',
	  heightMode: 'max',
	  disableKeyboardControls: false,
	  transitionMode: 'scroll',
	  onResize: function onResize() {},
	  slideIndex: 0,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  style: {},
	  pauseOnHover: true,
	  renderCenterLeftControls: function renderCenterLeftControls(props) {
	    return _react.default.createElement(_defaultControls.PreviousButton, props);
	  },
	  renderCenterRightControls: function renderCenterRightControls(props) {
	    return _react.default.createElement(_defaultControls.NextButton, props);
	  },
	  renderBottomCenterControls: function renderBottomCenterControls(props) {
	    return _react.default.createElement(_defaultControls.PagingDots, props);
	  },
	  slideWidth: 1,
	  speed: 500,
	  swiping: true,
	  vertical: false,
	  width: '100%',
	  withoutControls: false,
	  wrapAround: false
	};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FadeTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(FadeTransition, _React$Component);
	
	  function FadeTransition(props) {
	    var _this;
	
	    _classCallCheck(this, FadeTransition);
	
	    _this = _possibleConstructorReturn(this, (FadeTransition.__proto__ || Object.getPrototypeOf(FadeTransition)).call(this, props));
	    _this.fadeFromSlide = props.currentSlide;
	    return _this;
	  }
	
	  _createClass(FadeTransition, [{
	    key: "formatChildren",
	    value: function formatChildren(children, opacity) {
	      var _this2 = this;
	
	      var _props = this.props,
	          currentSlide = _props.currentSlide,
	          slidesToShow = _props.slidesToShow;
	      return _react.default.Children.map(children, function (child, index) {
	        var visible = index >= currentSlide && index < currentSlide + slidesToShow;
	        return _react.default.createElement("li", {
	          className: "slider-slide".concat(visible ? ' slide-visible' : ''),
	          style: _this2.getSlideStyles(index, opacity),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "getSlideOpacityAndLeftMap",
	    value: function getSlideOpacityAndLeftMap(fadeFrom, fadeTo, fade) {
	      // Figure out which position to fade to
	      var fadeToPosition = fadeTo;
	
	      if (fadeFrom > fade && fadeFrom === 0) {
	        fadeToPosition = fadeFrom - this.props.slidesToShow;
	      } else if (fadeFrom < fade && fadeFrom + this.props.slidesToShow > this.props.slideCount - 1) {
	        fadeToPosition = fadeFrom + this.props.slidesToShow;
	      } // Calculate opacity for active slides
	
	
	      var opacity = {};
	
	      if (fadeFrom === fadeTo) {
	        opacity[fadeFrom] = 1;
	      } else {
	        var distance = fadeFrom - fadeToPosition;
	        opacity[fadeFrom] = (fade - fadeToPosition) / distance;
	        opacity[fadeTo] = (fadeFrom - fade) / distance;
	      } // Calculate left for slides and merge in opacity
	
	
	      var map = {};
	
	      for (var i = 0; i < this.props.slidesToShow; i++) {
	        map[fadeFrom + i] = {
	          opacity: opacity[fadeFrom],
	          left: this.props.slideWidth * i
	        };
	        map[fadeTo + i] = {
	          opacity: opacity[fadeTo],
	          left: this.props.slideWidth * i
	        };
	      }
	
	      return map;
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, data) {
	      return {
	        position: 'absolute',
	        visibility: data[index] ? 'inherit' : 'hidden',
	        left: data[index] ? data[index].left : 0,
	        top: 0,
	        opacity: data[index] ? data[index].opacity : 0,
	        display: 'block',
	        listStyleType: 'none',
	        verticalAlign: 'top',
	        width: this.props.slideWidth,
	        height: 'auto',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        marginLeft: this.props.cellSpacing / 2,
	        marginRight: this.props.cellSpacing / 2,
	        marginTop: 'auto',
	        marginBottom: 'auto'
	      };
	    }
	  }, {
	    key: "getContainerStyles",
	    value: function getContainerStyles() {
	      var width = this.props.slideWidth * this.props.slidesToShow;
	      return {
	        display: 'block',
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
	        padding: 0,
	        height: this.props.slideHeight,
	        width: width,
	        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        touchAction: 'none'
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var fade = -(this.props.deltaX || this.props.deltaY) / this.props.slideWidth;
	
	      if (parseInt(fade) === fade) {
	        this.fadeFromSlide = fade;
	      }
	
	      var opacityAndLeftMap = this.getSlideOpacityAndLeftMap(this.fadeFromSlide, this.props.currentSlide, fade);
	      var children = this.formatChildren(this.props.children, opacityAndLeftMap);
	      return _react.default.createElement("ul", {
	        className: "slider-list",
	        style: this.getContainerStyles()
	      }, children);
	    }
	  }]);
	
	  return FadeTransition;
	}(_react.default.Component);
	
	exports.default = FadeTransition;
	FadeTransition.propTypes = {
	  deltaX: _propTypes.default.number,
	  deltaY: _propTypes.default.number,
	  slideWidth: _propTypes.default.number,
	  slideHeight: _propTypes.default.number,
	  slideCount: _propTypes.default.number,
	  currentSlide: _propTypes.default.number,
	  isWrappingAround: _propTypes.default.bool,
	  top: _propTypes.default.number,
	  left: _propTypes.default.number,
	  cellSpacing: _propTypes.default.number,
	  vertical: _propTypes.default.bool,
	  dragging: _propTypes.default.bool,
	  wrapAround: _propTypes.default.bool,
	  slidesToShow: _propTypes.default.number
	};
	FadeTransition.defaultProps = {
	  deltaX: 0,
	  deltaY: 0,
	  slideWidth: 0,
	  slideHeight: 0,
	  slideCount: 0,
	  currentSlide: 0,
	  isWrappingAround: false,
	  top: 0,
	  left: 0,
	  cellSpacing: 0,
	  vertical: false,
	  dragging: false,
	  wrapAround: false,
	  slidesToShow: 1
	};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var ScrollTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ScrollTransition, _React$Component);
	
	  function ScrollTransition(props) {
	    var _this;
	
	    _classCallCheck(this, ScrollTransition);
	
	    _this = _possibleConstructorReturn(this, (ScrollTransition.__proto__ || Object.getPrototypeOf(ScrollTransition)).call(this, props));
	    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(ScrollTransition, [{
	    key: "getSlideDirection",
	    value: function getSlideDirection(start, end, isWrapping) {
	      var direction = 0;
	      if (start === end) return direction;
	
	      if (isWrapping) {
	        direction = start < end ? -1 : 1;
	      } else {
	        direction = start < end ? 1 : -1;
	      }
	
	      return direction;
	    }
	  }, {
	    key: "getSlideTargetPosition",
	    value: function getSlideTargetPosition(index, positionValue) {
	      var targetPosition = (this.props.slideWidth + this.props.cellSpacing) * index;
	      var startSlide = Math.min(Math.abs(Math.floor(positionValue / this.props.slideWidth)), this.props.slideCount - 1);
	
	      if (this.props.wrapAround && index !== startSlide) {
	        var direction = this.getSlideDirection(startSlide, this.props.currentSlide, this.props.isWrappingAround);
	        var slidesBefore = Math.floor((this.props.slideCount - 1) / 2);
	        var slidesAfter = this.props.slideCount - slidesBefore - 1;
	
	        if (direction < 0) {
	          var temp = slidesBefore;
	          slidesBefore = slidesAfter;
	          slidesAfter = temp;
	        }
	
	        var distanceFromStart = Math.abs(startSlide - index);
	
	        if (index < startSlide) {
	          if (distanceFromStart > slidesBefore) {
	            targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount + index);
	          }
	        } else if (distanceFromStart > slidesAfter) {
	          targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount - index) * -1;
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: "formatChildren",
	    value: function formatChildren(children) {
	      var _this2 = this;
	
	      var _props = this.props,
	          top = _props.top,
	          left = _props.left,
	          currentSlide = _props.currentSlide,
	          slidesToShow = _props.slidesToShow;
	      var positionValue = this.props.vertical ? top : left;
	      return _react.default.Children.map(children, function (child, index) {
	        var visible = index >= currentSlide && index < currentSlide + slidesToShow;
	        return _react.default.createElement("li", {
	          className: "slider-slide".concat(visible ? ' slide-visible' : ''),
	          style: _this2.getSlideStyles(index, positionValue),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, positionValue) {
	      var targetPosition = this.getSlideTargetPosition(index, positionValue);
	      return {
	        position: 'absolute',
	        left: this.props.vertical ? 0 : targetPosition,
	        top: this.props.vertical ? targetPosition : 0,
	        display: this.props.vertical ? 'block' : 'inline-block',
	        listStyleType: 'none',
	        verticalAlign: 'top',
	        width: this.props.vertical ? '100%' : this.props.slideWidth,
	        height: 'auto',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto'
	      };
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles(styles) {
	      var deltaX = styles.deltaX,
	          deltaY = styles.deltaY;
	
	      var listWidth = this.props.slideWidth * _react.default.Children.count(this.props.children);
	
	      var spacingOffset = this.props.cellSpacing * _react.default.Children.count(this.props.children);
	
	      var transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0)");
	      return {
	        transform: transform,
	        WebkitTransform: transform,
	        msTransform: "translate(".concat(deltaX, "px, ").concat(deltaY, "px)"),
	        position: 'relative',
	        display: 'block',
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
	        padding: 0,
	        height: this.props.vertical ? listWidth + spacingOffset : this.props.slideHeight,
	        width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
	        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y')
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.formatChildren(this.props.children);
	      var deltaX = this.props.deltaX;
	      var deltaY = this.props.deltaY;
	      return _react.default.createElement("ul", {
	        className: "slider-list",
	        style: this.getListStyles({
	          deltaX: deltaX,
	          deltaY: deltaY
	        })
	      }, children);
	    }
	  }]);
	
	  return ScrollTransition;
	}(_react.default.Component);
	
	exports.default = ScrollTransition;
	ScrollTransition.propTypes = {
	  deltaX: _propTypes.default.number,
	  deltaY: _propTypes.default.number,
	  slideWidth: _propTypes.default.number,
	  slideHeight: _propTypes.default.number,
	  slideCount: _propTypes.default.number,
	  currentSlide: _propTypes.default.number,
	  isWrappingAround: _propTypes.default.bool,
	  top: _propTypes.default.number,
	  left: _propTypes.default.number,
	  cellSpacing: _propTypes.default.number,
	  vertical: _propTypes.default.bool,
	  dragging: _propTypes.default.bool,
	  wrapAround: _propTypes.default.bool
	};
	ScrollTransition.defaultProps = {
	  deltaX: 0,
	  deltaY: 0,
	  slideWidth: 0,
	  slideHeight: 0,
	  slideCount: 0,
	  currentSlide: 0,
	  isWrappingAround: false,
	  top: 0,
	  left: 0,
	  cellSpacing: 0,
	  vertical: false,
	  dragging: false,
	  wrapAround: false
	};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSlideHeight = exports.getValidChildren = exports.addAccessibility = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var addAccessibility = function addAccessibility(children, slidesToShow, currentSlide) {
	  var needsTabIndex;
	
	  if (slidesToShow > 1) {
	    return _react.default.Children.map(children, function (child, index) {
	      // create a range from first visible slide to last visible slide
	      var firstVisibleSlide = index >= currentSlide;
	      var lastVisibleSlide = index < slidesToShow + currentSlide;
	      needsTabIndex = firstVisibleSlide && lastVisibleSlide; // if the index of the slide is in range add ariaProps to the slide
	
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      } : {
	        'aria-hidden': 'true'
	      };
	      return _react.default.cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  } else {
	    // when slidesToshow is 1
	    return _react.default.Children.map(children, function (child, index) {
	      needsTabIndex = index !== currentSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'true'
	      } : {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      };
	      return _react.default.cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  }
	};
	
	exports.addAccessibility = addAccessibility;
	
	var getValidChildren = function getValidChildren(children) {
	  // .toArray automatically removes invalid React children
	  return _react.default.Children.toArray(children);
	};
	
	exports.getValidChildren = getValidChildren;
	
	var findMaxHeightSlide = function findMaxHeightSlide(slides) {
	  var maxHeight = 0;
	
	  for (var i = 0; i < slides.length; i++) {
	    if (slides[i].offsetHeight > maxHeight) {
	      maxHeight = slides[i].offsetHeight;
	    }
	  }
	
	  return maxHeight;
	};
	
	var getSlideHeight = function getSlideHeight(props, state) {
	  var childNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var heightMode = props.heightMode,
	      vertical = props.vertical,
	      initialSlideHeight = props.initialSlideHeight;
	  var slidesToShow = state.slidesToShow,
	      currentSlide = state.currentSlide;
	  var firstSlide = childNodes[0];
	
	  if (firstSlide && heightMode === 'first') {
	    return vertical ? firstSlide.offsetHeight * slidesToShow : firstSlide.offsetHeight;
	  }
	
	  if (heightMode === 'max') {
	    return findMaxHeightSlide(childNodes);
	  }
	
	  if (heightMode === 'current') {
	    return childNodes[currentSlide].offsetHeight;
	  }
	
	  return initialSlideHeight || 100;
	};
	
	exports.getSlideHeight = getSlideHeight;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = exports.getFrameStyles = exports.getSliderStyles = exports.getDecoratorStyles = exports.getImgTagStyles = void 0;
	
	var getImgTagStyles = function getImgTagStyles() {
	  return ".slider-slide > img { width: 100%; display: block;}\n          .slider-slide > img:focus {margin: auto; width: 99.5%; outline-width: 11px}";
	};
	
	exports.getImgTagStyles = getImgTagStyles;
	
	var getDecoratorStyles = function getDecoratorStyles(position) {
	  switch (position) {
	    case 'TopLeft':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: 0
	        };
	      }
	
	    case 'TopCenter':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: '50%',
	          transform: 'translateX(-50%)',
	          WebkitTransform: 'translateX(-50%)',
	          msTransform: 'translateX(-50%)'
	        };
	      }
	
	    case 'TopRight':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          right: 0
	        };
	      }
	
	    case 'CenterLeft':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          left: 0,
	          transform: 'translateY(-50%)',
	          WebkitTransform: 'translateY(-50%)',
	          msTransform: 'translateY(-50%)'
	        };
	      }
	
	    case 'CenterCenter':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          left: '50%',
	          transform: 'translate(-50%,-50%)',
	          WebkitTransform: 'translate(-50%, -50%)',
	          msTransform: 'translate(-50%, -50%)'
	        };
	      }
	
	    case 'CenterRight':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          right: 0,
	          transform: 'translateY(-50%)',
	          WebkitTransform: 'translateY(-50%)',
	          msTransform: 'translateY(-50%)'
	        };
	      }
	
	    case 'BottomLeft':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          left: 0
	        };
	      }
	
	    case 'BottomCenter':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          left: '50%',
	          transform: 'translateX(-50%)',
	          WebkitTransform: 'translateX(-50%)',
	          msTransform: 'translateX(-50%)'
	        };
	      }
	
	    case 'BottomRight':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          right: 0
	        };
	      }
	
	    default:
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: 0
	        };
	      }
	  }
	};
	
	exports.getDecoratorStyles = getDecoratorStyles;
	
	var getSliderStyles = function getSliderStyles(propWidth, stateSlideWidth) {
	  return {
	    position: 'relative',
	    display: 'block',
	    width: propWidth,
	    height: 'auto',
	    boxSizing: 'border-box',
	    MozBoxSizing: 'border-box',
	    visibility: stateSlideWidth ? 'inherit' : 'hidden'
	  };
	};
	
	exports.getSliderStyles = getSliderStyles;
	
	var getFrameStyles = function getFrameStyles(propFrameOverFlow, propVertical, propFramePadding, stateFrameWidth) {
	  return {
	    position: 'relative',
	    display: 'block',
	    overflow: propFrameOverFlow,
	    height: propVertical ? stateFrameWidth || 'initial' : 'auto',
	    margin: propFramePadding,
	    padding: 0,
	    transform: 'translate3d(0, 0, 0)',
	    WebkitTransform: 'translate3d(0, 0, 0)',
	    msTransform: 'translate(0, 0)',
	    boxSizing: 'border-box',
	    MozBoxSizing: 'border-box',
	    touchAction: "pinch-zoom ".concat(propVertical ? 'pan-x' : 'pan-y')
	  };
	};
	
	exports.getFrameStyles = getFrameStyles;
	
	var getTransitionProps = function getTransitionProps(props, state) {
	  return {
	    slideWidth: state.slideWidth,
	    slideHeight: state.slideHeight,
	    slideCount: state.slideCount,
	    currentSlide: state.currentSlide,
	    isWrappingAround: state.isWrappingAround,
	    top: state.top,
	    left: state.left,
	    cellSpacing: props.cellSpacing,
	    vertical: props.vertical,
	    dragging: props.dragging,
	    wrapAround: props.wrapAround,
	    slidesToShow: state.slidesToShow
	  };
	};
	
	exports.getTransitionProps = getTransitionProps;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calcSomeInitialState = exports.shouldUpdate = exports.swipeDirection = exports.getPropsByTransitionMode = exports.addAccessibility = exports.removeEvent = exports.addEvent = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var addEvent = function addEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	
	  if (elem.addEventListener) {
	    elem.addEventListener(type, eventHandle, false);
	  } else if (elem.attachEvent) {
	    elem.attachEvent("on".concat(type), eventHandle);
	  } else {
	    elem["on".concat(type)] = eventHandle;
	  }
	};
	
	exports.addEvent = addEvent;
	
	var removeEvent = function removeEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	
	  if (elem.removeEventListener) {
	    elem.removeEventListener(type, eventHandle, false);
	  } else if (elem.detachEvent) {
	    elem.detachEvent("on".concat(type), eventHandle);
	  } else {
	    elem["on".concat(type)] = null;
	  }
	};
	
	exports.removeEvent = removeEvent;
	
	var addAccessibility = function addAccessibility(children, slidesToShow, currentSlide) {
	  var needsTabIndex;
	
	  if (slidesToShow > 1) {
	    return _react.default.Children.map(children, function (child, index) {
	      var firstVisibleSlide = index >= currentSlide;
	      var lastVisibleSlide = index < slidesToShow + currentSlide;
	      needsTabIndex = firstVisibleSlide && lastVisibleSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      } : {
	        'aria-hidden': 'true'
	      };
	      return _react.default.cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  } else {
	    return _react.default.Children.map(children, function (child, index) {
	      needsTabIndex = index !== currentSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'true'
	      } : {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      };
	      return _react.default.cloneElement(child, _objectSpread({}, child.props, ariaProps));
	    });
	  }
	};
	
	exports.addAccessibility = addAccessibility;
	
	var getPropsByTransitionMode = function getPropsByTransitionMode(props, keys) {
	  var slidesToShow = props.slidesToShow,
	      transitionMode = props.transitionMode;
	  var updatedDefaults = {};
	
	  if (transitionMode === 'fade') {
	    keys.forEach(function (key) {
	      switch (key) {
	        case 'slidesToShow':
	          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
	          break;
	
	        case 'slidesToScroll':
	          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
	          break;
	
	        case 'cellAlign':
	          updatedDefaults[key] = 'left';
	          break;
	
	        default:
	          updatedDefaults[key] = props[key];
	          break;
	      }
	    });
	  } else {
	    keys.forEach(function (key) {
	      updatedDefaults[key] = props[key];
	    });
	  }
	
	  return updatedDefaults;
	};
	
	exports.getPropsByTransitionMode = getPropsByTransitionMode;
	
	var swipeDirection = function swipeDirection(x1, x2, y1, y2, vertical) {
	  var xDist = x1 - x2;
	  var yDist = y1 - y2;
	  var r = Math.atan2(yDist, xDist);
	  var swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0) {
	    return 1;
	  }
	
	  if (swipeAngle <= 360 && swipeAngle >= 315) {
	    return 1;
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return -1;
	  }
	
	  if (vertical === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return 1;
	    } else {
	      return -1;
	    }
	  }
	
	  return 0;
	};
	
	exports.swipeDirection = swipeDirection;
	
	var shouldUpdate = function shouldUpdate(curr, next, keys) {
	  var update = false;
	
	  for (var i = 0; i < keys.length; i++) {
	    if (curr[keys[i]] !== next[keys[i]]) {
	      update = true;
	      break;
	    }
	  }
	
	  return update;
	};
	
	exports.shouldUpdate = shouldUpdate;
	
	var calcSomeInitialState = function calcSomeInitialState(props) {
	  var _getPropsByTransition = getPropsByTransitionMode(props, ['slidesToScroll', 'slidesToShow', 'cellAlign']),
	      slidesToScroll = _getPropsByTransition.slidesToScroll,
	      slidesToShow = _getPropsByTransition.slidesToShow,
	      cellAlign = _getPropsByTransition.cellAlign;
	
	  var slideWidth = props.vertical ? props.initialSlideHeight || 0 : props.initialSlideWidth || 0;
	  var slideHeight = props.vertical ? (props.initialSlideHeight || 0) * props.slidesToShow : props.initialSlideHeight || 0;
	  var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
	  var frameWidth = props.vertical ? frameHeight : '100%';
	  return {
	    slideWidth: slideWidth,
	    slideHeight: slideHeight,
	    frameWidth: frameWidth,
	    slidesToScroll: slidesToScroll,
	    slidesToShow: slidesToShow,
	    cellAlign: cellAlign
	  };
	};
	
	exports.calcSomeInitialState = calcSomeInitialState;

/***/ }),
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(207);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(161);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(209);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(160);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(206);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(208);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(207);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(161);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(209);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(160);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(206);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(208);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(207);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(161);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(209);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(501);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(160);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(206);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(208);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(498);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(499);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(500);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(504);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(262);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(161);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(503);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(262);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Timer = __webpack_require__(194);
	
	var _transition = __webpack_require__(507);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  weak
	/* eslint max-len: "off" */
	
	var Animate = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Animate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = typeof _this.props.start === 'function' ? _this.props.start() : _this.props.start, _this.checkTransitionStatus = function () {
	      if (!_this.TRANSITION_SCHEDULES) {
	        _this.interval.stop();
	
	        if (_this.props.show === false) {
	          _this.renderNull = true;
	          _this.setState(function (prevState) {
	            return prevState;
	          }); // force render as null
	        }
	      }
	    }, _this.interval = null, _this.renderNull = true, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Animate.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.show === true) {
	      this.renderNull = false;
	    }
	  };
	
	  Animate.prototype.componentDidMount = function componentDidMount() {
	    var _props = this.props,
	        enter = _props.enter,
	        show = _props.show;
	
	
	    if (enter && show === true) {
	      _transition.transition.call(this, typeof enter === 'function' ? enter() : enter);
	    }
	  };
	
	  Animate.prototype.componentWillReceiveProps = function componentWillReceiveProps(next) {
	    var _this2 = this;
	
	    var show = next.show,
	        start = next.start,
	        enter = next.enter,
	        update = next.update,
	        leave = next.leave;
	
	
	    if (this.props.show === false && this.renderNull === true && show === true) {
	      this.renderNull = false;
	
	      this.setState(function () {
	        return typeof start === 'function' ? start() : start;
	      }, function () {
	        if (enter) {
	          _transition.transition.call(_this2, typeof enter === 'function' ? enter() : enter);
	        }
	      });
	    } else if (this.props.show === true && show === false) {
	      if (leave) {
	        _transition.transition.call(this, typeof leave === 'function' ? leave() : leave);
	        this.interval = (0, _d3Timer.interval)(this.checkTransitionStatus);
	      } else {
	        this.renderNull = true;
	        this.setState(function (prevState) {
	          return prevState;
	        }); // force render as null
	      }
	    } else if (show === true && update) {
	      if (this.interval) {
	        this.interval.stop();
	      }
	
	      _transition.transition.call(this, typeof update === 'function' ? update() : update);
	    }
	  };
	
	  Animate.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.interval) {
	      this.interval.stop();
	    }
	
	    _transition.stop.call(this);
	  };
	
	  Animate.prototype.render = function render() {
	    if (this.renderNull === true) {
	      return null;
	    }
	
	    var renderedChildren = this.props.children(this.state);
	    return renderedChildren && _react2.default.Children.only(renderedChildren);
	  };
	
	  return Animate;
	}(_react.Component);
	
	Animate.defaultProps = {
	  show: true
	};
	exports.default = Animate;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Animate = __webpack_require__(505);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Animate2.default; /* eslint-disable flowtype/require-valid-file-annotation */

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _transition = __webpack_require__(510);
	
	Object.defineProperty(exports, 'transition', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_transition).default;
	  }
	});
	
	var _stop = __webpack_require__(509);
	
	Object.defineProperty(exports, 'stop', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stop).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //  weak
	/* eslint no-use-before-define: "off" */
	// Apapted from https://github.com/d3/d3-transition/blob/master/src/transition/schedule.js
	
	exports.default = function (node, stateKey, id, timing, tweens) {
	  var events = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	  var schedules = node.TRANSITION_SCHEDULES;
	  if (!schedules) {
	    node.TRANSITION_SCHEDULES = {}; // eslint-disable-line no-param-reassign
	  } else if (id in schedules) {
	    return;
	  }
	
	  var config = _extends({ stateKey: stateKey, events: events, tweens: tweens }, timing, { timer: null, state: CREATED });
	  create(node, id, config);
	};
	
	var _d3Timer = __webpack_require__(194);
	
	var CREATED = 0;
	var SCHEDULED = 1;
	var STARTING = 2;
	var STARTED = 3;
	var RUNNING = 4;
	var ENDING = 5;
	var ENDED = 6;
	
	function create(node, id, config) {
	  var schedules = node.TRANSITION_SCHEDULES;
	
	  // Initialize the transition timer when the transition is created.
	  // Note the actual delay is not known until the first callback!
	  var transition = _extends({}, config);
	  var n = transition.tweens.length;
	  var tweens = new Array(n);
	
	  schedules[id] = transition;
	  transition.timer = (0, _d3Timer.timer)(schedule, 0, transition.time);
	
	  function schedule(elapsed) {
	    transition.state = SCHEDULED;
	    transition.timer.restart(start, transition.delay, transition.time);
	
	    // If the elapsed delay is less than our first sleep, start immediately.
	    if (transition.delay <= elapsed) {
	      start(elapsed - transition.delay);
	    }
	  }
	
	  function start(elapsed) {
	    // eslint-disable-line consistent-return
	    // If the state is not SCHEDULED, then we previously errored on start.
	    if (transition.state !== SCHEDULED) return stop();
	
	    for (var sid in schedules) {
	      // eslint-disable-line
	      var s = schedules[sid];
	
	      if (s.stateKey !== transition.stateKey) {
	        continue; // eslint-disable-line no-continue
	      }
	
	      // While this element already has a starting transition during this frame,
	      // defer starting an interrupting transition until that transition has a
	      // chance to tick (and possibly end); see d3/d3-transition#54!
	      if (s.state === STARTED) return (0, _d3Timer.timeout)(start);
	
	      // 1. Interrupt the active transition, if any. dispatch the interrupt event.
	      // 2. Cancel any pre-empted transitions. No interrupt event is dispatched
	      // because the cancelled transitions never started. Note that this also
	      // removes this transition from the pending list!
	
	      if (s.state === RUNNING) {
	        s.state = ENDED;
	        s.timer.stop();
	        if (s.events.interrupt && typeof s.events.interrupt === 'function') {
	          s.events.interrupt.call(this);
	        }
	        delete schedules[sid];
	      } else if (+sid < id) {
	        s.state = ENDED;
	        s.timer.stop();
	        delete schedules[sid];
	      }
	    }
	
	    // Defer the first tick to end of the current frame; see d3/d3#1576.
	    // Note the transition may be canceled after start and before the first tick!
	    // Note this must be scheduled before the start event; see d3/d3-transition#16!
	    // Assuming this is successful, subsequent callbacks go straight to tick.
	    (0, _d3Timer.timeout)(function () {
	      if (transition.state === STARTED) {
	        transition.state = RUNNING;
	        transition.timer.restart(tick, transition.delay, transition.time);
	        tick(elapsed);
	      }
	    });
	
	    transition.state = STARTING;
	    if (transition.events.start && typeof transition.events.start === 'function') {
	      transition.events.start.call(node);
	    }
	
	    if (transition.state !== STARTING) {
	      // interrupted
	      return; // eslint-disable-line consistent-return
	    }
	
	    transition.state = STARTED;
	
	    // Initialize the tween, deleting null tween.
	    var j = -1;
	
	    for (var i = 0; i < n; ++i) {
	      var res = transition.tweens[i].call(node);
	
	      if (res) {
	        tweens[++j] = res;
	      }
	    }
	
	    tweens.length = j + 1;
	  }
	
	  function tick(elapsed) {
	    var t = 1;
	
	    if (elapsed < transition.duration) {
	      t = transition.ease.call(null, elapsed / transition.duration);
	    } else {
	      transition.timer.restart(stop);
	      transition.state = ENDING;
	    }
	
	    var i = -1;
	
	    while (++i < tweens.length) {
	      tweens[i].call(null, t);
	    }
	
	    if (transition.state === ENDING) {
	      if (transition.events.end && typeof transition.events.end === 'function') {
	        transition.events.end.call(node);
	      }
	      stop();
	    }
	  }
	
	  function stop() {
	    transition.state = ENDED;
	    transition.timer.stop();
	
	    delete schedules[id];
	    for (var i in schedules) {
	      return;
	    } // eslint-disable-line guard-for-in, no-restricted-syntax
	    delete node.TRANSITION_SCHEDULES; // eslint-disable-line no-param-reassign
	  }
	}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = stop;
	//  weak
	
	function stop() {
	  var ts = this.TRANSITION_SCHEDULES;
	
	  if (ts) {
	    Object.keys(ts).forEach(function (s) {
	      ts[s].timer.stop();
	    });
	  }
	}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.preset = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //  weak
	
	exports.newId = newId;
	exports.default = transition;
	
	var _d3Timer = __webpack_require__(194);
	
	var _tween = __webpack_require__(511);
	
	var _tween2 = _interopRequireDefault(_tween);
	
	var _schedule = __webpack_require__(508);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function once(func) {
	  var called = false;
	
	  return function transitionEvent() {
	    if (!called) {
	      called = true;
	      func.call(this);
	    }
	  };
	}
	
	var id = 0;
	
	function newId() {
	  return ++id;
	}
	
	// from https://github.com/d3/d3-ease/blob/master/src/linear.js
	function linear(t) {
	  return +t;
	}
	
	var preset = exports.preset = {
	  time: null,
	  delay: 0,
	  duration: 250,
	  ease: linear
	};
	
	function scheduleTransitions() {
	  var _this = this;
	
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var transitions = _extends({}, config);
	
	  var events = transitions.events || {};
	  delete transitions.events;
	
	  // each event handler should be called only once
	  Object.keys(events).forEach(function (d) {
	    if (typeof events[d] !== 'function') {
	      throw new Error('Event handlers must be a function');
	    } else {
	      events[d] = once(events[d]);
	    }
	  });
	
	  var timing = transitions.timing || {};
	  delete transitions.timing;
	
	  Object.keys(transitions).forEach(function (stateKey) {
	    var tweens = [];
	
	    if (_typeof(transitions[stateKey]) === 'object' && Array.isArray(transitions[stateKey]) === false) {
	      Object.keys(transitions[stateKey]).forEach(function (attr) {
	        var val = transitions[stateKey][attr];
	
	        if (Array.isArray(val)) {
	          if (val.length === 1) {
	            tweens.push(_tween2.default.call(_this, stateKey, attr, val[0]));
	          } else {
	            _this.setState(function (state) {
	              var _extends2, _ref;
	
	              return _ref = {}, _ref[stateKey] = _extends({}, state[stateKey], (_extends2 = {}, _extends2[attr] = val[0], _extends2)), _ref;
	            });
	
	            tweens.push(_tween2.default.call(_this, stateKey, attr, val[1]));
	          }
	        } else if (typeof val === 'function') {
	          var getResonanceCustomTween = function getResonanceCustomTween() {
	            var resonanceCustomTween = function resonanceCustomTween(t) {
	              _this.setState(function (state) {
	                var _extends3, _ref2;
	
	                return _ref2 = {}, _ref2[stateKey] = _extends({}, state[stateKey], (_extends3 = {}, _extends3[attr] = val(t), _extends3)), _ref2;
	              });
	            };
	
	            return resonanceCustomTween;
	          };
	
	          tweens.push(getResonanceCustomTween);
	        } else {
	          _this.setState(function (state) {
	            var _extends4, _ref3;
	
	            return _ref3 = {}, _ref3[stateKey] = _extends({}, state[stateKey], (_extends4 = {}, _extends4[attr] = val, _extends4)), _ref3;
	          });
	          // This assures any existing transitions are stopped
	          tweens.push(_tween2.default.call(_this, stateKey, attr, val));
	        }
	      });
	    } else {
	      var val = transitions[stateKey];
	
	      if (Array.isArray(val)) {
	        if (val.length === 1) {
	          tweens.push(_tween2.default.call(_this, null, stateKey, val[0]));
	        } else {
	          _this.setState(function () {
	            var _ref4;
	
	            return _ref4 = {}, _ref4[stateKey] = val[0], _ref4;
	          });
	
	          tweens.push(_tween2.default.call(_this, null, stateKey, val[1]));
	        }
	      } else if (typeof val === 'function') {
	        var getResonanceCustomTween = function getResonanceCustomTween() {
	          var resonanceCustomTween = function resonanceCustomTween(t) {
	            _this.setState(function () {
	              var _ref5;
	
	              return _ref5 = {}, _ref5[stateKey] = val(t), _ref5;
	            });
	          };
	
	          return resonanceCustomTween;
	        };
	
	        tweens.push(getResonanceCustomTween);
	      } else {
	        _this.setState(function () {
	          var _ref6;
	
	          return _ref6 = {}, _ref6[stateKey] = val, _ref6;
	        });
	        // This assures any existing transitions are stopped
	        tweens.push(_tween2.default.call(_this, null, stateKey, val));
	      }
	    }
	
	    var timingConfig = _extends({}, preset, timing, { time: (0, _d3Timer.now)() });
	    (0, _schedule2.default)(_this, stateKey, newId(), timingConfig, tweens, events);
	  });
	}
	
	function transition(config) {
	  var _this2 = this;
	
	  if (Array.isArray(config)) {
	    config.forEach(function (c) {
	      scheduleTransitions.call(_this2, c);
	    });
	  } else {
	    scheduleTransitions.call(this, config);
	  }
	}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //  weak
	
	
	exports.getInterpolator = getInterpolator;
	
	exports.default = function (nameSpace, attr, value) {
	  return getTween.call(this, nameSpace, attr, value);
	};
	
	var _d3Interpolate = __webpack_require__(384);
	
	function getInterpolator(attr) {
	  if (attr === 'transform') {
	    return _d3Interpolate.interpolateTransformSvg;
	  }
	
	  return _d3Interpolate.interpolate;
	}
	
	function getTween(nameSpace, attr, value1) {
	  return function tween() {
	    var _this = this;
	
	    var value0 = nameSpace ? this.state[nameSpace][attr] : this.state[attr];
	
	    if (value0 === value1) {
	      return null;
	    }
	
	    var i = getInterpolator(attr)(value0, value1);
	
	    var stateTween = void 0;
	
	    if (nameSpace === null) {
	      stateTween = function stateTween(t) {
	        _this.setState(function () {
	          var _ref;
	
	          return _ref = {}, _ref[attr] = i(t), _ref;
	        });
	      };
	    } else {
	      stateTween = function stateTween(t) {
	        _this.setState(function (state) {
	          var _extends2, _ref2;
	
	          return _ref2 = {}, _ref2[nameSpace] = _extends({}, state[nameSpace], (_extends2 = {}, _extends2[attr] = i(t), _extends2)), _ref2;
	        });
	      };
	    }
	
	    return stateTween;
	  };
	}

/***/ }),
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(23);
	
	var _utils = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Annotation = function (_Component) {
	  _inherits(Annotation, _Component);
	
	  function Annotation() {
	    _classCallCheck(this, Annotation);
	
	    return _possibleConstructorReturn(this, (Annotation.__proto__ || Object.getPrototypeOf(Annotation)).apply(this, arguments));
	  }
	
	  _createClass(Annotation, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          projection = _props.projection,
	          subject = _props.subject,
	          style = _props.style,
	          hiddenStyle = _props.hiddenStyle,
	          dx = _props.dx,
	          dy = _props.dy,
	          zoom = _props.zoom,
	          stroke = _props.stroke,
	          strokeWidth = _props.strokeWidth,
	          children = _props.children,
	          curve = _props.curve,
	          markerEnd = _props.markerEnd,
	          width = _props.width,
	          height = _props.height;
	
	
	      var connectorPath = (0, _utils.createConnectorPath)(null, [-dx / zoom, -dy / zoom], curve);
	      var translation = projection(subject);
	
	      var lineString = {
	        "type": "Feature",
	        "geometry": {
	          "type": "LineString",
	          "coordinates": [projection.invert([width / 2, height / 2]), subject]
	        }
	      };
	
	      var radians = Math.PI / 2,
	          degrees = 90;
	      var isGlobe = projection.clipAngle && projection.clipAngle() === degrees;
	      var isHidden = isGlobe && (0, _d3Geo.geoLength)(lineString) > radians;
	
	      return _react2.default.createElement(
	        "g",
	        {
	          className: "rsm-annotation",
	          style: isHidden ? _extends({}, style, hiddenStyle) : style,
	          transform: "translate(\n          " + (translation[0] + dx / zoom) + "\n          " + (translation[1] + dy / zoom) + "\n        )",
	          textAnchor: (0, _utils.createTextAnchor)(dx)
	        },
	        children,
	        _react2.default.createElement("path", {
	          d: connectorPath,
	          stroke: stroke,
	          strokeWidth: strokeWidth,
	          fill: "none",
	          markerEnd: markerEnd
	        })
	      );
	    }
	  }]);
	
	  return Annotation;
	}(_react.Component);
	
	Annotation.defaultProps = {
	  curve: 0,
	  markerEnd: "none",
	  componentIdentifier: "Annotation",
	  stroke: "#000000",
	  strokeWidth: 1,
	  zoom: 1
	};
	
	exports.default = Annotation;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MapGroup = __webpack_require__(163);
	
	var _MapGroup2 = _interopRequireDefault(_MapGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Annotations = function Annotations(_ref) {
	  var groupName = _ref.groupName,
	      itemName = _ref.itemName,
	      componentIdentifier = _ref.componentIdentifier,
	      restProps = _objectWithoutProperties(_ref, ["groupName", "itemName", "componentIdentifier"]);
	
	  return _react2.default.createElement(_MapGroup2.default, _extends({
	    groupName: groupName,
	    itemName: itemName
	  }, restProps));
	};
	
	Annotations.defaultProps = {
	  componentIdentifier: "Annotations",
	  groupName: "annotations",
	  itemName: "annotation"
	};
	
	exports.default = Annotations;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _projections = __webpack_require__(538);
	
	var _projections2 = _interopRequireDefault(_projections);
	
	var _projectionConfig = __webpack_require__(267);
	
	var _projectionConfig2 = _interopRequireDefault(_projectionConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComposableMap = function (_Component) {
	  _inherits(ComposableMap, _Component);
	
	  function ComposableMap() {
	    _classCallCheck(this, ComposableMap);
	
	    var _this = _possibleConstructorReturn(this, (ComposableMap.__proto__ || Object.getPrototypeOf(ComposableMap)).call(this));
	
	    _this.projection = _this.projection.bind(_this);
	    return _this;
	  }
	
	  _createClass(ComposableMap, [{
	    key: "projection",
	    value: function projection() {
	      var _props = this.props,
	          projection = _props.projection,
	          projectionConfig = _props.projectionConfig,
	          width = _props.width,
	          height = _props.height;
	
	
	      return typeof projection !== "function" ? (0, _projections2.default)(width, height, projectionConfig, projection) : projection(width, height, projectionConfig);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height,
	          style = _props2.style,
	          className = _props2.className,
	          showCenter = _props2.showCenter,
	          children = _props2.children,
	          aspectRatio = _props2.aspectRatio,
	          viewBox = _props2.viewBox,
	          defs = _props2.defs;
	
	
	      return _react2.default.createElement(
	        "svg",
	        { width: width,
	          height: height,
	          viewBox: viewBox ? viewBox : "0 0 " + width + " " + height,
	          className: "rsm-svg " + (className || ''),
	          style: style,
	          preserveAspectRatio: aspectRatio },
	        defs && _react2.default.createElement(
	          "defs",
	          null,
	          defs
	        ),
	        _react2.default.cloneElement(this.props.children, {
	          projection: this.projection(),
	          width: width,
	          height: height
	        }),
	        showCenter && _react2.default.createElement(
	          "g",
	          null,
	          _react2.default.createElement("rect", { x: width / 2 - 0.5, y: 0, width: 1, height: height, fill: "#e91e63" }),
	          _react2.default.createElement("rect", { x: 0, y: height / 2 - 0.5, width: width, height: 1, fill: "#e91e63" })
	        )
	      );
	    }
	  }]);
	
	  return ComposableMap;
	}(_react.Component);
	
	ComposableMap.defaultProps = {
	  width: 800,
	  height: 450,
	  projection: "times",
	  projectionConfig: _projectionConfig2.default,
	  aspectRatio: "xMidYMid",
	  viewBox: null
	};
	
	exports.default = ComposableMap;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _topojsonClient = __webpack_require__(554);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Geographies = function (_Component) {
	  _inherits(Geographies, _Component);
	
	  function Geographies(props) {
	    _classCallCheck(this, Geographies);
	
	    var _this = _possibleConstructorReturn(this, (Geographies.__proto__ || Object.getPrototypeOf(Geographies)).call(this, props));
	
	    _this.state = {
	      geographyPaths: _this.shouldFetchGeographies(props.geography) ? [] : _this.parseGeographies(props.geography)
	    };
	    return _this;
	  }
	
	  _createClass(Geographies, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.geography !== this.props.geography) {
	        if (this.shouldFetchGeographies(nextProps.geography)) {
	          this.fetchGeographies(nextProps.geography);
	        } else {
	          this.setState({
	            geographyPaths: this.parseGeographies(nextProps.geography)
	          });
	        }
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var geoPathsChanged = nextState.geographyPaths.length !== this.state.geographyPaths.length;
	      return geoPathsChanged || nextProps.disableOptimization;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.geographyUrl || this.props.geographyPaths) {
	        console.warn("You are using the deprecated geographyUrl or geographyPaths props. Use the new geography prop instead. Check out the new docs here: https://github.com/zcreativelabs/react-simple-maps#Geographies-component");
	      }
	      if (this.shouldFetchGeographies(this.props.geography)) {
	        this.fetchGeographies(this.props.geography);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.cancelPendingRequest();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          projection = _props.projection,
	          style = _props.style,
	          children = _props.children;
	
	      return _react2.default.createElement(
	        "g",
	        { className: "rsm-geographies", style: style },
	        children(this.state.geographyPaths || [], projection)
	      );
	    }
	  }, {
	    key: "shouldFetchGeographies",
	    value: function shouldFetchGeographies(geography) {
	      return typeof geography === 'string';
	    }
	  }, {
	    key: "parseGeographies",
	    value: function parseGeographies(geography) {
	      if (Array.isArray(geography)) {
	        return geography;
	      }
	
	      if (Object.prototype.toString.call(geography) === '[object Object]') {
	        return (0, _topojsonClient.feature)(geography, geography.objects[Object.keys(geography.objects)[0]]).features;
	      }
	
	      return [];
	    }
	  }, {
	    key: "fetchGeographies",
	    value: function fetchGeographies(geography) {
	      var _this2 = this;
	
	      var request = new XMLHttpRequest();
	      request.open("GET", geography, true);
	      request.onload = function () {
	        if (request.status >= 200 && request.status < 400) {
	          var geographyPaths = JSON.parse(request.responseText);
	          _this2.setState({
	            geographyPaths: _this2.parseGeographies(geographyPaths)
	          }, function () {
	            if (_this2.props.onGeographyPathsLoaded) {
	              _this2.props.onGeographyPathsLoaded(String(request.status));
	            }
	          });
	        } else {
	          if (_this2.props.onGeographyPathsLoaded) {
	            _this2.props.onGeographyPathsLoaded(String(request.status));
	          }
	        }
	      };
	      request.onerror = function () {
	        console.log("There was a connection error...");
	      };
	      request.send();
	
	      this.cancelPendingRequest();
	      this._xhr = request;
	    }
	  }, {
	    key: "cancelPendingRequest",
	    value: function cancelPendingRequest() {
	      if (this._xhr) {
	        this._xhr.abort();
	        this._xhr = null;
	      }
	    }
	  }]);
	
	  return Geographies;
	}(_react.Component);
	
	Geographies.defaultProps = {
	  componentIdentifier: "Geographies",
	  disableOptimization: false,
	  geography: ""
	};
	
	exports.default = Geographies;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(23);
	
	var _utils = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pathCache = {};
	
	var renderPath = function renderPath(cacheId, geography, projection, round, precision) {
	  if (pathCache[cacheId]) return pathCache[cacheId];
	
	  var pathString = cacheId ? pathCache[cacheId] ? pathCache[cacheId] : round ? (0, _utils.roundPath)((0, _d3Geo.geoPath)().projection(projection)(geography), precision) : (0, _d3Geo.geoPath)().projection(projection)(geography) : round ? (0, _utils.roundPath)((0, _d3Geo.geoPath)().projection(projection)(geography), precision) : (0, _d3Geo.geoPath)().projection(projection)(geography);
	
	  if (cacheId) pathCache[cacheId] = pathString;
	
	  return pathString;
	};
	
	var Geography = function (_Component) {
	  _inherits(Geography, _Component);
	
	  function Geography() {
	    _classCallCheck(this, Geography);
	
	    var _this = _possibleConstructorReturn(this, (Geography.__proto__ || Object.getPrototypeOf(Geography)).call(this));
	
	    _this.state = {
	      hover: false,
	      pressed: false
	    };
	
	    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleMouseClick = _this.handleMouseClick.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Geography, [{
	    key: "handleMouseClick",
	    value: function handleMouseClick(evt) {
	      evt.persist();
	      var _props = this.props,
	          onClick = _props.onClick,
	          geography = _props.geography;
	
	      return onClick && onClick(geography, evt);
	    }
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(evt) {
	      evt.persist();
	      var _props2 = this.props,
	          onMouseEnter = _props2.onMouseEnter,
	          geography = _props2.geography;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onMouseEnter && onMouseEnter(geography, evt);
	      });
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(evt) {
	      evt.persist();
	      if (this.state.pressed) return;
	      var _props3 = this.props,
	          onMouseMove = _props3.onMouseMove,
	          geography = _props3.geography;
	
	      if (!this.state.hover) {
	        this.setState({
	          hover: true
	        }, function () {
	          return onMouseMove && onMouseMove(geography, evt);
	        });
	      } else if (onMouseMove) onMouseMove(geography, evt);else return;
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(evt) {
	      evt.persist();
	      var _props4 = this.props,
	          onMouseLeave = _props4.onMouseLeave,
	          geography = _props4.geography;
	
	      this.setState({
	        hover: false,
	        pressed: false
	      }, function () {
	        return onMouseLeave && onMouseLeave(geography, evt);
	      });
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(evt) {
	      evt.persist();
	      var _props5 = this.props,
	          onMouseDown = _props5.onMouseDown,
	          geography = _props5.geography;
	
	      this.setState({
	        pressed: true
	      }, function () {
	        return onMouseDown && onMouseDown(geography, evt);
	      });
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(evt) {
	      evt.persist();
	      var _props6 = this.props,
	          onMouseUp = _props6.onMouseUp,
	          geography = _props6.geography;
	
	      this.setState({
	        pressed: false
	      }, function () {
	        return onMouseUp && onMouseUp(geography, evt);
	      });
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(evt) {
	      evt.persist();
	      var _props7 = this.props,
	          onFocus = _props7.onFocus,
	          geography = _props7.geography;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onFocus && onFocus(geography, evt);
	      });
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(evt) {
	      evt.persist();
	      var _props8 = this.props,
	          onBlur = _props8.onBlur,
	          geography = _props8.geography;
	
	      this.setState({
	        hover: false
	      }, function () {
	        return onBlur && onBlur(geography, evt);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props9 = this.props,
	          geography = _props9.geography,
	          projection = _props9.projection,
	          round = _props9.round,
	          cacheId = _props9.cacheId,
	          precision = _props9.precision,
	          tabable = _props9.tabable,
	          style = _props9.style;
	      var _state = this.state,
	          hover = _state.hover,
	          pressed = _state.pressed;
	
	
	      var pathString = renderPath(cacheId, geography, projection, round, precision);
	
	      var excludeProps = ["geography", "projection", "round", "cacheId", "precision", "tabable", "style", "onClick", "onMouseEnter", "onMouseMove", "onMouseLeave", "onMouseDown", "onMouseUp", "onFocus", "onBlur"];
	
	      var restProps = Object.keys(this.props).filter(function (key) {
	        return excludeProps.indexOf(key) === -1;
	      }).reduce(function (obj, key) {
	        obj[key] = _this2.props[key];
	        return obj;
	      }, {});
	
	      return _react2.default.createElement("path", _extends({
	        d: pathString,
	        className: "rsm-geography" + (pressed ? " rsm-geography--pressed" : "") + (hover ? " rsm-geography--hover" : ""),
	        style: style[pressed || hover ? pressed ? "pressed" : "hover" : "default"],
	        onClick: this.handleMouseClick,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseMove: this.handleMouseMove,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        tabIndex: tabable ? 0 : -1
	      }, restProps));
	    }
	  }]);
	
	  return Geography;
	}(_react.Component);
	
	Geography.defaultProps = {
	  precision: 0.1,
	  cacheId: null,
	  round: false,
	  tabable: true,
	  style: {
	    default: {},
	    hover: {},
	    pressed: {}
	  }
	};
	
	exports.default = Geography;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(23);
	
	var _utils = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var computeGraticule = function computeGraticule(projection, step) {
	  return (0, _d3Geo.geoPath)().projection(projection)((0, _d3Geo.geoGraticule)().step(step)());
	};
	
	var computeOutline = function computeOutline(projection) {
	  return (0, _d3Geo.geoPath)().projection(projection)((0, _d3Geo.geoGraticule)().outline());
	};
	
	var Graticule = function (_Component) {
	  _inherits(Graticule, _Component);
	
	  function Graticule() {
	    _classCallCheck(this, Graticule);
	
	    var _this = _possibleConstructorReturn(this, (Graticule.__proto__ || Object.getPrototypeOf(Graticule)).call(this));
	
	    _this.state = {
	      renderGraticule: false,
	      graticulePath: "",
	      outlinePath: ""
	    };
	    _this.renderGraticule = _this.renderGraticule.bind(_this);
	    return _this;
	  }
	
	  _createClass(Graticule, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.renderGraticule();
	    }
	  }, {
	    key: "renderGraticule",
	    value: function renderGraticule() {
	      var _props = this.props,
	          step = _props.step,
	          projection = _props.projection,
	          round = _props.round,
	          precision = _props.precision;
	
	
	      this.setState({
	        renderGraticule: true,
	        graticulePath: round ? (0, _utils.roundPath)(computeGraticule(projection, step), precision) : computeGraticule(projection, step),
	        outlinePath: round ? (0, _utils.roundPath)(computeOutline(projection), precision) : computeOutline(projection)
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props,
	          step = _props2.step,
	          projection = _props2.projection,
	          round = _props2.round,
	          precision = _props2.precision,
	          globe = _props2.globe;
	
	
	      if (nextProps.round !== round || nextProps.precision !== precision || globe) {
	        this.setState({
	          graticulePath: nextProps.round ? (0, _utils.roundPath)(computeGraticule(projection, step), precision) : computeGraticule(projection, step),
	          outlinePath: nextProps.round ? (0, _utils.roundPath)(computeOutline(projection), precision) : computeOutline(projection)
	        });
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.disableOptimization;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props3 = this.props,
	          zoom = _props3.zoom,
	          style = _props3.style,
	          outline = _props3.outline,
	          fill = _props3.fill,
	          stroke = _props3.stroke;
	
	
	      return this.state.renderGraticule && _react2.default.createElement(
	        "g",
	        { className: "rsm-graticule" },
	        _react2.default.createElement("path", {
	          fill: fill,
	          stroke: stroke,
	          d: this.state.graticulePath,
	          style: style
	        }),
	        outline && _react2.default.createElement("path", {
	          fill: fill,
	          stroke: stroke,
	          d: this.state.outlinePath,
	          style: style
	        })
	      );
	    }
	  }]);
	
	  return Graticule;
	}(_react.Component);
	
	Graticule.defaultProps = {
	  componentIdentifier: "Graticule",
	  disableOptimization: true,
	  globe: false,
	  round: true,
	  precision: 0.1,
	  step: [10, 10],
	  outline: true,
	  stroke: "#DDDDDD",
	  fill: "transparent",
	  style: {
	    pointerEvents: "none"
	  }
	};
	
	exports.default = Graticule;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Line = function (_Component) {
	  _inherits(Line, _Component);
	
	  function Line(props) {
	    _classCallCheck(this, Line);
	
	    var _this = _possibleConstructorReturn(this, (Line.__proto__ || Object.getPrototypeOf(Line)).call(this, props));
	
	    _this.state = {
	      hover: false,
	      pressed: false
	    };
	
	    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleMouseClick = _this.handleMouseClick.bind(_this);
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Line, [{
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(evt) {
	      evt.persist();
	      var _props = this.props,
	          onMouseEnter = _props.onMouseEnter,
	          line = _props.line;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onMouseEnter && onMouseEnter(line, evt);
	      });
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(evt) {
	      evt.persist();
	      if (this.state.pressed) return;
	      var _props2 = this.props,
	          onMouseMove = _props2.onMouseMove,
	          line = _props2.line;
	
	      if (!this.state.hover) {
	        this.setState({
	          hover: true
	        }, function () {
	          return onMouseMove && onMouseMove(line, evt);
	        });
	      } else if (onMouseMove) onMouseMove(line, evt);else return;
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(evt) {
	      evt.persist();
	      var _props3 = this.props,
	          onMouseLeave = _props3.onMouseLeave,
	          line = _props3.line;
	
	      this.setState({
	        hover: false
	      }, function () {
	        return onMouseLeave && onMouseLeave(line, evt);
	      });
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(evt) {
	      evt.persist();
	      var _props4 = this.props,
	          onMouseDown = _props4.onMouseDown,
	          line = _props4.line;
	
	      this.setState({
	        pressed: true
	      }, function () {
	        return onMouseDown && onMouseDown(line, evt);
	      });
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(evt) {
	      evt.persist();
	      var _props5 = this.props,
	          onMouseUp = _props5.onMouseUp,
	          line = _props5.line;
	
	      this.setState({
	        pressed: false
	      }, function () {
	        return onMouseUp && onMouseUp(line, evt);
	      });
	    }
	  }, {
	    key: "handleMouseClick",
	    value: function handleMouseClick(evt) {
	      if (!this.props.onClick) return;
	      evt.persist();
	      var _props6 = this.props,
	          onClick = _props6.onClick,
	          line = _props6.line,
	          projection = _props6.projection;
	
	      return onClick && onClick(line, [projection(line.coordinates.start), projection(line.coordinates.end)], evt);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(evt) {
	      evt.persist();
	      var _props7 = this.props,
	          onFocus = _props7.onFocus,
	          line = _props7.line;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onFocus && onFocus(line, evt);
	      });
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(evt) {
	      evt.persist();
	      var _props8 = this.props,
	          onBlur = _props8.onBlur,
	          line = _props8.line;
	
	      this.setState({
	        hover: false
	      }, function () {
	        return onBlur && onBlur(line, evt);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props9 = this.props,
	          className = _props9.className,
	          projection = _props9.projection,
	          line = _props9.line,
	          style = _props9.style,
	          tabable = _props9.tabable,
	          zoom = _props9.zoom,
	          preserveMarkerAspect = _props9.preserveMarkerAspect,
	          width = _props9.width,
	          height = _props9.height,
	          buildPath = _props9.buildPath,
	          strokeWidth = _props9.strokeWidth;
	      var _state = this.state,
	          pressed = _state.pressed,
	          hover = _state.hover;
	
	
	      var scale = preserveMarkerAspect ? " scale(" + 1 / zoom + ")" : "";
	
	      var buildLineString = function buildLineString(coordinates) {
	        return {
	          type: "Feature",
	          geometry: {
	            type: "LineString",
	            coordinates: [projection.invert([width / 2, height / 2]), coordinates]
	          }
	        };
	      };
	      var startLineString = buildLineString(line.coordinates.start);
	      var endLineString = buildLineString(line.coordinates.end);
	
	      var radians = Math.PI / 2,
	          degrees = 90;
	      var isGlobe = projection.clipAngle && projection.clipAngle() === degrees;
	      var isHidden = isGlobe && ((0, _d3Geo.geoLength)(startLineString) > radians || (0, _d3Geo.geoLength)(endLineString) > radians);
	
	      var start = projection(line.coordinates.start);
	      var end = projection(line.coordinates.end);
	
	      var path = buildPath ? buildPath(start, end, line) : "M " + start.join(" ") + " L " + end.join(" ");
	
	      return _react2.default.createElement("path", {
	        className: "rsm-line" + (pressed ? " rsm-line--pressed" : "") + (hover ? " rsm-line--hover" : "") + " " + className,
	        transform: "" + scale,
	        style: style[isHidden ? "hidden" : pressed || hover ? pressed ? "pressed" : "hover" : "default"],
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onClick: this.handleMouseClick,
	        onMouseMove: this.handleMouseMove,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        tabIndex: tabable ? 0 : -1,
	        d: path,
	        strokeWidth: strokeWidth
	      });
	    }
	  }]);
	
	  return Line;
	}(_react.Component);
	
	Line.defaultProps = {
	  style: {
	    default: {},
	    hover: {},
	    pressed: {}
	  },
	  line: {
	    coordinates: {
	      start: [0, 0],
	      end: [-99.1, 19.4]
	    }
	  },
	  tabable: true,
	  preserveMarkerAspect: true,
	  strokeWidth: 1,
	  className: ""
	};
	
	exports.default = Line;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MapGroup = __webpack_require__(163);
	
	var _MapGroup2 = _interopRequireDefault(_MapGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Lines = function Lines(_ref) {
	  var groupName = _ref.groupName,
	      itemName = _ref.itemName,
	      componentIdentifier = _ref.componentIdentifier,
	      restProps = _objectWithoutProperties(_ref, ["groupName", "itemName", "componentIdentifier"]);
	
	  return _react2.default.createElement(_MapGroup2.default, _extends({
	    groupName: groupName,
	    itemName: itemName
	  }, restProps));
	};
	
	Lines.defaultProps = {
	  componentIdentifier: "Lines",
	  groupName: "lines",
	  itemName: "line"
	};
	
	exports.default = Lines;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Marker = function (_Component) {
	  _inherits(Marker, _Component);
	
	  function Marker() {
	    _classCallCheck(this, Marker);
	
	    var _this = _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).call(this));
	
	    _this.state = {
	      hover: false,
	      pressed: false
	    };
	
	    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleMouseClick = _this.handleMouseClick.bind(_this);
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Marker, [{
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(evt) {
	      evt.persist();
	      var _props = this.props,
	          onMouseEnter = _props.onMouseEnter,
	          marker = _props.marker;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onMouseEnter && onMouseEnter(marker, evt);
	      });
	    }
	  }, {
	    key: "handleMouseMove",
	    value: function handleMouseMove(evt) {
	      evt.persist();
	      if (this.state.pressed) return;
	      var _props2 = this.props,
	          onMouseMove = _props2.onMouseMove,
	          marker = _props2.marker;
	
	      if (!this.state.hover) {
	        this.setState({
	          hover: true
	        }, function () {
	          return onMouseMove && onMouseMove(marker, evt);
	        });
	      } else if (onMouseMove) onMouseMove(marker, evt);else return;
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(evt) {
	      evt.persist();
	      var _props3 = this.props,
	          onMouseLeave = _props3.onMouseLeave,
	          marker = _props3.marker;
	
	      this.setState({
	        hover: false
	      }, function () {
	        return onMouseLeave && onMouseLeave(marker, evt);
	      });
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(evt) {
	      evt.persist();
	      var _props4 = this.props,
	          onMouseDown = _props4.onMouseDown,
	          marker = _props4.marker;
	
	      this.setState({
	        pressed: true
	      }, function () {
	        return onMouseDown && onMouseDown(marker, evt);
	      });
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(evt) {
	      evt.persist();
	      var _props5 = this.props,
	          onMouseUp = _props5.onMouseUp,
	          marker = _props5.marker;
	
	      this.setState({
	        pressed: false
	      }, function () {
	        return onMouseUp && onMouseUp(marker, evt);
	      });
	    }
	  }, {
	    key: "handleMouseClick",
	    value: function handleMouseClick(evt) {
	      if (!this.props.onClick) return;
	      evt.persist();
	      var _props6 = this.props,
	          onClick = _props6.onClick,
	          marker = _props6.marker,
	          projection = _props6.projection;
	
	      return onClick && onClick(marker, projection(marker.coordinates), evt);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(evt) {
	      evt.persist();
	      var _props7 = this.props,
	          onFocus = _props7.onFocus,
	          marker = _props7.marker;
	
	      this.setState({
	        hover: true
	      }, function () {
	        return onFocus && onFocus(marker, evt);
	      });
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(evt) {
	      evt.persist();
	      var _props8 = this.props,
	          onBlur = _props8.onBlur,
	          marker = _props8.marker;
	
	      this.setState({
	        hover: false
	      }, function () {
	        return onBlur && onBlur(marker, evt);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props9 = this.props,
	          projection = _props9.projection,
	          marker = _props9.marker,
	          style = _props9.style,
	          tabable = _props9.tabable,
	          zoom = _props9.zoom,
	          children = _props9.children,
	          preserveMarkerAspect = _props9.preserveMarkerAspect,
	          width = _props9.width,
	          height = _props9.height;
	      var _state = this.state,
	          pressed = _state.pressed,
	          hover = _state.hover;
	
	
	      var scale = preserveMarkerAspect ? " scale(" + 1 / zoom + ")" : "";
	      var translation = projection(marker.coordinates);
	
	      var lineString = {
	        "type": "Feature",
	        "geometry": {
	          "type": "LineString",
	          "coordinates": [projection.invert([width / 2, height / 2]), marker.coordinates]
	        }
	      };
	
	      var radians = Math.PI / 2,
	          degrees = 90;
	      var isGlobe = projection.clipAngle && projection.clipAngle() === degrees;
	      var isHidden = isGlobe && (0, _d3Geo.geoLength)(lineString) > radians;
	
	      return _react2.default.createElement(
	        "g",
	        { className: "rsm-marker" + (pressed ? " rsm-marker--pressed" : "") + (hover ? " rsm-marker--hover" : ""),
	          transform: "translate(\n           " + translation[0] + "\n           " + translation[1] + "\n         ) " + scale,
	          style: style[isHidden ? "hidden" : pressed || hover ? pressed ? "pressed" : "hover" : "default"],
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseDown: this.handleMouseDown,
	          onMouseUp: this.handleMouseUp,
	          onClick: this.handleMouseClick,
	          onMouseMove: this.handleMouseMove,
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          tabIndex: tabable ? 0 : -1
	        },
	        children
	      );
	    }
	  }]);
	
	  return Marker;
	}(_react.Component);
	
	Marker.defaultProps = {
	  style: {
	    default: {},
	    hover: {},
	    pressed: {}
	  },
	  marker: {
	    coordinates: [0, 0]
	  },
	  tabable: true,
	  preserveMarkerAspect: true
	};
	
	exports.default = Marker;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MapGroup = __webpack_require__(163);
	
	var _MapGroup2 = _interopRequireDefault(_MapGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Markers = function Markers(_ref) {
	  var groupName = _ref.groupName,
	      itemName = _ref.itemName,
	      componentIdentifier = _ref.componentIdentifier,
	      restProps = _objectWithoutProperties(_ref, ["groupName", "itemName", "componentIdentifier"]);
	
	  return _react2.default.createElement(_MapGroup2.default, _extends({
	    groupName: groupName,
	    itemName: itemName
	  }, restProps));
	};
	
	Markers.defaultProps = {
	  componentIdentifier: "Markers",
	  groupName: "markers",
	  itemName: "marker"
	};
	
	exports.default = Markers;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(23);
	
	var _utils = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZoomableGlobe = function (_Component) {
	  _inherits(ZoomableGlobe, _Component);
	
	  function ZoomableGlobe(props) {
	    _classCallCheck(this, ZoomableGlobe);
	
	    var _this = _possibleConstructorReturn(this, (ZoomableGlobe.__proto__ || Object.getPrototypeOf(ZoomableGlobe)).call(this, props));
	
	    var initialRotation = props.projection.rotate();
	
	    _this.state = {
	      mouseX: 0,
	      mouseY: 0,
	      mouseXStart: 0,
	      mouseYStart: 0,
	      isPressed: false,
	      rotation: [initialRotation[0] - props.center[0], initialRotation[1] - props.center[1], initialRotation[2]]
	    };
	
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
	    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
	    return _this;
	  }
	
	  _createClass(ZoomableGlobe, [{
	    key: "handleMouseMove",
	    value: function handleMouseMove(_ref) {
	      var pageX = _ref.pageX,
	          pageY = _ref.pageY,
	          clientX = _ref.clientX,
	          clientY = _ref.clientY;
	
	      if (this.props.disablePanning) return;
	      if (!this.state.isPressed) return;
	
	      var differenceX = clientX - this.state.mouseXStart;
	      var differenceY = clientY - this.state.mouseYStart;
	
	      this.setState({
	        mouseX: clientX,
	        mouseY: clientY,
	        mouseXStart: clientX,
	        mouseYStart: clientY,
	        rotation: [this.state.rotation[0] + differenceX * this.props.sensitivity, this.state.rotation[1] - differenceY * this.props.sensitivity, this.state.rotation[2]]
	      });
	    }
	  }, {
	    key: "handleTouchMove",
	    value: function handleTouchMove(_ref2) {
	      var touches = _ref2.touches;
	
	      this.handleMouseMove(touches[0]);
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp() {
	      if (this.props.disablePanning) return;
	      if (!this.state.isPressed) return;
	      this.setState({
	        isPressed: false
	      });
	      if (!this.props.onMoveEnd) return;
	      var newCenter = this.props.projection.invert([this.props.width / 2, this.props.height / 2]);
	      this.props.onMoveEnd(newCenter);
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(_ref3) {
	      var pageX = _ref3.pageX,
	          pageY = _ref3.pageY,
	          clientX = _ref3.clientX,
	          clientY = _ref3.clientY;
	
	      if (this.props.disablePanning) return;
	      this.setState({
	        isPressed: true,
	        mouseXStart: clientX,
	        mouseYStart: clientY
	      });
	      if (!this.props.onMoveStart) return;
	      var currentCenter = this.props.projection.invert([this.props.width / 2, this.props.height / 2]);
	      this.props.onMoveStart(currentCenter);
	    }
	  }, {
	    key: "handleTouchStart",
	    value: function handleTouchStart(_ref4) {
	      var touches = _ref4.touches;
	
	      if (touches.length > 1) {
	        this.handleMouseDown(touches[0]);
	      } else {
	        this.handleMouseUp();
	      }
	    }
	  }, {
	    key: "preventTouchScroll",
	    value: function preventTouchScroll(evt) {
	      if (evt.touches.length > 1) {
	        evt.preventDefault();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _state = this.state,
	          mouseX = _state.mouseX,
	          mouseY = _state.mouseY;
	      var _props = this.props,
	          projection = _props.projection,
	          center = _props.center,
	          zoom = _props.zoom;
	
	
	      var zoomFactor = nextProps.zoom / zoom;
	      var centerChanged = JSON.stringify(nextProps.center) !== JSON.stringify(center);
	
	      this.setState({
	        zoom: nextProps.zoom,
	        rotation: centerChanged ? [-nextProps.center[0], -nextProps.center[1], this.state.rotation[2]] : this.state.rotation
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height,
	          projection = _props2.projection,
	          zoom = _props2.zoom;
	
	
	      window.addEventListener("resize", this.handleResize);
	      window.addEventListener("mouseup", this.handleMouseUp);
	      this.zoomableGlobeNode.addEventListener("touchmove", this.preventTouchScroll);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.handleResize);
	      window.removeEventListener("mouseup", this.handleMouseUp);
	      this.zoomableGlobeNode.removeEventListener("touchmove", this.preventTouchScroll);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          width = _props3.width,
	          height = _props3.height,
	          zoom = _props3.zoom,
	          style = _props3.style,
	          projection = _props3.projection,
	          children = _props3.children;
	      var _state2 = this.state,
	          mouseX = _state2.mouseX,
	          mouseY = _state2.mouseY;
	
	
	      return _react2.default.createElement(
	        "g",
	        { className: "rsm-zoomable-globe",
	          ref: function ref(zoomableGlobeNode) {
	            return _this2.zoomableGlobeNode = zoomableGlobeNode;
	          },
	          transform: "\n           translate(" + width / 2 + " " + height / 2 + ")\n           scale(" + zoom + ")\n           translate(" + -width / 2 + " " + -height / 2 + ")\n         ",
	          onMouseMove: this.handleMouseMove,
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleTouchStart,
	          onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleMouseUp,
	          style: style
	        },
	        (0, _utils.createNewChildren)(children, {
	          width: width,
	          height: height,
	          center: this.center,
	          backdrop: this.backdrop,
	          zoom: this.props.zoom,
	          disablePanning: this.props.disablePanning,
	          children: children,
	          projection: projection.rotate(this.state.rotation)
	        })
	      );
	    }
	  }]);
	
	  return ZoomableGlobe;
	}(_react.Component);
	
	ZoomableGlobe.defaultProps = {
	  center: [0, 0],
	  zoom: 1,
	  disablePanning: false,
	  sensitivity: 0.25
	};
	
	exports.default = ZoomableGlobe;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Geo = __webpack_require__(23);
	
	var _utils = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZoomableGroup = function (_Component) {
	  _inherits(ZoomableGroup, _Component);
	
	  function ZoomableGroup(props) {
	    _classCallCheck(this, ZoomableGroup);
	
	    var _this = _possibleConstructorReturn(this, (ZoomableGroup.__proto__ || Object.getPrototypeOf(ZoomableGroup)).call(this, props));
	
	    var backdrop = (0, _utils.computeBackdrop)(props.projection, props.backdrop);
	
	    _this.state = {
	      mouseX: (0, _utils.calculateMousePosition)("x", props.projection, props, props.zoom, 1),
	      mouseY: (0, _utils.calculateMousePosition)("y", props.projection, props, props.zoom, 1),
	      mouseXStart: 0,
	      mouseYStart: 0,
	      isPressed: false,
	      resizeFactorX: 1,
	      resizeFactorY: 1,
	      backdrop: {
	        width: Math.round(backdrop.width),
	        height: Math.round(backdrop.height),
	        x: Math.round(backdrop.x),
	        y: Math.round(backdrop.y)
	      }
	    };
	
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
	    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(ZoomableGroup, [{
	    key: "handleMouseMove",
	    value: function handleMouseMove(_ref) {
	      var pageX = _ref.pageX,
	          pageY = _ref.pageY;
	
	      if (this.props.disablePanning) return;
	      if (!this.state.isPressed) return;
	      this.setState({
	        mouseX: pageX - this.state.mouseXStart,
	        mouseY: pageY - this.state.mouseYStart
	      });
	    }
	  }, {
	    key: "handleTouchMove",
	    value: function handleTouchMove(_ref2) {
	      var touches = _ref2.touches;
	
	      this.handleMouseMove(touches[0]);
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp() {
	      if (this.props.disablePanning) return;
	      if (!this.state.isPressed) return;
	      this.setState({
	        isPressed: false
	      });
	      if (!this.props.onMoveEnd) return;
	      var _state = this.state,
	          mouseX = _state.mouseX,
	          mouseY = _state.mouseY,
	          resizeFactorX = _state.resizeFactorX,
	          resizeFactorY = _state.resizeFactorY;
	      var _props = this.props,
	          zoom = _props.zoom,
	          width = _props.width,
	          height = _props.height,
	          projection = _props.projection,
	          onMoveEnd = _props.onMoveEnd;
	
	      var x = width / 2 - mouseX * resizeFactorX / zoom;
	      var y = height / 2 - mouseY * resizeFactorY / zoom;
	      var newCenter = projection.invert([x, y]);
	      onMoveEnd(newCenter);
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(_ref3) {
	      var pageX = _ref3.pageX,
	          pageY = _ref3.pageY;
	
	      if (this.props.disablePanning) return;
	      var _state2 = this.state,
	          mouseX = _state2.mouseX,
	          mouseY = _state2.mouseY,
	          resizeFactorX = _state2.resizeFactorX,
	          resizeFactorY = _state2.resizeFactorY;
	      var _props2 = this.props,
	          zoom = _props2.zoom,
	          width = _props2.width,
	          height = _props2.height,
	          projection = _props2.projection,
	          onMoveStart = _props2.onMoveStart;
	
	      this.setState({
	        isPressed: true,
	        mouseXStart: pageX - mouseX,
	        mouseYStart: pageY - mouseY
	      });
	      if (!onMoveStart) return;
	      var x = width / 2 - mouseX * resizeFactorX / zoom;
	      var y = height / 2 - mouseY * resizeFactorY / zoom;
	      var currentCenter = projection.invert([x, y]);
	      onMoveStart(currentCenter);
	    }
	  }, {
	    key: "handleTouchStart",
	    value: function handleTouchStart(_ref4) {
	      var touches = _ref4.touches;
	
	      if (touches.length > 1) {
	        this.handleMouseDown(touches[0]);
	      } else {
	        this.handleMouseUp();
	      }
	    }
	  }, {
	    key: "preventTouchScroll",
	    value: function preventTouchScroll(evt) {
	      if (evt.touches.length > 1) {
	        evt.preventDefault();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _state3 = this.state,
	          mouseX = _state3.mouseX,
	          mouseY = _state3.mouseY,
	          resizeFactorX = _state3.resizeFactorX,
	          resizeFactorY = _state3.resizeFactorY;
	      var _props3 = this.props,
	          projection = _props3.projection,
	          center = _props3.center,
	          zoom = _props3.zoom;
	
	
	      var zoomFactor = nextProps.zoom / zoom;
	      var centerChanged = JSON.stringify(nextProps.center) !== JSON.stringify(center);
	
	      this.setState({
	        zoom: nextProps.zoom,
	        mouseX: centerChanged ? (0, _utils.calculateMousePosition)("x", nextProps.projection, nextProps, nextProps.zoom, resizeFactorX) : mouseX * zoomFactor,
	        mouseY: centerChanged ? (0, _utils.calculateMousePosition)("y", nextProps.projection, nextProps, nextProps.zoom, resizeFactorY) : mouseY * zoomFactor
	      });
	    }
	  }, {
	    key: "handleResize",
	    value: function handleResize() {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          projection = _props4.projection,
	          zoom = _props4.zoom;
	
	
	      var resizeFactorX = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().width, width);
	      var resizeFactorY = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().height, height);
	
	      var xPercentageChange = 1 / resizeFactorX * this.state.resizeFactorX;
	      var yPercentageChange = 1 / resizeFactorY * this.state.resizeFactorY;
	
	      this.setState({
	        resizeFactorX: resizeFactorX,
	        resizeFactorY: resizeFactorY,
	        mouseX: this.state.mouseX * xPercentageChange,
	        mouseY: this.state.mouseY * yPercentageChange
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props5 = this.props,
	          width = _props5.width,
	          height = _props5.height,
	          projection = _props5.projection,
	          zoom = _props5.zoom;
	
	
	      var resizeFactorX = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().width, width);
	      var resizeFactorY = (0, _utils.calculateResizeFactor)(this.zoomableGroupNode.parentNode.getBoundingClientRect().height, height);
	
	      this.setState({
	        resizeFactorX: resizeFactorX,
	        resizeFactorY: resizeFactorY,
	        mouseX: (0, _utils.calculateMousePosition)("x", projection, this.props, zoom, resizeFactorX),
	        mouseY: (0, _utils.calculateMousePosition)("y", projection, this.props, zoom, resizeFactorY)
	      });
	
	      window.addEventListener("resize", this.handleResize);
	      window.addEventListener("mouseup", this.handleMouseUp);
	      this.zoomableGroupNode.addEventListener("touchmove", this.preventTouchScroll);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.handleResize);
	      window.removeEventListener("mouseup", this.handleMouseUp);
	      this.zoomableGroupNode.removeEventListener("touchmove", this.preventTouchScroll);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height,
	          zoom = _props6.zoom,
	          style = _props6.style,
	          projection = _props6.projection,
	          children = _props6.children;
	      var _state4 = this.state,
	          mouseX = _state4.mouseX,
	          mouseY = _state4.mouseY,
	          resizeFactorX = _state4.resizeFactorX,
	          resizeFactorY = _state4.resizeFactorY;
	
	
	      return _react2.default.createElement(
	        "g",
	        { className: "rsm-zoomable-group",
	          ref: function ref(zoomableGroupNode) {
	            return _this2.zoomableGroupNode = zoomableGroupNode;
	          },
	          transform: "\n           translate(\n             " + Math.round((width / 2 + resizeFactorX * mouseX) * 100) / 100 + "\n             " + Math.round((height / 2 + resizeFactorY * mouseY) * 100) / 100 + "\n           )\n           scale(" + zoom + ")\n           translate(" + -width / 2 + " " + -height / 2 + ")\n         ",
	          onMouseMove: this.handleMouseMove,
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleTouchStart,
	          onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleMouseUp,
	          style: style
	        },
	        _react2.default.createElement("rect", {
	          x: this.state.backdrop.x,
	          y: this.state.backdrop.y,
	          width: this.state.backdrop.width,
	          height: this.state.backdrop.height,
	          fill: "transparent",
	          style: { strokeWidth: 0 }
	        }),
	        (0, _utils.createNewChildren)(children, this.props)
	      );
	    }
	  }]);
	
	  return ZoomableGroup;
	}(_react.Component);
	
	ZoomableGroup.defaultProps = {
	  center: [0, 0],
	  backdrop: {
	    x: [-179.9, 179.9],
	    y: [89.9, -89.9]
	  },
	  zoom: 1,
	  disablePanning: false
	};
	
	exports.default = ZoomableGroup;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ComposableMap = __webpack_require__(527);
	
	Object.defineProperty(exports, "ComposableMap", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ComposableMap).default;
	  }
	});
	
	var _ZoomableGroup = __webpack_require__(536);
	
	Object.defineProperty(exports, "ZoomableGroup", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ZoomableGroup).default;
	  }
	});
	
	var _ZoomableGlobe = __webpack_require__(535);
	
	Object.defineProperty(exports, "ZoomableGlobe", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ZoomableGlobe).default;
	  }
	});
	
	var _Geographies = __webpack_require__(528);
	
	Object.defineProperty(exports, "Geographies", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Geographies).default;
	  }
	});
	
	var _Geography = __webpack_require__(529);
	
	Object.defineProperty(exports, "Geography", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Geography).default;
	  }
	});
	
	var _Marker = __webpack_require__(533);
	
	Object.defineProperty(exports, "Marker", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Marker).default;
	  }
	});
	
	var _Markers = __webpack_require__(534);
	
	Object.defineProperty(exports, "Markers", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Markers).default;
	  }
	});
	
	var _Line = __webpack_require__(531);
	
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Line).default;
	  }
	});
	
	var _Lines = __webpack_require__(532);
	
	Object.defineProperty(exports, "Lines", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Lines).default;
	  }
	});
	
	var _MapGroup = __webpack_require__(163);
	
	Object.defineProperty(exports, "MapGroup", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MapGroup).default;
	  }
	});
	
	var _Annotation = __webpack_require__(525);
	
	Object.defineProperty(exports, "Annotation", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Annotation).default;
	  }
	});
	
	var _Annotations = __webpack_require__(526);
	
	Object.defineProperty(exports, "Annotations", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Annotations).default;
	  }
	});
	
	var _Graticule = __webpack_require__(530);
	
	Object.defineProperty(exports, "Graticule", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Graticule).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (width, height, config, projectionName) {
	
	  var scale = config.scale || _projectionConfig2.default.scale;
	  var xOffset = config.xOffset || _projectionConfig2.default.xOffset;
	  var yOffset = config.yOffset || _projectionConfig2.default.yOffset;
	  var rotation = config.rotation || _projectionConfig2.default.rotation;
	  var precision = config.precision || _projectionConfig2.default.precision;
	
	  var baseProjection = projectionReference[projectionName]().scale(scale).translate([xOffset + width / 2, yOffset + height / 2]).precision(precision);
	
	  return projectionName === "albersUsa" ? baseProjection : projectionName === "orthographic" ? baseProjection.rotate(rotation).clipAngle(90) : baseProjection.rotate(rotation);
	};
	
	var _d3GeoProjection = __webpack_require__(383);
	
	var _d3Geo = __webpack_require__(23);
	
	var _projectionConfig = __webpack_require__(267);
	
	var _projectionConfig2 = _interopRequireDefault(_projectionConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projectionReference = {
	  mercator: _d3Geo.geoMercator,
	  miller: _d3GeoProjection.geoMiller,
	  times: _d3GeoProjection.geoTimes,
	  robinson: _d3GeoProjection.geoRobinson,
	  winkel3: _d3GeoProjection.geoWinkel3,
	  eckert4: _d3GeoProjection.geoEckert4,
	  albersUsa: _d3Geo.geoAlbersUsa,
	  orthographic: _d3Geo.geoOrthographic
	};

/***/ }),
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(24);
	var sprite = __webpack_require__(25);
	var symbol = new SpriteSymbol({
	  "id": "chevron-left",
	  "use": "chevron-left-usage",
	  "viewBox": "0 0 20 20",
	  "content": "<symbol viewBox=\"0 0 20 20\" id=\"chevron-left\">\n<!--Generated by IJSVG (https://github.com/iconjar/IJSVG)-->\n    <path d=\"M12.452,4.516c0.446,0.436 0.481,1.043 0,1.576l-3.747,3.908l3.747,3.908c0.481,0.533 0.446,1.141 0,1.574c-0.445,0.436 -1.197,0.408 -1.615,0c-0.418,-0.406 -4.502,-4.695 -4.502,-4.695c-0.223,-0.217 -0.335,-0.502 -0.335,-0.787c0,-0.285 0.112,-0.57 0.335,-0.789c0,0 4.084,-4.287 4.502,-4.695c0.418,-0.409 1.17,-0.436 1.615,0Z\" />\n</symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(24);
	var sprite = __webpack_require__(25);
	var symbol = new SpriteSymbol({
	  "id": "chevron-right",
	  "use": "chevron-right-usage",
	  "viewBox": "0 0 20 20",
	  "content": "<symbol viewBox=\"0 0 20 20\" id=\"chevron-right\">\n<!--Generated by IJSVG (https://github.com/iconjar/IJSVG)-->\n    <path d=\"M9.163,4.516c0.418,0.408 4.502,4.695 4.502,4.695c0.223,0.219 0.335,0.504 0.335,0.789c0,0.285 -0.112,0.57 -0.335,0.787c0,0 -4.084,4.289 -4.502,4.695c-0.418,0.408 -1.17,0.436 -1.615,0c-0.446,-0.434 -0.481,-1.041 0,-1.574l3.747,-3.908l-3.747,-3.908c-0.481,-0.533 -0.446,-1.141 0,-1.576c0.445,-0.436 1.197,-0.409 1.615,0Z\" />\n</symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),
/* 553 */,
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/topojson/topojson-client Version 2.1.0. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.topojson = global.topojson || {})));
	}(this, (function (exports) { 'use strict';
	
	var identity = function(x) {
	  return x;
	};
	
	var transform = function(topology) {
	  if ((transform = topology.transform) == null) return identity;
	  var transform,
	      x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(point, i) {
	    if (!i) x0 = y0 = 0;
	    point[0] = (x0 += point[0]) * kx + dx;
	    point[1] = (y0 += point[1]) * ky + dy;
	    return point;
	  };
	};
	
	var bbox = function(topology) {
	  var bbox = topology.bbox;
	
	  function bboxPoint(p0) {
	    p1[0] = p0[0], p1[1] = p0[1], t(p1);
	    if (p1[0] < x0) x0 = p1[0];
	    if (p1[0] > x1) x1 = p1[0];
	    if (p1[1] < y0) y0 = p1[1];
	    if (p1[1] > y1) y1 = p1[1];
	  }
	
	  function bboxGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
	      case "Point": bboxPoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
	    }
	  }
	
	  if (!bbox) {
	    var t = transform(topology), p0, p1 = new Array(2), name,
	        x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
	
	    topology.arcs.forEach(function(arc) {
	      var i = -1, n = arc.length;
	      while (++i < n) {
	        p0 = arc[i], p1[0] = p0[0], p1[1] = p0[1], t(p1, i);
	        if (p1[0] < x0) x0 = p1[0];
	        if (p1[0] > x1) x1 = p1[0];
	        if (p1[1] < y0) y0 = p1[1];
	        if (p1[1] > y1) y1 = p1[1];
	      }
	    });
	
	    for (name in topology.objects) {
	      bboxGeometry(topology.objects[name]);
	    }
	
	    bbox = topology.bbox = [x0, y0, x1, y1];
	  }
	
	  return bbox;
	};
	
	var reverse = function(array, n) {
	  var t, j = array.length, i = j - n;
	  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	};
	
	var feature = function(topology, o) {
	  return o.type === "GeometryCollection"
	      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature$1(topology, o); })}
	      : feature$1(topology, o);
	};
	
	function feature$1(topology, o) {
	  var id = o.id,
	      bbox = o.bbox,
	      properties = o.properties == null ? {} : o.properties,
	      geometry = object(topology, o);
	  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
	      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
	      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
	}
	
	function object(topology, o) {
	  var transformPoint = transform(topology),
	      arcs = topology.arcs;
	
	  function arc(i, points) {
	    if (points.length) points.pop();
	    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
	      points.push(transformPoint(a[k].slice(), k));
	    }
	    if (i < 0) reverse(points, n);
	  }
	
	  function point(p) {
	    return transformPoint(p.slice());
	  }
	
	  function line(arcs) {
	    var points = [];
	    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
	    if (points.length < 2) points.push(points[0].slice());
	    return points;
	  }
	
	  function ring(arcs) {
	    var points = line(arcs);
	    while (points.length < 4) points.push(points[0].slice());
	    return points;
	  }
	
	  function polygon(arcs) {
	    return arcs.map(ring);
	  }
	
	  function geometry(o) {
	    var type = o.type, coordinates;
	    switch (type) {
	      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
	      case "Point": coordinates = point(o.coordinates); break;
	      case "MultiPoint": coordinates = o.coordinates.map(point); break;
	      case "LineString": coordinates = line(o.arcs); break;
	      case "MultiLineString": coordinates = o.arcs.map(line); break;
	      case "Polygon": coordinates = polygon(o.arcs); break;
	      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
	      default: return null;
	    }
	    return {type: type, coordinates: coordinates};
	  }
	
	  return geometry(o);
	}
	
	var stitch = function(topology, arcs) {
	  var stitchedArcs = {},
	      fragmentByStart = {},
	      fragmentByEnd = {},
	      fragments = [],
	      emptyIndex = -1;
	
	  // Stitch empty arcs first, since they may be subsumed by other arcs.
	  arcs.forEach(function(i, j) {
	    var arc = topology.arcs[i < 0 ? ~i : i], t;
	    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
	      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
	    }
	  });
	
	  arcs.forEach(function(i) {
	    var e = ends(i),
	        start = e[0],
	        end = e[1],
	        f, g;
	
	    if (f = fragmentByEnd[start]) {
	      delete fragmentByEnd[f.end];
	      f.push(i);
	      f.end = end;
	      if (g = fragmentByStart[end]) {
	        delete fragmentByStart[g.start];
	        var fg = g === f ? f : f.concat(g);
	        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else if (f = fragmentByStart[end]) {
	      delete fragmentByStart[f.start];
	      f.unshift(i);
	      f.start = start;
	      if (g = fragmentByEnd[start]) {
	        delete fragmentByEnd[g.end];
	        var gf = g === f ? f : g.concat(f);
	        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else {
	      f = [i];
	      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
	    }
	  });
	
	  function ends(i) {
	    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
	    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
	    else p1 = arc[arc.length - 1];
	    return i < 0 ? [p1, p0] : [p0, p1];
	  }
	
	  function flush(fragmentByEnd, fragmentByStart) {
	    for (var k in fragmentByEnd) {
	      var f = fragmentByEnd[k];
	      delete fragmentByStart[f.start];
	      delete f.start;
	      delete f.end;
	      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
	      fragments.push(f);
	    }
	  }
	
	  flush(fragmentByEnd, fragmentByStart);
	  flush(fragmentByStart, fragmentByEnd);
	  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
	
	  return fragments;
	};
	
	var mesh = function(topology) {
	  return object(topology, meshArcs.apply(this, arguments));
	};
	
	function meshArcs(topology, object$$1, filter) {
	  var arcs, i, n;
	  if (arguments.length > 1) arcs = extractArcs(topology, object$$1, filter);
	  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
	  return {type: "MultiLineString", arcs: stitch(topology, arcs)};
	}
	
	function extractArcs(topology, object$$1, filter) {
	  var arcs = [],
	      geomsByArc = [],
	      geom;
	
	  function extract0(i) {
	    var j = i < 0 ? ~i : i;
	    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
	  }
	
	  function extract1(arcs) {
	    arcs.forEach(extract0);
	  }
	
	  function extract2(arcs) {
	    arcs.forEach(extract1);
	  }
	
	  function extract3(arcs) {
	    arcs.forEach(extract2);
	  }
	
	  function geometry(o) {
	    switch (geom = o, o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "LineString": extract1(o.arcs); break;
	      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
	      case "MultiPolygon": extract3(o.arcs); break;
	    }
	  }
	
	  geometry(object$$1);
	
	  geomsByArc.forEach(filter == null
	      ? function(geoms) { arcs.push(geoms[0].i); }
	      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
	
	  return arcs;
	}
	
	function planarRingArea(ring) {
	  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
	  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
	  return Math.abs(area); // Note: doubled area!
	}
	
	var merge = function(topology) {
	  return object(topology, mergeArcs.apply(this, arguments));
	};
	
	function mergeArcs(topology, objects) {
	  var polygonsByArc = {},
	      polygons = [],
	      groups = [];
	
	  objects.forEach(geometry);
	
	  function geometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "Polygon": extract(o.arcs); break;
	      case "MultiPolygon": o.arcs.forEach(extract); break;
	    }
	  }
	
	  function extract(polygon) {
	    polygon.forEach(function(ring) {
	      ring.forEach(function(arc) {
	        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
	      });
	    });
	    polygons.push(polygon);
	  }
	
	  function area(ring) {
	    return planarRingArea(object(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
	  }
	
	  polygons.forEach(function(polygon) {
	    if (!polygon._) {
	      var group = [],
	          neighbors = [polygon];
	      polygon._ = 1;
	      groups.push(group);
	      while (polygon = neighbors.pop()) {
	        group.push(polygon);
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
	              if (!polygon._) {
	                polygon._ = 1;
	                neighbors.push(polygon);
	              }
	            });
	          });
	        });
	      }
	    }
	  });
	
	  polygons.forEach(function(polygon) {
	    delete polygon._;
	  });
	
	  return {
	    type: "MultiPolygon",
	    arcs: groups.map(function(polygons) {
	      var arcs = [], n;
	
	      // Extract the exterior (unique) arcs.
	      polygons.forEach(function(polygon) {
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
	              arcs.push(arc);
	            }
	          });
	        });
	      });
	
	      // Stitch the arcs into one or more rings.
	      arcs = stitch(topology, arcs);
	
	      // If more than one ring is returned,
	      // at most one of these rings can be the exterior;
	      // choose the one with the greatest absolute area.
	      if ((n = arcs.length) > 1) {
	        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
	          if ((ki = area(arcs[i])) > k) {
	            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
	          }
	        }
	      }
	
	      return arcs;
	    })
	  };
	}
	
	var bisect = function(a, x) {
	  var lo = 0, hi = a.length;
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	    if (a[mid] < x) lo = mid + 1;
	    else hi = mid;
	  }
	  return lo;
	};
	
	var neighbors = function(objects) {
	  var indexesByArc = {}, // arc index -> array of object indexes
	      neighbors = objects.map(function() { return []; });
	
	  function line(arcs, i) {
	    arcs.forEach(function(a) {
	      if (a < 0) a = ~a;
	      var o = indexesByArc[a];
	      if (o) o.push(i);
	      else indexesByArc[a] = [i];
	    });
	  }
	
	  function polygon(arcs, i) {
	    arcs.forEach(function(arc) { line(arc, i); });
	  }
	
	  function geometry(o, i) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
	    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
	  }
	
	  var geometryType = {
	    LineString: line,
	    MultiLineString: polygon,
	    Polygon: polygon,
	    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
	  };
	
	  objects.forEach(geometry);
	
	  for (var i in indexesByArc) {
	    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
	      for (var k = j + 1; k < m; ++k) {
	        var ij = indexes[j], ik = indexes[k], n;
	        if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
	        if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
	      }
	    }
	  }
	
	  return neighbors;
	};
	
	var quantize = function(topology, n) {
	  if (!((n = Math.floor(n)) >= 2)) throw new Error("n must be ≥2");
	  if (topology.transform) throw new Error("already quantized");
	  var bb = bbox(topology), name,
	      dx = bb[0], kx = (bb[2] - dx) / (n - 1) || 1,
	      dy = bb[1], ky = (bb[3] - dy) / (n - 1) || 1;
	
	  function quantizePoint(p) {
	    p[0] = Math.round((p[0] - dx) / kx);
	    p[1] = Math.round((p[1] - dy) / ky);
	  }
	
	  function quantizeGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(quantizeGeometry); break;
	      case "Point": quantizePoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(quantizePoint); break;
	    }
	  }
	
	  topology.arcs.forEach(function(arc) {
	    var i = 1,
	        j = 1,
	        n = arc.length,
	        pi = arc[0],
	        x0 = pi[0] = Math.round((pi[0] - dx) / kx),
	        y0 = pi[1] = Math.round((pi[1] - dy) / ky),
	        pj,
	        x1,
	        y1;
	
	    for (; i < n; ++i) {
	      pi = arc[i];
	      x1 = Math.round((pi[0] - dx) / kx);
	      y1 = Math.round((pi[1] - dy) / ky);
	      if (x1 !== x0 || y1 !== y0) {
	        pj = arc[j++];
	        pj[0] = x1 - x0, x0 = x1;
	        pj[1] = y1 - y0, y0 = y1;
	      }
	    }
	
	    if (j < 2) {
	      pj = arc[j++];
	      pj[0] = 0;
	      pj[1] = 0;
	    }
	
	    arc.length = j;
	  });
	
	  for (name in topology.objects) {
	    quantizeGeometry(topology.objects[name]);
	  }
	
	  topology.transform = {
	    scale: [kx, ky],
	    translate: [dx, dy]
	  };
	
	  return topology;
	};
	
	var untransform = function(topology) {
	  if ((transform = topology.transform) == null) return identity;
	  var transform,
	      x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(point, i) {
	    if (!i) x0 = y0 = 0;
	    var x1 = Math.round((point[0] - dx) / kx),
	        y1 = Math.round((point[1] - dy) / ky);
	    point[0] = x1 - x0, x0 = x1;
	    point[1] = y1 - y0, y0 = y1;
	    return point;
	  };
	};
	
	exports.bbox = bbox;
	exports.feature = feature;
	exports.mesh = mesh;
	exports.meshArcs = meshArcs;
	exports.merge = merge;
	exports.mergeArcs = mergeArcs;
	exports.neighbors = neighbors;
	exports.quantize = quantize;
	exports.transform = transform;
	exports.untransform = untransform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-js-c2460d201f0209840c60.js